webpackJsonp([2],{

/***/ "+/qu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Allnews_vue__ = __webpack_require__("M6QC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57292ae4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Allnews_vue__ = __webpack_require__("24Yu");
function injectStyle (ssrContext) {
  __webpack_require__("pJnW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Allnews_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57292ae4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Allnews_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+0IY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("8buw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bbd34ae0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("7Ib9");
function injectStyle (ssrContext) {
  __webpack_require__("EUen")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bbd34ae0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+49+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainStatusInstructions_vue__ = __webpack_require__("gNn8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78937cf9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainStatusInstructions_vue__ = __webpack_require__("2N6X");
function injectStyle (ssrContext) {
  __webpack_require__("qwHR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainStatusInstructions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78937cf9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainStatusInstructions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+9k9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails(),
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'Facilities',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        file: null,
        cropped: null
      },
      sliderImage: {
        file: null,
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      },
      firstSlider: false
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post('/api/images/upload/' + this.post.name + '_inner-image', { cropped: i }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + _this.post.name + '" />';
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      };
      if (!this.content.content) {
        this.errors.push("İçerik");
      };
      if (!this.image.cropped && !this.image.file) {
        this.errors.push("Resim");
      };
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this2.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'
        _this2.saveImage();
      });
    },
    saveImage: function saveImage() {
      var _this3 = this;

      if (this.image.cropped) {
        this.$http.post('/api/images/upload/' + this.slugify(this.post.name), this.image).then(function (response) {
          _this3.post.image = response.body.Data.Response.name;
          _this3.savePost();
        }, function (e) {
          button.innerHTML = 'Kaydet';
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this3.toggleLoader();
        });
      } else {
        this.savePost();
      }
    },
    savePost: function savePost() {
      var _this4 = this;

      this.post.comments = null;
      this.post.menus = null;
      this.post.slider = null;
      this.tempMetas = this.post.post_metas;
      this.post.post_metas = null;
      this.post.post_tags = null;
      this.post.category = null;
      this.post.sub_category = null;
      this.post.user = null;
      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.$http.post('/api/posts/edit/' + this.post.id, this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this4.post.id = pid;
        _this4.slider.post_id = pid;
        _this4.slider.order_number = pid;
        _this4.metas.post_id = pid;
        _this4.saveMetas();
      }, function (e) {
        _this4.toggleLoader();

        if (!e.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this4.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveMetas: function saveMetas() {
      var _this5 = this;

      this.$http.put('/api/post-metas/edit-bulk/', this.metas).then(function (response) {
        _this5.notifier('top', 'right', 'success', 'Başarılı');
        _this5.$router.push('/facilities');
        _this5.toggleLoader();
      }, function (e) {
        _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this5.toggleLoader();
      });
    },
    getInitialData: function getInitialData() {
      var _this6 = this;

      this.toggleLoader();
      this.$http.get('/api/posts/get/' + this.id).then(function (response) {
        _this6.post = response.body;
        _this6.content = _this6.post.content;
        _this6.image.file = _this6.mediaURL() + _this6.post.image;
        if (_this6.post.video !== null) {
          _this6.video = _this6.post.video;
        }
        if (_this6.post.slider == null) {
          _this6.firstSlider = true;
        }
        _this6.metas = {
          post_id: _this6.post.id,
          items: {
            meta2: {
              meta_id: _this6.post.post_metas[_this6.post.meta_title].id,
              meta_key: 'title',
              meta_value: _this6.post.post_metas[_this6.post.meta_title].meta_value
            },
            meta3: {
              meta_id: _this6.post.post_metas[_this6.post.meta_description].id,
              meta_key: 'description',
              meta_value: _this6.post.post_metas[_this6.post.meta_description].meta_value
            }
          }
        };
        _this6.toggleLoader();
      }, function (er) {
        _this6.toggleLoader();
        _this6.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name);
    },
    slugifyUrl: function slugifyUrl() {
      this.announcement.url = this.slugify(this.announcement.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this7 = this;

        request.$http.get('/api/filter/posts/exclude/id:' + this.id + '/post-type/Facilities/name/' + request.post.name).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this7.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.name) {
        this.croppieType = type;
      } else {
        this.notifier('top', 'right', 'danger', 'Resim ekleyebilmek için bir başlık belirlemelisiniz.');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this8 = this;

      var dis = this;
      var wdt = 550;
      var hgt = 311;
      if (this.croppieType === "tinymce") {
        wdt = 550;
        hgt = 311;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: wdt,
            height: hgt
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this8.croppieType === 'main') {
            dis.image.cropped = output;
            document.getElementById('main-i').src = dis.image.cropped;
          } else if (_this8.croppieType === 'tinymce') {
            _this8.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this8.addImageToEditor(output);
          }
          _this8.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.getInitialData();
  }
});

/***/ }),

/***/ "+KYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);


/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

var GlobalDirectives = {
  install: function install(Vue) {
    Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalDirectives);

/***/ }),

/***/ "+S5Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('index-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+SvU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      subscriber: {
        email: null,
        is_subscribed: 1
      },
      errors: [],
      // end of post data
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.subscriber.email) {
        this.errors.push("E-Posta Alanını Doldurmanız Gerek");
      };
      if (!this.validEmail(this.subscriber.email)) {
        this.errors.push("E-Posta Formatı Doğru Değil");
      }
      if (!this.errors.length) {
        this.saveEmail();
      }
    },
    saveEmail: function saveEmail() {
      var _this = this;

      this.toggleLoader();
      this.$http.post('/api/newsletter/add', this.subscriber).then(function (response) {
        _this.notifier('top', 'right', 'success', 'Başarılı');
        _this.$router.push('/newsletter');
        _this.toggleLoader();
      }, function (e) {
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    validEmail: function validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }
});

/***/ }),

/***/ "+TJz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_search_select__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      menu: {
        name: null,
        item_order: null,
        url: null,
        category_id: null,
        post_id: null,
        tag_id: null,
        sub_category_id: null
      },
      selectedType: null,
      types: ['URL', 'Kategori', 'Alt Kategori', 'Yayın', 'Etiket'],
      options: [],
      menus: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_1_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      this.toggleLoader();
      this.$http.post('/api/menus/delete/' + id).then(function (response) {
        _this.notifier('top', 'right', 'warning', 'Menu elemanı silindi');
        _this.getMenus();
        _this.toggleLoader();
      }, function (e) {
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    loadItems: function loadItems() {
      var _this2 = this;

      this.options = [];
      var resourse = null;
      if (this.selectedType === "URL") {
        this.menu.category_id = null;
        this.menu.sub_category_id = null;
        this.menu.post_id = null;
        this.menu.tag_id = null;
        return;
      } else if (this.selectedType === 'Kategori') {
        resourse = 'categories';
        this.menu.url = null;
        this.menu.sub_category_id = null;
        this.menu.post_id = null;
        this.menu.tag_id = null;
      } else if (this.selectedType === 'Alt Kategori') {
        resourse = 'sub-categories';
        this.menu.url = null;
        this.menu.category_id = null;
        this.menu.post_id = null;
        this.menu.tag_id = null;
      } else if (this.selectedType === 'Yayın') {
        resourse = 'posts';
        this.menu.url = null;
        this.menu.sub_category_id = null;
        this.menu.category_id = null;
        this.menu.tag_id = null;
      } else if (this.selectedType === 'Etiket') {
        this.menu.url = null;
        this.menu.sub_category_id = null;
        this.menu.post_id = null;
        this.menu.category_id = null;
        resourse = 'tags';
      }
      this.toggleLoader();
      var url = '/api/' + resourse + '/all/';
      this.$http.get(url).then(function (response) {
        response = response.body;
        for (var i = 0; i < response.length; i++) {
          var temp = { value: response[i].id, text: response[i].name };
          _this2.options.push(temp);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        _this2.toggleLoader();
      });
    },
    update: function update(id) {
      var _this3 = this;

      this.$http.post('/api/menus/edit/', this.menus).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Sıralama güncellendi');
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
      });
    },
    save: function save(id) {
      var _this4 = this;

      this.menu.item_order = this.menus.length;
      this.toggleLoader();
      this.$http.post('/api/menus/add/', this.menu).then(function (response) {
        _this4.menu = {
          name: null,
          item_order: null,
          url: null,
          category_id: null,
          post_id: null,
          tag_id: null,
          sub_category_id: null
        };
        _this4.getMenus();
        _this4.toggleLoader();
        _this4.notifier('top', 'right', 'success', 'Sıralama güncellendi');
      }, function (e) {
        _this4.toggleLoader();
        _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
      });
    },
    getMenus: function getMenus() {
      var _this5 = this;

      this.toggleLoader();
      var url = '/api/menus/all/';
      this.$http.get(url).then(function (response) {
        _this5.menus = response.body;
        _this5.toggleLoader();
      }, function (er) {
        _this5.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        _this5.toggleLoader();
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getMenus();
    });
  }
});

/***/ }),

/***/ "+a0N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+bKo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+iwA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__ = __webpack_require__("Pfth");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49cb7ff8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__ = __webpack_require__("jB+/");
function injectStyle (ssrContext) {
  __webpack_require__("Cj6S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49cb7ff8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+kWA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+mpZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+rbr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+sSv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("OLFD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43e3b941_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("ikqp");
function injectStyle (ssrContext) {
  __webpack_require__("LWzg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43e3b941_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+xnJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/4dZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/7Uy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"change":_vm.validate,"keyup":_vm.createUrl,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"id":"url-label"}},[_vm._v("URL")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.url),expression:"post.url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('URL')},attrs:{"type":"text","placeholder":"URL","aria-label":"URL","id":"url","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.url)},on:{"keyup":_vm.slugifyUrl,"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3"},[_c('tinymce',{class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('vue-tabs',[_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Resim"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.file,"id":"main-i"}})],1)])]),_vm._v(" "),_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"SEO"}},[_c('div',{staticClass:"row settings my-4"},[_c('div',{staticClass:"col-12 input-group px-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.metas.items.meta2.meta_value),expression:"metas.items.meta2.meta_value"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Meta Başlığı","aria-label":"Başlık","id":"title","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.metas.items.meta2.meta_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.metas.items.meta2, "meta_value", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v(" - Statik Site Başlığı")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group px-5 mt-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Meta Açıklaması")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.metas.items.meta3.meta_value),expression:"metas.items.meta3.meta_value"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.metas.items.meta3.meta_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.metas.items.meta3, "meta_value", $event.target.value)}}})])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 480, height: 270, type: 'suare'},"boundary":{width: 640, height: 360},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Da7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/H5H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        is_active: 0
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    deactivate: function deactivate(id) {
      var _this = this;

      this.toggleLoader();
      this.post.is_active = 0;
      this.$http.post('/api/job-postings/edit/' + id, this.post).then(function (response) {
        _this.notifier('top', 'right', 'warning', 'İş İlanı Yayından Kaldırıldı');
        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    activate: function activate(id) {
      var _this2 = this;

      this.toggleLoader();
      this.post.is_active = 1;
      this.$http.post('/api/job-postings/edit/' + id, this.post).then(function (response) {
        _this2.notifier('top', 'right', 'success', 'İş İlanı Yayına Alındı');
        _this2.getPosts(_this2.page, _this2.type);
        _this2.toggleLoader();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this3 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';

      this.toggleLoader();
      this.type = t;
      var url = '/api/filter/job-postings/limit/' + this.limit + '/page/' + p;

      this.$http.get(url).then(function (response) {
        _this3.table = response.body.data;
        _this3.total = response.body.meta.total;
        _this3.page = p;
        _this3.pageCount = [];
        for (var i = 0; i < _this3.total / _this3.limit; i++) {
          _this3.pageCount.push(i + 1);
        }
        _this3.toggleLoader();
      }, function (er) {
        _this3.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        _this3.toggleLoader();
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "/Iak":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      settings: {
        name: null,
        meta: {
          title: null
        },
        data: null
      },
      err: null,
      imageIndex: -1,
      image: {
        cropped: null
      },
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    getSettings: function getSettings() {
      var _this = this;

      this.toggleLoader();
      this.$http.get("/api/settings/get-history-settings/").then(function (response) {
        _this.settings = response.body;
        _this.settings.meta = JSON.parse(_this.settings.meta);

        // for (var i = 0; i < this.settings.length; i++) {
        //   this.settings[i].meta = JSON.parse(this.settings[i].meta);
        // }

        _this.toggleLoader();
      }, function (er) {

        if (!er.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this.err = er.body.Error;
          _this.notifier('top', 'right', 'danger', er.body.Error);
        }
        _this.toggleLoader();
      });
    },
    submit: function submit() {
      var _this2 = this;

      event.preventDefault();
      this.$http.post("/api/settings/update-one/", this.settings).then(function (response) {
        _this2.notifier("top", "right", "success", "Başarıyla güncellendi");
        _this2.getSettings();
      }, function (e) {
        if (!e.body.Error) {
          _this2.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        } else {
          _this2.notifier("top", "right", "danger", e.body.Error);
        }
      });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSettings();
    });
  }
});

/***/ }),

/***/ "/KKg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-7"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',[_vm._v("İzinler")]),_vm._v(" "),_vm._l((_vm.permissions),function(permission){return _c('card',{key:permission.id},[_c('div',{staticClass:"row mb-0"},[_c('div',{staticClass:"col-4 font-weight-bold"},[_vm._v("Erişilecek Kaynak")]),_vm._v(" "),_c('div',{staticClass:"col-3 font-weight-bold"},[_vm._v("İzinler")]),_vm._v(" "),_c('div',{staticClass:"col-2 font-weight-bold"},[_vm._v("Kısıtlama")]),_vm._v(" "),_c('div',{staticClass:"col-2 font-weight-bold"},[_vm._v("Eylemler")])]),_vm._v(" "),_c('div',{staticClass:"row mb-0"},[_c('div',{staticClass:"col-4"},[_vm._v(_vm._s(permission.name_tr))]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('Checkbox',{model:{value:(permission.r),callback:function ($$v) {_vm.$set(permission, "r", $$v)},expression:"permission.r"}},[_c('template',{slot:"label"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tOkuma\n\t\t\t\t\t\t\t\t\t\t\t")])],2),_vm._v(" "),_c('Checkbox',{attrs:{"readonly":permission.resource === 'Logs'},model:{value:(permission.w),callback:function ($$v) {_vm.$set(permission, "w", $$v)},expression:"permission.w"}},[_c('template',{slot:"label"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tYazma\n\t\t\t\t\t\t\t\t\t\t\t")])],2),_vm._v(" "),_c('Checkbox',{attrs:{"readonly":permission.resource === 'Logs'},model:{value:(permission.d),callback:function ($$v) {_vm.$set(permission, "d", $$v)},expression:"permission.d"}},[_c('template',{slot:"label"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tSilme\n\t\t\t\t\t\t\t\t\t\t\t")])],2)],1),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('Checkbox',{attrs:{"readonly":permission.resource === 'Logs'},model:{value:(permission.ristricted),callback:function ($$v) {_vm.$set(permission, "ristricted", $$v)},expression:"permission.ristricted"}},[_c('template',{slot:"label"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tKısıtlı İzin\n\t\t\t\t\t\t\t\t\t\t\t")])],2)],1),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('button',{staticClass:"btn btn-primary btn-fill btn-sm",on:{"click":function($event){return _vm.updatePermission(permission)}}},[_vm._v("Kaydet")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-fill btn-sm",on:{"click":function($event){return _vm.deletePermission(permission.id)}}},[_vm._v("Sil")])])]),_vm._v(" "),(permission.resource === 'Logs')?_c('label',{staticClass:"text-warning"},[_c('i',{staticClass:"fas fa-exclamation"}),_vm._v(" Sistem hareketlerine yazma ve silme izni verilemez. Kısıtlama yapılamaz")]):_vm._e()])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-5"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',[_vm._v("İzin Ekle")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('label',{staticClass:"input-group-text border-0 bg-white",attrs:{"for":"inputGroupSelect01"}},[_vm._v("Kaynak")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.resourceWithType),expression:"resourceWithType"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.resourceWithType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.resources),function(item){return _c('option',{key:item.value,domProps:{"value":item}},[_vm._v(_vm._s(item.value))])}),0)]),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_c('Checkbox',{model:{value:(_vm.newPermission.r),callback:function ($$v) {_vm.$set(_vm.newPermission, "r", $$v)},expression:"newPermission.r"}},[_c('template',{slot:"label"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tOkuma\n\t\t\t\t\t\t\t\t\t")])],2),_vm._v(" "),_c('Checkbox',{attrs:{"readonly":_vm.newPermission.resource === 'Logs'},model:{value:(_vm.newPermission.w),callback:function ($$v) {_vm.$set(_vm.newPermission, "w", $$v)},expression:"newPermission.w"}},[_c('template',{slot:"label"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tYazma\n\t\t\t\t\t\t\t\t\t")])],2),_vm._v(" "),_c('Checkbox',{attrs:{"readonly":_vm.newPermission.resource === 'Logs'},model:{value:(_vm.newPermission.d),callback:function ($$v) {_vm.$set(_vm.newPermission, "d", $$v)},expression:"newPermission.d"}},[_c('template',{slot:"label"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tSilme\n\t\t\t\t\t\t\t\t\t")])],2),_vm._v(" "),_c('Checkbox',{attrs:{"readonly":_vm.newPermission.resource === 'Logs'},model:{value:(_vm.newPermission.ristricted),callback:function ($$v) {_vm.$set(_vm.newPermission, "ristricted", $$v)},expression:"newPermission.ristricted"}},[_c('template',{slot:"label"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tKısıtlı izin\n\t\t\t\t\t\t\t\t\t")])],2),_vm._v(" "),(_vm.newPermission.resource === 'Logs')?_c('label',{staticClass:"text-warning"},[_c('i',{staticClass:"fas fa-exclamation"}),_vm._v(" Sistem hareketlerine yazma ve silme izni verilemez. Kısıtlama yapılamaz")]):_vm._e()],1),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){return _vm.savePermission()}}},[_vm._v("Ekle")])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[(_vm.newPermission.resource)?_c('label',{staticClass:"text-info"},[_c('i',{staticClass:"fas fa-exclamation"}),_vm._v(" Kullanıcının bir kaynağa erişimini açtığınız zaman. O kaynağa bağlı bazı diğer kaynaklara da erişim izni kazanabilir.")]):_vm._e()])])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Lme":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/URD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Ug1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/dCU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubBoards_vue__ = __webpack_require__("44lS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b6dbed4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubBoards_vue__ = __webpack_require__("qSbS");
function injectStyle (ssrContext) {
  __webpack_require__("xmGu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubBoards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b6dbed4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubBoards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/hgj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("NI8N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5337382_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("evSb");
function injectStyle (ssrContext) {
  __webpack_require__("i7fd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5337382_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/s7h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("ID+a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06d286f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("FDgi");
function injectStyle (ssrContext) {
  __webpack_require__("7iB3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06d286f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/yJn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      publishTime: null,
      futurePost: false,
      socialMedia: true,
      // post data
      currency1: '',
      currency2: '',
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'Sayfa',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          },
          meta4: {
            meta_key: 'view_count',
            meta_value: 0
          }
        }
      },
      content: {
        content: null
      },
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    setName: function setName() {
      this.post.name = this.currency1 + '/' + this.currency2;
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.currency1) {
        this.errors.push("Para Birimi");
      };
      if (!this.post.url) {
        this.errors.push("URL");
      };
      if (!this.currency2) {
        this.errors.push("Karşı Para Birimi");
      };
      if (!this.content.content) {
        this.errors.push("Kısa Açıklama");
      };
      if (!this.metas.items.meta2.meta_value) {
        this.errors.push("Site Başlığı");
      };
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
        _this.saveContent();
      });
    },
    saveContent: function saveContent() {
      var _this2 = this;

      var button = event.target;
      if (this.content.content) {
        this.$http.post('/api/contents/add', this.content).then(function (response) {
          _this2.post.content_id = response.body.Data.Response.id;
          _this2.savePost();
        }, function (e) {
          button.innerHTML = 'Kaydet';
          _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this2.toggleLoader();
        });
      } else {
        this.savePost();
      }
    },
    savePost: function savePost() {
      var _this3 = this;

      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.$http.post('/api/posts/add', this.post).then(function (response) {
        _this3.metas.post_id = response.body.Data.Response.id;
        _this3.saveMetas();
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this3.toggleLoader();
      });
    },
    saveMetas: function saveMetas() {
      var _this4 = this;

      this.$http.post('/api/post-metas/add-bulk', this.metas).then(function (response) {
        _this4.notifier('top', 'right', 'success', 'Başarılı');
        _this4.$router.push('/main');
        _this4.toggleLoader();
      }, function (e) {
        _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this4.toggleLoader();
      });
    },
    slugifyUrl: function slugifyUrl() {
      this.post.url = this.slugify(this.post.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this5 = this;

        request.$http.get('/api/filter/posts/url/' + request.post.url).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this5.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    }
  }
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0016":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewSubscriber_vue__ = __webpack_require__("+SvU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db6c5e8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewSubscriber_vue__ = __webpack_require__("Kea2");
function injectStyle (ssrContext) {
  __webpack_require__("ZTIy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewSubscriber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db6c5e8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewSubscriber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "04S3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "068J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{attrs:{"id":"app"}},[_c('vue-dropzone',{ref:"dropzone",attrs:{"id":"drop1","options":_vm.dropOptions},on:{"vdropzone-complete-multiple":_vm.afterComplete}})],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("Galeri \n              "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"})]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("Resim boyutu 1600 x 1200 pixel")]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-11"},[_c('img',{staticClass:"img-fluid",attrs:{"width":"150px","src":_vm.mediaURL() + item.image}})]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn btn-sm ",attrs:{"title":"Slider Resmini Değiştir"},on:{"click":function($event){return _vm.initiateCroppie(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 border border-secondary p-2 d-none",attrs:{"src":_vm.newSliderImage.cropped}})])])])])}),0)],1)],1)])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 688, height: 400, type: 'suare'},"boundary":{width: 700, height: 425},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "087A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("NN78");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3708a089_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("aWsS");
function injectStyle (ssrContext) {
  __webpack_require__("nakg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3708a089_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "096f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostModules_ComingFromYou_Index_vue__ = __webpack_require__("vcPX");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostsTable: __WEBPACK_IMPORTED_MODULE_0__PostModules_ComingFromYou_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "0AsC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__ = __webpack_require__("MDnB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4078fa7b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__ = __webpack_require__("r5Uy");
function injectStyle (ssrContext) {
  __webpack_require__("D0Sq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4078fa7b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0Bjw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0C+u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/leader'}}},[_c('button',{staticClass:"btn btn-info btn-sm active px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("İçerik")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/gallery'}}},[_c('button',{staticClass:"btn btn-warning btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Fotogaleri")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/pressgallery'}}},[_c('button',{staticClass:"btn btn-danger btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Yazılı Basın")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/articles'}}},[_c('button',{staticClass:"btn btn-success btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Başkanın Yazıları")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/articlesorder'}}},[_c('button',{staticClass:"btn btn-primary btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Yazı Sıralama")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/digital-press'}}},[_c('button',{staticClass:"btn btn-secondary btn-sm  mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Dijital Basın")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/digital-press-order'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Dijital Basın Sıralama")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('form',{staticClass:"w-100",on:{"submit":_vm.saveImage}},[(!_vm.err)?_c('div',[_c('h1',{staticClass:"h4 mt-0 d-flex justify-content-between"},[_c('span',[_vm._v("Başkanın Bölümü")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-sm btn-fill",attrs:{"type":"submit"}},[_vm._v("Kaydet")])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.settings),function(item){return _c('div',{key:item.id,class:{ 'col-md-6': !item.meta.isimage,'col-md-12':item.meta.isimage}},[_c('div',{staticClass:"d-flex flex-column"},[_c('label',{class:item.meta.labelClass,attrs:{"id":item.meta.id,"for":item.name}},[(!item.meta.isimage)?_c('span',{staticClass:"title"},[_vm._v(_vm._s(item.meta.title))]):_vm._e(),_vm._v(" "),(item.meta.subTitle)?_c('span',[_vm._v("("+_vm._s(item.meta.subTitle)+")")]):_vm._e()]),_vm._v(" "),((item.meta.type)==='checkbox'&&(!item.meta.isimage))?_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.data),expression:"item.data"}],staticClass:"form-control",class:item.meta.class,attrs:{"disabled":item.meta.disabled,"id":item.name,"type":"checkbox"},domProps:{"checked":Array.isArray(item.data)?_vm._i(item.data,null)>-1:(item.data)},on:{"change":function($event){var $$a=item.data,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "data", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "data", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "data", $$c)}}}}):((item.meta.type)==='radio'&&(!item.meta.isimage))?_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.data),expression:"item.data"}],staticClass:"form-control",class:item.meta.class,attrs:{"disabled":item.meta.disabled,"id":item.name,"type":"radio"},domProps:{"checked":_vm._q(item.data,null)},on:{"change":function($event){return _vm.$set(item, "data", null)}}}):(!item.meta.isimage)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.data),expression:"item.data"}],staticClass:"form-control",class:item.meta.class,attrs:{"disabled":item.meta.disabled,"id":item.name,"type":item.meta.type},domProps:{"value":(item.data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "data", $event.target.value)}}}):_vm._e()]),_vm._v(" "),(item.meta.isimage)?_c('div',{staticClass:"row text-right"},[_c('div',{staticClass:"col-8 col-md-8 m-3 d-flex align-items-center justify-content-between"},[_c('div',{staticClass:"d-flex flex-column align-items-center"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(item.meta.title))]),_vm._v(" "),(_vm.image.cropped)?_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",attrs:{"src":_vm.image.cropped}}):_vm._e(),_vm._v(" "),(!_vm.image.cropped)?_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",attrs:{"src":_vm.mediaURL() + item.data}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column"},[_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("400 x 450 pixel")]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")])],1)]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",refInFor:true,attrs:{"enable-resize":false,"viewport":{width: 300, height: 338, type: 'suare'},"boundary":{width: 360, height: 405},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1):_vm._e()])}),0)]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n"+_vm._s(_vm.err)+"\n")]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Emb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/races'}}},[_c('button',{staticClass:"btn btn-warning btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Yarışlar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/seasons'}}},[_c('button',{staticClass:"btn btn-info  btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Sezonlar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/members'}}},[_c('button',{staticClass:"btn btn-danger active btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Üyeler")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('div',[_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Ad Soyad")]),_vm._v(" "),_c('th',[_vm._v("Branş")]),_vm._v(" "),_c('th',[_vm._v("Kategori")]),_vm._v(" "),_c('th',[_vm._v("Opsiyonel Kategori")]),_vm._v(" "),_c('th',[_vm._v("Doğum Tarihi")]),_vm._v(" "),_c('th',[_vm._v("Cinsiyet")]),_vm._v(" "),_c('th',[_vm._v("Telefon No")]),_vm._v(" "),_c('th',[_vm._v("Kimlik No")]),_vm._v(" "),_c('th',[_vm._v("Lisans")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.user.athletes),function(athletes,key){return _c('tr',{key:key},[_c('td',[_vm._v(_vm._s(athletes.name)+" "+_vm._s(athletes.surname))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(athletes.branch))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(athletes.category))]),_vm._v(" "),_c('td',[(athletes.optionalCategory)?_c('span',[_vm._v(_vm._s(athletes.optionalCategory))]):_vm._e(),_vm._v(" "),(!athletes.optionalCategory)?_c('span',[_vm._v("Seçilmedi")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(athletes.birthdate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(athletes.gender))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(athletes.phone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(athletes.tc))]),_vm._v(" "),_c('td',[(athletes.license)?_c('a',{staticClass:"ml-3",attrs:{"href":_vm.license(athletes.license),"target":"_blank"}},[_vm._v("Lisans Aç")]):_vm._e()])])}),0)])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0FOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "0MD3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Directors_vue__ = __webpack_require__("RoxM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e301a076_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Directors_vue__ = __webpack_require__("aBO7");
function injectStyle (ssrContext) {
  __webpack_require__("gppO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Directors_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e301a076_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Directors_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0RVX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Eğitim Düzenle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"url-label"}},[_vm._v("URL")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.url),expression:"post.url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('URL')},attrs:{"type":"text","placeholder":"URL","aria-label":"URL","id":"url","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.url)},on:{"keyup":_vm.slugifyUrl,"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3  d-flex flex-column align-items-end"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],staticClass:"btn btn-primary btn-sm btn-fill",staticStyle:{"margin-bottom":"-34px","z-index":"2"},on:{"click":function($event){return _vm.initiateCroppie('tinymce')}}},[_vm._v("Resim Ekle")]),_vm._v(" "),_c('tinymce',{class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('vue-tabs',[_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Resim"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.file,"id":"main-i"}})],1)])]),_vm._v(" "),_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Video"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 input-group px-5 m-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Video Adresi")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.video.video_url),expression:"video.video_url"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"https://www.youtube.com/watch?v=KZzON_7EQ70","aria-label":"Başlık","id":"title","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.video.video_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.video, "video_url", $event.target.value)}}})])])]),_vm._v(" "),_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"SEO"}},[_c('div',{staticClass:"row settings my-4"},[_c('div',{staticClass:"col-12 input-group px-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.metas.items.meta2.meta_value),expression:"metas.items.meta2.meta_value"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Meta Başlığı","aria-label":"Başlık","id":"title","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.metas.items.meta2.meta_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.metas.items.meta2, "meta_value", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v(" - Statik Site Başlığı")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group px-5 mt-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Meta Açıklaması")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.metas.items.meta3.meta_value),expression:"metas.items.meta3.meta_value"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.metas.items.meta3.meta_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.metas.items.meta3, "meta_value", $event.target.value)}}})])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 480, height: 270, type: 'suare'},"boundary":{width: 640, height: 360},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0VlS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0W4T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('posts-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0XqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stats-card',
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0__Card_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "0aOW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0ffJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0iFY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Dosya Seç")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata\n        ")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"d-flex justify-content-around w-100 align-items-center"},[_c('label',{staticClass:"ml-4 btn btn-lg btn-danger mb-0",attrs:{"for":"excel"}},[_vm._v("Dosya Seç")]),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","id":"excel"},on:{"change":function($event){return _vm.uploadExcel($event)}}}),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])])]),_vm._v(" "),(_vm.content.content)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"container"},[_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('thead',{staticClass:"thead-dark"},_vm._l((_vm.content.content.head),function(item,index){return _c('th',{key:index},[_vm._v(_vm._s(item))])}),0),_vm._v(" "),_c('tbody',_vm._l((_vm.content.content.values),function(item,index){return _c('tr',{key:index},_vm._l((item),function(value,key){return _c('td',{key:key},[_vm._v("\n            "+_vm._s(value)+"\n          ")])}),0)}),0)])])]):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0jKv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      videoupdated: false,
      publishTime: null,
      futurePost: false,
      socialMedia: true,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'News',
        image: null,
        newvideo: null,
        newvideo_id: null,
        content_id: null,
        video_id: null
      },
      order: {
        post_id: null,
        slider_group: "News",
        is_active: 1
      },
      categories: null,
      category: {
        category_id: "",
        name: null,
        url: null,
        is_active: 1
      },
      subCategories: null,
      disableParent: false,
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          },
          meta4: {
            meta_key: 'view_count',
            meta_value: 0
          }
        }
      },
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        cropped: null
      },
      sliderImage: {
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post('/api/images/upload/' + this.post.url + '_inner-image', {
        cropped: i
      }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + _this.post.url + '" />';
      }, function (e) {
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push('Başlık');
      }
      if (!this.post.category_id) {
        this.errors.push('Kategori');
      }
      if (!this.post.sub_category_id) {
        this.errors.push('Alt Kategori');
      }
      if (!this.post.url) {
        this.errors.push('URL');
      }
      if (!this.content.content) {
        this.errors.push('İçerik');
      }
      if (!this.image.cropped) {
        this.errors.push('Resim');
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    uploadPdf: function uploadPdf(event) {
      var _this2 = this;

      this.file = event.target.files[0];
      if (this.file.type !== "application/pdf") {
        this.notifier('top', 'right', 'danger', 'Lütfen excel formatında bir dosya seçiniz');
      } else {
        var data = new FormData();
        data.append("file", this.file);
        var fileName = this.file.name.split(".");
        var extension = "";
        var newName = "";
        fileName.forEach(function (e, index) {
          if (index < fileName.length - 1) {
            newName += e;
          }
          if (index == fileName.length - 1) {
            extension += e;
          }
        });
        newName += new Date().getTime();
        var fullName = newName + "." + extension;
        data.append("fileName", fullName);
        this.$http.post("/api/files/upload-news-pdf/" + fullName, data).then(function (response) {
          _this2.post.link = fullName;
          _this2.notifier("top", "right", "success", "Pdf başarıyla kaydedildi");
        }, function (er) {
          _this2.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        });
      }
    },
    save: function save() {
      var _this3 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this3.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this3.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'
        _this3.saveContent();
      });
    },
    saveContent: function saveContent() {
      var _this4 = this;

      var button = event.target;
      this.$http.post('/api/contents/add', this.content).then(function (response) {
        _this4.post.content_id = response.body.Data.Response.id;
        _this4.saveVideo();
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this4.toggleLoader();
      });
    },
    saveVideo: function saveVideo() {
      var _this5 = this;

      if (this.video.video_url !== null) {

        this.$http.post('/api/videos/add', this.video).then(function (response) {
          _this5.post.video_id = response.body.Data.Response.name;
          _this5.saveImage();
        }, function (e) {
          _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this5.toggleLoader();
        });
      } else {
        this.saveImage();
      }
    },
    saveImage: function saveImage() {
      var _this6 = this;

      this.$http.post('/api/images/upload/' + this.post.url, this.image).then(function (response) {
        _this6.post.image = response.body.Data.Response.name;
        _this6.savePost();
      }, function (e) {
        _this6.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this6.toggleLoader();
      });
    },

    savePost: function savePost() {
      var _this7 = this;

      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      if (this.videoupdated) {
        this.post.video = this.video;
      } else {
        this.post.video = null;
      }
      if (this.post.newvideo) {

        var newvideo_id = this.post.newvideo.split('v=')[1];
        var ampersandPosition = newvideo_id.indexOf('&');
        if (ampersandPosition != -1) {
          newvideo_id = newvideo_id.substring(0, ampersandPosition);
        }
        this.post.newvideo_id = newvideo_id;
      }
      this.$http.post('/api/posts/add', this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this7.post.id = pid;
        _this7.metas.post_id = pid;
        _this7.order.post_id = pid;
        _this7.saveOrder();
      }, function (e) {
        _this7.toggleLoader();

        if (!e.body.Error) {
          _this7.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {

          _this7.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveOrder: function saveOrder() {
      var _this8 = this;

      if (this.allposts && this.allposts.length) {
        this.order.order_number = this.allposts.length;
      } else {
        this.order.order_number = 0;
      }
      this.$http.post("/api/slider/add/News", this.order).then(function (response) {
        _this8.saveMetas();
        _this8.notifier("top", "right", "success", "Başarılı");
      }, function (e) {
        _this8.toggleLoader();
        _this8.notifier("top", "right", "danger", "Bir Hata Oluştu");
      });
    },
    saveMetas: function saveMetas() {
      var _this9 = this;

      this.$http.post('/api/post-metas/add-bulk', this.metas).then(function (response) {
        _this9.notifier('top', 'right', 'success', 'Başarılı');
        _this9.$router.push('/news');
        _this9.toggleLoader();
      }, function (e) {
        _this9.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this9.toggleLoader();
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name) + '-' + this.post.category_id + '-' + this.post.sub_category_id;
    },
    slugifyUrl: function slugifyUrl() {
      this.post.url = this.slugify(this.post.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    allPosts: function allPosts() {
      var _this10 = this;

      this.$http.get("/api/posts/get-with-type/News").then(function (response) {
        _this10.allposts = response.body;
      }, function (er) {
        _this10.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        _this10.toggleLoader();
      });
    },
    loadItems: function loadItems() {
      var _this11 = this;

      this.subCategories = null;
      this.createUrl();
      this.$http.get('/api/sub-categories/getsubcategories/' + this.post.category_id).then(function (response) {

        _this11.subCategories = response.body;
        _this11.createUrl();
      }, function (er) {
        _this11.toggleLoader();
        _this11.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this12 = this;

        request.$http.get('/api/filter/posts/url/' + request.post.url).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this12.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.url) {
        this.croppieType = type;
      } else {
        this.notifier('top', 'right', 'danger', 'Resim ekleyebilmek için bir başlık belirlemelisiniz.');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById('myImage').files.length) {
        oFReader.readAsDataURL(document.getElementById('myImage').files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this13 = this;

      var dis = this;
      var wdt = 600;
      var hgt = 450;
      if (this.croppieType === 'tinymce') {
        wdt = 600;
        hgt = 450;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: wdt,
            height: hgt
          },

          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this13.croppieType === 'main') {
            dis.image.cropped = output;
          } else if (_this13.croppieType === 'slider') {
            dis.sliderImage.cropped = output;
            dis.sliderImageLoaded = true;
          } else if (_this13.croppieType === 'tinymce') {
            _this13.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this13.addImageToEditor(output);
          }
          _this13.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    var _this14 = this;

    this.allPosts();
    if (this.post.video) {
      this.video = this.post.video;
    } else {
      this.post.video = {
        video_url: null
      };
    }
    this.$http.get('/api/categories/all').then(function (response) {
      _this14.categories = response.body;
    }, function (er) {
      _this14.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
      _this14.toggleLoader();
    });
  }

});

/***/ }),

/***/ "1+T5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "16UY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "18G7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Yazı Ekle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata\n        ")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('small',[_vm._v("Resim Boyutu 1600x1200")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"change":_vm.validate,"keyup":_vm.createUrl,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"url-label"}},[_vm._v("URL")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.url),expression:"post.url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('URL')},attrs:{"type":"text","placeholder":"URL","aria-label":"URL","id":"url","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.url)},on:{"keyup":_vm.slugifyUrl,"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3 d-flex flex-column align-items-end"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],staticClass:"btn btn-primary btn-sm btn-fill",staticStyle:{"margin-bottom":"-34px","z-index":"2"},on:{"click":function($event){return _vm.initiateCroppie('tinymce')}}},[_vm._v("Resim Ekle")]),_vm._v(" "),_c('tinymce',{class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}}),_vm._v(" "),_c('label',{staticClass:"btn btn-primary btn-fill mt-3",attrs:{"for":"pdf"}},[_vm._v("PDF Ekle")]),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","id":"pdf"},on:{"change":function($event){return _vm.uploadPdf($event)}}})],1)]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 450, height: 300, type: 'suare'},"boundary":{width: 600, height: 450},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1Aya":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Races_vue__ = __webpack_require__("nTpl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62901b80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Races_vue__ = __webpack_require__("as5a");
function injectStyle (ssrContext) {
  __webpack_require__("lLQs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Races_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62901b80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Races_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1Dgy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1KkG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1L4k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("4pyR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fef2708c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("fonp");
function injectStyle (ssrContext) {
  __webpack_require__("/URD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fef2708c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1S5a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1YMZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("Xdm/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49cd44e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("81NY");
function injectStyle (ssrContext) {
  __webpack_require__("jG28")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49cd44e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1ZkG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1gd4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1gvC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			permissions: null,
			resourceWithType: {},
			newPermission: {
				user_id: this.$route.params.id,
				resource: null,
				ristricted: false,
				type: null,
				nameTr: null,
				r: false,
				w: false,
				d: false
			},
			resources: [{ id: 'Images', type: 'homeslide', value: 'Anasayfa Slider' }, { id: 'Settings', type: 'introvideo', value: 'İntro Videosu' }, { id: 'Posts', type: 'Homeboxes', value: 'Anasayfa Kutular' }, { id: 'Posts', type: 'Homeinfos', value: 'Anasayfa Bilgiler' }, { id: 'Posts', type: 'Announcements', value: 'Anasayfa Duyurular' }, { id: 'Images', type: 'directors', value: 'Yönetim Kurulu' }, { id: 'Images', type: 'staffs', value: 'Federasyon Personeli' }, { id: 'Images', type: 'allleaders', value: 'Başkanlarımız' }, { id: 'Settings', type: 'history', value: 'Tarihçe' }, { id: 'Categories', type: 'subboards', value: 'Alt Kurullar' }, { id: 'Images', type: 'subboards', value: 'Alt Kurullar(Kişiler)' }, { id: 'Images', type: 'provincialoffices', value: 'İl Temsilcilikleri' }, { id: 'Posts', type: 'BankInformations', value: 'Hesap Numaraları' }, { id: 'Images', type: 'mainstatusinstructions', value: 'Ana Statü Talimatlar' }, { id: 'Settings', type: 'leadername', value: 'Başkanın Bölümü-İçerik' }, { id: 'Images', type: 'leadergallery', value: 'Başkanın Bölümü-Fotogaleri' }, { id: 'Images', type: 'pressgallery', value: 'Başkanın Bölümü-Yazılı Basın' }, { id: 'Posts', type: 'LeaderArticles', value: 'Başkanın Bölümü-Başkanın Yazıları' }, { id: 'Slider', type: 'LeaderArticles', value: 'Başkanın Bölümü-Yazı Sıralama' }, { id: 'Posts', type: 'DigitalPress', value: 'Başkanın Bölümü-Dijital Basın' }, { id: 'Slider', type: 'DigitalPress', value: 'Başkanın Bölümü-Dijital Basın Sıralama' }, { id: 'Images', type: 'sitegallery', value: 'Galeri' }, { id: 'Images', type: 'videogallery', value: 'Video Galeri' }, { id: 'Categories', type: 'reports', value: 'Bildiri Kategorileri' }, { id: 'Categories', type: 'news', value: 'Haber Kategorileri' }, { id: 'Posts', type: 'Races', value: 'Yarışlar' }, { id: 'Race', type: null, value: 'Yarış Başvuruları' }, { id: 'Categories', type: 'seasons', value: 'Yarış Sezonları' }, { id: 'Users', type: 3, value: 'Üyeler' }, { id: 'Posts', type: 'News', value: 'Bildiriler' }, { id: 'Slider', type: 'News', value: 'Bildiri Sıralama' }, { id: 'Posts', type: 'Allnews', value: 'Haberler' }, { id: 'Slider', type: 'Allnews', value: 'Haber Sıralaması' }, { id: 'Posts', type: 'ComingFromYou', value: 'Sizden Gelenler' }, { id: 'Settings', type: 'comingfromyou', value: 'Gönderi Oluştur İçerik' }, { id: 'Slider', type: 'Featured', value: 'Vitrin' }, { id: 'Posts', type: 'Activityprogrampage', value: 'Faaliyet Programı' }, { id: 'Posts', type: 'Cuppointpage', value: 'Kupa Puanları' }, { id: 'Settings', type: 'activityprogram', value: 'Faaliyet Programı İçerik' }, { id: 'Posts', type: 'Informationbankspage', value: 'Bilgi Bankası' }, { id: 'Settings', type: 'informationbank', value: 'Bilgi Bankası İçerik' }, { id: 'Posts', type: 'Facilities', value: 'Tesisler' }, { id: 'Posts', type: 'ActivityProgram', value: 'Excel Yüklemeleri' }, { id: 'Users', type: 2, value: 'Kullanıcılar' }, { id: 'Settings', type: 'GeneralSettings', value: 'Genel Site Ayarları' }]
		};
	},
	components: {
		Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
		Checkbox: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */]
	},
	methods: {
		getPermissions: function getPermissions() {
			var _this = this;

			this.toggleLoader();
			this.$http.get('/api/user-permissions/get/' + this.newPermission.user_id).then(function (response) {
				_this.permissions = response.body;
				_this.toggleLoader();
			}, function (er) {
				_this.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
				_this.toggleLoader();
			});
		},
		nothing: function nothing() {
			return false;
		},
		savePermission: function savePermission() {
			var _this2 = this;

			this.newPermission.resource = this.resourceWithType.id;
			this.newPermission.nameTr = this.resourceWithType.value;
			if (this.resourceWithType.type) {
				this.newPermission.type = this.resourceWithType.type;
			} else {
				this.newPermission.type = null;
			}
			this.toggleLoader();
			this.$http.post('/api/user-permissions/add/', this.newPermission).then(function (response) {
				_this2.toggleLoader();
				_this2.notifier('top', 'right', 'success', 'İzinler Başarıyla Kaydedildi');
				_this2.getPermissions();
				_this2.newPermission = {
					user_id: _this2.$route.params.id,
					resource: null,
					ristricted: false,
					type: null,
					nameTr: null,
					r: false,
					w: false,
					d: false
				};
			}, function (e) {
				_this2.toggleLoader();
				_this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
			});
		},
		updatePermission: function updatePermission(prm) {
			var _this3 = this;

			this.toggleLoader();
			delete prm.user;
			delete prm.created;
			delete prm.modified;
			var id = prm.id;
			delete prm.id;
			this.$http.post('/api/user-permissions/edit/' + id, prm).then(function (response) {
				_this3.toggleLoader();
				_this3.notifier('top', 'right', 'success', 'İzinler Başarıyla Güncellendi');
				_this3.getPermissions();
			}, function (e) {
				_this3.toggleLoader();
				_this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
			});
		},
		deletePermission: function deletePermission(id) {
			var _this4 = this;

			this.toggleLoader();
			this.$http.delete('/api/user-permissions/delete/' + id).then(function (response) {
				_this4.toggleLoader();
				_this4.notifier('top', 'right', 'danger', 'Kullanıcı İzni Silindi');
				_this4.getPermissions();
			}, function (e) {
				_this4.toggleLoader();
				_this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
			});
		}
	},
	mounted: function mounted() {
		this.$nextTick(function () {
			this.getPermissions();
		});
	}
});

/***/ }),

/***/ "1hF9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      featuredTitles: [{
        key: "bellow_slider_1",
        title: null,
        details: null,
        link: null,
        image: null
      }, {
        key: "bellow_slider_2",
        title: null,
        details: null,
        link: null,
        image: null
      }, {
        key: "bellow_slider_3",
        title: null,
        details: null,
        link: null,
        image: null
      }],
      slider: {
        post_id: null,
        slider_group: "Allnews",
        order_number: null,
        is_active: 1
      },
      selectedType: null,
      types: ["URL", "Kategori", "Alt Kategori", "Yayın", "Etiket"],
      options: [],
      sliderItems: null,
      newFeaturedImage: {
        featured_id: null,
        cropped: null
      },
      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "all",
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      this.toggleLoader();
      this.$http.delete("/api/slider/delete/" + id).then(function (response) {
        _this.notifier("top", "right", "warning", "Menu elemanı silindi");
        _this.getSlider();
        _this.toggleLoader();
      }, function (e) {
        _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this.toggleLoader();
      });
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post("/api/images/upload/boxes-under-slider-" + this.newFeaturedImage.id, this.newFeaturedImage).then(function (response) {
        _this2.featuredTitles[_this2.newFeaturedImage.id].image = response.body.Data.Response.name;
        _this2.hideCroppieModal();
        document.getElementById("submit-image").innerHTML = "Kaydet";
        _this2.toggleLoader();
      }, function (e) {
        _this2.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this2.toggleLoader();
      });
    },
    loadItems: function loadItems() {
      var _this3 = this;

      this.options = [];
      this.toggleLoader();
      var url = "/api/posts/latest";
      this.$http.get(url).then(function (response) {
        response = response.body;
        for (var i = 0; i < response.length; i++) {
          var temp = { value: response[i].id, text: response[i].name };
          _this3.options.push(temp);
        }
        _this3.toggleLoader();
      }, function (er) {
        _this3.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        _this3.toggleLoader();
      });
    },
    loadFeaturedTitles: function loadFeaturedTitles() {
      var _this4 = this;

      this.toggleLoader();
      this.$http.get("/api/settings/get-featured-under-slider").then(function (response) {
        var settings = response.body;
        _this4.featuredTitles = [];
        for (var i = 0; i < settings.length; i++) {
          var jsonData = JSON.parse(settings[i].data);
          jsonData.key = "bellow_slider_" + (i + 1);
          _this4.featuredTitles.push(jsonData);
        }
        _this4.toggleLoader();
      }, function (er) {
        _this4.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        _this4.toggleLoader();
      });
    },
    update: function update(id) {
      var _this5 = this;

      this.$http.post("/api/slider/edit/", this.sliderItems).then(function (response) {
        _this5.notifier("top", "right", "success", "Sıralama güncellendi");
      }, function (e) {
        if (!e.body.Error) {
          _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this5.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    save: function save(id) {
      var _this6 = this;

      this.toggleLoader();
      this.$http.post("/api/slider/add/Allnews", this.slider).then(function (response) {
        _this6.getSlider();
        _this6.toggleLoader();
        _this6.notifier("top", "right", "success", "Başarılı");
      }, function (e) {
        _this6.toggleLoader();
        if (!e.body.Error) {
          _this6.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this6.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveSettings: function saveSettings() {
      var _this7 = this;

      this.toggleLoader();
      this.$http.post("/api/settings/edit-bulk/", this.featuredTitles).then(function (response) {
        _this7.toggleLoader();
        _this7.notifier("top", "right", "success", "Başarılı");
      }, function (e) {
        _this7.toggleLoader();
        if (!e.body.Error) {
          _this7.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this7.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    getSlider: function getSlider() {
      var _this8 = this;

      this.toggleLoader();
      var url = "/api/slider/all/Allnews";
      this.$http.get(url).then(function (response) {
        _this8.sliderItems = response.body;
        if (_this8.sliderItems.length > 0) {
          _this8.slider.order_number = _this8.sliderItems[0].order_number + 1;
          _this8.slider.post_id = 0;
        } else {
          _this8.slider.order_number = 0;
        }
        _this8.toggleLoader();
      }, function (er) {
        _this8.toggleLoader();

        if (!er.body.Error) {
          _this8.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this8.err = er.body.Error;
          _this8.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    initiateCroppie: function initiateCroppie(id) {
      this.newFeaturedImage.id = id;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById("new-post").classList.contains("d-none")) {
        document.getElementById("new-post").classList.remove("d-none");
      } else {
        document.getElementById("new-post").classList.add("d-none");
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {
      document.getElementById("submit-image").innerHTML = "<i class='fas fa-circle-notch fa-spin'></i>";
      this.crop();
    },
    crop: function crop() {
      var _this9 = this;

      var dis = this;
      this.toggleLoader();
      var color = "#e17d00";
      if (this.newFeaturedImage.id === 0) {
        color = "#dc3545";
      } else if (this.newFeaturedImage.id === 1) {
        color = "#17a2b8";
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: "jpeg",
          size: {
            width: 277,
            height: 244
          },
          backgroundColor: color,
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this9.newFeaturedImage.cropped = output;
          _this9.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
      this.loadItems();
      this.loadFeaturedTitles();
    });
  }
});

/***/ }),

/***/ "1l9q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      settings: {
        name: null,
        meta: {
          title: null
        },
        data: null
      },
      imageIndex: -1,
      image: {
        cropped: null
      },
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      },
      err: null
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    getSettings: function getSettings() {
      var _this = this;

      this.toggleLoader();
      this.$http.get("/api/settings/get-activity-program/").then(function (response) {
        _this.settings = response.body;
        _this.settings.meta = JSON.parse(_this.settings.meta);

        // for (var i = 0; i < this.settings.length; i++) {
        //   this.settings[i].meta = JSON.parse(this.settings[i].meta);
        // }

        _this.toggleLoader();
      }, function (er) {
        if (!er.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this.err = er.body.Error;
          _this.notifier('top', 'right', 'danger', er.body.Error);
        }
        _this.toggleLoader();
      });
    },
    submit: function submit() {
      var _this2 = this;

      event.preventDefault();
      this.$http.post("/api/settings/update-one/", this.settings).then(function (response) {
        _this2.notifier("top", "right", "success", "Başarıyla güncellendi");
        _this2.getSettings();
      }, function (e) {
        if (!e.body.Error) {
          _this2.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        } else {
          _this2.notifier("top", "right", "danger", e.body.Error);
        }
      });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSettings();
    });
  }
});

/***/ }),

/***/ "1lSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__ = __webpack_require__("Ond/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");



/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

var GlobalComponents = {
  install: function install(Vue) {
    Vue.component('fg-input', __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */]);
    Vue.component('drop-down', __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),

/***/ "1ror":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("KyLj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eda1399_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("o/oS");
function injectStyle (ssrContext) {
  __webpack_require__("B1pu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eda1399_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2/Dm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "24Yu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('posts-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "28ys":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_v_tooltip__ = __webpack_require__("VN6J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notifyjs__ = __webpack_require__("1SRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_notifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globalComponents__ = __webpack_require__("1lSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globalDirectives__ = __webpack_require__("+KYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UIComponents_SidebarPlugin__ = __webpack_require__("Crv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifyjs_themes_default_scss__ = __webpack_require__("Sczw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifyjs_themes_default_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_notifyjs_themes_default_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_sass_light_bootstrap_dashboard_scss__ = __webpack_require__("/4dZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_sass_light_bootstrap_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_sass_light_bootstrap_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_demo_css__ = __webpack_require__("947H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_demo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_css_demo_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_es6_promise_auto__);

// Notifications plugin

// A plugin file where you could register global components used across the app

// A plugin file where you could register global directives

// Sidebar on the right. Used as a local plugin in DashboardLayout.vue


// asset imports





// library auto imports


/**
 * This is the main Light Bootstrap Dashboard Vue plugin where dashboard related plugins are registerd.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.use(__WEBPACK_IMPORTED_MODULE_2__globalComponents__["a" /* default */]);
    Vue.use(__WEBPACK_IMPORTED_MODULE_3__globalDirectives__["a" /* default */]);
    Vue.use(__WEBPACK_IMPORTED_MODULE_4__components_UIComponents_SidebarPlugin__["a" /* default */]);
    Vue.use(__WEBPACK_IMPORTED_MODULE_1_vue_notifyjs___default.a);
    Vue.use(__WEBPACK_IMPORTED_MODULE_0_v_tooltip__["a" /* default */]);
  }
});

/***/ }),

/***/ "2ByX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Staffs_vue__ = __webpack_require__("QTl8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea833160_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Staffs_vue__ = __webpack_require__("76Qd");
function injectStyle (ssrContext) {
  __webpack_require__("hY3A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Staffs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea833160_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Staffs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2JBm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AllLeadersModules_AllLeaders_vue__ = __webpack_require__("W172");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__AllLeadersModules_AllLeaders_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "2Ll6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2N6X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2TPd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RaceCategoryModules_Main_vue__ = __webpack_require__("P3v9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__RaceCategoryModules_Main_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "2aTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__ = __webpack_require__("zTLC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f2e6f78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__ = __webpack_require__("KZhD");
function injectStyle (ssrContext) {
  __webpack_require__("M08G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f2e6f78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2jDg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        siralama: null
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    deactivate: function deactivate(id) {
      var _this = this;

      this.toggleLoader();
      this.post.sure = 999999;
      this.$http.post('/api/archive/edit/' + id, this.post).then(function (response) {
        _this.notifier('top', 'right', 'warning', 'Silindi');
        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this2 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';

      this.toggleLoader();
      this.type = t;
      var url = '/api/filter/archive/exclude/sure:999999/limit/' + this.limit + '/page/' + p;
      this.$http.get(url).then(function (response) {

        _this2.table = response.body.data;
        _this2.total = response.body.meta.total;
        _this2.page = p;
        _this2.pageCount = [];
        for (var i = 0; i < _this2.total / _this2.limit; i++) {
          _this2.pageCount.push(i + 1);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        _this2.toggleLoader();
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "2ub+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2vxi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tinymce_tinymce__ = __webpack_require__("5eDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tinymce_tinymce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tinymce_tinymce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tinymce_themes_modern_theme__ = __webpack_require__("o5MN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tinymce_themes_modern_theme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_tinymce_themes_modern_theme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tinymce_plugins_advlist__ = __webpack_require__("Abny");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tinymce_plugins_advlist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tinymce_plugins_advlist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tinymce_plugins_wordcount__ = __webpack_require__("yXOt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tinymce_plugins_wordcount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_tinymce_plugins_wordcount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tinymce_plugins_autolink__ = __webpack_require__("nw5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tinymce_plugins_autolink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_tinymce_plugins_autolink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tinymce_plugins_autosave__ = __webpack_require__("mV4C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tinymce_plugins_autosave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_tinymce_plugins_autosave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tinymce_plugins_charmap__ = __webpack_require__("fUAb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tinymce_plugins_charmap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_tinymce_plugins_charmap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tinymce_plugins_codesample__ = __webpack_require__("OdVP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tinymce_plugins_codesample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_tinymce_plugins_codesample__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tinymce_plugins_contextmenu__ = __webpack_require__("q/hF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tinymce_plugins_contextmenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_tinymce_plugins_contextmenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_tinymce_plugins_emoticons__ = __webpack_require__("IU9l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_tinymce_plugins_emoticons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_tinymce_plugins_emoticons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_tinymce_plugins_fullscreen__ = __webpack_require__("3OjJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_tinymce_plugins_fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_tinymce_plugins_fullscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_tinymce_plugins_hr__ = __webpack_require__("6YOY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_tinymce_plugins_hr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_tinymce_plugins_hr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_tinymce_plugins_imagetools__ = __webpack_require__("XjFM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_tinymce_plugins_imagetools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_tinymce_plugins_imagetools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_tinymce_plugins_insertdatetime__ = __webpack_require__("bfCA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_tinymce_plugins_insertdatetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_tinymce_plugins_insertdatetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_tinymce_plugins_link__ = __webpack_require__("NBEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_tinymce_plugins_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_tinymce_plugins_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_tinymce_plugins_media__ = __webpack_require__("XUqK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_tinymce_plugins_media___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_tinymce_plugins_media__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_tinymce_plugins_noneditable__ = __webpack_require__("dH/N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_tinymce_plugins_noneditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_tinymce_plugins_noneditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_tinymce_plugins_paste__ = __webpack_require__("SlIL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_tinymce_plugins_paste___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_tinymce_plugins_paste__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_tinymce_plugins_print__ = __webpack_require__("njYm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_tinymce_plugins_print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_tinymce_plugins_print__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_tinymce_plugins_searchreplace__ = __webpack_require__("PbEf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_tinymce_plugins_searchreplace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_tinymce_plugins_searchreplace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_tinymce_plugins_tabfocus__ = __webpack_require__("UFS3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_tinymce_plugins_tabfocus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_tinymce_plugins_tabfocus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_tinymce_plugins_template__ = __webpack_require__("g01R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_tinymce_plugins_template___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_tinymce_plugins_template__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_tinymce_plugins_textpattern__ = __webpack_require__("gvu3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_tinymce_plugins_textpattern___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_tinymce_plugins_textpattern__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_tinymce_plugins_visualblocks__ = __webpack_require__("ManF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_tinymce_plugins_visualblocks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_tinymce_plugins_visualblocks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_tinymce_plugins_anchor__ = __webpack_require__("/Xt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_tinymce_plugins_anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_tinymce_plugins_anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_tinymce_plugins_autoresize__ = __webpack_require__("GLi4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_tinymce_plugins_autoresize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_tinymce_plugins_autoresize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_tinymce_plugins_bbcode__ = __webpack_require__("6oK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_tinymce_plugins_bbcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_tinymce_plugins_bbcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_tinymce_plugins_code__ = __webpack_require__("gBhd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_tinymce_plugins_code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_tinymce_plugins_code__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_tinymce_plugins_colorpicker__ = __webpack_require__("Rv7z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_tinymce_plugins_colorpicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_tinymce_plugins_colorpicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_tinymce_plugins_directionality__ = __webpack_require__("QLMD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_tinymce_plugins_directionality___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_tinymce_plugins_directionality__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_tinymce_plugins_fullpage__ = __webpack_require__("UWKq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_tinymce_plugins_fullpage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_tinymce_plugins_fullpage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_tinymce_plugins_help__ = __webpack_require__("4YQI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_tinymce_plugins_help___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_tinymce_plugins_help__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_tinymce_plugins_image__ = __webpack_require__("HaK5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_tinymce_plugins_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_tinymce_plugins_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_tinymce_plugins_importcss__ = __webpack_require__("1tuh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_tinymce_plugins_importcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_tinymce_plugins_importcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_tinymce_plugins_legacyoutput__ = __webpack_require__("YR2B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_tinymce_plugins_legacyoutput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_tinymce_plugins_legacyoutput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_tinymce_plugins_lists__ = __webpack_require__("f85y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_tinymce_plugins_lists___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_tinymce_plugins_lists__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_tinymce_plugins_nonbreaking__ = __webpack_require__("eGY0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_tinymce_plugins_nonbreaking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_tinymce_plugins_nonbreaking__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_tinymce_plugins_pagebreak__ = __webpack_require__("5bBJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_tinymce_plugins_pagebreak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_tinymce_plugins_pagebreak__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_tinymce_plugins_preview__ = __webpack_require__("S0tB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_tinymce_plugins_preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_tinymce_plugins_preview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_tinymce_plugins_save__ = __webpack_require__("Ux5r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_tinymce_plugins_save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_tinymce_plugins_save__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_tinymce_plugins_spellchecker__ = __webpack_require__("BT+F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_tinymce_plugins_spellchecker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_tinymce_plugins_spellchecker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_tinymce_plugins_table__ = __webpack_require__("Q/P+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_tinymce_plugins_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_tinymce_plugins_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_tinymce_plugins_textcolor__ = __webpack_require__("c/6r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_tinymce_plugins_textcolor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_tinymce_plugins_textcolor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_tinymce_plugins_toc__ = __webpack_require__("loUf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_tinymce_plugins_toc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_tinymce_plugins_toc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_tinymce_plugins_visualchars__ = __webpack_require__("ctVV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_tinymce_plugins_visualchars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_tinymce_plugins_visualchars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_tinymce_skins_lightgray_skin_min_css__ = __webpack_require__("6pu/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_tinymce_skins_lightgray_skin_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_tinymce_skins_lightgray_skin_min_css__);
//
//
//
//
//
//

// Import TinyMCE


// A theme is also required


// Any plugins you want to use has to be imported














































/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'tinymce',
    props: {
        id: {
            type: String,
            required: true
        },
        htmlClass: { default: '', type: String },
        value: { default: '' },
        plugins: { default: function _default() {
                return ['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality', 'template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample'];
            }, type: Array
        },
        toolbar1: { default: 'formatselect | bold italic  strikethrough  forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat', type: String },
        toolbar2: { default: '', type: String },
        other_options: { default: function _default() {
                return {};
            }, type: Object },
        readonly: { default: false, type: Boolean }
    },
    data: function data() {
        return {
            content: '',
            editor: null,
            cTinyMce: null,
            checkerTimeout: null,
            isTyping: false
        };
    },
    mounted: function mounted() {
        this.content = this.value;
        this.init();
    },
    beforeDestroy: function beforeDestroy() {
        this.editor.destroy();
    },

    watch: {
        value: function value(newValue) {
            if (!this.isTyping) {
                if (this.editor !== null) this.editor.setContent(newValue);else this.content = newValue;
            }
        },
        readonly: function readonly(value) {
            if (value) {
                this.editor.setMode('readonly');
            } else {
                this.editor.setMode('design');
            }
        }
    },
    methods: {
        init: function init() {
            var options = {
                selector: '#' + this.id,
                skin: false,
                toolbar1: this.toolbar1,
                toolbar2: this.toolbar2,
                plugins: this.plugins,
                init_instance_callback: this.initEditor
            };
            __WEBPACK_IMPORTED_MODULE_0_tinymce_tinymce___default.a.init(this.concatAssciativeArrays(options, this.other_options));
        },
        initEditor: function initEditor(editor) {
            var _this = this;

            this.editor = editor;
            editor.on('KeyUp', function (e) {
                _this.submitNewContent();
            });
            editor.on('Change', function (e) {
                if (_this.editor.getContent() !== _this.value) {
                    _this.submitNewContent();
                }
                _this.$emit('editorChange', e);
            });
            editor.on('init', function (e) {
                editor.setContent(_this.content);
                _this.$emit('input', _this.content);
            });
            if (this.readonly) {
                this.editor.setMode('readonly');
            } else {
                this.editor.setMode('design');
            }

            this.$emit('editorInit', editor);
        },
        concatAssciativeArrays: function concatAssciativeArrays(array1, array2) {
            if (array2.length === 0) return array1;
            if (array1.length === 0) return array2;
            var dest = [];
            for (var key in array1) {
                dest[key] = array1[key];
            }for (var _key in array2) {
                dest[_key] = array2[_key];
            }return dest;
        },
        submitNewContent: function submitNewContent() {
            var _this2 = this;

            this.isTyping = true;
            if (this.checkerTimeout !== null) clearTimeout(this.checkerTimeout);
            this.checkerTimeout = setTimeout(function () {
                _this2.isTyping = false;
            }, 300);

            this.$emit('input', this.editor.getContent());
        }
    }
});

/***/ }),

/***/ "3+FW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "31ur":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("WV8w");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_169310dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("0C+u");
function injectStyle (ssrContext) {
  __webpack_require__("t5XZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_169310dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "32ah":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProvincialOffices_vue__ = __webpack_require__("DV+G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17496e39_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProvincialOffices_vue__ = __webpack_require__("Lfka");
function injectStyle (ssrContext) {
  __webpack_require__("HenA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProvincialOffices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17496e39_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProvincialOffices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "34Lw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "370S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3CqE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("L/hf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10d33142_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("0iFY");
function injectStyle (ssrContext) {
  __webpack_require__("gD8N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10d33142_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3EhU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('index-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3LKB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Q3N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  inheritAttrs: false,
  inject: {
    autoClose: {
      default: true
    }
  },
  props: {
    link: {
      type: [String, Object],
      default: function _default() {
        return {
          name: '',
          path: '',
          icon: ''
        };
      }
    },
    tag: {
      type: String,
      default: 'router-link'
    }
  },
  methods: {
    hideSidebar: function hideSidebar() {
      if (this.autoClose && this.$sidebar && this.$sidebar.showSidebar === true) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
});

/***/ }),

/***/ "3QED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar",style:(_vm.sidebarStyle),attrs:{"data-color":_vm.backgroundColor,"data-image":_vm.backgroundImage}},[_c('div',{staticClass:"sidebar-wrapper"},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"simple-text",attrs:{"href":"#"}},[_vm._m(0),_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])]),_vm._v(" "),_vm._t("content"),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._t("default",_vm._l((_vm.sidebarLinks),function(link,index){return _c('sidebar-link',{key:link.name + index,attrs:{"to":link.path,"link":link},on:{"click":_vm.closeNavbar}},[_c('i',{class:link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(link.name))])])}))],2)],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-img"},[_c('img',{attrs:{"src":"static/img/logo.png","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Un7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3XGD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails(),
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'Education',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        file: null,
        cropped: null
      },
      sliderImage: {
        file: null,
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      },
      firstSlider: false
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post('/api/images/upload/' + this.post.url + '_inner-image', { cropped: i }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + _this.post.url + '" />';
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      };
      if (!this.post.url) {
        this.errors.push("URL");
      };
      if (!this.content.content) {
        this.errors.push("İçerik");
      };
      if (!this.image.cropped && !this.image.file) {
        this.errors.push("Resim");
      };
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this2.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
        _this2.saveImage();
      });
    },
    saveImage: function saveImage() {
      var _this3 = this;

      if (this.image.cropped) {
        this.$http.post('/api/images/upload/' + this.post.url, this.image).then(function (response) {
          _this3.post.image = response.body.Data.Response.name;
          _this3.savePost();
        }, function (e) {
          button.innerHTML = 'Kaydet';
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this3.toggleLoader();
        });
      } else {
        this.savePost();
      }
    },
    savePost: function savePost() {
      var _this4 = this;

      this.post.comments = null;
      this.post.menus = null;
      this.post.slider = null;
      this.tempMetas = this.post.post_metas;
      this.post.post_metas = null;
      this.post.post_tags = null;
      this.post.category = null;
      this.post.sub_category = null;
      this.post.user = null;
      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.$http.post('/api/posts/edit/' + this.post.id, this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this4.post.id = pid;
        _this4.slider.post_id = pid;
        _this4.slider.order_number = pid;
        _this4.metas.post_id = pid;
        _this4.saveMetas();
      }, function (e) {
        _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this4.toggleLoader();
      });
    },
    saveMetas: function saveMetas() {
      var _this5 = this;

      this.$http.put('/api/post-metas/edit-bulk/', this.metas).then(function (response) {
        _this5.notifier('top', 'right', 'success', 'Başarılı');
        _this5.$router.push('/educations');
        _this5.toggleLoader();
      }, function (e) {
        _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this5.toggleLoader();
      });
    },
    getInitialData: function getInitialData() {
      var _this6 = this;

      this.toggleLoader();
      this.$http.get('/api/posts/get/' + this.id).then(function (response) {
        _this6.post = response.body;
        _this6.content = _this6.post.content;
        _this6.image.file = _this6.mediaURL() + _this6.post.image;
        if (_this6.post.video !== null) {
          _this6.video = _this6.post.video;
        }
        if (_this6.post.slider == null) {
          _this6.firstSlider = true;
        }
        _this6.metas = {
          post_id: _this6.post.id,
          items: {
            meta2: {
              meta_id: _this6.post.post_metas[_this6.post.meta_title].id,
              meta_key: 'title',
              meta_value: _this6.post.post_metas[_this6.post.meta_title].meta_value
            },
            meta3: {
              meta_id: _this6.post.post_metas[_this6.post.meta_description].id,
              meta_key: 'description',
              meta_value: _this6.post.post_metas[_this6.post.meta_description].meta_value
            }
          }
        };
        _this6.toggleLoader();
      }, function (er) {
        _this6.toggleLoader();
        _this6.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name);
    },
    slugifyUrl: function slugifyUrl() {
      this.announcement.url = this.slugify(this.announcement.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this7 = this;

        request.$http.get('/api/filter/posts/exclude/id:' + this.id + '/url/' + request.post.url).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this7.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.url) {
        this.croppieType = type;
      } else {
        this.notifier('top', 'right', 'danger', 'Resim ekleyebilmek için bir başlık belirlemelisiniz.');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this8 = this;

      var dis = this;
      var wdt = 1920;
      var hgt = 1080;
      if (this.croppieType === "tinymce") {
        wdt = 960;
        hgt = 540;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: wdt,
            height: hgt
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this8.croppieType === 'main') {
            dis.image.cropped = output;
            document.getElementById('main-i').src = dis.image.cropped;
          } else if (_this8.croppieType === 'tinymce') {
            _this8.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this8.addImageToEditor(output);
          }
          _this8.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    console.log(this.$routes.params.id);
    this.getInitialData();
  }
});

/***/ }),

/***/ "3c77":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEdit_vue__ = __webpack_require__("DZuI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0845f159_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEdit_vue__ = __webpack_require__("fFLU");
function injectStyle (ssrContext) {
  __webpack_require__("i3p5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0845f159_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3yox":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/allnews'}}},[_c('button',{staticClass:"btn btn-info active btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Haberler")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/allnews-order'}}},[_c('button',{staticClass:"btn btn-warning btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Haber Sıralaması")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[(!_vm.err)?_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Tüm Haberler \n      "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill float-md-right",attrs:{"title":"Yeni Sayfa Oluştur","to":{ path: 'allnews/add'},"tag":"li"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Yeni Haber")])],1),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Sayfa")]),_vm._v(" "),_c('th',[_vm._v("URL")]),_vm._v(" "),_c('th',[_vm._v("Kategori")]),_vm._v(" "),_c('th',[_vm._v("Yayın Tarihi")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.url))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.category.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(item.created,"Do/MM/YYYY HH:mm:ss"))+" ")]),_vm._v(" "),_c('td',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"to":{ path: 'allnews/edit/'+item.id},"title":"Düzenle","tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-warning btn-fill btn-xs",attrs:{"to":{ path: 'allnews/slider/'+item.id},"title":"Slider","tag":"li"}},[_c('i',{staticClass:"fas fa-images"})]),_vm._v(" "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-success btn-fill btn-xs",attrs:{"to":{ path: 'allnews/gallery/'+item.id},"title":"Galeri","tag":"li"}},[_c('i',{staticClass:"far fa-image"})]),_vm._v(" "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-info btn-fill btn-xs",attrs:{"to":{ path: 'allnews/pdf/'+item.id},"title":"Pdf","tag":"li"}},[_c('i',{staticClass:"far fa-file-pdf"})]),_vm._v(" "),(item.status !== 4 )?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"deactivate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,4)}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(item.status === 4)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,1)}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e(),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-dark btn-fill",attrs:{"href":"#","title":"Okunma Sayısı"}},[_c('i',{staticClass:"fa fa-book"}),_vm._v(" "+_vm._s(item.readed))])],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n    "+_vm._s(_vm.err)+"\n  ")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "403M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isEdit: false,
      user: {
        user_type_id: null,
        name: null,
        surname: null,
        tcno: null,
        email: null,
        password: null,
        profile_photo: null,
        url: 'nourl',
        authkey: 'nokey',
        recoverytoken: null,
        lastrecovery: null,
        is_active: 1
      },
      passwordRepeat: null,
      userTypes: null,
      errors: [],
      image: {
        cropped: null
      },
      imageRecreated: false,
      croppieType: 'main',
      // end of post data
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.user.name) {
        this.errors.push("Ad Alanı Boş");
      };
      if (!this.user.surname) {
        this.errors.push("Soyad Alanı Boş");
      };
      if (!this.user.email) {
        this.errors.push("E-Posta Alanı Boş");
      };
      if (!this.isEdit) {
        if (!this.user.password) {
          this.errors.push("Şifre Alanı Boş");
        };
      }
      if (!this.isEdit) {
        if (this.user.password !== this.passwordRepeat) {
          this.errors.push("Şifreler Birbiriyle Eşleşmedi");
        }
      } else {
        if (this.user.password !== this.passwordRepeat && 'password' in this.user && this.user.password !== "") {
          this.errors.push("Şifreler Birbiriyle Eşleşmedi");
        }
      }
      if (!this.validEmail(this.user.email)) {
        this.errors.push("E-Posta Formatı Doğru Değil");
      }
      if (!this.errors.length) {
        this.saveImage();
      }
    },
    validEmail: function validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    saveImage: function saveImage() {
      var _this = this;

      this.toggleLoader();
      if (this.imageRecreated) {
        this.$http.post('/api/images/upload/' + this.user.url, this.image).then(function (response) {
          _this.user.profile_photo = response.body.Data.Response.name;
          if (_this.isEdit) {
            _this.updateUser();
          } else {
            _this.saveUser();
          }
        }, function (e) {
          button.innerHTML = 'Kaydet';
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this.toggleLoader();
        });
      } else {
        if (this.isEdit) {
          this.updateUser();
        } else {
          this.saveUser();
        }
      }
    },
    saveUser: function saveUser() {
      var _this2 = this;

      this.$http.post('/api/users/add', this.user).then(function (response) {
        _this2.notifier('top', 'right', 'success', 'Başarılı');
        if (_this2.$route.params.type === 'member') {
          _this2.$router.push('/members');
        } else {
          _this2.$router.push('/users');
        }
        _this2.toggleLoader();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    updateUser: function updateUser() {
      var _this3 = this;

      if (this.user.password === "") {
        delete this.user.password;
      }
      this.user.url = this.user.url + '-' + this.user.id;
      this.$http.post('/api/users/edit/' + this.user.id, this.user).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Başarılı');
        if (_this3.$route.params.type === 'member') {
          _this3.$router.push('/members');
        } else {
          _this3.$router.push('/users');
        }
        _this3.toggleLoader();
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this3.toggleLoader();
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      this.croppieType = type;
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this4 = this;

      var dis = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: 800,
            height: 800
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this4.croppieType === 'main') {
            dis.image.cropped = output;
            dis.imageRecreated = true;
          } else if (_this4.croppieType === 'slider') {
            dis.sliderimage.cropped = output;
            dis.sliderImageLoaded = true;
          }
          _this4.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var _this5 = this;

      this.toggleLoader();
      this.$http.get('/api/user-types/all').then(function (response) {
        _this5.userTypes = response.body;
        if (_this5.$route.params.id) {
          _this5.$http.get('/api/users/get-without-joins/' + _this5.$route.params.id).then(function (response) {
            _this5.isEdit = true;
            _this5.user = response.body;
            _this5.image.cropped = _this5.mediaURL() + _this5.user.profile_photo;
            _this5.toggleLoader();
          }, function (response) {
            _this5.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
            _this5.toggleLoader();
          });
        } else {
          _this5.toggleLoader();
        }
      }, function (er) {
        _this5.toggleLoader();
        _this5.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
      });
    });
  }
});

/***/ }),

/***/ "44lS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SubBoardsModules_SubBoards_vue__ = __webpack_require__("Supl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__SubBoardsModules_SubBoards_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "4OsH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Announcements_vue__ = __webpack_require__("ZzSH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5341c414_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Announcements_vue__ = __webpack_require__("tN3x");
function injectStyle (ssrContext) {
  __webpack_require__("2/Dm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Announcements_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5341c414_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Announcements_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4PGM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("9GZn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07a59c4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("zlvs");
function injectStyle (ssrContext) {
  __webpack_require__("mwiY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07a59c4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4fcA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostsTable_vue__ = __webpack_require__("hIkQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d4b9a88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostsTable_vue__ = __webpack_require__("AHMZ");
function injectStyle (ssrContext) {
  __webpack_require__("qNYv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d4b9a88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4k8k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[(!_vm.err)?_c('div',[_c('h4',{staticClass:"card-title d-md-flex justify-content-between",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Kategoriler")]),_vm._v(" "),_c('div',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary",attrs:{"title":"Yeni Kategori Ekle","to":{ path: 'newcategory/add-edit/'},"tag":"li"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Yeni Kategori")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h6',{staticClass:"ml-3"},[_vm._v("Kategoriler")]),_vm._v(" "),_c('b-tabs',{attrs:{"pills":"","card":"","vertical":""}},_vm._l((_vm.categories),function(category,index){return _c('div',{key:index,staticClass:"row"},[_c('div',{staticClass:"col-12 card mb-1"},[_c('div',{staticClass:"card-body p-2"},[_c('h5',{staticClass:"d-md-flex justify-content-between align-items-center m-0"},[_c('span',[_vm._v(_vm._s(category.name))]),_vm._v(" "),_c('div',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"title":"Düzenle","to":{ path: 'newcategory/add-edit/'+category.id+'/0'},"tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-danger btn-xs",attrs:{"title":"Sil"},on:{"click":function($event){return _vm.remove(category.id,'categories')}}},[_c('i',{staticClass:"fas fa-eye-slash"})]),_vm._v(" "),(category.is_active)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"remove-item.id"},on:{"click":function($event){return _vm.deactivate(category.id,'categories')}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(!category.is_active)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.activate(category.id,'categories')}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e()],1)])])])])}),0)],1)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n      "+_vm._s(_vm.err)+"\n    ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4n3r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('race-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4pBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("PBKA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c3e508e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("tPn6");
function injectStyle (ssrContext) {
  __webpack_require__("3LKB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c3e508e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4pyR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      comment: {
        published: 0
      },
      report: {
        is_active: 0
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      query: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeType: function changeType(t) {
      this.type = t;
      var buttons = Array.prototype.slice.call(document.getElementsByClassName('type-button'));
      buttons.forEach(function (b) {
        b.classList.remove('active');
      });
      event.target.classList.add('active');
      this.getPosts(1, this.type);
    },
    deleteComment: function deleteComment(id) {
      var _this = this;

      this.toggleLoader();
      this.comment.published = 0;
      this.$http.post('/api/comments/edit/' + id, this.comment).then(function (response) {
        _this.notifier('top', 'right', 'warning', 'Yorum Yayından Kaldırıldı');
        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    deleteReport: function deleteReport(id) {
      var _this2 = this;

      this.toggleLoader();
      this.report.is_active = 0;
      this.$http.post('/api/comment-reports/edit/' + id, this.report).then(function (response) {
        _this2.notifier('top', 'right', 'warning', 'Şikayet Silindi');
        _this2.getPosts(_this2.page, _this2.type);
        _this2.toggleLoader();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this3 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';

      this.type = t;
      var url = '/api/filter/comment-reports/is-active/1/comments.published/1/limit/' + this.limit + '/page/' + p;

      this.$http.get(url).then(function (response) {
        _this3.table = response.body.data;
        _this3.table.forEach(function (i) {
          i.comment.comment = _this3.$sanitize(i.comment.comment, { allowedTags: ['user-reference'] }).replace(/<user-reference>/g, '@').replace(/<\/user-reference>/g, ' ');
        });
        _this3.total = response.body.meta.total;
        _this3.page = p;
        _this3.pageCount = [];
        for (var i = 0; i < _this3.total / _this3.limit; i++) {
          _this3.pageCount.push(i + 1);
        }
      }, function (er) {
        _this3.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "50CK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaticPages_vue__ = __webpack_require__("arGQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_792cbbb3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StaticPages_vue__ = __webpack_require__("UyT9");
function injectStyle (ssrContext) {
  __webpack_require__("cGQf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaticPages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_792cbbb3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StaticPages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "59WU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5CsY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("O4zg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04dd61cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("VJFq");
function injectStyle (ssrContext) {
  __webpack_require__("AhrW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04dd61cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5Dxb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      // post data
      post: {
        id: null,
        link: null,
        subtitle: null,
        user_id: this.getCurrentUserDetails(),
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'Activityprogrampage',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        file: null,
        cropped: null
      },
      sliderImage: {
        file: null,
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      },
      firstSlider: false
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post('/api/images/upload/' + this.post.name + 'act_inner-image', { cropped: i }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + _this.post.name + '" />';
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      };
      if (!this.image.cropped && !this.image.file) {
        this.errors.push("Resim");
      };
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this2.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'
        _this2.saveImage();
      });
    },
    saveImage: function saveImage() {
      var _this3 = this;

      if (this.image.cropped) {
        this.$http.post('/api/images/upload/' + this.slugify(this.post.name), this.image).then(function (response) {
          _this3.post.image = response.body.Data.Response.name;
          _this3.savePost();
        }, function (e) {
          button.innerHTML = 'Kaydet';
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this3.toggleLoader();
        });
      } else {
        this.savePost();
      }
    },
    savePost: function savePost() {
      var _this4 = this;

      this.post.comments = null;
      this.post.menus = null;
      this.post.slider = null;
      this.tempMetas = this.post.post_metas;
      this.post.post_metas = null;
      this.post.post_tags = null;
      this.post.category = null;
      this.post.sub_category = null;
      this.post.user = null;
      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.$http.post('/api/posts/edit/' + this.post.id, this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this4.post.id = pid;
        _this4.slider.post_id = pid;
        _this4.slider.order_number = pid;
        _this4.metas.post_id = pid;
        _this4.saveMetas();
      }, function (e) {
        _this4.toggleLoader();

        if (!e.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this4.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveMetas: function saveMetas() {
      var _this5 = this;

      this.$http.put('/api/post-metas/edit-bulk/', this.metas).then(function (response) {
        _this5.notifier('top', 'right', 'success', 'Başarılı');
        _this5.$router.push('/activity-program-page');
        _this5.toggleLoader();
      }, function (e) {
        _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this5.toggleLoader();
      });
    },
    getInitialData: function getInitialData() {
      var _this6 = this;

      this.toggleLoader();
      this.$http.get('/api/posts/get/' + this.id).then(function (response) {
        _this6.post = response.body;
        _this6.content = _this6.post.content;
        _this6.image.file = _this6.mediaURL() + _this6.post.image;
        if (_this6.post.video !== null) {
          _this6.video = _this6.post.video;
        }
        if (_this6.post.slider == null) {
          _this6.firstSlider = true;
        }
        _this6.metas = {
          post_id: _this6.post.id,
          items: {
            meta2: {
              meta_id: _this6.post.post_metas[_this6.post.meta_title].id,
              meta_key: 'title',
              meta_value: _this6.post.post_metas[_this6.post.meta_title].meta_value
            },
            meta3: {
              meta_id: _this6.post.post_metas[_this6.post.meta_description].id,
              meta_key: 'description',
              meta_value: _this6.post.post_metas[_this6.post.meta_description].meta_value
            }
          }
        };
        _this6.toggleLoader();
      }, function (er) {
        _this6.toggleLoader();
        _this6.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name);
    },
    slugifyUrl: function slugifyUrl() {
      this.announcement.url = this.slugify(this.announcement.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this7 = this;

        request.$http.get('/api/filter/posts/exclude/id:' + this.id + '/post-type/Activityprogrampage/name/' + request.post.name).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this7.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.name) {
        this.croppieType = type;
      } else {
        this.notifier('top', 'right', 'danger', 'Resim ekleyebilmek için bir başlık belirlemelisiniz.');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this8 = this;

      var dis = this;
      var wdt = 150;
      var hgt = 150;
      if (this.croppieType === "tinymce") {
        wdt = 150;
        hgt = 150;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          backgroundColor: '#fff',
          size: {
            width: wdt,
            height: hgt
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this8.croppieType === 'main') {
            dis.image.cropped = output;
            document.getElementById('main-i').src = dis.image.cropped;
          } else if (_this8.croppieType === 'tinymce') {
            _this8.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this8.addImageToEditor(output);
          }
          _this8.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.getInitialData();
  }
});

/***/ }),

/***/ "5FAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__ = __webpack_require__("eAxr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_084d5bc3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__ = __webpack_require__("esuq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_084d5bc3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5Guz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/directors'}}},[_c('button',{staticClass:"btn btn-danger btn-sm px-2 mr-2",attrs:{"type":"submit"}},[_vm._v("Yönetim Kurulu")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/staffs'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Federasyon Personeli")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/all-leaders'}}},[_c('button',{staticClass:"btn btn-primary btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Başkanlarımız")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/history'}}},[_c('button',{staticClass:"btn btn-success active btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Tarihçe")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/sub-board-categories'}}},[_c('button',{staticClass:"btn btn-warning btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Alt Kurullar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/provincial-offices'}}},[_c('button',{staticClass:"btn btn-secondary btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("İl Temsilcilikleri")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/bank-informations'}}},[_c('button',{staticClass:"btn btn-success btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Hesap Numaraları")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/main-status-instructions'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Ana Statü Talimatlar")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('form',{staticClass:"w-100",on:{"submit":_vm.submit}},[(!_vm.err)?_c('div',[_c('h1',{staticClass:"h4 mt-0 d-flex justify-content-between"},[_c('span',[_vm._v("Tarihçe")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-sm btn-fill",attrs:{"type":"submit"}},[_vm._v("Kaydet")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"d-flex flex-column"},[_c('label',{attrs:{"for":_vm.settings.name}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.settings.meta.title))])]),_vm._v(" "),_c('tinymce',{staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.settings.data),callback:function ($$v) {_vm.$set(_vm.settings, "data", $$v)},expression:"settings.data"}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n                "+_vm._s(_vm.err)+"\n              ")]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5RfT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__("rPrJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b2779d3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__("KLDw");
function injectStyle (ssrContext) {
  __webpack_require__("34Lw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b2779d3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5S9i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Sayfa Ekle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Param Birimi")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currency1),expression:"currency1"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Para Birimi')},attrs:{"type":"text","placeholder":"Para Birimi","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.currency1)},on:{"keyup":_vm.setName,"input":function($event){if($event.target.composing){ return; }_vm.currency1=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Karşı Param Birimi")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currency2),expression:"currency2"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Karşı Para Birimi')},attrs:{"type":"text","placeholder":"Karşı Para Birimi","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.currency2)},on:{"keyup":_vm.setName,"input":function($event){if($event.target.composing){ return; }_vm.currency2=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Sayfa Başlığı")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.metas.items.meta2.meta_value),expression:"metas.items.meta2.meta_value"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Site Başlığı')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.metas.items.meta2.meta_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.metas.items.meta2, "meta_value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"url-label"}},[_vm._v("URL")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.url),expression:"post.url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('URL')},attrs:{"type":"text","placeholder":"URL","aria-label":"URL","id":"url","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.url)},on:{"keyup":_vm.slugifyUrl,"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Canlı Grafik")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.content.content),expression:"content.content"}],staticClass:"form-control",domProps:{"value":(_vm.content.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.content, "content", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Meta Açıklaması")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.metas.items.meta3.meta_value),expression:"metas.items.meta3.meta_value"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.metas.items.meta3.meta_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.metas.items.meta3, "meta_value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('vue-tabs',[_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Ayarlar"}},[_c('div',{staticClass:"row settings my-4"},[_c('div',{staticClass:"col-12"})])]),_vm._v(" "),_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Yorumlar"}},[_c('div',{staticClass:"row settings my-4"},[_c('div',{staticClass:"col-12"})])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5bLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider_vue__ = __webpack_require__("gnfa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_581cdeb9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slider_vue__ = __webpack_require__("rg9P");
function injectStyle (ssrContext) {
  __webpack_require__("Kel6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_581cdeb9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5gdh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('posts-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5lYI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllnewsOrder_vue__ = __webpack_require__("1hF9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d953f712_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllnewsOrder_vue__ = __webpack_require__("C3eh");
function injectStyle (ssrContext) {
  __webpack_require__("+bKo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllnewsOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d953f712_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllnewsOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5lwa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaceLogs_vue__ = __webpack_require__("TyP5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26dc9cc5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaceLogs_vue__ = __webpack_require__("WY2n");
function injectStyle (ssrContext) {
  __webpack_require__("hCvF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaceLogs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26dc9cc5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaceLogs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5oU2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__("dLYe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eb476e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__("4k8k");
function injectStyle (ssrContext) {
  __webpack_require__("POB4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eb476e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5tTk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostModules_Education_Index_vue__ = __webpack_require__("ZDLM");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostsTable: __WEBPACK_IMPORTED_MODULE_0__PostModules_Education_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "5wM0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("CawJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76f88e64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("O590");
function injectStyle (ssrContext) {
  __webpack_require__("2Ll6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76f88e64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6/gU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("tcE3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cb0ad8d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("kx+k");
function injectStyle (ssrContext) {
  __webpack_require__("Ljql")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cb0ad8d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6QrH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6U+M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("wHlF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba353302_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("d3Fl");
function injectStyle (ssrContext) {
  __webpack_require__("zILr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba353302_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6WqJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JobPostingModules_Index_vue__ = __webpack_require__("YBie");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    IndexTable: __WEBPACK_IMPORTED_MODULE_0__JobPostingModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "6biR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("mVQN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e9f02ed_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("H+cs");
function injectStyle (ssrContext) {
  __webpack_require__("axsZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e9f02ed_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6bpm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6cK5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Dijital Basın Ekle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata\n        ")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"change":_vm.validate,"keyup":_vm.createUrl,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"url-label"}},[_vm._v("URL")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.url),expression:"post.url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('URL')},attrs:{"type":"text","placeholder":"URL","aria-label":"URL","id":"url","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.url)},on:{"keyup":_vm.slugifyUrl,"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3 d-flex flex-column align-items-end"},[_c('tinymce',{class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('vue-tabs',[_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Resim"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("1200 x 600 pixel")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.cropped}})],1)])]),_vm._v(" "),_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Video"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 input-group px-5 m-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Video Adresi")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.newvideo),expression:"post.newvideo"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"https://www.youtube.com/watch?v=KZzON_7EQ70","aria-label":"Başlık","id":"title","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.newvideo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "newvideo", $event.target.value)}}})])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 480, height: 270, type: 'suare'},"boundary":{width: 640, height: 360},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6pu/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6sYh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      featuredTitles: [{
        key: "bellow_slider_1",
        title: null,
        details: null,
        link: null,
        image: null
      }, {
        key: "bellow_slider_2",
        title: null,
        details: null,
        link: null,
        image: null
      }, {
        key: "bellow_slider_3",
        title: null,
        details: null,
        link: null,
        image: null
      }],
      slider: {
        post_id: null,
        slider_group: "LeaderArticles",
        order_number: null,
        is_active: 1
      },
      selectedType: null,
      types: ["URL", "Kategori", "Alt Kategori", "Yayın", "Etiket"],
      options: [],
      sliderItems: null,
      newFeaturedImage: {
        featured_id: null,
        cropped: null
      },
      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "all",
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      this.toggleLoader();
      this.$http.delete("/api/slider/delete/" + id).then(function (response) {
        _this.notifier("top", "right", "warning", "Menu elemanı silindi");
        _this.getSlider();
        _this.toggleLoader();
      }, function (e) {
        _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this.toggleLoader();
      });
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post("/api/images/upload/boxes-under-slider-" + this.newFeaturedImage.id, this.newFeaturedImage).then(function (response) {
        _this2.featuredTitles[_this2.newFeaturedImage.id].image = response.body.Data.Response.name;
        _this2.hideCroppieModal();
        document.getElementById("submit-image").innerHTML = "Kaydet";
        _this2.toggleLoader();
      }, function (e) {
        _this2.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this2.toggleLoader();
      });
    },
    loadItems: function loadItems() {
      var _this3 = this;

      this.options = [];
      this.toggleLoader();
      var url = "/api/posts/latest";
      this.$http.get(url).then(function (response) {
        response = response.body;
        for (var i = 0; i < response.length; i++) {
          var temp = { value: response[i].id, text: response[i].name };
          _this3.options.push(temp);
        }
        _this3.toggleLoader();
      }, function (er) {
        _this3.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        _this3.toggleLoader();
      });
    },
    loadFeaturedTitles: function loadFeaturedTitles() {
      var _this4 = this;

      this.toggleLoader();
      this.$http.get("/api/settings/get-featured-under-slider").then(function (response) {
        var settings = response.body;
        _this4.featuredTitles = [];
        for (var i = 0; i < settings.length; i++) {
          var jsonData = JSON.parse(settings[i].data);
          jsonData.key = "bellow_slider_" + (i + 1);
          _this4.featuredTitles.push(jsonData);
        }
        _this4.toggleLoader();
      }, function (er) {
        _this4.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        _this4.toggleLoader();
      });
    },
    update: function update(id) {
      var _this5 = this;

      this.$http.post("/api/slider/edit/", this.sliderItems).then(function (response) {
        _this5.notifier("top", "right", "success", "Sıralama güncellendi");
      }, function (e) {
        if (!e.body.Error) {
          _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this5.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    save: function save(id) {
      var _this6 = this;

      this.toggleLoader();
      this.$http.post("/api/slider/add/LeaderArticles", this.slider).then(function (response) {
        _this6.getSlider();
        _this6.toggleLoader();
        _this6.notifier("top", "right", "success", "Başarılı");
      }, function (e) {
        _this6.toggleLoader();
        if (!e.body.Error) {
          _this6.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this6.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveSettings: function saveSettings() {
      var _this7 = this;

      this.toggleLoader();
      this.$http.post("/api/settings/edit-bulk/", this.featuredTitles).then(function (response) {
        _this7.toggleLoader();
        _this7.notifier("top", "right", "success", "Başarılı");
      }, function (e) {
        _this7.toggleLoader();
        _this7.notifier("top", "right", "danger", "Bir Hata Oluştu");
      });
    },
    getSlider: function getSlider() {
      var _this8 = this;

      this.toggleLoader();
      var url = "/api/slider/all/LeaderArticles";
      this.$http.get(url).then(function (response) {
        _this8.sliderItems = response.body;
        if (_this8.sliderItems.length > 0) {
          _this8.slider.order_number = _this8.sliderItems[0].order_number + 1;
          _this8.slider.post_id = 0;
        } else {
          _this8.slider.order_number = 0;
        }
        _this8.toggleLoader();
      }, function (er) {
        _this8.toggleLoader();
        if (!er.body.Error) {
          _this8.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this8.err = er.body.Error;
          _this8.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    initiateCroppie: function initiateCroppie(id) {
      this.newFeaturedImage.id = id;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById("new-post").classList.contains("d-none")) {
        document.getElementById("new-post").classList.remove("d-none");
      } else {
        document.getElementById("new-post").classList.add("d-none");
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {
      document.getElementById("submit-image").innerHTML = "<i class='fas fa-circle-notch fa-spin'></i>";
      this.crop();
    },
    crop: function crop() {
      var _this9 = this;

      var dis = this;
      this.toggleLoader();
      var color = "#e17d00";
      if (this.newFeaturedImage.id === 0) {
        color = "#dc3545";
      } else if (this.newFeaturedImage.id === 1) {
        color = "#17a2b8";
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: "jpeg",
          size: {
            width: 277,
            height: 244
          },
          backgroundColor: color,
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this9.newFeaturedImage.cropped = output;
          _this9.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
      this.loadItems();
      this.loadFeaturedTitles();
    });
  }
});

/***/ }),

/***/ "6zzE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("X4Is");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e4ac524_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("ziMA");
function injectStyle (ssrContext) {
  __webpack_require__("qgkf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e4ac524_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "751y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("8ks4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae19308_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("tk/b");
function injectStyle (ssrContext) {
  __webpack_require__("Ib6w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae19308_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7583":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("UwXn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2f1351e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("T64n");
function injectStyle (ssrContext) {
  __webpack_require__("1KkG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2f1351e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "76Qd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/directors'}}},[_c('button',{staticClass:"btn btn-danger  btn-sm  px-2 mr-2",attrs:{"type":"submit"}},[_vm._v("Yönetim Kurulu")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/staffs'}}},[_c('button',{staticClass:"btn btn-info active btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Federasyon Personeli")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/all-leaders'}}},[_c('button',{staticClass:"btn btn-primary btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Başkanlarımız")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/history'}}},[_c('button',{staticClass:"btn btn-success btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Tarihçe")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/sub-board-categories'}}},[_c('button',{staticClass:"btn btn-warning btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Alt Kurullar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/provincial-offices'}}},[_c('button',{staticClass:"btn btn-secondary btn-sm  mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("İl Temsilcilikleri")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/bank-informations'}}},[_c('button',{staticClass:"btn btn-success btn-sm  mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Hesap Numaraları")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/main-status-instructions'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Ana Statü Talimatlar")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[(!_vm.err)?_c('div',[_c('div',{staticClass:"d-flex flex-column"},[_c('small',{staticClass:"text-danger mb-3"},[_vm._v("Büyük Resim seçimi yapılan resmi sayfanın en üstünde bulunacaktır ve yalnız en üstteki resim büyük resim olarak eklenebilir.")]),_vm._v(" "),_c('small',[_vm._v("Resim Boyutu (Büyük resim için 400x450px) (Küçük resim için 300x300px)")])]),_vm._v(" "),_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("Federasyon Personeli\n                "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"mr-2 btn btn-danger btn-sm btn-fill",on:{"click":function($event){return _vm.addNew()}}},[_vm._v("\n                  Ekle\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm btn-fill",on:{"click":function($event){return _vm.update()}}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.mediaURL() + item.image}})]),_vm._v(" "),_c('div',{staticClass:"col-9 d-flex align-items-center"},[_c('div',{staticClass:"row w-100"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Ad Soyad")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.title),expression:"item.title"}],staticClass:"form-control",attrs:{"type":"text","name":""},domProps:{"value":(item.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Görevi")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.target_url),expression:"item.target_url"}],staticClass:"form-control",attrs:{"type":"text","name":""},domProps:{"value":(item.target_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "target_url", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[(item.order_number==(_vm.slider.length-1))?_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.crp",modifiers:{"crp":true}},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn btn-sm  btn-info",attrs:{"title":"Büyük Resim Seç"},on:{"click":function($event){return _vm.initiateCroppie(item.id,index,0,'big')}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]):_vm._e(),_vm._v(" "),(item.order_number!==(_vm.slider.length-1))?_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModalsmall",modifiers:{"croppieModalsmall":true}},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn btn-sm btn-warning",attrs:{"title":"Küçük Resim Seç"},on:{"click":function($event){return _vm.initiateCroppie(item.id,index,0,'small')}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 border border-secondary p-2 d-none",attrs:{"src":_vm.newSliderImage.cropped}})])])])])}),0)],1)],1):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n"+_vm._s(_vm.err)+"\n            ")]):_vm._e()])])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"crp","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 200, height: 225, type: 'suare'},"boundary":{width: 400, height: 450},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModalsmall","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 300, height: 300, type: 'suare'},"boundary":{width: 400, height: 400},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "77Ng":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SubBoardCategoriesModules_Main_vue__ = __webpack_require__("q0PG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__SubBoardCategoriesModules_Main_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "7Ib9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/main'}}},[_c('button',{staticClass:"btn btn-danger  btn-sm  px-2 mr-2",attrs:{"type":"submit"}},[_vm._v("Anasayfa Slider")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/intro-video'}}},[_c('button',{staticClass:"btn btn-primary btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("İntro Videosu")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/homeboxes'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Anasayfa Kutular")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/homeinfos'}}},[_c('button',{staticClass:"btn btn-warning btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Anasayfa Bilgiler")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/announcements'}}},[_c('button',{staticClass:"btn btn-success active btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Anasayfa Duyurular")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[(!_vm.err)?_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Tüm Duyurular\n      "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill float-md-right",attrs:{"title":"Yeni Sayfa Oluştur","to":{ path: '/announcements/add'},"tag":"li"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Yeni Duyuru\n      ")])],1),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Sayfa")]),_vm._v(" "),_c('th',[_vm._v("URL")]),_vm._v(" "),_c('th',[_vm._v("Yayın Tarihi")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.url))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(item.created,"Do/MM/YYYY HH:mm:ss")))]),_vm._v(" "),_c('td',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"to":{ path: '/announcements/edit/'+item.id},"title":"Düzenle","tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),(item.status !== 4 )?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"deactivate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,4)}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(item.status === 4)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,1)}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e()],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n    "+_vm._s(_vm.err)+"\n  ")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7KM9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("duuz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba0eb57c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("Aya3");
function injectStyle (ssrContext) {
  __webpack_require__("q0Ix")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba0eb57c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7NAF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostModules_HomeInfos_Index_vue__ = __webpack_require__("uF2b");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__PostModules_HomeInfos_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "7SdG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarLink_vue__ = __webpack_require__("3Q3N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d09261_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarLink_vue__ = __webpack_require__("UvUG");
function injectStyle (ssrContext) {
  __webpack_require__("h0DP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d09261_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7WKp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7eDO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemberModules_Index_vue__ = __webpack_require__("J+N9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    IndexTable: __WEBPACK_IMPORTED_MODULE_0__MemberModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "7iB3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7j+8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "81NY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[(!_vm.err)?_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Tüm Tesisler \n      "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill float-md-right",attrs:{"title":"Yeni Sayfa Oluştur","to":{ path: 'facilities/add'},"tag":"li"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Yeni Tesis")])],1),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Sayfa")]),_vm._v(" "),_c('th',[_vm._v("Yayın Tarihi")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(item.created,"Do/MM/YYYY HH:mm:ss"))+" ")]),_vm._v(" "),_c('td',{staticClass:"d-flex justify-content-around align-items-center"},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"to":{ path: 'facilities/edit/'+item.id},"title":"Düzenle","tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),(item.status !== 4 )?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"deactivate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,4)}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(item.status === 4)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,1)}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e()],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n"+_vm._s(_vm.err)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8PBF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_min_css__ = __webpack_require__("9BHd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_min_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: [{
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'newgallery' + this.$route.params.id,
        order_number: null
      }],
      selectedType: null,
      types: ['URL', 'Kategori', 'Alt Kategori', 'Yayın', 'Etiket'],
      options: [],
      sliderItems: null,
      newSliderImage: {
        cropped: null,
        image_id: null,
        image_name: null,
        imageIndex: null
      },
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: [],
      dropOptions: {
        url: "/api/images/upload-with-dropzone/" + this.$route.params.id + '/newgallery',
        addRemoveLinks: true,
        uploadMultiple: true,
        acceptedFiles: 'image/*',
        dictDefaultMessage: "Dosyaları yüklemek için sürükle bırak yapabilir veya bu alana tıklayabilirsiniz."
      }
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"],
    vueDropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a
  },

  methods: {
    afterComplete: function afterComplete(file) {
      var vm = this;
      vm.update();
      setTimeout(function () {
        vm.$refs.dropzone.removeAllFiles();
      }, 2500);
    },
    removeAllFiles: function removeAllFiles() {
      this.$refs.dropzone.removeAllFiles();
    },

    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier('top', 'right', 'danger', 'Slider Başarıyla silindi');
          _this.getSlider();
        }, function (e) {
          _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          _this.toggleLoader();
        });
      }
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post('/api/images/upload/new-gallery', this.newSliderImage).then(function (response) {
        var i = _this2.newSliderImage.n === 0 ? 'image' : 'image2';
        _this2.slider[_this2.newSliderImage.imageIndex][i] = response.body.Data.Response.name;
        _this2.toggleLoader();
        _this2.hideCroppieModal();
        _this2.update();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    addNew: function addNew() {
      this.slider.unshift({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'newgallery' + this.$route.params.id,
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      var newdis = this;
      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = 'newgallery' + newdis.$route.params.id;
      });
      this.$http.post('/api/images/edit/', this.slider).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi');
        _this3.getSlider();
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = '/api/images/newgallery/' + this.$route.params.id;
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
      }, function (er) {
        _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
      });
    },
    initiateCroppie: function initiateCroppie(id, i, n) {
      this.newSliderImage.image_id = id;
      this.newSliderImage.image_name = this.slugify(this.slider[i].title);
      this.newSliderImage.imageIndex = i;
      this.newSliderImage.n = n;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {

      this.crop();
    },
    crop: function crop() {
      var _this5 = this;

      var dis = this;
      this.toggleLoader();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg' | 'png' | 'webp',
          backgroundColor: '#fff',
          size: {
            width: 1600,
            height: 1200
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this5.newSliderImage.cropped = output;
          _this5.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "8PLX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("Slider \n              "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"mr-2 btn btn-danger btn-sm btn-fill",on:{"click":function($event){return _vm.addNew()}}},[_vm._v("\n                Ekle\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm btn-fill",on:{"click":function($event){return _vm.update()}}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("Resim boyutu 1600 x 800 pixel")]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-11"},[_c('img',{staticClass:"img-fluid",attrs:{"width":"150px","src":_vm.mediaURL() + item.image}})]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn btn-sm ",attrs:{"title":"Slider Resmini Değiştir"},on:{"click":function($event){return _vm.initiateCroppie(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 border border-secondary p-2 d-none",attrs:{"src":_vm.newSliderImage.cropped}})])])])])}),0)],1)],1)])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 450, height: 240, type: 'suare'},"boundary":{width: 600, height: 320},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8SDh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("THPi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d82341be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("Ay9Z");
function injectStyle (ssrContext) {
  __webpack_require__("Q5IF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d82341be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8Tiq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("8PBF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_edb6148a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("ZhT1");
function injectStyle (ssrContext) {
  __webpack_require__("0Bjw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_edb6148a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8buw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        status: 1
      },
      table: null,
      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "Announcements",
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeStatus: function changeStatus(id, status) {
      var _this = this;

      this.toggleLoader();
      this.post.status = status;
      this.$http.post("/api/posts/edit/" + id, this.post).then(function (response) {
        if (status !== 1) {
          _this.notifier("top", "right", "warning", "Sayfa Yayından Kaldırıldı");
        } else {
          _this.notifier("top", "right", "success", "Sayfa Yayınlandı");
        }

        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();
        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this2 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Announcements";

      this.toggleLoader();
      this.type = t;
      var url = "/api/filter/posts/post-type/" + this.type + "/limit/" + this.limit + "/page/" + p;
      this.$http.get(url).then(function (response) {
        _this2.table = response.body.data;
        _this2.total = response.body.meta.total;
        _this2.pageCount = [];
        for (var i = 0; i < _this2.total / _this2.limit; i++) {
          _this2.pageCount.push(i + 1);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.toggleLoader();

        if (!er.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this2.err = er.body.Error;
          _this2.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById("new-post").classList.contains("d-none")) {
        document.getElementById("new-post").classList.remove("d-none");
      } else {
        document.getElementById("new-post").classList.add("d-none");
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "8ewU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NewsletterModules_Index_vue__ = __webpack_require__("Evg4");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    IndexTable: __WEBPACK_IMPORTED_MODULE_0__NewsletterModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "8fFC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.title),expression:"post.title"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.title)},on:{"change":_vm.validate,"keyup":_vm.createUrl,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"url-label"}},[_vm._v("URL")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.url),expression:"post.url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('URL')},attrs:{"type":"text","placeholder":"URL","aria-label":"URL","id":"url","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.url)},on:{"keyup":_vm.slugifyUrl,"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('label',{staticClass:"input-group-text border-0 bg-white",attrs:{"for":"inputGroupSelect01"}},[_vm._v("Kategori")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.category_id),expression:"post.category_id"}],staticClass:"custom-select",class:{'is-invalid' : _vm.errors.includes('Kategori')},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.post, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.getSubCategories]}},_vm._l((_vm.categories),function(cat){return _c('option',{domProps:{"value":cat.id}},[_vm._v("\n              "+_vm._s(cat.name)+"\n            ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('label',{staticClass:"input-group-text border-0 bg-white",attrs:{"for":"inputGroupSelect01"}},[_vm._v("Alt Kategori")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.sub_category_id),expression:"post.sub_category_id"}],staticClass:"custom-select",class:{'is-invalid' : _vm.errors.includes('Alt Kategori')},attrs:{"id":"sub-category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.post, "sub_category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.subCategories),function(scat){return _c('option',{domProps:{"value":scat.id}},[_vm._v("\n              "+_vm._s(scat.name)+"\n            ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3"},[_c('tinymce',{class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('vue-tabs',[_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Resim"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.file,"id":"main-i"}})],1)])]),_vm._v(" "),_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Video"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 input-group px-5 m-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Video Adresi")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.video.video_url),expression:"video.video_url"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"https://www.youtube.com/watch?v=KZzON_7EQ70","aria-label":"Başlık","id":"title","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.video.video_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.video, "video_url", $event.target.value)}}})])])]),_vm._v(" "),_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"SEO"}},[_c('div',{staticClass:"row settings my-4"},[_c('div',{staticClass:"col-12 input-group px-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.metas.items.meta2.meta_value),expression:"metas.items.meta2.meta_value"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Meta Başlığı","aria-label":"Başlık","id":"title","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.metas.items.meta2.meta_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.metas.items.meta2, "meta_value", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v(" - Statik Site Başlığı")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group px-5 mt-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Meta Açıklaması")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.metas.items.meta3.meta_value),expression:"metas.items.meta3.meta_value"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.metas.items.meta3.meta_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.metas.items.meta3, "meta_value", $event.target.value)}}})])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Yayınla")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 480, height: 270, type: 'suare'},"boundary":{width: 640, height: 360},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8k//":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("CBpD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e845612_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("g8Lp");
function injectStyle (ssrContext) {
  __webpack_require__("r/j7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e845612_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8ks4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      settings: null,
      position: {
        lat: 39.902372948487,
        lng: 32.859761160718
      },
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    getSettings: function getSettings() {
      var _this = this;

      this.toggleLoader();
      this.$http.get('/api/settings/get-settings/').then(function (response) {
        _this.settings = response.body;
        for (var i = 0; i < _this.settings.length; i++) {
          _this.settings[i].meta = JSON.parse(_this.settings[i].meta);
          if (_this.settings[i].name === "latitude") {
            _this.position.lat = parseFloat(_this.settings[i].data);
          }
          if (_this.settings[i].name === "longitude") {
            _this.position.lng = parseFloat(_this.settings[i].data);
          }
        }

        _this.toggleLoader();
      }, function (er) {
        if (!er.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this.err = er.body.Error;
          _this.notifier('top', 'right', 'danger', er.body.Error);
        }
        _this.toggleLoader();
      });
    },
    submit: function submit() {
      var _this2 = this;

      event.preventDefault();
      this.$http.post('/api/settings/update-bulk-general/', this.settings).then(function (response) {
        _this2.notifier('top', 'right', 'success', 'Sıralama güncellendi');
      }, function (e) {
        if (!e.body.Error) {
          _this2.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        } else {
          _this2.notifier("top", "right", "danger", e.body.Error);
        }
      });
    },
    changePosition: function changePosition(e) {
      this.position.lat = e.lat();
      this.position.lng = e.lng();
      for (var i = 0; i < this.settings.length; i++) {
        if (this.settings[i].name === "latitude") {
          this.settings[i].data = e.lat();
        }
        if (this.settings[i].name === "longitude") {
          this.settings[i].data = e.lng();
        }
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSettings();
    });
  }
});

/***/ }),

/***/ "8pnP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NewcategoryModules_Main_vue__ = __webpack_require__("5oU2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__NewcategoryModules_Main_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "8s++":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("Gp5R");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7989d7de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("ljUl");
function injectStyle (ssrContext) {
  __webpack_require__("M8FP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7989d7de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8sm4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ComingFromYouContentModules_Index_vue__ = __webpack_require__("vzqY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__ComingFromYouContentModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "8zch":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeaderArticles_vue__ = __webpack_require__("WLsg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf7d0ca8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeaderArticles_vue__ = __webpack_require__("kTPG");
function injectStyle (ssrContext) {
  __webpack_require__("fLY8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeaderArticles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf7d0ca8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeaderArticles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "947H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "96Jg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        status: 1
      },
      table: null,
      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "LeaderArticles",
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeStatus: function changeStatus(id, status) {
      var _this = this;

      this.toggleLoader();
      this.post.status = status;
      this.$http.post("/api/posts/edit/" + id, this.post).then(function (response) {
        if (status !== 1) {
          _this.notifier("top", "right", "warning", "Sayfa Yayından Kaldırıldı");
        } else {
          _this.notifier("top", "right", "success", "Sayfa Yayınlandı");
        }

        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();
        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this2 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "LeaderArticles";

      this.toggleLoader();
      this.type = t;
      var url = "/api/filter/posts/post-type/" + this.type + "/limit/" + this.limit + "/page/" + p;
      this.$http.get(url).then(function (response) {
        _this2.table = response.body.data;
        _this2.total = response.body.meta.total;
        _this2.page = p;
        _this2.pageCount = [];
        for (var i = 0; i < _this2.total / _this2.limit; i++) {
          _this2.pageCount.push(i + 1);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.toggleLoader();

        if (!er.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this2.err = er.body.Error;
          _this2.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById("new-post").classList.contains("d-none")) {
        document.getElementById("new-post").classList.remove("d-none");
      } else {
        document.getElementById("new-post").classList.add("d-none");
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "9BHd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9GZn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      // post data
      videoupdated: false,
      post: {
        id: null,
        newvideo: null,
        user_id: this.getCurrentUserDetails(),
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: "Announcements",
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: "title",
            meta_value: null
          },
          meta3: {
            meta_key: "description",
            meta_value: null
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        file: null,
        cropped: null
      },
      sliderImage: {
        file: null,
        cropped: null
      },
      croppieType: "main",
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      },
      firstSlider: false
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    uploadPdf: function uploadPdf(event) {
      var _this = this;

      this.file = event.target.files[0];
      console.log(this.file);
      if (this.file.type !== "application/pdf") {
        this.notifier('top', 'right', 'danger', 'Lütfen excel formatında bir dosya seçiniz');
      } else {
        var data = new FormData();
        data.append("file", this.file);
        var fileName = this.file.name.split(".");
        var extension = "";
        var newName = "";
        fileName.forEach(function (e, index) {
          if (index < fileName.length - 1) {
            newName += e;
          }
          if (index == fileName.length - 1) {
            extension += e;
          }
        });
        newName += new Date().getTime();
        var fullName = newName + "." + extension;
        data.append("fileName", fullName);
        this.$http.post("/api/files/upload-pdf/" + fullName, data).then(function (response) {
          _this.post.image = fullName;
          _this.notifier("top", "right", "success", "Pdf başarıyla kaydedildi");
        }, function (er) {
          _this.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        });
      }
    },
    addImageToEditor: function addImageToEditor(i) {
      var _this2 = this;

      this.$http.post("/api/images/upload/" + this.post.url + "announcements_inner-image", {
        cropped: i
      }).then(function (response) {
        _this2.content.content = _this2.content.content + '<div class="flex-images"><img src="' + _this2.mediaURL() + response.body.Data.Response.name + '" width="600px height="450px" alt="' + _this2.post.url + '" /></div>';
      }, function (e) {
        _this2.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this2.toggleLoader();
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.url) {
        this.croppieType = type;
      } else {
        this.notifier("top", "right", "danger", "Resim ekleyebilmek için bir başlık belirlemelisiniz.");
      }
    },

    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      }
      if (!this.post.url) {
        this.errors.push("URL");
      }
      if (!this.content.content) {
        this.errors.push("İçerik");
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this3 = this;

      var dis = this;
      var wdt = 600;
      var hgt = 450;
      if (this.croppieType === "tinymce") {
        wdt = 1600;
        hgt = 1200;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: "jpeg",
          size: {
            width: wdt,
            height: hgt
          },

          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this3.croppieType === "main") {
            dis.image.cropped = output;
          } else if (_this3.croppieType === "slider") {
            dis.sliderImage.cropped = output;
            dis.sliderImageLoaded = true;
          } else if (_this3.croppieType === "tinymce") {
            _this3.notifier("top", "right", "warning", "Lütfen resim yükleninceye kadar bekleyin.");
            _this3.addImageToEditor(output);
          }
          _this3.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result: function result(output) {
      return output;
    },

    save: function save() {
      var _this4 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById("url").classList.add("is-invalid");
        document.getElementById("url").classList.remove("is-valid");
        document.getElementById("url-label").classList.add("is-invalid");
        document.getElementById("url-label").classList.remove("is-valid");
        _this4.notifier("top", "right", "danger", "URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin");
        _this4.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
        _this4.saveContent();
      });
    },
    saveContent: function saveContent() {
      var _this5 = this;

      var button = event.target;
      this.$http.post("/api/contents/edit/" + this.post.content.id, this.content).then(function (response) {
        _this5.savePost();
      }, function (e) {
        button.innerHTML = "Kaydet";
        _this5.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this5.toggleLoader();
      });
    },
    saveImage: function saveImage() {
      var _this6 = this;

      this.$http.post("/api/images/upload/" + this.post.url, this.image).then(function (response) {
        _this6.post.image = response.body.Data.Response.name;
        _this6.savePost();
      }, function (e) {
        _this6.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this6.toggleLoader();
      });
    },
    savePost: function savePost() {
      var _this7 = this;

      this.post.comments = null;
      this.post.menus = null;
      this.post.slider = null;
      this.tempMetas = this.post.post_metas;
      this.post.post_metas = null;
      this.post.post_tags = null;
      this.post.category = null;
      this.post.sub_category = null;
      this.post.user = null;
      this.post.content = null;
      if (this.videoupdated) {
        this.post.video = this.video;
      } else {
        this.post.video = null;
      }

      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ["br"] }).substring(0, 500);
      }
      this.$http.post("/api/posts/edit/" + this.post.id, this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this7.post.id = pid;
        _this7.slider.post_id = pid;
        _this7.slider.order_number = pid;
        _this7.metas.post_id = pid;
        _this7.saveMetas();
      }, function (e) {
        _this7.toggleLoader();

        if (!e.body.Error) {
          _this7.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this7.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveMetas: function saveMetas() {
      var _this8 = this;

      this.$http.put("/api/post-metas/edit-bulk/", this.metas).then(function (response) {
        _this8.notifier("top", "right", "success", "Başarılı");
        _this8.$router.push("/announcements");
        _this8.toggleLoader();
      }, function (e) {
        _this8.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this8.toggleLoader();
      });
    },
    getInitialData: function getInitialData() {
      var _this9 = this;

      this.toggleLoader();
      this.$http.get("/api/posts/get/" + this.id).then(function (response) {
        _this9.post = response.body;
        _this9.content = _this9.post.content;
        _this9.image.file = _this9.mediaURL() + _this9.post.image;
        if (_this9.post.video) {
          _this9.video = _this9.post.video;
        } else {
          _this9.post.video = {
            video_url: null
          };
        }
        if (_this9.post.slider == null) {
          _this9.firstSlider = true;
        }
        _this9.metas = {
          post_id: _this9.post.id,
          items: {
            meta2: {
              meta_id: _this9.post.post_metas[_this9.post.meta_title].id,
              meta_key: "title",
              meta_value: _this9.post.post_metas[_this9.post.meta_title].meta_value
            },
            meta3: {
              meta_id: _this9.post.post_metas[_this9.post.meta_description].id,
              meta_key: "description",
              meta_value: _this9.post.post_metas[_this9.post.meta_description].meta_value
            }
          }
        };
        _this9.toggleLoader();
      }, function (er) {
        _this9.toggleLoader();
        _this9.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        return;
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name) + "-d";
    },
    slugifyUrl: function slugifyUrl() {
      this.announcement.url = this.slugify(this.announcement.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById("url").classList.add("is-invalid");
        document.getElementById("url").classList.remove("is-valid");
        document.getElementById("url-label").classList.add("is-invalid");
        document.getElementById("url-label").classList.remove("is-valid");
      }).catch(function (er) {
        document.getElementById("url").classList.add("is-valid");
        document.getElementById("url").classList.remove("is-invalid");
        document.getElementById("url-label").classList.add("is-valid");
        document.getElementById("url-label").classList.remove("is-invalid");
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this10 = this;

        request.$http.get("/api/filter/posts/exclude/id:" + this.id + "/url/" + request.post.url).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this10.notifier("top", "right", "danger", "Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        });
      });
    }
  },
  mounted: function mounted() {
    this.getInitialData();
  }
});

/***/ }),

/***/ "9IEI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('h4',{staticClass:"card-title d-md-flex justify-content-between",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Kullanıcılar")]),_vm._v(" "),_c('div',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary",attrs:{"title":"Yeni Kullanıcı Ekle","to":{ path: 'user/add-edit/'},"tag":"li"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Yeni Kullanıcı")])],1)]),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("E-Posta")]),_vm._v(" "),_c('th',[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.email))]),_vm._v(" "),_c('td',{staticStyle:{"width":"15%"}},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"title":"Düzenle","to":{ path: 'user/add-edit/'+item.id},"tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-warning btn-fill btn-xs",attrs:{"title":"İzin Ayarları","to":{ path: 'user/permissions/'+item.id},"tag":"li"}},[_c('i',{staticClass:"fas fa-lock"})]),_vm._v(" "),(item.is_active)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Pasif Et","id":"deactivate-item.id"},on:{"click":function($event){return _vm.deactivate(item.id)}}},[_c('i',{staticClass:"fas fa-unlink"})]):_vm._e(),_vm._v(" "),(!item.is_active)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Aktif Et","id":"activate-item.id"},on:{"click":function($event){return _vm.activate(item.id)}}},[_c('i',{staticClass:"fas fa-link"})]):_vm._e()],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return _c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current)}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])])}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9J5m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9QIj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("F0oR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13629b0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("zRwl");
function injectStyle (ssrContext) {
  __webpack_require__("1gd4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13629b0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9R4Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9XOi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A9rn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("Astv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_734d725b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("18G7");
function injectStyle (ssrContext) {
  __webpack_require__("6bpm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_734d725b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AHMZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('h4',{staticClass:"card-title d-md-flex justify-content-between",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Sabit Sayfalar")]),_vm._v(" "),_c('div',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-fill btn-primary",attrs:{"title":"Yeni Sabit Sayfa Ekle","to":{ path: 'static-page/add/'},"tag":"li"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Yeni Sabit Sayfa")])],1)]),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Başlık")]),_vm._v(" "),_c('th',[_vm._v("Yayın Tarihi")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(item.created,"Do/MM/YYYY HH:mm:ss"))+" ")]),_vm._v(" "),_c('td',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"to":{ path: 'static-page/edit/'+item.id},"title":"Düzenle","tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"#","title":"Önizleme"}},[_c('i',{staticClass:"fas fa-eye"}),_vm._v(" "+_vm._s(item.view_count))]),_vm._v(" "),(item.status)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"deactivate-item.id"},on:{"click":function($event){return _vm.deactivate(item.id)}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(!item.status)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.activate(item.id)}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e()],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return _c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current)}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])])}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AM9e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__("qvnn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38a787d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__("liWi");
function injectStyle (ssrContext) {
  __webpack_require__("TbJv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38a787d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AdDj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("\n                Bildiriler Pdf\n                "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"mr-2 btn btn-danger btn-sm btn-fill",on:{"click":function($event){return _vm.addNew()}}},[_vm._v("Ekle")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm btn-fill",on:{"click":function($event){return _vm.update()}}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"row w-100"},[_c('div',{staticClass:"col-12 col-md-2 d-flex align-items-center"},[_c('button',{staticClass:"btn btn-warning activebtn-s mr-2 px-2",attrs:{"disabled":!item.image,"type":"submit"}},[(item.image)?_c('a',{staticClass:"text-warning",attrs:{"href":_vm.generalURL('haberler')+item.image,"target":"_blank"}},[_vm._v("PDF AÇ")]):_vm._e(),_vm._v(" "),(!item.image)?_c('span',{staticClass:"text-danger text-light pdf-alert-text"},[_vm._v("Pdf Yüklenmedi")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-9"},[_c('label',[_vm._v("Açıklama")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.target_url),expression:"item.target_url"}],staticClass:"form-control",attrs:{"type":"text","name":""},domProps:{"value":(item.target_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "target_url", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{staticClass:"btn btn btn-sm",attrs:{"title":"PDF Değiştir"},on:{"click":function($event){return _vm.myPdf(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('input',{staticClass:"m-3",staticStyle:{"display":"none"},attrs:{"name":"myFile","id":'myPdf'+index,"type":"file"},on:{"change":function($event){return _vm.upload($event)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])])])])])])}),0)],1)],1)])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AdK6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("dF6d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc71ad4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("Gbj9");
function injectStyle (ssrContext) {
  __webpack_require__("yYKm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc71ad4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AhrW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AiZQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Al/j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Bilgi Ekle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata\n        ")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Detay Linki")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.link),expression:"post.link"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Link","aria-label":"Başlık","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "link", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("İçerik")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.content.content),expression:"content.content"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('İçerik')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.content.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.content, "content", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3 d-flex flex-column align-items-end"}),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("400 x 200 pixel")]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),(_vm.image.cropped)?_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.cropped}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":true,"viewport":{width: 500, height: 250, type: 'suare'},"boundary":{width: 600, height: 300},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ApCf":
/***/ (function(module, exports) {

module.exports = {"_args":[["weekstart@1.0.1","/home/bilemedimki/www/buzpateni.org.tr/panel/panel-development"]],"_from":"weekstart@1.0.1","_id":"weekstart@1.0.1","_inBundle":false,"_integrity":"sha512-h6B1HSJxg7sZEXqIpDqAtwiDBp3x5y2jY8WYcUSBhLTcTCy7laQzBmamqMuQM5fpvo1pgpma0OCRpE2W8xrA9A==","_location":"/weekstart","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"weekstart@1.0.1","name":"weekstart","escapedName":"weekstart","rawSpec":"1.0.1","saveSpec":null,"fetchSpec":"1.0.1"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/weekstart/-/weekstart-1.0.1.tgz","_spec":"1.0.1","_where":"/home/bilemedimki/www/buzpateni.org.tr/panel/panel-development","author":{"name":"Denis Sikuler"},"bugs":{"url":"https://github.com/gamtiq/weekstart/issues"},"description":"Library to get first day of week.","devDependencies":{"@babel/preset-env":"7.6.3","eslint":"6.5.1","eslint-config-guard":"1.0.3","ink-docstrap":"1.3.2","jest":"24.9.0","jsdoc":"3.6.3","microbundle":"0.4.4","version-bump-prompt":"5.0.5"},"homepage":"https://github.com/gamtiq/weekstart","keywords":["week","start","first","day","locale","country","region"],"license":"MIT","main":"dist/commonjs/main.js","module":"dist/es-module/main.js","name":"weekstart","repository":{"type":"git","url":"git://github.com/gamtiq/weekstart.git"},"scripts":{"all":"npm run check-all && npm run doc && npm run build","build":"npm run build-umd && npm run build-commonjs && npm run build-esm && npm run build-umd-min","build-commonjs":"microbundle build \"src/!(*.test).js\" --output dist/commonjs --format cjs --strict --no-compress","build-esm":"microbundle build \"src/!(*.test).js\" --output dist/es-module --format es --no-compress","build-umd":"microbundle build src/main.js src/full.js --output dist --format umd --strict --no-compress","build-umd-min":"microbundle build src/main.js src/full.js --output dist/min --format umd --strict","check":"npm run lint && npm test","check-all":"npm run lint-all && npm test","doc":"jsdoc -c jsdoc-conf.json","lint":"eslint --cache --max-warnings 0 \"**/*.js\"","lint-all":"eslint --max-warnings 0 \"**/*.js\"","lint-all-error":"eslint \"**/*.js\"","lint-error":"eslint --cache \"**/*.js\"","release":"bump patch --commit --tag --all --push package.json package-lock.json bower.json component.json","release-major":"bump major --commit --tag --all --push package.json package-lock.json bower.json component.json","release-minor":"bump minor --commit --tag --all --push package.json package-lock.json bower.json component.json","test":"jest"},"types":"./index.d.ts","umd:main":"dist/main.js","version":"1.0.1"}

/***/ }),

/***/ "AqsR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostModules_DigitalPress_Index_vue__ = __webpack_require__("vHBR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostsTable: __WEBPACK_IMPORTED_MODULE_0__PostModules_DigitalPress_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "Astv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      videoupdated: false,
      publishTime: null,
      futurePost: false,
      socialMedia: true,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: "Announcements",
        image: null,
        newvideo: null,
        newvideo_id: null,
        content_id: null,
        video_id: null
      },
      categories: null,
      category: {
        category_id: "",
        name: null,
        url: null,
        is_active: 1
      },
      subCategories: null,
      disableParent: false,
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      order: {
        post_id: null,
        slider_group: "Announcements",
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: "title",
            meta_value: null
          },
          meta3: {
            meta_key: "description",
            meta_value: null
          },
          meta4: {
            meta_key: "view_count",
            meta_value: 0
          }
        }
      },
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        cropped: null
      },
      sliderImage: {
        cropped: null
      },
      croppieType: "main",
      sliderImageLoaded: false,
      // end of post data
      users: null,
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    uploadPdf: function uploadPdf(event) {
      var _this = this;

      this.file = event.target.files[0];
      if (this.file.type !== "application/pdf") {
        this.notifier('top', 'right', 'danger', 'Lütfen excel formatında bir dosya seçiniz');
      } else {
        var data = new FormData();
        data.append("file", this.file);
        var fileName = this.file.name.split(".");
        var extension = "";
        var newName = "";
        fileName.forEach(function (e, index) {
          if (index < fileName.length - 1) {
            newName += e;
          }
          if (index == fileName.length - 1) {
            extension += e;
          }
        });
        newName += new Date().getTime();
        var fullName = newName + "." + extension;
        data.append("fileName", fullName);
        this.$http.post("/api/files/upload-pdf/" + fullName, data).then(function (response) {
          _this.post.image = fullName;
          _this.notifier("top", "right", "success", "Pdf başarıyla kaydedildi");
        }, function (er) {
          _this.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        });
      }
    },
    addImageToEditor: function addImageToEditor(i) {
      var _this2 = this;

      this.$http.post('/api/images/upload/' + this.post.url + 'announcements_inner-image', {
        cropped: i
      }).then(function (response) {
        _this2.content.content = _this2.content.content + '<div class="flex-images"><img src="' + _this2.mediaURL() + response.body.Data.Response.name + '" width="600px height="450px" alt="' + _this2.post.url + '" /></div>';
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.url) {
        this.croppieType = type;
      } else {
        this.notifier('top', 'right', 'danger', 'Resim ekleyebilmek için bir başlık belirlemelisiniz.');
      }
    },

    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      }
      if (!this.post.url) {
        this.errors.push("URL");
      }
      if (!this.content.content) {
        this.errors.push("İçerik");
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this3 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById("url").classList.add("is-invalid");
        document.getElementById("url").classList.remove("is-valid");
        document.getElementById("url-label").classList.add("is-invalid");
        document.getElementById("url-label").classList.remove("is-valid");
        _this3.notifier("top", "right", "danger", "URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin");
        _this3.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
        _this3.saveContent();
      });
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById('myImage').files.length) {
        oFReader.readAsDataURL(document.getElementById('myImage').files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this4 = this;

      var dis = this;
      var wdt = 600;
      var hgt = 450;
      if (this.croppieType === 'tinymce') {
        wdt = 1600;
        hgt = 1200;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: wdt,
            height: hgt
          },

          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this4.croppieType === 'main') {
            dis.image.cropped = output;
          } else if (_this4.croppieType === 'slider') {
            dis.sliderImage.cropped = output;
            dis.sliderImageLoaded = true;
          } else if (_this4.croppieType === 'tinymce') {
            _this4.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this4.addImageToEditor(output);
          }
          _this4.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    },

    saveContent: function saveContent() {
      var _this5 = this;

      var button = event.target;
      this.$http.post("/api/contents/add", this.content).then(function (response) {
        _this5.post.content_id = response.body.Data.Response.id;
        _this5.saveVideo();
      }, function (e) {
        button.innerHTML = "Kaydet";
        _this5.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this5.toggleLoader();
      });
    },
    saveImage: function saveImage() {
      var _this6 = this;

      this.$http.post('/api/images/upload/' + this.post.url, this.image).then(function (response) {
        _this6.post.image = response.body.Data.Response.name;
        _this6.savePost();
      }, function (e) {
        _this6.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this6.toggleLoader();
      });
    },
    saveVideo: function saveVideo() {
      var _this7 = this;

      if (this.video.video_url !== null) {
        this.$http.post("/api/videos/add", this.video).then(function (response) {
          _this7.post.video_id = response.body.Data.Response.name;
          _this7.saveImage();
        }, function (e) {
          _this7.notifier("top", "right", "danger", "Bir Hata Oluştu");
          _this7.toggleLoader();
        });
      } else {
        this.savePost();
      }
    },

    savePost: function savePost() {
      var _this8 = this;

      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ["br"] }).substring(0, 500);
      }
      if (this.videoupdated) {
        this.post.video = this.video;
      } else {
        this.post.video = null;
      }

      this.$http.post("/api/posts/add", this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this8.post.id = pid;
        _this8.metas.post_id = pid;
        _this8.order.post_id = pid;
        _this8.saveMetas();
      }, function (e) {
        _this8.toggleLoader();

        if (!e.body.Error) {
          _this8.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {

          _this8.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveMetas: function saveMetas() {
      var _this9 = this;

      this.$http.post("/api/post-metas/add-bulk", this.metas).then(function (response) {
        _this9.notifier("top", "right", "success", "Başarılı");
        _this9.$router.push("/announcements");
        _this9.toggleLoader();
      }, function (e) {
        _this9.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this9.toggleLoader();
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name) + '-d';
    },
    slugifyUrl: function slugifyUrl() {
      this.post.url = this.slugify(this.post.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById("url").classList.add("is-invalid");
        document.getElementById("url").classList.remove("is-valid");
        document.getElementById("url-label").classList.add("is-invalid");
        document.getElementById("url-label").classList.remove("is-valid");
      }).catch(function (er) {
        document.getElementById("url").classList.add("is-valid");
        document.getElementById("url").classList.remove("is-invalid");
        document.getElementById("url-label").classList.add("is-valid");
        document.getElementById("url-label").classList.remove("is-invalid");
      });
    },

    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this10 = this;

        request.$http.get("/api/filter/posts/url/" + request.post.url).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this10.notifier("top", "right", "danger", "Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        });
      });
    }

  }, mounted: function mounted() {
    var _this11 = this;

    this.$http.get("/api/posts/get-with-type/Announcements").then(function (response) {
      _this11.allposts = response.body;
    }, function (er) {
      _this11.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
      _this11.toggleLoader();
    });
  }
});

/***/ }),

/***/ "Ay9Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('h4',{staticClass:"card-title d-md-flex justify-content-between",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Yatırımcı Sözlüğü")]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('addWord'),expression:"'addWord'"}],staticClass:"m-1 btn-sm"},[_vm._v("Ekle")])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"addWord"}},[_c('b-card',[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Kelime")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newWord.word),expression:"newWord.word"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.newWord.word)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newWord, "word", $event.target.value)}}})]),_vm._v(" "),_c('span',{attrs:{"id":"basic-addon1"}},[_vm._v("Açıklama")]),_vm._v(" "),_c('tinymce',{ref:"tm",staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.newWord.description),callback:function ($$v) {_vm.$set(_vm.newWord, "description", $$v)},expression:"newWord.description"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-success mt-3 float-right",on:{"click":function($event){return _vm.saveWord()}}},[_vm._v("Kaydet")])],1)],1),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('div',{staticClass:"filters my-3 d-flex justify-content-between"},[_c('b-button-group',{attrs:{"size":"sm"}},[_c('b-button',{staticClass:"btn-fill btn-success active type-button",attrs:{"id":"type-all"},on:{"click":function($event){return _vm.changeType('all')}}},[_vm._v("Tümü")]),_vm._v(" "),_vm._l((_vm.letters),function(item){return _c('b-button',{key:item,staticClass:"btn-fill btn-success type-button",attrs:{"id":"type-1"},on:{"click":function($event){return _vm.changeType(item)}}},[_vm._v(_vm._s(item.toUpperCase()))])})],2)],1),_vm._v(" "),_c('div',{staticClass:"filters my-3 d-flex ml-3 w-25 align-items-center position-relatice"},[_c('div',{staticClass:"input-group w-100 ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],staticClass:"form-control form-control-sm border-primary text-primary",attrs:{"type":"text","placeholder":"Arama"},domProps:{"value":(_vm.query)},on:{"keyup":function($event){return _vm.getPosts()},"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text bg-white border-primary text-primary",attrs:{"id":"basic-addon2"}},[_c('i',{staticClass:"fas fa-circle-notch fa-spin d-none",attrs:{"id":"small-spinner"}})])])])])]),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[(!_vm.query)?_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]):_vm._e(),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Kelime")]),_vm._v(" "),_c('th',{staticStyle:{"width":"75%"}},[_vm._v("Açıklama")]),_vm._v(" "),_c('th',{staticStyle:{"width":"5%"}},[_vm._v("İşlem")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.word))]),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(item.description)}}),_vm._v(" "),_c('td',[_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Sil","id":"deactivate-item.id"},on:{"click":function($event){return _vm.sil(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])])])}),0)]),_vm._v(" "),(!_vm.query)?_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Aya3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[(!_vm.err)?_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Tüm Sayfalar\n      ")]),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Sayfa")]),_vm._v(" "),_c('th',[_vm._v("Bölüm")]),_vm._v(" "),_c('th',[_vm._v("Yayın Tarihi")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.subtitle))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(item.created,"Do/MM/YYYY HH:mm:ss")))]),_vm._v(" "),_c('td',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"to":{ path: '/activity-program/edit/'+item.id},"title":"Düzenle","tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),(item.status !== 4 )?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"deactivate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,4)}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(item.status === 4)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,1)}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e()],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n  "+_vm._s(_vm.err)+"\n")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B1pu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B4lv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BBt8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LeaderModules_Index_vue__ = __webpack_require__("31ur");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__LeaderModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "BFq9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BGbZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BJ9F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Haber Düzenle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata\n        ")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('span'),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"url-label"}},[_vm._v("URL")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.url),expression:"post.url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('URL')},attrs:{"type":"text","placeholder":"URL","aria-label":"URL","id":"url","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.url)},on:{"keyup":_vm.slugifyUrl,"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.category_id),expression:"post.category_id"}],staticClass:"custom-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.post, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.createUrl]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Üst Kategori Seçimi Yapınız")]),_vm._v(" "),_vm._l((_vm.categories),function(cat){return _c('option',{key:cat.id,domProps:{"value":cat.id}},[_vm._v("\n              "+_vm._s(cat.name)+"\n            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3 d-flex flex-column align-items-end"},[_c('tinymce',{class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('vue-tabs',[_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Resim"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("600 x 450 pixel")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.file,"id":"main-i"}})],1)])]),_vm._v(" "),_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Video"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 input-group px-5 m-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Video Adresi")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.newvideo),expression:"post.newvideo"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"https://www.youtube.com/watch?v=KZzON_7EQ70","aria-label":"Başlık","id":"title","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.newvideo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "newvideo", $event.target.value)}}})])])])],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 450, height: 300, type: 'suare'},"boundary":{width: 600, height: 450},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BU5j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BZ9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menus_vue__ = __webpack_require__("Hq+v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01e917a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menus_vue__ = __webpack_require__("hmwy");
function injectStyle (ssrContext) {
  __webpack_require__("fIVt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01e917a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BZdN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/activity-program-page'}}},[_c('button',{staticClass:"btn btn-info  btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Faaliyet Programı")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/activity-program-content'}}},[_c('button',{staticClass:"btn btn-danger active btn-sm  px-2 mr-2",attrs:{"type":"submit"}},[_vm._v("İçerik")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('form',{staticClass:"w-100",on:{"submit":_vm.submit}},[(!_vm.err)?_c('div',[_c('h1',{staticClass:"h4 mt-0 d-flex justify-content-between"},[_c('span',[_vm._v("Aktivite Programı İçerik")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-sm btn-fill",attrs:{"type":"submit"}},[_vm._v("Kaydet")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"d-flex flex-column"},[_c('label',{attrs:{"for":_vm.settings.name}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.settings.meta.title))])]),_vm._v(" "),_c('tinymce',{staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.settings.data),callback:function ($$v) {_vm.$set(_vm.settings, "data", $$v)},expression:"settings.data"}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n      "+_vm._s(_vm.err)+"\n    ")]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BZxW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('stats-card',[_c('div',{staticClass:"icon-warning",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"nc-icon nc-chart text-warning"})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',{staticClass:"card-category"},[_vm._v("Capacity")]),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("105GB")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("Updated now\n          ")])])],1),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('stats-card',[_c('div',{staticClass:"icon-success",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"nc-icon nc-light-3 text-success"})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',{staticClass:"card-category"},[_vm._v("Revenue")]),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("$1,345")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('i',{staticClass:"fa fa-calendar-o"}),_vm._v("Last day\n          ")])])],1),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('stats-card',[_c('div',{staticClass:"icon-danger",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"nc-icon nc-vector text-danger"})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',{staticClass:"card-category"},[_vm._v("Errors")]),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("23")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v("Last day\n          ")])])],1),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('stats-card',[_c('div',{staticClass:"icon-info",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"nc-icon nc-favourite-28 text-primary"})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',{staticClass:"card-category"},[_vm._v("Followers")]),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("+45")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("Updated now\n          ")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('chart-card',{attrs:{"chart-data":_vm.lineChart.data,"chart-options":_vm.lineChart.options,"responsive-options":_vm.lineChart.responsiveOptions}},[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Users Behavior")]),_vm._v(" "),_c('p',{staticClass:"card-category"},[_vm._v("24 Hours performance")])]),_vm._v(" "),_c('template',{slot:"footer"},[_c('div',{staticClass:"legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" Open\n              "),_c('i',{staticClass:"fa fa-circle text-danger"}),_vm._v(" Click\n              "),_c('i',{staticClass:"fa fa-circle text-warning"}),_vm._v(" Click Second Time\n            ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"fa fa-history"}),_vm._v(" Updated 3 minutes ago\n            ")])])],2)],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('chart-card',{attrs:{"chart-data":_vm.pieChart.data,"chart-type":"Pie"}},[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Email Statistics")]),_vm._v(" "),_c('p',{staticClass:"card-category"},[_vm._v("Last Campaign Performance")])]),_vm._v(" "),_c('template',{slot:"footer"},[_c('div',{staticClass:"legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" Open\n              "),_c('i',{staticClass:"fa fa-circle text-danger"}),_vm._v(" Bounce\n              "),_c('i',{staticClass:"fa fa-circle text-warning"}),_vm._v(" Unsubscribe\n            ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v(" Campaign sent 2 days ago\n            ")])])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('chart-card',{attrs:{"chart-data":_vm.barChart.data,"chart-options":_vm.barChart.options,"chart-responsive-options":_vm.barChart.responsiveOptions,"chart-type":"Bar"}},[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("2014 Sales")]),_vm._v(" "),_c('p',{staticClass:"card-category"},[_vm._v("All products including Taxes")])]),_vm._v(" "),_c('template',{slot:"footer"},[_c('div',{staticClass:"legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" Tesla Model S\n              "),_c('i',{staticClass:"fa fa-circle text-danger"}),_vm._v(" BMW 5 Series\n            ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Data information certified\n            ")])])],2)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('card',[_c('template',{slot:"header"},[_c('h5',{staticClass:"title"},[_vm._v("Tasks")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Backend development")])]),_vm._v(" "),_c('l-table',{attrs:{"data":_vm.tableData.data,"columns":_vm.tableData.columns},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('td',[_c('Checkbox',{model:{value:(row.checked),callback:function ($$v) {_vm.$set(row, "checked", $$v)},expression:"row.checked"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.title))]),_vm._v(" "),_c('td',{staticClass:"td-actions text-right"},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip.top-center",value:(_vm.editTooltip),expression:"editTooltip",modifiers:{"top-center":true}}],staticClass:"btn-simple btn btn-xs btn-info",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip.top-center",value:(_vm.deleteTooltip),expression:"deleteTooltip",modifiers:{"top-center":true}}],staticClass:"btn-simple btn btn-xs btn-danger",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-times"})])])]}}])},[_c('template',{slot:"columns"})],2),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"fa fa-history"}),_vm._v(" Updated 3 minutes ago\n            ")])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C3eh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/allnews'}}},[_c('button',{staticClass:"btn btn-info  btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Haberler")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/allnews-order'}}},[_c('button',{staticClass:"btn btn-warning active text-white btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Haber Sıralaması")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('div',{staticClass:"row"},[(!_vm.err)?_c('div',{staticClass:"col-12 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',[_vm._v("\n              Haberleri Sırala\n              "),_c('small',{staticClass:"text-info"},[_vm._v("Haberlerin sıralamasını değiştirmek için sürükleyin.")])]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.sliderItems),callback:function ($$v) {_vm.sliderItems=$$v},expression:"sliderItems"}},[_c('transition-group',_vm._l((_vm.sliderItems),function(item){return _c('div',{key:item.id},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-12 d-flex align-items-center"},[_vm._v(_vm._s(item.post.name)+"( Kategori Adı - "+_vm._s(item.post.category.name)+" )")])])])])}),0)],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n        "+_vm._s(_vm.err)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('p',{staticClass:"text-danger mb-0"},[_vm._v("Genişlik(277) Yükseklik(244). PNG ve arkası şeffaf olacak şekilde")]),_vm._v(" "),_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 277, height: 244, type: 'suare'},"boundary":{width: 400, height: 400},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CBpD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      videoupdated: false,
      publishTime: null,
      futurePost: false,
      socialMedia: true,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: "LeaderArticles",
        image: null,
        newvideo: null,
        newvideo_id: null,
        content_id: null,
        video_id: null
      },
      categories: null,
      category: {
        category_id: "",
        name: null,
        url: null,
        is_active: 1
      },
      subCategories: null,
      disableParent: false,
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      order: {
        post_id: null,
        slider_group: "LeaderArticles",
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: "title",
            meta_value: null
          },
          meta3: {
            meta_key: "description",
            meta_value: null
          },
          meta4: {
            meta_key: "view_count",
            meta_value: 0
          }
        }
      },
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        cropped: null
      },
      sliderImage: {
        cropped: null
      },
      croppieType: "main",
      sliderImageLoaded: false,
      // end of post data
      users: null,
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post("/api/images/upload/" + this.post.url + "_inner-image", {
        cropped: i
      }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + _this.post.url + '" />';
      }, function (e) {
        _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      }
      if (!this.post.url) {
        this.errors.push("URL");
      }
      if (!this.content.content) {
        this.errors.push("İçerik");
      }
      if (!this.image.cropped) {
        this.errors.push("Resim");
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById("url").classList.add("is-invalid");
        document.getElementById("url").classList.remove("is-valid");
        document.getElementById("url-label").classList.add("is-invalid");
        document.getElementById("url-label").classList.remove("is-valid");
        _this2.notifier("top", "right", "danger", "URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin");
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
        _this2.saveContent();
      });
    },
    saveContent: function saveContent() {
      var _this3 = this;

      var button = event.target;
      this.$http.post("/api/contents/add", this.content).then(function (response) {
        _this3.post.content_id = response.body.Data.Response.id;
        _this3.saveVideo();
      }, function (e) {
        button.innerHTML = "Kaydet";
        _this3.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this3.toggleLoader();
      });
    },
    saveVideo: function saveVideo() {
      var _this4 = this;

      if (this.video.video_url !== null) {
        this.$http.post("/api/videos/add", this.video).then(function (response) {
          _this4.post.video_id = response.body.Data.Response.name;
          _this4.saveImage();
        }, function (e) {
          _this4.notifier("top", "right", "danger", "Bir Hata Oluştu");
          _this4.toggleLoader();
        });
      } else {
        this.saveImage();
      }
    },
    saveImage: function saveImage() {
      var _this5 = this;

      this.$http.post("/api/images/upload/" + this.post.url, this.image).then(function (response) {
        _this5.post.image = response.body.Data.Response.name;
        _this5.savePost();
      }, function (e) {
        _this5.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this5.toggleLoader();
      });
    },

    savePost: function savePost() {
      var _this6 = this;

      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ["br"] }).substring(0, 500);
      }
      if (this.videoupdated) {
        this.post.video = this.video;
      } else {
        this.post.video = null;
      }
      if (this.post.newvideo) {
        var newvideo_id = this.post.newvideo.split("v=")[1];
        var ampersandPosition = newvideo_id.indexOf("&");
        if (ampersandPosition != -1) {
          newvideo_id = newvideo_id.substring(0, ampersandPosition);
        }
        this.post.newvideo_id = newvideo_id;
      }
      this.$http.post("/api/posts/add", this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this6.post.id = pid;
        _this6.metas.post_id = pid;
        _this6.order.post_id = pid;
        _this6.saveOrder();
      }, function (e) {
        _this6.toggleLoader();

        if (!e.body.Error) {
          _this6.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {

          _this6.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveOrder: function saveOrder() {
      var _this7 = this;

      if (this.allposts && this.allposts.length) {
        this.order.order_number = this.allposts.length;
      } else {
        this.order.order_number = 0;
      }
      this.$http.post("/api/slider/add/LeaderArticles", this.order).then(function (response) {
        _this7.saveMetas();
        _this7.notifier("top", "right", "success", "Başarılı");
      }, function (e) {
        _this7.toggleLoader();
        _this7.notifier("top", "right", "danger", "Bir Hata Oluştu");
      });
    },
    saveMetas: function saveMetas() {
      var _this8 = this;

      this.$http.post("/api/post-metas/add-bulk", this.metas).then(function (response) {
        _this8.notifier("top", "right", "success", "Başarılı");
        _this8.$router.push("/leader/articles");
        _this8.toggleLoader();
      }, function (e) {
        _this8.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this8.toggleLoader();
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name) + '-la';
    },
    slugifyUrl: function slugifyUrl() {
      this.post.url = this.slugify(this.post.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById("url").classList.add("is-invalid");
        document.getElementById("url").classList.remove("is-valid");
        document.getElementById("url-label").classList.add("is-invalid");
        document.getElementById("url-label").classList.remove("is-valid");
      }).catch(function (er) {
        document.getElementById("url").classList.add("is-valid");
        document.getElementById("url").classList.remove("is-invalid");
        document.getElementById("url-label").classList.add("is-valid");
        document.getElementById("url-label").classList.remove("is-invalid");
      });
    },

    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this9 = this;

        request.$http.get("/api/filter/posts/url/" + request.post.url).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this9.notifier("top", "right", "danger", "Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.url) {
        this.croppieType = type;
      } else {
        this.notifier("top", "right", "danger", "Resim ekleyebilmek için bir başlık belirlemelisiniz.");
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this10 = this;

      var dis = this;
      var wdt = 1200;
      var hgt = 600;
      if (this.croppieType === "tinymce") {
        wdt = 1200;
        hgt = 600;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: "jpeg",
          size: {
            width: wdt,
            height: hgt
          },

          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this10.croppieType === "main") {
            dis.image.cropped = output;
          } else if (_this10.croppieType === "slider") {
            dis.sliderImage.cropped = output;
            dis.sliderImageLoaded = true;
          } else if (_this10.croppieType === "tinymce") {
            _this10.notifier("top", "right", "warning", "Lütfen resim yükleninceye kadar bekleyin.");
            _this10.addImageToEditor(output);
          }
          _this10.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result: function result(output) {
      return output;
    }
  }, mounted: function mounted() {
    var _this11 = this;

    this.$http.get("/api/posts/get-with-type/LeaderArticles").then(function (response) {
      _this11.allposts = response.body;
    }, function (er) {
      _this11.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
      _this11.toggleLoader();
    });
  }
});

/***/ }),

/***/ "CCCg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Bildiri Ekle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('span'),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"change":_vm.validate,"keyup":_vm.createUrl,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"url-label"}},[_vm._v("URL")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.url),expression:"post.url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('URL')},attrs:{"type":"text","placeholder":"URL","aria-label":"URL","id":"url","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.url)},on:{"keyup":_vm.slugifyUrl,"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Alt Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.subtitle),expression:"post.subtitle"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Alt Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.subtitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "subtitle", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Kategori")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.category_id),expression:"post.category_id"}],staticClass:"custom-select",class:{'is-invalid' : _vm.errors.includes('Kategori')},attrs:{"disabled":_vm.disableParent},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.post, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.loadItems]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Üst Kategori Seçimi Yapınız")]),_vm._v(" "),_vm._l((_vm.categories),function(cat){return _c('option',{key:cat.id,domProps:{"value":cat.id}},[_vm._v("\n              "+_vm._s(cat.name)+"\n            ")])})],2)]),_vm._v(" "),(_vm.subCategories)?_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Alt Kategori")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.sub_category_id),expression:"post.sub_category_id"}],staticClass:"custom-select",class:{'is-invalid' : _vm.errors.includes('Alt Kategori')},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.post, "sub_category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.createUrl]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Alt Kategori Seçimi Yapınız")]),_vm._v(" "),_vm._l((_vm.subCategories),function(cat){return _c('option',{key:cat.id,domProps:{"value":cat.id}},[_vm._v("\n              "+_vm._s(cat.name)+"\n            ")])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3 d-flex flex-column align-items-end"},[_c('tinymce',{class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('vue-tabs',[_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Resim"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("600 x 450 pixel")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.cropped}})],1)])]),_vm._v(" "),_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Video"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 input-group px-5 m-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Video Adresi")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.newvideo),expression:"post.newvideo"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"https://www.youtube.com/watch?v=KZzON_7EQ70","aria-label":"Başlık","id":"title","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.newvideo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "newvideo", $event.target.value)}}})])])])],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 450, height: 300, type: 'suare'},"boundary":{width: 600, height: 450},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CMvA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('h4',{staticClass:"card-title d-md-flex justify-content-between align-items-center",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Üye Ara")])]),_vm._v(" "),_c('div',{staticClass:"filters my-3 d-flex flex-column align-items-center position-relatice"},[_c('div',{staticClass:"user-types"},[_vm._v("\n              Arama\n            ")]),_vm._v(" "),_c('div',{staticClass:"input-group w-25"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],staticClass:"form-control border-primary text-primary",attrs:{"type":"text","placeholder":"Ne aramıştınız?"},domProps:{"value":(_vm.query)},on:{"keyup":function($event){return _vm.getPosts()},"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text bg-white border-primary text-primary",attrs:{"id":"basic-addon2"}},[_c('i',{staticClass:"fas fa-circle-notch fa-spin d-none",attrs:{"id":"small-spinner"}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("E-Posta")]),_vm._v(" "),_c('th',[_vm._v("İsim")]),_vm._v(" "),_c('th',[_vm._v("Telefon Numarası")]),_vm._v(" "),_c('th',[_vm._v("Kullanıcı Adı")]),_vm._v(" "),_c('th',[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name)+" "+_vm._s(item.surname))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.username))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.phone))]),_vm._v(" "),_c('td',{staticStyle:{"width":"15%"}},[(item.is_active)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Pasif Et","id":"deactivate-item.id"},on:{"click":function($event){return _vm.deactivate(item.id)}}},[_c('i',{staticClass:"fas fa-unlink"})]):_vm._e(),_vm._v(" "),(!item.is_active)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Aktif Et","id":"activate-item.id"},on:{"click":function($event){return _vm.activate(item.id)}}},[_c('i',{staticClass:"fas fa-link"})]):_vm._e()])])}),0)])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CTT9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CawJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      comment: {
        is_active: 0
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      query: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeType: function changeType(t) {
      this.type = t;
      var buttons = Array.prototype.slice.call(document.getElementsByClassName('type-button'));
      buttons.forEach(function (b) {
        b.classList.remove('active');
      });
      event.target.classList.add('active');
      this.getPosts(1, this.type);
    },
    deactivate: function deactivate(id) {
      var _this = this;

      this.toggleLoader();
      this.comment.published = 0;
      this.$http.post('/api/comments/edit/' + id, this.comment).then(function (response) {
        _this.notifier('top', 'right', 'warning', 'Yorum Yayından Kaldırıldı');
        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    activate: function activate(id) {
      var _this2 = this;

      this.toggleLoader();
      this.comment.published = 1;
      this.$http.post('/api/comments/edit/' + id, this.comment).then(function (response) {
        _this2.notifier('top', 'right', 'success', 'Yorum Yayınlandı');
        _this2.getPosts(_this2.page, _this2.type);
        _this2.toggleLoader();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this3 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';

      if (this.query) {
        if (this.tmId) {
          clearTimeout(this.tmId);
        }
        this.tmId = setTimeout(function () {
          if (_this3.query) {
            document.getElementById('small-spinner').classList.remove('d-none');
            _this3.$http.get('/api/search-comment/' + _this3.query).then(function (response) {
              document.getElementById('small-spinner').classList.add('d-none');
              _this3.table = response.body;
              _this3.table.forEach(function (i) {
                i.comment = _this3.$sanitize(i.comment, { allowedTags: ['user-reference'] }).replace(/<user-reference>/g, '@').replace(/<\/user-reference>/g, ' ');
              });
              clearTimeout(_this3.tmId);
            }, function (er) {
              _this3.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
              clearTimeout(_this3.tmId);
            });
          }
        }, 700);
      } else {
        this.type = t;
        var url = '/api/filter/comments/limit/' + this.limit + '/page/' + p;
        if (this.type !== 'all') {
          url = url + '/published/' + this.type;
        }

        this.$http.get(url).then(function (response) {
          _this3.table = response.body.data;
          _this3.table.forEach(function (i) {
            i.comment = _this3.$sanitize(i.comment, { allowedTags: ['user-reference'] }).replace(/<user-reference>/g, '@').replace(/<\/user-reference>/g, ' ');
          });
          _this3.total = response.body.meta.total;
          _this3.page = p;
          _this3.pageCount = [];
          for (var i = 0; i < _this3.total / _this3.limit; i++) {
            _this3.pageCount.push(i + 1);
          }
        }, function (er) {
          _this3.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      }
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "Cj6S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ckm2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__ = __webpack_require__("lcz4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bc0b1aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__ = __webpack_require__("sNgK");
function injectStyle (ssrContext) {
  __webpack_require__("6QrH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bc0b1aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CpV0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/activity-program-page'}}},[_c('button',{staticClass:"btn btn-info active btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Faaliyet Programı")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/activity-program-content'}}},[_c('button',{staticClass:"btn btn-danger  btn-sm  px-2 mr-2",attrs:{"type":"submit"}},[_vm._v("İçerik")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[(!_vm.err)?_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Faaliyet Programı\n      ")]),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Sayfa")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',{staticClass:"d-flex justify-content-around align-items-center"},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"to":{ path: 'activity-program-page/edit/'+item.id},"title":"Düzenle","tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})])],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n    "+_vm._s(_vm.err)+"\n  ")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Crv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__("R5Ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarLink_vue__ = __webpack_require__("7SdG");



var SidebarStore = {
  showSidebar: false,
  sidebarLinks: [{
    name: 'Dashboard',
    icon: 'ti-panel',
    path: '/admin/overview'
  }],
  displaySidebar: function displaySidebar(value) {
    this.showSidebar = value;
  }
};

var SidebarPlugin = {
  install: function install(Vue) {
    Vue.mixin({
      data: function data() {
        return {
          sidebarStore: SidebarStore
        };
      }
    });

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get: function get() {
        return this.$root.sidebarStore;
      }
    });
    Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]);
    Vue.component('sidebar-link', __WEBPACK_IMPORTED_MODULE_1__SidebarLink_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),

/***/ "D0NI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D0Sq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D204":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D2Ge":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D3dw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',[_vm._v("\n            "+_vm._s(e)+"\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('label',{staticClass:"input-group-text border-0 bg-white",attrs:{"for":"inputGroupSelect01"}},[_vm._v("Kullanıcı Türü")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.user_type_id),expression:"user.user_type_id"}],staticClass:"custom-select",class:{'is-invalid' : _vm.errors.includes('Kategori')},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.user, "user_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.userTypes),function(type){return _c('option',{domProps:{"value":type.id}},[_vm._v("\n              "+_vm._s(type.name)+"\n            ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Ad")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.name),expression:"user.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Ad","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.user.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Soyad")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.surname),expression:"user.surname"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Soyad","id":"surname","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.user.surname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "surname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("TC Kimlik No")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.tcno),expression:"user.tcno"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"number","placeholder":"TC Kimlik Numarası","id":"tcno","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.user.tcno)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "tcno", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("E-Posta")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.email),expression:"user.email"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"E-Posta","id":"email","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.user.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('h6',[_vm._v("Şifre Değiştir")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Şifre")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password),expression:"user.password"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"password","placeholder":"Şifre","id":"pass","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.user.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Şifre Tekrar")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.passwordRepeat),expression:"passwordRepeat"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"password","placeholder":"Şifre Tekrar","id":"passw","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.passwordRepeat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.passwordRepeat=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 300, height: 300, type: 'suare'},"boundary":{width: 400, height: 400},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("dXrS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e22f0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("O0jz");
function injectStyle (ssrContext) {
  __webpack_require__("c0Rt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e22f0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DHhI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("DdyV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39843740_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("8PLX");
function injectStyle (ssrContext) {
  __webpack_require__("lG1W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39843740_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DV+G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: [{
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'provincialoffices',
        order_number: null
      }],
      err: null,
      selectedType: null,
      types: ['URL', 'Kategori', 'Alt Kategori', 'Yayın', 'Etiket'],
      options: [],
      sliderItems: null,
      newSliderImage: {
        cropped: null,
        image_id: null,
        image_name: null,
        imageIndex: null
      },
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier('top', 'right', 'danger', 'Slider Başarıyla silindi');
          _this.getSlider();
        }, function (e) {
          if (!e.body.Error) {
            _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          } else {
            _this.notifier("top", "right", "danger", e.body.Error);
          }
        });
      }
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post('/api/images/upload/' + this.newSliderImage.image_name + 'allleaders-slider', this.newSliderImage).then(function (response) {
        var i = _this2.newSliderImage.n === 0 ? 'image' : 'image2';
        _this2.slider[_this2.newSliderImage.imageIndex][i] = response.body.Data.Response.name;
        _this2.toggleLoader();
        _this2.hideCroppieModal();
        _this2.update();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    addNew: function addNew() {
      this.slider.push({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'provincialoffices',
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = 'provincialoffices';
      });
      this.$http.post('/api/images/edit/', this.slider).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi');
        _this3.getSlider();
      }, function (e) {
        if (!e.body.Error) {
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this3.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = '/api/images/provincialoffices';
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
      }, function (er) {
        if (!er.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this4.err = er.body.Error;
          _this4.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    initiateCroppie: function initiateCroppie(id, i, n) {
      this.newSliderImage.image_id = id;
      this.newSliderImage.image_name = this.slugify(this.slider[i].title);
      this.newSliderImage.imageIndex = i;
      this.newSliderImage.n = n;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          console.log(refz.main.bind);
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {

      this.crop();
    },
    crop: function crop() {
      var _this5 = this;

      var dis = this;
      this.toggleLoader();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg' | 'png' | 'webp',
          backgroundColor: '#fff',
          size: {
            width: 500,
            height: 500
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this5.newSliderImage.cropped = output;
          _this5.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "DZuI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isEdit: false,
      categories: null,
      category: {
        category_id: "",
        name: null,
        url: null,
        is_active: 1
      },
      subCategories: null,
      disableParent: false,
      errors: [],
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.category.name) {
        this.errors.push("Başlık");
      };
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      this.toggleLoader();
      if (this.isEdit) {
        this.updateCategory();
      } else {
        this.saveCategory();
      }
    },
    saveCategory: function saveCategory() {
      var _this = this;

      if (this.category.category_id === "") {
        if (this.subCategories !== null) {
          this.subCategories = this.subCategories.split(/\n/g);
          var sub_categories = [];
          for (var i = 0; i < this.subCategories.length; i++) {
            var subCategory = {
              name: this.subCategories[i],
              url: this.slugify(this.subCategories[i]) + '-' + Math.floor(Math.random() * (99999 - 0) + 0),
              is_active: 1
            };
            sub_categories.push(subCategory);
          }
          this.category.sub_categories = sub_categories;
        }
        this.category.url = this.slugify(this.category.name + '-' + Math.floor(Math.random() * (999 - 0) + 0));
        this.category.category_type = "seasons";
        delete this.category.category_id;
        this.$http.post('/api/categories/add', this.category).then(function (response) {
          _this.notifier('top', 'right', 'success', 'Başarılı');
          _this.$router.push('/seasons');
          _this.toggleLoader();
        }, function (e) {
          _this.toggleLoader();
          if (!e.body.Error) {
            _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          } else {
            _this.notifier('top', 'right', 'danger', e.body.Error);
          }
        });
      } else {
        this.category.url = this.slugify(this.category.name + '-' + Math.floor(Math.random() * (999 - 0) + 0));
        this.$http.post('/api/sub-categories/add', this.category).then(function (response) {
          _this.notifier('top', 'right', 'success', 'Başarılı');
          _this.$router.push('/seasons');
          _this.toggleLoader();
        }, function (e) {
          _this.toggleLoader();
          if (!e.body.Error) {
            _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          } else {
            _this.notifier('top', 'right', 'danger', e.body.Error);
          }
        });
      }
    },
    updateCategory: function updateCategory() {
      var _this2 = this;

      if (this.category.category_id === "") {
        if (this.subCategories !== null) {
          this.subCategories = this.subCategories.split(/\n/g);
          var sub_categories = [];
          for (var i = 0; i < this.subCategories.length; i++) {
            var subCategory = {
              name: this.subCategories[i],
              url: this.slugify(this.subCategories[i]) + '-' + Math.floor(Math.random() * (99999 - 0) + 0),
              is_active: 1
            };
            sub_categories.push(subCategory);
          }
          this.category.sub_categories = sub_categories;
        }
        this.category.url = this.slugify(this.category.name + '-' + Math.floor(Math.random() * (999 - 0) + 0));
        delete this.category.category_id;
        this.category.category_type = "seasons";
        this.$http.post('/api/categories/edit/' + this.$route.params.id, this.category).then(function (response) {
          _this2.notifier('top', 'right', 'success', 'Başarılı');
          _this2.$router.push('/seasons');
          _this2.toggleLoader();
        }, function (e) {
          _this2.toggleLoader();
          if (!e.body.Error) {
            _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          } else {
            _this2.notifier('top', 'right', 'danger', e.body.Error);
          }
        });
      } else {
        this.category.url = this.slugify(this.category.name + '-' + Math.floor(Math.random() * (999 - 0) + 0));
        this.$http.post('/api/sub-categories/edit/' + this.$route.params.id, this.category).then(function (response) {
          _this2.notifier('top', 'right', 'success', 'Başarılı');
          _this2.$router.push('/seasons');
          _this2.toggleLoader();
        }, function (e) {
          _this2.toggleLoader();
          if (!e.body.Error) {
            _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          } else {
            _this2.notifier('top', 'right', 'danger', e.body.Error);
          }
        });
      }
    },
    createUrl: function createUrl() {
      if (!isEdit) {
        this.category.url = this.slugify(this.category.name);
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var _this3 = this;

      this.toggleLoader();
      this.$http.get('/api/categories/seasons').then(function (response) {
        _this3.categories = response.body;
        if (_this3.$route.params.id && _this3.$route.params.type) {
          var controller = null;
          if (parseInt(_this3.$route.params.type)) {
            controller = 'sub-categories';
          } else {
            controller = 'categories';
            _this3.disableParent = true;
          }
          _this3.$http.get('/api/' + controller + '/get-without-joins/' + _this3.$route.params.id).then(function (response) {
            _this3.isEdit = true;
            _this3.category = response.body;
            delete _this3.category.sub_categories;
            if (controller === 'categories') {
              _this3.category.category_id = '';
            }
            _this3.toggleLoader();
          }, function (response) {
            _this3.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
            _this3.toggleLoader();
          });
        } else {
          _this3.toggleLoader();
        }
      }, function (er) {
        _this3.toggleLoader();
        _this3.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    });
  }
});

/***/ }),

/***/ "Dc25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ddip":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedbacks_vue__ = __webpack_require__("uiR1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cb93116_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedbacks_vue__ = __webpack_require__("3EhU");
function injectStyle (ssrContext) {
  __webpack_require__("xx5g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedbacks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cb93116_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedbacks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DdyV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: [{
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'newslider' + this.$route.params.id,
        order_number: null
      }],
      selectedType: null,
      types: ['URL', 'Kategori', 'Alt Kategori', 'Yayın', 'Etiket'],
      options: [],
      sliderItems: null,
      newSliderImage: {
        cropped: null,
        image_id: null,
        image_name: null,
        imageIndex: null
      },
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier('top', 'right', 'danger', 'Slider Başarıyla silindi');
          _this.getSlider();
        }, function (e) {
          _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          _this.toggleLoader();
        });
      }
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post('/api/images/upload/new-slider', this.newSliderImage).then(function (response) {
        var i = _this2.newSliderImage.n === 0 ? 'image' : 'image2';
        _this2.slider[_this2.newSliderImage.imageIndex][i] = response.body.Data.Response.name;
        _this2.toggleLoader();
        _this2.hideCroppieModal();
        _this2.update();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    addNew: function addNew() {
      this.slider.unshift({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'newslider' + this.$route.params.id,
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      var newdis = this;
      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = 'newslider' + newdis.$route.params.id;
      });
      this.$http.post('/api/images/edit/', this.slider).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi');
        _this3.getSlider();
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = '/api/images/newslider/' + this.$route.params.id;
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
      }, function (er) {
        _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
      });
    },
    initiateCroppie: function initiateCroppie(id, i, n) {
      this.newSliderImage.image_id = id;
      this.newSliderImage.image_name = this.slugify(this.slider[i].title);
      this.newSliderImage.imageIndex = i;
      this.newSliderImage.n = n;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {

      this.crop();
    },
    crop: function crop() {
      var _this5 = this;

      var dis = this;
      this.toggleLoader();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg' | 'png' | 'webp',
          backgroundColor: '#fff',
          size: {
            width: 1600,
            height: 800
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this5.newSliderImage.cropped = output;
          _this5.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "Dlmg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: [{
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'allleaders',
        order_number: null
      }],
      err: null,
      selectedType: null,
      types: ['URL', 'Kategori', 'Alt Kategori', 'Yayın', 'Etiket'],
      options: [],
      sliderItems: null,
      newSliderImage: {
        cropped: null,
        image_id: null,
        image_name: null,
        imageIndex: null
      },
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier('top', 'right', 'danger', 'Slider Başarıyla silindi');
          _this.getSlider();
        }, function (e) {
          if (!e.body.Error) {
            _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          } else {
            _this.notifier("top", "right", "danger", e.body.Error);
          }
        });
      }
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post('/api/images/upload/' + this.newSliderImage.image_name + 'allleaders-slider', this.newSliderImage).then(function (response) {
        var i = _this2.newSliderImage.n === 0 ? 'image' : 'image2';
        _this2.slider[_this2.newSliderImage.imageIndex][i] = response.body.Data.Response.name;
        _this2.toggleLoader();
        _this2.hideCroppieModal();
        _this2.update();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    addNew: function addNew() {
      this.slider.push({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'allleaders',
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = 'allleaders';
      });
      this.$http.post('/api/images/edit/', this.slider).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi');
        _this3.getSlider();
      }, function (e) {
        if (!e.body.Error) {
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this3.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = '/api/images/allleaders';
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
      }, function (er) {
        if (!er.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this4.err = er.body.Error;
          _this4.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    initiateCroppie: function initiateCroppie(id, i, n) {
      this.newSliderImage.image_id = id;
      this.newSliderImage.image_name = this.slugify(this.slider[i].title);
      this.newSliderImage.imageIndex = i;
      this.newSliderImage.n = n;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {

      this.crop();
    },
    crop: function crop() {
      var _this5 = this;

      var dis = this;
      this.toggleLoader();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg' | 'png' | 'webp',
          backgroundColor: '#fff',
          size: {
            width: 580,
            height: 388
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this5.newSliderImage.cropped = output;
          _this5.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "DqtS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dvrb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("+9k9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97be6c5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("TyVL");
function injectStyle (ssrContext) {
  __webpack_require__("w2DA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97be6c5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ERSz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_search_select__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: [{
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'allnewpdf' + this.$route.params.id,
        order_number: null
      }],
      fullName: '',
      selectedType: null,
      types: ["URL", "Kategori", "Alt Kategori", "Yayın", "Etiket"],
      options: [],
      sliderItems: null,
      newPdf: {
        Pdf_id: null,
        Pdf_name: null,
        PdfIndex: null
      },

      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "all",
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_1_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier('top', 'right', 'danger', 'PDF Başarıyla silindi');
          _this.getSlider();
        }, function (e) {
          _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          _this.toggleLoader();
        });
      }
    },
    upload: function upload(event) {
      var _this2 = this;

      var file = event.target.files[0];
      if (file.type !== "application/pdf") return console.log(file);
      var data = new FormData();
      data.append("file", file);
      var newfile = file.name.split('.');
      var extension = '';
      var name = '';
      newfile.forEach(function (e, index) {
        if (index < newfile.length - 1) {
          name += e;
        }
        if (index == newfile.length - 1) {
          extension += e;
        }
      });

      var newName = name + new Date().getTime();
      this.fullName = newName + '.' + extension;
      data.append("fileName", this.fullName);

      this.$http.post("/api/files/upload-news-pdf/" + this.newPdf.Pdf_name, data).then(function (response) {
        var i = _this2.newPdf.n === 0 ? 'image' : 'image2';
        _this2.slider[_this2.newPdf.PdfIndex][i] = _this2.newPdf.Pdf_name;
        console.log(_this2.newPdf.Pdf_name);
        _this2.notifier('top', 'right', 'success', 'Pdf Başarıyla Yüklendi');
        _this2.update();
      }, function (er) {
        _this2.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
      });
    },
    myPdf: function myPdf(id, i, n) {
      this.newPdf.Pdf_id = id;
      if (this.slider[i].target_url) {
        this.newPdf.Pdf_name = this.slugify(this.slider[i].target_url) + new Date().getTime() + '.pdf';
      } else {
        this.newPdf.Pdf_name = 'BuzPateni' + new Date().getTime() + '.pdf';
      }
      this.newPdf.PdfIndex = i;
      this.newPdf.n = n;
      document.getElementById('myPdf' + i).click();
    },
    addNew: function addNew() {
      this.slider.push({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'allnewpdf' + this.$route.params.id,
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      var newdis = this;
      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = 'allnewpdf' + newdis.$route.params.id;
      });
      this.$http.post('/api/images/edit/', this.slider).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi');
        _this3.getSlider();
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = "/api/images/allnewpdf/" + this.$route.params.id;
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
      }, function (er) {
        _this4.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
      });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "EUen":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Evg4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("qwbg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9ba2c20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("XmhP");
function injectStyle (ssrContext) {
  __webpack_require__("f71D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9ba2c20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "F04T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isEdit: false,
      user: {
        user_type_id: null,
        name: null,
        surname: null,
        tcno: null,
        email: null,
        password: null,
        profile_photo: null,
        url: "nourl",
        authkey: "nokey",
        recoverytoken: null,
        lastrecovery: null,
        is_active: 1
      },
      passwordRepeat: null,
      userTypes: null,
      errors: [],
      image: {
        cropped: null
      },
      imageRecreated: false,
      croppieType: "main",
      // end of post data
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      },
      branches: {
        0: "Senkronize Buz Pateni",
        1: "Artistik Buz Pateni",
        2: "Short Track"
      },
      categories: {
        0: {
          0: "Pre-Juvenile",
          1: "Juvenile",
          2: "Basic Novice",
          3: "Advanced Novice",
          4: "Mixed Age 1",
          5: "Senior Elite 12",
          6: "Mixed Age 3",
          7: "Junior",
          8: "Senior"
        },
        1: {
          0: "Senior",
          1: "Junior",
          2: "Advanced Novice",
          3: "Intermediate Novice",
          4: "Basic Novice 1",
          5: "Basic Novice 2",
          6: "Pre-Novice",
          7: "Cubs 1",
          8: "Cubs 2",
          9: "Chicks 1",
          10: "Chicks 2"
        },
        2: {
          0: "Mix",
          1: "Senior",
          2: "Junior A",
          3: "Junior B",
          4: "Junior C",
          5: "Junior D",
          6: "Junior E",
          7: "Junior F",
          8: "Junior G"
        },
        3: {
          0: "1. Grup",
          1: "2. Grup",
          2: "3. Grup",
          3: "4. Grup"
        },
        4: {
          0: "1. Grup",
          1: "2. Grup",
          2: "3. Grup"
        }
      },
      genders: {
        0: "Kadın",
        1: "Erkek"
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    setUrl: function setUrl(data, path) {
      return this.raceURL() + data + path;
    },
    license: function license(data) {
      return this.licenseURL() + data;
    },
    hes: function hes(data) {
      return this.hesURL() + data;
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.user.name) {
        this.errors.push("Ad Alanı Boş");
      }
      if (!this.user.surname) {
        this.errors.push("Soyad Alanı Boş");
      }
      if (!this.user.email) {
        this.errors.push("E-Posta Alanı Boş");
      }
      if (!this.isEdit) {
        if (!this.user.password) {
          this.errors.push("Şifre Alanı Boş");
        }
      }
      if (!this.isEdit) {
        if (this.user.password !== this.passwordRepeat) {
          this.errors.push("Şifreler Birbiriyle Eşleşmedi");
        }
      } else {
        if (this.user.password !== this.passwordRepeat && "password" in this.user && this.user.password !== "") {
          this.errors.push("Şifreler Birbiriyle Eşleşmedi");
        }
      }
      if (!this.validEmail(this.user.email)) {
        this.errors.push("E-Posta Formatı Doğru Değil");
      }
      if (!this.errors.length) {
        this.saveImage();
      }
    },
    validEmail: function validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    saveImage: function saveImage() {
      var _this = this;

      this.toggleLoader();
      if (this.imageRecreated) {
        this.$http.post("/api/images/upload/" + this.user.url, this.image).then(function (response) {
          _this.user.profile_photo = response.body.Data.Response.name;
          if (_this.isEdit) {
            _this.updateUser();
          } else {
            _this.saveUser();
          }
        }, function (e) {
          button.innerHTML = "Kaydet";
          _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          _this.toggleLoader();
        });
      } else {
        if (this.isEdit) {
          this.updateUser();
        } else {
          this.saveUser();
        }
      }
    },
    saveUser: function saveUser() {
      var _this2 = this;

      this.$http.post("/api/users/add", this.user).then(function (response) {
        _this2.notifier("top", "right", "success", "Başarılı");
        if (_this2.$route.params.type === "member") {
          _this2.$router.push("/members");
        } else {
          _this2.$router.push("/users");
        }
        _this2.toggleLoader();
      }, function (e) {
        _this2.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this2.toggleLoader();
      });
    },
    updateUser: function updateUser() {
      var _this3 = this;

      if (this.user.password === "") {
        delete this.user.password;
      }
      this.user.url = this.user.url + "-" + this.user.id;
      this.$http.post("/api/users/edit/" + this.user.id, this.user).then(function (response) {
        _this3.notifier("top", "right", "success", "Başarılı");
        if (_this3.$route.params.type === "member") {
          _this3.$router.push("/members");
        } else {
          _this3.$router.push("/users");
        }
        _this3.toggleLoader();
      }, function (e) {
        _this3.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this3.toggleLoader();
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      this.croppieType = type;
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this4 = this;

      var dis = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: "jpeg",
          size: {
            width: 800,
            height: 800
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this4.croppieType === "main") {
            dis.image.cropped = output;
            dis.imageRecreated = true;
          } else if (_this4.croppieType === "slider") {
            dis.sliderimage.cropped = output;
            dis.sliderImageLoaded = true;
          }
          _this4.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var _this5 = this;

      this.toggleLoader();
      this.$http.get("/api/user-types/all").then(function (response) {
        _this5.userTypes = response.body;
        if (_this5.$route.params.id) {
          _this5.$http.get("/api/users/get-without-joins/" + _this5.$route.params.id).then(function (response) {
            _this5.isEdit = true;
            _this5.user = response.body;
            _this5.user.athletes = JSON.parse(_this5.user.athletes);
            _this5.user.athletes.forEach(function (e) {
              e.category = _this5.categories[e.branch][e.category];
              e.branch = _this5.branches[e.branch];
              e.gender = _this5.genders[e.gender];
            });
            _this5.image.cropped = _this5.mediaURL() + _this5.user.profile_photo;
            _this5.toggleLoader();
          }, function (response) {
            _this5.notifier("top", "right", "danger", "Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
            _this5.toggleLoader();
          });
        } else {
          _this5.toggleLoader();
        }
      }, function (er) {
        _this5.toggleLoader();
        _this5.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
      });
    });
  }
});

/***/ }),

/***/ "F0oR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      publishTime: null,
      futurePost: false,
      socialMedia: true,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'Activityprogrampage',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          },
          meta4: {
            meta_key: 'view_count',
            meta_value: 0
          }
        }
      },
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        cropped: null
      },
      sliderImage: {
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post('/api/images/upload/' + this.post.name + 'act_inner-image', {
        cropped: i
      }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + '" />';
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push('Başlık');
      }
      if (!this.image.cropped) {
        this.errors.push('Resim');
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this2.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
        _this2.saveImage();
      });
    },
    saveImage: function saveImage() {
      var _this3 = this;

      this.$http.post('/api/images/upload/' + this.slugify(this.post.name), this.image).then(function (response) {
        _this3.post.image = response.body.Data.Response.name;
        _this3.savePost();
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this3.toggleLoader();
      });
    },
    savePost: function savePost() {
      var _this4 = this;

      var newdate = new Date();
      if (!this.post.url) {
        this.post.url = this.post.name + newdate.getTime();
      }
      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.$http.post('/api/posts/add', this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this4.post.id = pid;
        _this4.metas.post_id = pid;
        _this4.saveMetas();
      }, function (e) {
        _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this4.toggleLoader();
      });
    },
    saveMetas: function saveMetas() {
      var _this5 = this;

      this.$http.post('/api/post-metas/add-bulk', this.metas).then(function (response) {
        _this5.notifier('top', 'right', 'success', 'Başarılı');
        _this5.$router.push('/activity-program-page');
        _this5.toggleLoader();
      }, function (e) {
        _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this5.toggleLoader();
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name);
    },
    slugifyUrl: function slugifyUrl() {
      this.post.url = this.slugify(this.post.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this6 = this;

        request.$http.get('/api/filter/posts/post-type/Activityprogrampage/name/' + request.post.name).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this6.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.name) {
        this.croppieType = type;
      } else {
        this.notifier('top', 'right', 'danger', 'Resim ekleyebilmek için bir başlık belirlemelisiniz.');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById('myImage').files.length) {
        oFReader.readAsDataURL(document.getElementById('myImage').files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this7 = this;

      var dis = this;
      var wdt = 150;
      var hgt = 150;
      if (this.croppieType === 'tinymce') {
        wdt = 150;
        hgt = 150;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: wdt,
            height: hgt
          },
          quality: 1,
          backgroundColor: '#fff'
        };
        dis.$refs.main.result(options, function (output) {
          if (_this7.croppieType === 'main') {
            dis.image.cropped = output;
          } else if (_this7.croppieType === 'tinymce') {
            _this7.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this7.addImageToEditor(output);
          }
          _this7.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  }
});

/***/ }),

/***/ "FDgi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"d-flex w-100 align-items-center"},[_c('label',{staticClass:"ml-4 btn btn-lg btn-danger mb-0",attrs:{"for":"file"}},[_vm._v("Dosya Seç")]),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","id":"file"},on:{"change":function($event){return _vm.uploadZip($event)}}}),_vm._v(" "),_c('p',{staticClass:"m-0 ml-3 h6"},[_vm._v(_vm._s(_vm.file.name))]),_vm._v(" "),_c('p',{staticClass:"m-0 ml-3 h6 text-danger",attrs:{"id":"percent"}},[_vm._v(_vm._s(_vm.uploadPercent)+" %")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FGMu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FXdQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,

      // post data
      videoupdated: false,
      post: {
        id: null,
        newvideo: null,
        user_id: this.getCurrentUserDetails(),
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: "Races",
        image: null,
        content_id: null,
        video_id: null,
        start_date: null,
        finish_date: null,
        changed_date: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: "title",
            meta_value: null
          },
          meta3: {
            meta_key: "description",
            meta_value: null
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        file: null,
        cropped: null
      },
      sliderImage: {
        file: null,
        cropped: null
      },
      croppieType: "main",
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      },
      firstSlider: false
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post("/api/images/upload/" + this.post.url + "races_inner-image", {
        cropped: i
      }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + _this.post.url + '" />';
      }, function (e) {
        _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      }
      if (!this.post.url) {
        this.errors.push("URL");
      }
      if (!this.content.content) {
        this.errors.push("İçerik");
      }
      if (!this.image.cropped && !this.image.file) {
        this.errors.push("Resim");
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById("url").classList.add("is-invalid");
        document.getElementById("url").classList.remove("is-valid");
        document.getElementById("url-label").classList.add("is-invalid");
        document.getElementById("url-label").classList.remove("is-valid");
        _this2.notifier("top", "right", "danger", "URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin");
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
        _this2.saveContent();
      });
    },
    saveContent: function saveContent() {
      var _this3 = this;

      var button = event.target;
      this.$http.post("/api/contents/edit/" + this.post.content.id, this.content).then(function (response) {
        _this3.saveImage();
      }, function (e) {
        button.innerHTML = "Kaydet";
        _this3.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this3.toggleLoader();
      });
    },
    saveImage: function saveImage() {
      var _this4 = this;

      if (this.image.cropped) {
        this.$http.post("/api/images/upload/" + this.post.url, this.image).then(function (response) {
          _this4.post.image = response.body.Data.Response.name;
          _this4.savePost();
        }, function (e) {
          button.innerHTML = "Kaydet";
          _this4.notifier("top", "right", "danger", "Bir Hata Oluştu");
          _this4.toggleLoader();
        });
      } else {
        this.savePost();
      }
    },
    savePost: function savePost() {
      var _this5 = this;

      this.post.comments = null;
      this.post.menus = null;
      this.post.slider = null;
      this.tempMetas = this.post.post_metas;
      this.post.post_metas = null;
      this.post.post_tags = null;
      this.post.category = null;
      this.post.sub_category = null;
      this.post.user = null;
      this.post.content = null;
      if (this.videoupdated) {
        this.post.video = this.video;
      } else {
        this.post.video = null;
      }

      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ["br"] }).substring(0, 500);
      }
      this.$http.post("/api/posts/edit/" + this.post.id, this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this5.post.id = pid;
        _this5.slider.post_id = pid;
        _this5.metas.post_id = pid;
        _this5.saveMetas();
      }, function (e) {
        _this5.toggleLoader();

        if (!e.body.Error) {
          _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this5.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveMetas: function saveMetas() {
      var _this6 = this;

      this.$http.put("/api/post-metas/edit-bulk/", this.metas).then(function (response) {
        _this6.notifier("top", "right", "success", "Başarılı");
        _this6.$router.push("/races");
        _this6.toggleLoader();
      }, function (e) {
        _this6.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this6.toggleLoader();
      });
    },
    getInitialData: function getInitialData() {
      var _this7 = this;

      this.toggleLoader();
      this.$http.get("/api/posts/get/" + this.id).then(function (response) {
        _this7.post = response.body;
        _this7.getSubs(_this7.post.category_id);
        _this7.content = _this7.post.content;
        _this7.image.file = _this7.mediaURL() + _this7.post.image;
        if (_this7.post.video) {
          _this7.video = _this7.post.video;
        } else {
          _this7.post.video = {
            video_url: null
          };
        }
        if (_this7.post.slider == null) {
          _this7.firstSlider = true;
        }
        _this7.metas = {
          post_id: _this7.post.id,
          items: {
            meta2: {
              meta_id: _this7.post.post_metas[_this7.post.meta_title].id,
              meta_key: "title",
              meta_value: _this7.post.post_metas[_this7.post.meta_title].meta_value
            },
            meta3: {
              meta_id: _this7.post.post_metas[_this7.post.meta_description].id,
              meta_key: "description",
              meta_value: _this7.post.post_metas[_this7.post.meta_description].meta_value
            }
          }
        };
        _this7.toggleLoader();
      }, function (er) {
        _this7.toggleLoader();
        _this7.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        return;
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name) + "-" + this.post.category_id + "-r" + this.post.sub_category_id;
    },
    slugifyUrl: function slugifyUrl() {
      this.announcement.url = this.slugify(this.announcement.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById("url").classList.add("is-invalid");
        document.getElementById("url").classList.remove("is-valid");
        document.getElementById("url-label").classList.add("is-invalid");
        document.getElementById("url-label").classList.remove("is-valid");
      }).catch(function (er) {
        document.getElementById("url").classList.add("is-valid");
        document.getElementById("url").classList.remove("is-invalid");
        document.getElementById("url-label").classList.add("is-valid");
        document.getElementById("url-label").classList.remove("is-invalid");
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this8 = this;

        request.$http.get("/api/filter/posts/exclude/id:" + this.id + "/url/" + request.post.url).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this8.notifier("top", "right", "danger", "Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      this.croppieType = type;
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    loadItems: function loadItems() {
      var _this9 = this;

      this.subCategories = null;
      this.createUrl();
      this.$http.get("/api/sub-categories/getsubcategories/" + this.post.category_id).then(function (response) {
        _this9.subCategories = response.body;
        _this9.createUrl();
      }, function (er) {
        _this9.toggleLoader();
        _this9.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        return;
      });
    },
    getSubs: function getSubs(id) {
      var _this10 = this;

      this.$http.get("/api/sub-categories/getsubcategories/" + id).then(function (response) {
        _this10.subCategories = response.body;
        _this10.createUrl();
      }, function (er) {
        _this10.toggleLoader();
        _this10.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        return;
      });
    },
    crop: function crop() {
      var _this11 = this;

      var dis = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: "jpeg",
          size: {
            width: 500,
            height: 300
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this11.croppieType === "main") {
            dis.image.cropped = output;
            document.getElementById("main-i").src = dis.image.cropped;
          } else if (_this11.croppieType === "slider") {
            dis.sliderImage.cropped = output;
            dis.sliderImageLoaded = true;
            document.getElementById("slider-i").src = dis.sliderImage.cropped;
          } else if (_this11.croppieType === "tinymce") {
            _this11.notifier("top", "right", "warning", "Lütfen resim yükleninceye kadar bekleyin.");
            _this11.addImageToEditor(output);
          }
          _this11.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    var _this12 = this;

    this.getInitialData(), this.$http.get("/api/categories/seasons").then(function (response) {
      _this12.categories = response.body;
    }, function (er) {
      _this12.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
      _this12.toggleLoader();
    });
  }
});

/***/ }),

/***/ "FkmI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        status: 1
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'Races',
      viewCounts: [],
      err: null

    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeStatus: function changeStatus(id, status) {
      var _this = this;

      this.toggleLoader();
      this.post.status = status;
      this.$http.post('/api/posts/edit/' + id, this.post).then(function (response) {
        if (!status) {
          _this.notifier('top', 'right', 'warning', 'Sayfa Yayından Kaldırıldı');
        } else {
          _this.notifier('top', 'right', 'success', 'Sayfa Yayınlandı');
        }

        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();
        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this2 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Races';

      this.toggleLoader();
      this.type = t;
      var url = '/api/filter/posts/post-type/' + this.type + '/limit/' + this.limit + '/page/' + p;
      this.$http.get(url).then(function (response) {
        _this2.table = response.body.data;
        _this2.total = response.body.meta.total;
        _this2.page = p;
        _this2.pageCount = [];
        for (var i = 0; i < _this2.total / _this2.limit; i++) {
          _this2.pageCount.push(i + 1);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.toggleLoader();

        if (!er.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this2.err = er.body.Error;
          _this2.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "Fzx+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("HudK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec37e88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("WgEv");
function injectStyle (ssrContext) {
  __webpack_require__("D0NI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec37e88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G3wS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GUeS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("QVsv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22d034a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("ZDDP");
function injectStyle (ssrContext) {
  __webpack_require__("sLXE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22d034a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gbj9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Bildiri Düzenle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata\n        ")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('span'),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"url-label"}},[_vm._v("URL")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.url),expression:"post.url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('URL')},attrs:{"type":"text","placeholder":"URL","aria-label":"URL","id":"url","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.url)},on:{"keyup":_vm.slugifyUrl,"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Alt Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.subtitle),expression:"post.subtitle"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Alt Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.subtitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "subtitle", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.category_id),expression:"post.category_id"}],staticClass:"custom-select",class:{'is-invalid' : _vm.errors.includes('Kategori')},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.post, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.loadItems]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Üst Kategori Seçimi Yapınız")]),_vm._v(" "),_vm._l((_vm.categories),function(cat){return _c('option',{key:cat.id,domProps:{"value":cat.id}},[_vm._v(_vm._s(cat.name))])})],2)]),_vm._v(" "),(_vm.subCategories)?_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.sub_category_id),expression:"post.sub_category_id"}],staticClass:"custom-select",class:{'is-invalid' : _vm.errors.includes('Alt Kategori')},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.post, "sub_category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.createUrl]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Alt Kategori Seçimi Yapınız")]),_vm._v(" "),_vm._l((_vm.subCategories),function(cat){return _c('option',{key:cat.id,domProps:{"value":cat.id}},[_vm._v(_vm._s(cat.name))])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3 d-flex flex-column align-items-end"},[_c('tinymce',{class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('vue-tabs',[_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Resim"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("600 x 450 pixel")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.file,"id":"main-i"}})],1)])]),_vm._v(" "),_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Video"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 input-group px-5 m-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Video Adresi")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.newvideo),expression:"post.newvideo"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"https://www.youtube.com/watch?v=KZzON_7EQ70","aria-label":"Başlık","id":"title","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.newvideo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "newvideo", $event.target.value)}}})])])])],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 450, height: 300, type: 'suare'},"boundary":{width: 600, height: 450},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GjBJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gp5R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      publishTime: null,
      futurePost: false,
      socialMedia: true,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'BankInformations',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          },
          meta4: {
            meta_key: 'view_count',
            meta_value: 0
          }
        }
      },
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        cropped: null
      },
      sliderImage: {
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post('/api/images/upload/' + this.post.name + '_bank-informations', {
        cropped: i
      }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + '" />';
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push('Başlık');
      }
      if (!this.content.content) {
        this.errors.push('İçerik');
      }
      if (!this.image.cropped) {
        this.errors.push('Resim');
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this2.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'
        _this2.saveContent();
      });
    },
    saveContent: function saveContent() {
      var _this3 = this;

      var button = event.target;
      this.$http.post('/api/contents/add', this.content).then(function (response) {
        _this3.post.content_id = response.body.Data.Response.id;
        _this3.saveVideo();
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this3.toggleLoader();
      });
    },

    saveVideo: function saveVideo() {
      var _this4 = this;

      if (this.video.video_url !== null) {
        this.$http.post('/api/videos/add', this.video).then(function (response) {
          _this4.post.video_id = response.body.Data.Response.name;
          _this4.saveImage();
        }, function (e) {
          button.innerHTML = 'Kaydet';
          _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this4.toggleLoader();
        });
      } else {
        this.saveImage();
      }
    },
    saveImage: function saveImage() {
      var _this5 = this;

      this.$http.post('/api/images/upload/' + this.slugify(this.post.name), this.image).then(function (response) {
        _this5.post.image = response.body.Data.Response.name;
        _this5.savePost();
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this5.toggleLoader();
      });
    },
    savePost: function savePost() {
      var _this6 = this;

      var newdate = new Date();
      if (!this.post.url) {
        this.post.url = this.post.name + newdate.getTime();
      }
      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.$http.post('/api/posts/add', this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this6.post.id = pid;
        _this6.metas.post_id = pid;
        _this6.saveMetas();
      }, function (e) {
        _this6.toggleLoader();

        if (!e.body.Error) {
          _this6.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {

          _this6.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveMetas: function saveMetas() {
      var _this7 = this;

      this.$http.post('/api/post-metas/add-bulk', this.metas).then(function (response) {
        _this7.notifier('top', 'right', 'success', 'Başarılı');
        _this7.$router.push('/bank-informations');
        _this7.toggleLoader();
      }, function (e) {
        _this7.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this7.toggleLoader();
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name);
    },
    slugifyUrl: function slugifyUrl() {
      this.post.url = this.slugify(this.post.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this8 = this;

        request.$http.get('/api/filter/posts/post-type/BankInformations/name/' + request.post.name).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this8.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.name) {
        this.croppieType = type;
      } else {
        this.notifier('top', 'right', 'danger', 'Resim ekleyebilmek için bir başlık belirlemelisiniz.');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById('myImage').files.length) {
        oFReader.readAsDataURL(document.getElementById('myImage').files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this9 = this;

      var dis = this;
      var wdt = 300;
      var hgt = 139;
      if (this.croppieType === 'tinymce') {
        wdt = 300;
        hgt = 139;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          backgroundColor: '#f8f9fa',
          size: {
            width: wdt,
            height: hgt
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this9.croppieType === 'main') {
            dis.image.cropped = output;
          } else if (_this9.croppieType === 'tinymce') {
            _this9.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this9.addImageToEditor(output);
          }
          _this9.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  }
});

/***/ }),

/***/ "Gp7W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GzUv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H+cs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Geri Bildirimler\n  ")]),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("E-Posta")]),_vm._v(" "),_c('th',[_vm._v("Mesaj")]),_vm._v(" "),_c('th',[_vm._v("Tarih")]),_vm._v(" "),_c('th')]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return (item)?_c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.url))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',{staticStyle:{"width":"45%"}},[_vm._v(_vm._s(item.content.content))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(_vm._f("duration")(item.created,'add', 3, 'hours'),'add', '3 hours', "DD.MM.YYYY HH:mm:ss")))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.deactivate(item.id)}}},[_vm._v("Sil")])])]):_vm._e()}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return _c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current)}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])])}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H3L1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-check",class:{disabled: _vm.disabled}},[_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.cbId}},[(_vm.$slots.label)?_vm._t("label"):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"form-check-input",attrs:{"id":_vm.cbId,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:(_vm.model)},on:{"change":function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"form-check-sign"})],2),_vm._v(" "),_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HXyF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HenA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HiXn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProvincialOfficesModules_ProvincialOffices_vue__ = __webpack_require__("32ah");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__ProvincialOfficesModules_ProvincialOffices_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "HnS8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hq+v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MenuModules_Index_vue__ = __webpack_require__("vtDO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__MenuModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "Hq6I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-7"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',[_vm._v("Ana Menü "),_c('small',{staticClass:"text-info"},[_vm._v("Menü sıralamasını değiştirmek için sürükleyin ")])]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.menus),callback:function ($$v) {_vm.menus=$$v},expression:"menus"}},[_c('transition-group',_vm._l((_vm.menus),function(menu){return _c('div',{key:menu.id},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-9"},[_vm._v(_vm._s(menu.name))]),_vm._v(" "),_c('div',{staticClass:"col-3 d-flex justify-content-end"},[_c('div',[_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Sil"},on:{"click":function($event){return _vm.remove(menu.id)}}},[_c('i',{staticClass:"fas fa-times"})])])])])])])}),0)],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-5"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',[_vm._v("Ekle")]),_vm._v(" "),_c('div',{staticClass:" input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.menu.name),expression:"menu.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Başlık","id":"name"},domProps:{"value":(_vm.menu.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.menu, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('label',{staticClass:"input-group-text border-0 bg-white",attrs:{"for":"inputGroupSelect01"}},[_vm._v("Tür")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedType),expression:"selectedType"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.loadItems]}},_vm._l((_vm.types),function(item){return _c('option',{key:item,domProps:{"value":item}},[_vm._v(_vm._s(item))])}),0)]),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[(_vm.selectedType == 'URL')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.menu.url),expression:"menu.url"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"URL","id":"name"},domProps:{"value":(_vm.menu.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.menu, "url", $event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.selectedType == 'Kategori')?_c('model-select',{staticClass:"form-control",attrs:{"options":_vm.options,"placeholder":"Kategori"},model:{value:(_vm.menu.category_id),callback:function ($$v) {_vm.$set(_vm.menu, "category_id", $$v)},expression:"menu.category_id"}}):_vm._e(),_vm._v(" "),(_vm.selectedType == 'Alt Kategori')?_c('model-select',{staticClass:"form-control",attrs:{"options":_vm.options,"placeholder":"Alt Kategori"},model:{value:(_vm.menu.sub_category_id),callback:function ($$v) {_vm.$set(_vm.menu, "sub_category_id", $$v)},expression:"menu.sub_category_id"}}):_vm._e(),_vm._v(" "),(_vm.selectedType == 'Yayın')?_c('model-select',{staticClass:"form-control",attrs:{"options":_vm.options,"placeholder":"Yayın"},model:{value:(_vm.menu.post_id),callback:function ($$v) {_vm.$set(_vm.menu, "post_id", $$v)},expression:"menu.post_id"}}):_vm._e(),_vm._v(" "),(_vm.selectedType == 'Etiket')?_c('model-select',{staticClass:"form-control",attrs:{"options":_vm.options,"placeholder":"Etiket"},model:{value:(_vm.menu.tag_id),callback:function ($$v) {_vm.$set(_vm.menu, "tag_id", $$v)},expression:"menu.tag_id"}}):_vm._e()],1),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){return _vm.save()}}},[_vm._v("Ekle")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HudK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      // post data
      post: {
        id: null,
        link: null,
        subtitle: null,
        user_id: this.getCurrentUserDetails(),
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'Cuppointpage',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        file: null,
        cropped: null
      },
      sliderImage: {
        file: null,
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      },
      firstSlider: false
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post('/api/images/upload/' + this.post.name + 'act_inner-image', { cropped: i }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + _this.post.name + '" />';
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      };
      if (!this.image.cropped && !this.image.file) {
        this.errors.push("Resim");
      };
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this2.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'
        _this2.saveImage();
      });
    },
    saveImage: function saveImage() {
      var _this3 = this;

      if (this.image.cropped) {
        this.$http.post('/api/images/upload/' + this.slugify(this.post.name), this.image).then(function (response) {
          _this3.post.image = response.body.Data.Response.name;
          _this3.savePost();
        }, function (e) {
          button.innerHTML = 'Kaydet';
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this3.toggleLoader();
        });
      } else {
        this.savePost();
      }
    },
    savePost: function savePost() {
      var _this4 = this;

      this.post.comments = null;
      this.post.menus = null;
      this.post.slider = null;
      this.tempMetas = this.post.post_metas;
      this.post.post_metas = null;
      this.post.post_tags = null;
      this.post.category = null;
      this.post.sub_category = null;
      this.post.user = null;
      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.$http.post('/api/posts/edit/' + this.post.id, this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this4.post.id = pid;
        _this4.slider.post_id = pid;
        _this4.slider.order_number = pid;
        _this4.metas.post_id = pid;
        _this4.saveMetas();
      }, function (e) {
        _this4.toggleLoader();

        if (!e.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this4.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveMetas: function saveMetas() {
      var _this5 = this;

      this.$http.put('/api/post-metas/edit-bulk/', this.metas).then(function (response) {
        _this5.notifier('top', 'right', 'success', 'Başarılı');
        _this5.$router.push('/cup-point-page');
        _this5.toggleLoader();
      }, function (e) {
        _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this5.toggleLoader();
      });
    },
    getInitialData: function getInitialData() {
      var _this6 = this;

      this.toggleLoader();
      this.$http.get('/api/posts/get/' + this.id).then(function (response) {
        _this6.post = response.body;
        _this6.content = _this6.post.content;
        _this6.image.file = _this6.mediaURL() + _this6.post.image;
        if (_this6.post.video !== null) {
          _this6.video = _this6.post.video;
        }
        if (_this6.post.slider == null) {
          _this6.firstSlider = true;
        }
        _this6.metas = {
          post_id: _this6.post.id,
          items: {
            meta2: {
              meta_id: _this6.post.post_metas[_this6.post.meta_title].id,
              meta_key: 'title',
              meta_value: _this6.post.post_metas[_this6.post.meta_title].meta_value
            },
            meta3: {
              meta_id: _this6.post.post_metas[_this6.post.meta_description].id,
              meta_key: 'description',
              meta_value: _this6.post.post_metas[_this6.post.meta_description].meta_value
            }
          }
        };
        _this6.toggleLoader();
      }, function (er) {
        _this6.toggleLoader();
        _this6.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name);
    },
    slugifyUrl: function slugifyUrl() {
      this.announcement.url = this.slugify(this.announcement.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this7 = this;

        request.$http.get('/api/filter/posts/exclude/id:' + this.id + '/post-type/Cuppointpage/name/' + request.post.name).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this7.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.name) {
        this.croppieType = type;
      } else {
        this.notifier('top', 'right', 'danger', 'Resim ekleyebilmek için bir başlık belirlemelisiniz.');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this8 = this;

      var dis = this;
      var wdt = 150;
      var hgt = 150;
      if (this.croppieType === "tinymce") {
        wdt = 150;
        hgt = 150;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          backgroundColor: '#fff',
          size: {
            width: wdt,
            height: hgt
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this8.croppieType === 'main') {
            dis.image.cropped = output;
            document.getElementById('main-i').src = dis.image.cropped;
          } else if (_this8.croppieType === 'tinymce') {
            _this8.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this8.addImageToEditor(output);
          }
          _this8.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.getInitialData();
  }
});

/***/ }),

/***/ "Hwcx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("SS9B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fcd4e9b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("CpV0");
function injectStyle (ssrContext) {
  __webpack_require__("0VlS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fcd4e9b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HwiA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Permissions_vue__ = __webpack_require__("1gvC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3820a7f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Permissions_vue__ = __webpack_require__("/KKg");
function injectStyle (ssrContext) {
  __webpack_require__("uIpp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Permissions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3820a7f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Permissions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I1r1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/leader'}}},[_c('button',{staticClass:"btn btn-info btn-sm  px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("İçerik")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/gallery'}}},[_c('button',{staticClass:"btn btn-warning btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Fotogaleri")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/pressgallery'}}},[_c('button',{staticClass:"btn btn-danger  btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Yazılı Basın")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/articles'}}},[_c('button',{staticClass:"btn btn-success active btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Başkanın Yazıları")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/articlesorder'}}},[_c('button',{staticClass:"btn btn-primary btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Yazı Sıralama")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/digital-press'}}},[_c('button',{staticClass:"btn btn-secondary btn-sm  mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Dijital Basın")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/digital-press-order'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Dijital Basın Sıralama")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[(!_vm.err)?_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n        Tüm Yazılar\n        "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill float-md-right",attrs:{"title":"Yeni Sayfa Oluştur","to":{ path: '/leader/articles/add'},"tag":"li"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Yeni Yazı\n        ")])],1),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Sayfa")]),_vm._v(" "),_c('th',[_vm._v("URL")]),_vm._v(" "),_c('th',[_vm._v("Yayın Tarihi")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.url))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(item.created,"Do/MM/YYYY HH:mm:ss")))]),_vm._v(" "),_c('td',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"to":{ path: '/leader/articles/edit/'+item.id},"title":"Düzenle","tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-warning btn-fill btn-xs",attrs:{"to":{ path: '/leader/articles/slider/'+item.id},"title":"Slider","tag":"li"}},[_c('i',{staticClass:"fas fa-images"})]),_vm._v(" "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-success btn-fill btn-xs",attrs:{"to":{ path: '/leader/articles/gallery/'+item.id},"title":"Galeri","tag":"li"}},[_c('i',{staticClass:"far fa-image"})]),_vm._v(" "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-info btn-fill btn-xs",attrs:{"to":{ path: '/leader/pdf/'+item.id},"title":"Pdf","tag":"li"}},[_c('i',{staticClass:"far fa-file-pdf"})]),_vm._v(" "),(item.status !== 4 )?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"deactivate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,4)}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(item.status === 4)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,1)}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e(),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-dark btn-fill",attrs:{"href":"#","title":"Okunma Sayısı"}},[_c('i',{staticClass:"fa fa-book"}),_vm._v(" "+_vm._s(item.readed))])],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n"+_vm._s(_vm.err)+"\n")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I7jR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("rp+z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36530c98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("dH+H");
function injectStyle (ssrContext) {
  __webpack_require__("hqgg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36530c98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ID+a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      file: {},
      uploadPercent: 0
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    uploadZip: function uploadZip(event) {
      var _this = this;

      this.file = event.target.files[0];
      if (!(this.file.type === "application/zip" || this.file.type === "application/x-zip-compressed")) {
        this.notifier("top", "right", "danger", "Lütfen zip formatında bir dosya seçiniz");
      } else {
        var data = new FormData();
        data.append("file", this.file);
        var fileName = this.file.name.split(".");
        var extension = "";
        var newName = "";
        fileName.forEach(function (e, index) {
          if (index < fileName.length - 1) {
            newName += e;
          }
          if (index == fileName.length - 1) {
            extension += e;
          }
        });
        newName += new Date().getTime();
        var fullName = newName + "." + extension;
        data.append("fileName", fullName);

        this.$http.post("/api/files/upload-zip/" + fullName, data, {
          progress: function progress(e) {
            if (e.lengthComputable) {
              this.uploadPercent = e.loaded / e.total * 100;
              document.getElementById('percent').innerHTML = this.uploadPercent.toFixed(2) + '%';
            }
          }
        }).then(function (response) {
          _this.notifier("top", "right", "success", "Sonuçlar Başarıyla Yüklendi");
          _this.file = {};
          event.target.value = null;
          _this.uploadPercent = 0;
        }, function (er) {
          _this.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
          _this.uploadPercent = 0;
        });
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  }
});

/***/ }),

/***/ "IS4u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEdit_vue__ = __webpack_require__("l0a+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4626f3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEdit_vue__ = __webpack_require__("nwHT");
function injectStyle (ssrContext) {
  __webpack_require__("u2Qy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4626f3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ib6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IckI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/main'}}},[_c('button',{staticClass:"btn btn-danger btn-sm px-2 mr-2",attrs:{"type":"submit"}},[_vm._v("Anasayfa Slider")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/intro-video'}}},[_c('button',{staticClass:"btn btn-primary active btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("İntro Videosu")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/homeboxes'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Anasayfa Kutular")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/homeinfos'}}},[_c('button',{staticClass:"btn btn-warning btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Anasayfa Bilgiler")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/announcements'}}},[_c('button',{staticClass:"btn btn-success btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Anasayfa Duyurular")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('form',{staticClass:"w-100",on:{"submit":_vm.submit}},[_c('div',{staticClass:"row"},[(!_vm.err)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"d-flex flex-column"},[_c('label',{attrs:{"for":_vm.settings.name}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.settings.meta.title))])]),_vm._v(" "),_c('div',{staticClass:"video d-flex justify-content-around align-items-center"},[_c('div',{ref:"video"}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-around w-100 align-items-center"},[_c('label',{staticClass:"ml-4 btn btn-lg btn-danger mb-0",attrs:{"for":"intro"}},[_vm._v("Dosya Seç")]),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","id":"intro"},on:{"change":function($event){return _vm.uploadVideo($event)}}})])])])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n          "+_vm._s(_vm.err)+"\n        ")]):_vm._e()])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ie5C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      // post data
      race: {
        id: null,
        user_id: null,
        post_id: null,
        athletes: null,
        general_music: null,
        document: null,
        club_list: null,
        extra_documents: null,
        status: null,
        notes: null,
        club_name: null,
        email: null,
        phone: null,
        full_name: null
      },
      oldRace: {
        id: null,
        user_id: null,
        post_id: null,
        athletes: null,
        general_music: null,
        document: null,
        club_list: null,
        extra_documents: null,
        status: null,
        notes: null,
        club_name: null,
        email: null,
        phone: null,
        full_name: null
      },
      logs: {
        user_id: null,
        race_id: null,
        old_datas: null,
        new_datas: null
      },
      user_id: this.getCurrentUserDetails().id,
      loading: false,
      branches: {
        0: "Senkronize Buz Pateni",
        1: "Artistik Buz Pateni",
        2: "Short Track"
      },
      categories: {
        0: {
          0: "Pre-Juvenile",
          1: "Juvenile",
          2: "Basic Novice",
          3: "Advanced Novice",
          4: "Mixed Age 1",
          5: "Senior Elite 12",
          6: "Mixed Age 3",
          7: "Junior",
          8: "Senior"
        },
        1: {
          0: "Senior",
          1: "Junior",
          2: "Advanced Novice",
          3: "Intermediate Novice",
          4: "Basic Novice 1",
          5: "Basic Novice 2",
          6: "Pre-Novice",
          7: "Cubs 1",
          8: "Cubs 2",
          9: "Chicks 1",
          10: "Chicks 2"
        },
        2: {
          0: "Men/Women",
          1: "Senior",
          2: "Junior A",
          3: "Junior B",
          4: "Junior C",
          5: "Junior D",
          6: "Junior E",
          7: "Junior F",
          8: "Junior G"
        },
        3: {
          0: "1. Grup",
          1: "2. Grup",
          2: "3. Grup",
          3: "4. Grup"
        },
        4: {
          0: "1. Grup",
          1: "2. Grup",
          2: "3. Grup"
        }
      },
      genders: {
        0: "Kadın",
        1: "Erkek"
      },
      categoryId: null
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    changeStatus: function changeStatus(id, key, status) {
      var _this = this;

      this.loading = true;
      this.toggleLoader();
      this.race.athletes.forEach(function (e, index) {
        if (index == key) {
          e.status = status;
        }
      });
      this.race.athletes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.race.athletes);
      this.$http.post("/api/race/edit-athlete/" + id, this.race).then(function (response) {
        // if (status == 1) {
        //   this.notifier("top", "right", "success", "Talep Kabul Edildi");
        // } else if (status == 4) {
        //   this.notifier("top", "right", "warning", "Talep Reddedildi");
        // }
        _this.saveLogs();
        _this.getInitialData();
        _this.toggleLoader();
      }, function (e) {
        _this.getInitialData();

        _this.toggleLoader();

        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveLogs: function saveLogs() {
      var _this2 = this;

      var vm = this;
      vm.logs.user_id = vm.user_id;
      vm.logs.race_id = vm.race.id;
      vm.logs.new_datas = vm.race.athletes;
      this.$http.post("/api/race-logs/add/", this.logs).then(function (response) {

        _this2.getInitialData();
      }, function (e) {
        _this2.getInitialData();

        _this2.toggleLoader();

        if (!e.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this2.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    setUrl: function setUrl(data, path) {
      return this.raceURL() + data + path;
    },
    license: function license(data) {
      return this.licenseURL() + data;
    },
    hes: function hes(data) {
      return this.hesURL() + data;
    },
    getInitialData: function getInitialData() {
      var _this3 = this;

      this.toggleLoader();
      this.$http.get("/api/race/get/" + this.id).then(function (response) {
        _this3.logs.old_datas = response.body.athletes;
        _this3.race = response.body;
        if (_this3.race.athletes) {
          _this3.race.athletes = JSON.parse(_this3.race.athletes);
        }
        _this3.loading = false;
        _this3.getRace();
        _this3.toggleLoader();
      }, function (er) {
        _this3.toggleLoader();
        _this3.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        return;
      });
    },

    getRace: function getRace() {
      var _this4 = this;

      this.toggleLoader();
      this.$http.get("/api/posts/get/" + this.race.post_id).then(function (response) {
        _this4.categoryId = response.body.category_id;
        // this.post = response.body;
        _this4.toggleLoader();
      }, function (er) {
        _this4.toggleLoader();
        _this4.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        return;
      });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getInitialData();
    });
  }
});

/***/ }),

/***/ "IeqH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/directors'}}},[_c('button',{staticClass:"btn btn-danger  btn-sm  px-2 mr-2",attrs:{"type":"submit"}},[_vm._v("Yönetim Kurulu")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/staffs'}}},[_c('button',{staticClass:"btn btn-info  btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Federasyon Personeli")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/all-leaders'}}},[_c('button',{staticClass:"btn btn-primary btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Başkanlarımız")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/history'}}},[_c('button',{staticClass:"btn btn-success btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Tarihçe")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/sub-board-categories'}}},[_c('button',{staticClass:"btn btn-warning btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Alt Kurullar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/provincial-offices'}}},[_c('button',{staticClass:"btn btn-secondary btn-sm  mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("İl Temsilcilikleri")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/bank-informations'}}},[_c('button',{staticClass:"btn btn-success active btn-sm  mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Hesap Numaraları")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/main-status-instructions'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Ana Statü Talimatlar")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[(!_vm.err)?_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Anasayfa Kutular\n      "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill float-md-right",attrs:{"title":"Yeni Sayfa Oluştur","to":{ path: 'bank-informations/add'},"tag":"li"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Yeni Hesap Numarası")])],1),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Sayfa")]),_vm._v(" "),_c('th',[_vm._v("Yayın Tarihi")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(item.created,"Do/MM/YYYY HH:mm:ss"))+" ")]),_vm._v(" "),_c('td',{staticClass:"d-flex justify-content-around align-items-center"},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"to":{ path: 'bank-informations/edit/'+item.id},"title":"Düzenle","tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),(item.status !== 4 )?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"deactivate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,4)}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(item.status === 4)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,1)}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e()],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n  "+_vm._s(_vm.err)+"\n")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IiAb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Yazı Ekle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata\n        ")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Bölüm")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.subtitle),expression:"post.subtitle"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Bölüm","aria-label":"Bölüm","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.subtitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "subtitle", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3 d-flex flex-column align-items-end"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.content.content),expression:"content.content"}],staticStyle:{"width":"100%"},attrs:{"cols":"30"},domProps:{"value":(_vm.content.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.content, "content", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IjiV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IjpU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      publishTime: null,
      futurePost: false,
      socialMedia: true,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'Facilities',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          },
          meta4: {
            meta_key: 'view_count',
            meta_value: 0
          }
        }
      },
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        cropped: null
      },
      sliderImage: {
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post('/api/images/upload/' + this.post.name + '_inner-image', {
        cropped: i
      }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + '" />';
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push('Başlık');
      }
      if (!this.content.content) {
        this.errors.push('İçerik');
      }
      if (!this.image.cropped) {
        this.errors.push('Resim');
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this2.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'
        _this2.saveContent();
      });
    },
    saveContent: function saveContent() {
      var _this3 = this;

      var button = event.target;
      this.$http.post('/api/contents/add', this.content).then(function (response) {
        _this3.post.content_id = response.body.Data.Response.id;
        _this3.saveVideo();
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this3.toggleLoader();
      });
    },

    saveVideo: function saveVideo() {
      var _this4 = this;

      if (this.video.video_url !== null) {
        this.$http.post('/api/videos/add', this.video).then(function (response) {
          _this4.post.video_id = response.body.Data.Response.name;
          _this4.saveImage();
        }, function (e) {
          button.innerHTML = 'Kaydet';
          _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this4.toggleLoader();
        });
      } else {
        this.saveImage();
      }
    },
    saveImage: function saveImage() {
      var _this5 = this;

      this.$http.post('/api/images/upload/' + this.slugify(this.post.name), this.image).then(function (response) {
        _this5.post.image = response.body.Data.Response.name;
        _this5.savePost();
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this5.toggleLoader();
      });
    },
    savePost: function savePost() {
      var _this6 = this;

      var newdate = new Date();
      if (!this.post.url) {
        this.post.url = this.post.name + newdate.getTime();
      }
      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.$http.post('/api/posts/add', this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this6.post.id = pid;
        _this6.metas.post_id = pid;
        _this6.saveMetas();
      }, function (e) {
        _this6.toggleLoader();

        if (!e.body.Error) {
          _this6.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {

          _this6.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveMetas: function saveMetas() {
      var _this7 = this;

      this.$http.post('/api/post-metas/add-bulk', this.metas).then(function (response) {
        _this7.notifier('top', 'right', 'success', 'Başarılı');
        _this7.$router.push('/facilities');
        _this7.toggleLoader();
      }, function (e) {
        _this7.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this7.toggleLoader();
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name);
    },
    slugifyUrl: function slugifyUrl() {
      this.post.url = this.slugify(this.post.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this8 = this;

        request.$http.get('/api/filter/posts/post-type/Facilities/name/' + request.post.name).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this8.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.name) {
        this.croppieType = type;
      } else {
        this.notifier('top', 'right', 'danger', 'Resim ekleyebilmek için bir başlık belirlemelisiniz.');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById('myImage').files.length) {
        oFReader.readAsDataURL(document.getElementById('myImage').files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this9 = this;

      var dis = this;
      var wdt = 550;
      var hgt = 311;
      if (this.croppieType === 'tinymce') {
        wdt = 550;
        hgt = 311;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: wdt,
            height: hgt
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this9.croppieType === 'main') {
            dis.image.cropped = output;
          } else if (_this9.croppieType === 'tinymce') {
            _this9.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this9.addImageToEditor(output);
          }
          _this9.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  }
});

/***/ }),

/***/ "Im1e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Archives_vue__ = __webpack_require__("bj7Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a52192d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Archives_vue__ = __webpack_require__("Sa9I");
function injectStyle (ssrContext) {
  __webpack_require__("Lcrg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Archives_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a52192d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Archives_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J+N9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("OtbY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4484ae4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("ksUs");
function injectStyle (ssrContext) {
  __webpack_require__("BGbZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4484ae4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JGrp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JSCY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      // post data
      post: {
        id: null,
        link: null,
        subtitle: null,
        user_id: this.getCurrentUserDetails(),
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'Homeinfos',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        file: null,
        cropped: null
      },
      sliderImage: {
        file: null,
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      },
      firstSlider: false
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post('/api/images/upload/' + this.post.name + '_inner-image', { cropped: i }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + _this.post.name + '" />';
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      };
      if (!this.content.content) {
        this.errors.push("İçerik");
      };
      if (!this.image.cropped && !this.image.file) {
        this.errors.push("Resim");
      };
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this2.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'
        _this2.saveImage();
      });
    },
    saveImage: function saveImage() {
      var _this3 = this;

      if (this.image.cropped) {
        this.$http.post('/api/images/upload/' + this.slugify(this.post.name), this.image).then(function (response) {
          _this3.post.image = response.body.Data.Response.name;
          _this3.savePost();
        }, function (e) {
          button.innerHTML = 'Kaydet';
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this3.toggleLoader();
        });
      } else {
        this.savePost();
      }
    },
    savePost: function savePost() {
      var _this4 = this;

      this.post.comments = null;
      this.post.menus = null;
      this.post.slider = null;
      this.tempMetas = this.post.post_metas;
      this.post.post_metas = null;
      this.post.post_tags = null;
      this.post.category = null;
      this.post.sub_category = null;
      this.post.user = null;
      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.$http.post('/api/posts/edit/' + this.post.id, this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this4.post.id = pid;
        _this4.slider.post_id = pid;
        _this4.slider.order_number = pid;
        _this4.metas.post_id = pid;
        _this4.saveMetas();
      }, function (e) {
        _this4.toggleLoader();

        if (!e.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this4.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveMetas: function saveMetas() {
      var _this5 = this;

      this.$http.put('/api/post-metas/edit-bulk/', this.metas).then(function (response) {
        _this5.notifier('top', 'right', 'success', 'Başarılı');
        _this5.$router.push('/homeinfos');
        _this5.toggleLoader();
      }, function (e) {
        _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this5.toggleLoader();
      });
    },
    getInitialData: function getInitialData() {
      var _this6 = this;

      this.toggleLoader();
      this.$http.get('/api/posts/get/' + this.id).then(function (response) {
        _this6.post = response.body;
        _this6.content = _this6.post.content;
        _this6.image.file = _this6.mediaURL() + _this6.post.image;
        if (_this6.post.video !== null) {
          _this6.video = _this6.post.video;
        }
        if (_this6.post.slider == null) {
          _this6.firstSlider = true;
        }
        _this6.metas = {
          post_id: _this6.post.id,
          items: {
            meta2: {
              meta_id: _this6.post.post_metas[_this6.post.meta_title].id,
              meta_key: 'title',
              meta_value: _this6.post.post_metas[_this6.post.meta_title].meta_value
            },
            meta3: {
              meta_id: _this6.post.post_metas[_this6.post.meta_description].id,
              meta_key: 'description',
              meta_value: _this6.post.post_metas[_this6.post.meta_description].meta_value
            }
          }
        };
        _this6.toggleLoader();
      }, function (er) {
        _this6.toggleLoader();
        _this6.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name);
    },
    slugifyUrl: function slugifyUrl() {
      this.announcement.url = this.slugify(this.announcement.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this7 = this;

        request.$http.get('/api/filter/posts/exclude/id:' + this.id + '/post-type/Homeinfos/name/' + request.post.name).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this7.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.name) {
        this.croppieType = type;
      } else {
        this.notifier('top', 'right', 'danger', 'Resim ekleyebilmek için bir başlık belirlemelisiniz.');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this8 = this;

      var dis = this;
      var wdt = 400;
      var hgt = 200;
      if (this.croppieType === "tinymce") {
        wdt = 400;
        hgt = 200;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          backgroundColor: '#fff',
          size: {
            width: wdt,
            height: hgt
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this8.croppieType === 'main') {
            dis.image.cropped = output;
            document.getElementById('main-i').src = dis.image.cropped;
          } else if (_this8.croppieType === 'tinymce') {
            _this8.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this8.addImageToEditor(output);
          }
          _this8.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.getInitialData();
  }
});

/***/ }),

/***/ "Jeve":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jik1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformationBanksPage_vue__ = __webpack_require__("rS5H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_019a806c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformationBanksPage_vue__ = __webpack_require__("ob/Y");
function injectStyle (ssrContext) {
  __webpack_require__("370S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformationBanksPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_019a806c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformationBanksPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JniN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__ = __webpack_require__("qg9l");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58447e10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__ = __webpack_require__("yM92");
function injectStyle (ssrContext) {
  __webpack_require__("0aOW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58447e10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jr+q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      videoupdated: false,
      publishTime: null,
      futurePost: false,
      socialMedia: true,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: "ActivityProgram",
        image: null,
        newvideo: null,
        newvideo_id: null,
        content_id: null,
        video_id: null
      },
      categories: null,
      category: {
        category_id: "",
        name: null,
        url: null,
        is_active: 1
      },
      subCategories: null,
      disableParent: false,
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      order: {
        post_id: null,
        slider_group: "ActivityProgram",
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: "title",
            meta_value: null
          },
          meta3: {
            meta_key: "description",
            meta_value: null
          },
          meta4: {
            meta_key: "view_count",
            meta_value: 0
          }
        }
      },
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        cropped: null
      },
      sliderImage: {
        cropped: null
      },
      croppieType: "main",
      sliderImageLoaded: false,
      // end of post data
      users: null,
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {

    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      }
      if (!this.content.content) {
        this.errors.push("İçerik");
      }
      if (!this.errors.length) {
        this.saveContent();
      }
    },

    saveContent: function saveContent() {
      var _this = this;

      var button = event.target;
      this.$http.post("/api/contents/add", this.content).then(function (response) {
        _this.post.content_id = response.body.Data.Response.id;
        _this.savePost();
      }, function (e) {
        button.innerHTML = "Kaydet";
        _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this.toggleLoader();
      });
    },

    savePost: function savePost() {
      var _this2 = this;

      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ["br"] }).substring(0, 500);
      }
      if (this.videoupdated) {
        this.post.video = this.video;
      } else {
        this.post.video = null;
      }
      if (this.post.url == null) this.post.url = new Date().getTime();
      this.$http.post("/api/posts/add", this.post).then(function (response) {
        _this2.notifier("top", "right", "success", "Başarılı");
        _this2.$router.push("/activity-program");
      }, function (e) {
        _this2.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this2.toggleLoader();
      });
    }
  }, mounted: function mounted() {
    var _this3 = this;

    this.$http.get("/api/posts/get-with-type/ActivityProgram").then(function (response) {
      _this3.allposts = response.body;
    }, function (er) {
      _this3.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
      _this3.toggleLoader();
    });
  }
});

/***/ }),

/***/ "KJSC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("FkmI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a08ead2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("WQnx");
function injectStyle (ssrContext) {
  __webpack_require__("jEs8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a08ead2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KLDw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[(!_vm.err)?_c('div',[_c('h4',{staticClass:"card-title d-md-flex justify-content-between",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Kategoriler")]),_vm._v(" "),_c('div',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary",attrs:{"title":"Yeni Kategori Ekle","to":{ path: 'category/add-edit/'},"tag":"li"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Yeni Kategori")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h6',{staticClass:"ml-3"},[_vm._v("Kategoriler")]),_vm._v(" "),_c('b-tabs',{attrs:{"pills":"","card":"","vertical":""}},_vm._l((_vm.categories),function(category,index){return _c('b-tab',{key:index,attrs:{"title":category.name}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"d-md-flex justify-content-between"},[_c('span',[_vm._v(_vm._s(category.name))]),_vm._v(" "),_c('div',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"title":"Düzenle","to":{ path: 'category/add-edit/'+category.id+'/0'},"tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-danger btn-xs",attrs:{"title":"Sil"},on:{"click":function($event){return _vm.remove(category.id,'categories')}}},[_c('i',{staticClass:"fas fa-eye-slash"})]),_vm._v(" "),(category.is_active)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"remove-item.id"},on:{"click":function($event){return _vm.deactivate(category.id,'categories')}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(!category.is_active)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.activate(category.id,'categories')}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"w-100 card card-body"},[_c('h6',[_vm._v("Alt Kategoriler")]),_vm._v(" "),_vm._l((_vm.categories[index].sub_categories),function(subCategory,i){return _c('div',{key:i,staticClass:"card mb-2"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-9"},[_vm._v(_vm._s(subCategory.name))]),_vm._v(" "),_c('div',{staticClass:"col-3 d-flex justify-content-end"},[_c('div',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"title":"Düzenle","to":{ path: 'category/add-edit/'+subCategory.id+'/1'},"tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-danger btn-xs",attrs:{"title":"Sil"},on:{"click":function($event){return _vm.remove(subCategory.id,'SubCategories')}}},[_c('i',{staticClass:"fas fa-eye-slash"})]),_vm._v(" "),(subCategory.is_active)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"deactivate-item.id"},on:{"click":function($event){return _vm.deactivate(subCategory.id,'sub-categories')}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(!subCategory.is_active)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.activate(subCategory.id,'sub-categories')}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e()],1)])])])})],2)])])])])}),1)],1)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n    "+_vm._s(_vm.err)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KRtd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KVwL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Leader_vue__ = __webpack_require__("BBt8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_287b508e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Leader_vue__ = __webpack_require__("59WU");
function injectStyle (ssrContext) {
  __webpack_require__("/Da7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Leader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_287b508e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Leader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KYtH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KZhD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-expand-lg"},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"#"}},[_vm._v("Türkiye Buz Pateni Federasyonu")]),_vm._v(" "),_c('button',{staticClass:"navbar-toggler navbar-toggler-right",class:{toggled: _vm.$sidebar.showSidebar},attrs:{"type":"button","aria-controls":"navigation-index","aria-expanded":"false","aria-label":"Toggle navigation"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"navbar-toggler-bar burger-lines"}),_vm._v(" "),_c('span',{staticClass:"navbar-toggler-bar burger-lines"}),_vm._v(" "),_c('span',{staticClass:"navbar-toggler-bar burger-lines"})]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse justify-content-end"},[_c('ul',{staticClass:"nav navbar-nav mr-auto"}),_vm._v(" "),_c('ul',{staticClass:"navbar-nav ml-auto"},[_c('drop-down',{attrs:{"tag":"li"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"nc-icon nc-circle-09"}),_vm._v(" "),_c('b',{staticClass:"caret"})]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":'/#/user/add-edit/' + _vm.getCurrentUserDetails().id}},[_vm._v("Profilim")])],2),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.logout}},[_c('i',{staticClass:"fas fa-sign-out-alt"}),_vm._v(" "),_c('span',{staticStyle:{"height":"100%"}},[_vm._v("Çıkış")])])])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"https://www.buzpateni.org.tr/","target":"_blank"}},[_vm._v("\n            Siteyi Gör\n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kea2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',[_vm._v("\n            "+_vm._s(e)+"\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",class:{'is-invalid' : _vm.errors.includes('E-Posta Formatı Doğru Değil')},attrs:{"id":"basic-addon1"}},[_vm._v("E-Posta")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subscriber.email),expression:"subscriber.email"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('E-Posta Formatı Doğru Değil')},attrs:{"type":"text","placeholder":"E-Posta","aria-label":"E-Posta","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.subscriber.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.subscriber, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill float-md-right",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kel6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KhoY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kp7B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobPostings_vue__ = __webpack_require__("6WqJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_574f8654_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobPostings_vue__ = __webpack_require__("rRCd");
function injectStyle (ssrContext) {
  __webpack_require__("Xqkb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobPostings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_574f8654_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobPostings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kwkj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Tesis Ekle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3 d-flex flex-column align-items-end"},[_c('tinymce',{ref:"tm",class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("550 x 311 pixel")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),(_vm.image.cropped)?_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.cropped}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 480, height: 270, type: 'suare'},"boundary":{width: 640, height: 360},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KyLj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      publishTime: null,
      futurePost: false,
      socialMedia: true,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'Homeboxes',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          },
          meta4: {
            meta_key: 'view_count',
            meta_value: 0
          }
        }
      },
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        cropped: null
      },
      sliderImage: {
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post('/api/images/upload/' + this.post.name + '_inner-image', {
        cropped: i
      }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + '" />';
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push('Başlık');
      }
      if (!this.content.content) {
        this.errors.push('İçerik');
      }
      if (!this.image.cropped) {
        this.errors.push('Resim');
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this2.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
        _this2.saveContent();
      });
    },
    saveContent: function saveContent() {
      var _this3 = this;

      var button = event.target;
      this.$http.post('/api/contents/add', this.content).then(function (response) {
        _this3.post.content_id = response.body.Data.Response.id;
        _this3.saveVideo();
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this3.toggleLoader();
      });
    },

    saveVideo: function saveVideo() {
      var _this4 = this;

      if (this.video.video_url !== null) {
        this.$http.post('/api/videos/add', this.video).then(function (response) {
          _this4.post.video_id = response.body.Data.Response.name;
          _this4.saveImage();
        }, function (e) {
          button.innerHTML = 'Kaydet';
          _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this4.toggleLoader();
        });
      } else {
        this.saveImage();
      }
    },
    saveImage: function saveImage() {
      var _this5 = this;

      this.$http.post('/api/images/upload/' + this.slugify(this.post.name), this.image).then(function (response) {
        _this5.post.image = response.body.Data.Response.name;
        _this5.savePost();
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this5.toggleLoader();
      });
    },
    savePost: function savePost() {
      var _this6 = this;

      var newdate = new Date();
      if (!this.post.url) {
        this.post.url = this.post.name + newdate.getTime();
      }
      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.$http.post('/api/posts/add', this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this6.post.id = pid;
        _this6.metas.post_id = pid;
        _this6.saveMetas();
      }, function (e) {
        _this6.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this6.toggleLoader();
      });
    },
    saveMetas: function saveMetas() {
      var _this7 = this;

      this.$http.post('/api/post-metas/add-bulk', this.metas).then(function (response) {
        _this7.notifier('top', 'right', 'success', 'Başarılı');
        _this7.$router.push('/homeboxes');
        _this7.toggleLoader();
      }, function (e) {
        _this7.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this7.toggleLoader();
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name);
    },
    slugifyUrl: function slugifyUrl() {
      this.post.url = this.slugify(this.post.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this8 = this;

        request.$http.get('/api/filter/posts/post-type/Homeboxes/name/' + request.post.name).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this8.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.name) {
        this.croppieType = type;
      } else {
        this.notifier('top', 'right', 'danger', 'Resim ekleyebilmek için bir başlık belirlemelisiniz.');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById('myImage').files.length) {
        oFReader.readAsDataURL(document.getElementById('myImage').files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this9 = this;

      var dis = this;
      var wdt = 150;
      var hgt = 150;
      if (this.croppieType === 'tinymce') {
        wdt = 150;
        hgt = 150;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: wdt,
            height: hgt
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this9.croppieType === 'main') {
            dis.image.cropped = output;
          } else if (_this9.croppieType === 'tinymce') {
            _this9.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this9.addImageToEditor(output);
          }
          _this9.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  }
});

/***/ }),

/***/ "L/hf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      // post data
      file: null,
      videoupdated: false,
      post: {
        id: null,
        newvideo: null,
        user_id: this.getCurrentUserDetails(),
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'ActivityProgram',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        file: null,
        cropped: null
      },
      sliderImage: {
        file: null,
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      },
      firstSlider: false
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    uploadExcel: function uploadExcel(event) {
      var _this = this;

      this.file = event.target.files[0];
      if (this.file.type !== ('application/vnd.ms-excel' && 'application/msexcel' && 'application/x-msexcel' && 'application/x-ms-excel' && 'application/x-excel' && 'application/x-dos_ms_excel' && 'application/xls' && 'application/x-xls' && 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
        this.notifier('top', 'right', 'danger', 'Lütfen excel formatında bir dosya seçiniz');
      } else {
        var data = new FormData();
        data.append("file", this.file);
        var fileName = this.file.name.split(".");
        var extension = "";
        var newName = "";
        fileName.forEach(function (e, index) {
          if (index < fileName.length - 1) {
            newName += e;
          }
          if (index == fileName.length - 1) {
            extension += e;
          }
        });
        newName += new Date().getTime();
        var fullName = newName + "." + extension;
        this.post.image = fullName;
        data.append("fileName", fullName);
        this.notifier("top", "right", "warning", "Dosya yüklenirken lütfen bekleyiniz.Yüklemeden sonra sayfa yenilenecektir");
        this.$http.post("api/files/upload-excel/" + fullName + '/' + this.post.content.id + '/' + this.id, data).then(function (response) {
          _this.notifier("top", "right", "success", "Excel başarıyla kaydedildi");
          _this.$router.go();
        }, function (er) {
          _this.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        });
      }
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push('Başlık');
      }
      if (!this.content.content) {
        this.errors.push('İçerik');
      }
      if (!this.errors.length) {
        this.savePost();
      }
    },
    saveContent: function saveContent() {
      var _this2 = this;

      var button = event.target;
      this.$http.post('/api/contents/edit/' + this.post.content.id, this.content).then(function (response) {
        _this2.notifier('top', 'right', 'success', 'Başarılı');
        _this2.$router.push('/activity-program');
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },

    savePost: function savePost() {
      var _this3 = this;

      this.post.comments = null;
      this.post.menus = null;
      this.post.slider = null;
      this.tempMetas = this.post.post_metas;
      this.post.post_metas = null;
      this.post.post_tags = null;
      this.post.category = null;
      this.post.sub_category = null;
      this.post.user = null;
      this.post.content = null;
      if (this.videoupdated) {
        this.post.video = this.video;
      } else {
        this.post.video = null;
      }

      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.$http.post('/api/posts/edit/' + this.post.id, this.post).then(function (response) {
        _this3.saveContent();
      }, function (e) {

        if (!e.body.Error) {
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this3.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    getInitialData: function getInitialData() {
      var _this4 = this;

      this.toggleLoader();
      this.$http.get('/api/posts/get/' + this.id).then(function (response) {
        _this4.post = response.body;
        _this4.content = _this4.post.content;
        _this4.content.content = JSON.parse(_this4.content.content);

        console.log(_this4.post.content.id);
        if (_this4.post.video) {
          _this4.video = _this4.post.video;
        } else {
          _this4.post.video = {
            video_url: null
          };
        }
        if (_this4.post.slider == null) {
          _this4.firstSlider = true;
        }
        _this4.toggleLoader();
      }, function (er) {
        _this4.toggleLoader();
        _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getInitialData();
    });
  }
});

/***/ }),

/***/ "L86m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEdit_vue__ = __webpack_require__("MUyA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0319a94a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEdit_vue__ = __webpack_require__("uq87");
function injectStyle (ssrContext) {
  __webpack_require__("Opci")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0319a94a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LF97":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Facilities_vue__ = __webpack_require__("po1X");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ae8e7e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Facilities_vue__ = __webpack_require__("0W4T");
function injectStyle (ssrContext) {
  __webpack_require__("j88V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Facilities_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ae8e7e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Facilities_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LGXr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Tesis Ekle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Kutu Linki")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.link),expression:"post.link"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Link","aria-label":"Başlık","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "link", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Alt Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.subtitle),expression:"post.subtitle"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Alt Başlık","aria-label":"Alt Başlık","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.subtitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "subtitle", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("150 x 150 pixel")]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),(_vm.image.cropped)?_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.cropped}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":true,"viewport":{width: 150, height: 150, type: 'suare'},"boundary":{width: 200, height: 200},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LUlP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"change":_vm.validate,"keyup":_vm.createUrl,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"url-label"}},[_vm._v("URL")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.url),expression:"post.url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('URL')},attrs:{"type":"text","placeholder":"URL","aria-label":"URL","id":"url","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.url)},on:{"keyup":_vm.slugifyUrl,"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3"},[_c('tinymce',{class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.post.content),callback:function ($$v) {_vm.$set(_vm.post, "content", $$v)},expression:"post.content"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-12 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başvuru Adresi")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.target_url),expression:"post.target_url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başvuru Adresi","aria-label":"Başvuru Adresi","id":"target","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.target_url)},on:{"change":_vm.validate,"keyup":_vm.createUrl,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "target_url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('vue-tabs',[_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Logo"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.cropped}})],1)])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":true,"viewport":{width: 480, height: 270, type: 'suare'},"boundary":{width: 640, height: 360},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LWzg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LX3s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lcrg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lfka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/directors'}}},[_c('button',{staticClass:"btn btn-danger  btn-sm  px-2 mr-2",attrs:{"type":"submit"}},[_vm._v("Yönetim Kurulu")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/staffs'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Federasyon Personeli")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/all-leaders'}}},[_c('button',{staticClass:"btn btn-primary  btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Başkanlarımız")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/history'}}},[_c('button',{staticClass:"btn btn-success btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Tarihçe")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/sub-board-categories'}}},[_c('button',{staticClass:"btn btn-warning btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Alt Kurullar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/provincial-offices'}}},[_c('button',{staticClass:"btn btn-secondary active btn-sm  mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("İl Temsilcilikleri")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/bank-informations'}}},[_c('button',{staticClass:"btn btn-success btn-sm  mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Hesap Numaraları")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/main-status-instructions'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Ana Statü Talimatlar")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('div',{staticClass:"row"},[(!_vm.err)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('small',[_vm._v("Resim Boyutu 500x500px")]),_vm._v(" "),_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("İl Temsilcilikleri\n                "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"mr-2 btn btn-danger btn-sm btn-fill",on:{"click":function($event){return _vm.addNew()}}},[_vm._v("\n                  Ekle\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm btn-fill",on:{"click":function($event){return _vm.update()}}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.mediaURL() + item.image}})]),_vm._v(" "),_c('div',{staticClass:"col-9 d-flex align-items-center"},[_c('div',{staticClass:"row w-100"},[_c('div',{staticClass:"col-12 col-md-4"},[_c('label',[_vm._v("Ad Soyad")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.title),expression:"item.title"}],staticClass:"form-control",attrs:{"type":"text","name":""},domProps:{"value":(item.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('label',[_vm._v("Bölge")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.target_url),expression:"item.target_url"}],staticClass:"form-control",attrs:{"type":"text","name":""},domProps:{"value":(item.target_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "target_url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('label',[_vm._v("Mail")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.description),expression:"item.description"}],staticClass:"form-control",attrs:{"type":"text","name":""},domProps:{"value":(item.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "description", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn btn-sm ",attrs:{"title":"Slider Resmini Değiştir"},on:{"click":function($event){return _vm.initiateCroppie(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 border border-secondary p-2 d-none",attrs:{"src":_vm.newSliderImage.cropped}})])])])])}),0)],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n"+_vm._s(_vm.err)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 200, height: 200, type: 'suare'},"boundary":{width: 300, height: 300},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ljql":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LnsZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsOrder_vue__ = __webpack_require__("aDtE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12075a32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsOrder_vue__ = __webpack_require__("zLQQ");
function injectStyle (ssrContext) {
  __webpack_require__("RL7+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12075a32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LoDK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız Gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email.subject),expression:"email.subject"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.email.subject)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.email, "subject", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3"},[_c('tinymce',{class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.email.body),callback:function ($$v) {_vm.$set(_vm.email, "body", $$v)},expression:"email.body"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill float-md-right",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LpoR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_search_select__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: [{
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: "mainstatusinstructions",
        order_number: null
      }],
      err: null,
      fullName: '',
      selectedType: null,
      types: ["URL", "Kategori", "Alt Kategori", "Yayın", "Etiket"],
      options: [],
      sliderItems: null,
      newPdf: {
        Pdf_id: null,
        Pdf_name: null,
        PdfIndex: null
      },
      file: null,
      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "all",
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_1_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier('top', 'right', 'danger', 'PDF Başarıyla silindi');
          _this.getSlider();
        }, function (e) {
          if (!e.body.Error) {
            _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          } else {
            _this.notifier("top", "right", "danger", e.body.Error);
          }
        });
      }
    },
    upload: function upload(event) {
      var _this2 = this;

      var file = event.target.files[0];
      if (file.type !== "application/pdf") return console.log(file);
      var data = new FormData();
      data.append("file", file);
      var newfile = file.name.split('.');
      var extension = '';
      var name = '';
      newfile.forEach(function (e, index) {
        if (index < newfile.length - 1) {
          name += e;
        }
        if (index == newfile.length - 1) {
          extension += e;
        }
      });

      var newName = name + new Date().getTime();
      this.fullName = newName + '.' + extension;
      data.append("fileName", this.fullName);

      this.$http.post("/api/files/upload/" + this.newPdf.Pdf_name, data).then(function (response) {
        var i = _this2.newPdf.n === 0 ? 'image' : 'image2';
        _this2.slider[_this2.newPdf.PdfIndex][i] = _this2.newPdf.Pdf_name;
        console.log(_this2.newPdf.Pdf_name);
        _this2.notifier('top', 'right', 'success', 'Pdf Başarıyla Yüklendi');
        _this2.update();
      }, function (er) {
        _this2.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
      });
    },
    myPdf: function myPdf(id, i, n) {
      this.newPdf.Pdf_id = id;
      this.newPdf.Pdf_name = 'BuzPateni' + new Date().getTime() + '.pdf';
      this.newPdf.PdfIndex = i;
      this.newPdf.n = n;
      document.getElementById('myPdf' + i).click();
    },
    addNew: function addNew() {
      this.slider.push({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'mainstatusinstructions' + this.$route.params.id,
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = 'mainstatusinstructions';
      });
      this.$http.post('/api/images/edit/', this.slider).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi');
        _this3.file = null;
        _this3.getSlider();
      }, function (e) {
        if (!e.body.Error) {
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this3.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = "/api/images/mainstatusinstructions";
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
      }, function (er) {
        if (!er.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this4.err = er.body.Error;
          _this4.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "LvYP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"ct-chart",attrs:{"id":_vm.chartId}})]),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"card-footer"},[_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M08G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M6QC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostModules_Allnews_Index_vue__ = __webpack_require__("Zx8T");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostsTable: __WEBPACK_IMPORTED_MODULE_0__PostModules_Allnews_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "M8FP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eac50c7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("ck91");
function injectStyle (ssrContext) {
  __webpack_require__("cwbb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eac50c7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MAJb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MDnB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DropDown: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Dropdown_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "MELt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      // post data
      post: {
        id: null,
        link: null,
        subtitle: null,
        user_id: this.getCurrentUserDetails(),
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'Informationbankspage',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        file: null,
        cropped: null
      },
      sliderImage: {
        file: null,
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      },
      firstSlider: false
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post('/api/images/upload/' + this.post.name + 'ib_inner-image', { cropped: i }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + _this.post.name + '" />';
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      };
      if (!this.image.cropped && !this.image.file) {
        this.errors.push("Resim");
      };
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this2.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'
        _this2.saveImage();
      });
    },
    saveImage: function saveImage() {
      var _this3 = this;

      if (this.image.cropped) {
        this.$http.post('/api/images/upload/' + this.slugify(this.post.name), this.image).then(function (response) {
          _this3.post.image = response.body.Data.Response.name;
          _this3.savePost();
        }, function (e) {
          button.innerHTML = 'Kaydet';
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this3.toggleLoader();
        });
      } else {
        this.savePost();
      }
    },
    savePost: function savePost() {
      var _this4 = this;

      this.post.comments = null;
      this.post.menus = null;
      this.post.slider = null;
      this.tempMetas = this.post.post_metas;
      this.post.post_metas = null;
      this.post.post_tags = null;
      this.post.category = null;
      this.post.sub_category = null;
      this.post.user = null;
      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.$http.post('/api/posts/edit/' + this.post.id, this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this4.post.id = pid;
        _this4.slider.post_id = pid;
        _this4.slider.order_number = pid;
        _this4.metas.post_id = pid;
        _this4.saveMetas();
      }, function (e) {
        _this4.toggleLoader();

        if (!e.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this4.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveMetas: function saveMetas() {
      var _this5 = this;

      this.$http.put('/api/post-metas/edit-bulk/', this.metas).then(function (response) {
        _this5.notifier('top', 'right', 'success', 'Başarılı');
        _this5.$router.push('/information-banks-page');
        _this5.toggleLoader();
      }, function (e) {
        _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this5.toggleLoader();
      });
    },
    getInitialData: function getInitialData() {
      var _this6 = this;

      this.toggleLoader();
      this.$http.get('/api/posts/get/' + this.id).then(function (response) {
        _this6.post = response.body;
        _this6.content = _this6.post.content;
        _this6.image.file = _this6.mediaURL() + _this6.post.image;
        if (_this6.post.video !== null) {
          _this6.video = _this6.post.video;
        }
        if (_this6.post.slider == null) {
          _this6.firstSlider = true;
        }
        _this6.metas = {
          post_id: _this6.post.id,
          items: {
            meta2: {
              meta_id: _this6.post.post_metas[_this6.post.meta_title].id,
              meta_key: 'title',
              meta_value: _this6.post.post_metas[_this6.post.meta_title].meta_value
            },
            meta3: {
              meta_id: _this6.post.post_metas[_this6.post.meta_description].id,
              meta_key: 'description',
              meta_value: _this6.post.post_metas[_this6.post.meta_description].meta_value
            }
          }
        };
        _this6.toggleLoader();
      }, function (er) {
        _this6.toggleLoader();
        _this6.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name);
    },
    slugifyUrl: function slugifyUrl() {
      this.announcement.url = this.slugify(this.announcement.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this7 = this;

        request.$http.get('/api/filter/posts/exclude/id:' + this.id + '/post-type/Informationbankspage/name/' + request.post.name).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this7.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.name) {
        this.croppieType = type;
      } else {
        this.notifier('top', 'right', 'danger', 'Resim ekleyebilmek için bir başlık belirlemelisiniz.');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this8 = this;

      var dis = this;
      var wdt = 150;
      var hgt = 150;
      if (this.croppieType === "tinymce") {
        wdt = 150;
        hgt = 150;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          backgroundColor: '#fff',
          size: {
            width: wdt,
            height: hgt
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this8.croppieType === 'main') {
            dis.image.cropped = output;
            document.getElementById('main-i').src = dis.image.cropped;
          } else if (_this8.croppieType === 'tinymce') {
            _this8.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this8.addImageToEditor(output);
          }
          _this8.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.getInitialData();
  }
});

/***/ }),

/***/ "MGj4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/races'}}},[_c('button',{staticClass:"btn btn-warning text-white active btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Yarışlar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/seasons'}}},[_c('button',{staticClass:"btn btn-info btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Sezonlar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/members'}}},[_c('button',{staticClass:"btn btn-danger btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Üyeler")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[(!_vm.err)?_c('div',[_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0 race-table"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Ad Soyad")]),_vm._v(" "),_c('th',[_vm._v("Kulüp Adı")]),_vm._v(" "),_c('th',[_vm._v("E-Mail")]),_vm._v(" "),_c('th',[_vm._v("Telefon Numarası")]),_vm._v(" "),_c('th',[_vm._v("Başvuru Tarihi")]),_vm._v(" "),_c('th',[_vm._v("Durum")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.club_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.phone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(item.created,"Do/MM/YYYY HH:mm:ss")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.vStatus))]),_vm._v(" "),_c('td',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"to":{ path: '/race-applications/inspect/'+item.id},"title":"İncele","tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-warning btn-fill btn-xs",attrs:{"to":{ path: '/race-applications/edit/'+item.id},"title":"Revize Talep Et ","tag":"li"}},[_c('i',{staticClass:"fas fa-exchange-alt"})]),_vm._v(" "),(item.status !== 4 )?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Reddet","id":"deactivate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,4)}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(item.status !== 1)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Kabul Et","id":"activate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,1)}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e()],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getRaces(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getRaces(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getRaces(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n        "+_vm._s(_vm.err)+"\n    ")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MQML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('index-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MUyA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isEdit: false,
      categories: null,
      category: {
        category_id: "",
        name: null,
        url: null,
        is_active: 1
      },
      subCategories: null,
      disableParent: false,
      errors: [],
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.category.name) {
        this.errors.push("Başlık");
      };
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      this.toggleLoader();
      if (this.isEdit) {
        this.updateCategory();
      } else {
        this.saveCategory();
      }
    },
    saveCategory: function saveCategory() {
      var _this = this;

      if (this.category.category_id === "") {
        if (this.subCategories !== null) {
          this.subCategories = this.subCategories.split(/\n/g);
          var sub_categories = [];
          for (var i = 0; i < this.subCategories.length; i++) {
            var subCategory = {
              name: this.subCategories[i],
              url: this.slugify(this.subCategories[i]) + '-' + Math.floor(Math.random() * (99999 - 0) + 0),
              is_active: 1
            };
            sub_categories.push(subCategory);
          }
          this.category.sub_categories = sub_categories;
        }
        this.category.url = this.slugify(this.category.name + '-' + Math.floor(Math.random() * (999 - 0) + 0));
        this.category.category_type = "news";
        delete this.category.category_id;
        this.$http.post('/api/categories/add', this.category).then(function (response) {
          _this.notifier('top', 'right', 'success', 'Başarılı');
          _this.$router.push('/newcategories');
          _this.toggleLoader();
        }, function (e) {
          _this.toggleLoader();
          if (!e.body.Error) {
            _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          } else {
            _this.notifier('top', 'right', 'danger', e.body.Error);
          }
        });
      } else {
        this.category.url = this.slugify(this.category.name + '-' + Math.floor(Math.random() * (999 - 0) + 0));
        this.$http.post('/api/sub-categories/add', this.category).then(function (response) {
          _this.notifier('top', 'right', 'success', 'Başarılı');
          _this.$router.push('/newcategories');
          _this.toggleLoader();
        }, function (e) {
          _this.toggleLoader();
          if (!e.body.Error) {
            _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          } else {
            _this.notifier('top', 'right', 'danger', e.body.Error);
          }
        });
      }
    },
    updateCategory: function updateCategory() {
      var _this2 = this;

      if (this.category.category_id === "") {
        if (this.subCategories !== null) {
          this.subCategories = this.subCategories.split(/\n/g);
          var sub_categories = [];
          for (var i = 0; i < this.subCategories.length; i++) {
            var subCategory = {
              name: this.subCategories[i],
              url: this.slugify(this.subCategories[i]) + '-' + Math.floor(Math.random() * (99999 - 0) + 0),
              is_active: 1
            };
            sub_categories.push(subCategory);
          }
          this.category.sub_categories = sub_categories;
        }
        this.category.url = this.slugify(this.category.name + '-' + Math.floor(Math.random() * (999 - 0) + 0));
        delete this.category.category_id;
        this.category.category_type = "news";
        this.$http.post('/api/categories/edit/' + this.$route.params.id, this.category).then(function (response) {
          _this2.notifier('top', 'right', 'success', 'Başarılı');
          _this2.$router.push('/newcategories');
          _this2.toggleLoader();
        }, function (e) {
          _this2.toggleLoader();
          if (!e.body.Error) {
            _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          } else {
            _this2.notifier('top', 'right', 'danger', e.body.Error);
          }
        });
      } else {
        this.category.url = this.slugify(this.category.name + '-' + Math.floor(Math.random() * (999 - 0) + 0));
        this.$http.post('/api/sub-categories/edit/' + this.$route.params.id, this.category).then(function (response) {
          _this2.notifier('top', 'right', 'success', 'Başarılı');
          _this2.$router.push('/newcategories');
          _this2.toggleLoader();
        }, function (e) {
          _this2.toggleLoader();
          if (!e.body.Error) {
            _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          } else {
            _this2.notifier('top', 'right', 'danger', e.body.Error);
          }
        });
      }
    },
    createUrl: function createUrl() {
      if (!isEdit) {
        this.category.url = this.slugify(this.category.name);
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var _this3 = this;

      this.toggleLoader();
      this.$http.get('/api/categories/allnews').then(function (response) {
        _this3.categories = response.body;
        if (_this3.$route.params.id && _this3.$route.params.type) {
          var controller = null;
          if (parseInt(_this3.$route.params.type)) {
            controller = 'sub-categories';
          } else {
            controller = 'categories';
            _this3.disableParent = true;
          }
          _this3.$http.get('/api/' + controller + '/get-without-joins/' + _this3.$route.params.id).then(function (response) {
            _this3.isEdit = true;
            _this3.category = response.body;
            delete _this3.category.sub_categories;
            if (controller === 'categories') {
              _this3.category.category_id = '';
            }
            _this3.toggleLoader();
          }, function (response) {
            _this3.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
            _this3.toggleLoader();
          });
        } else {
          _this3.toggleLoader();
        }
      }, function (er) {
        _this3.toggleLoader();
        _this3.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    });
  }
});

/***/ }),

/***/ "MZ8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__ = __webpack_require__("0FOK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2e3209e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__ = __webpack_require__("Dc25");
function injectStyle (ssrContext) {
  __webpack_require__("1+T5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2e3209e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MaVD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__ = __webpack_require__("WNzT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24f61c0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__ = __webpack_require__("5gdh");
function injectStyle (ssrContext) {
  __webpack_require__("jOGH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24f61c0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mca5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarLink_vue__ = __webpack_require__("7SdG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SidebarLink: __WEBPACK_IMPORTED_MODULE_0__SidebarLink_vue__["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: 'Merhaba'
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: function validator(value) {
        var acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundImage: {
      type: String,
      default: 'static/img/background.jpg'
    },
    sidebarLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide: function provide() {
    return {
      autoClose: this.autoClose
    };
  },

  computed: {
    sidebarStyle: function sidebarStyle() {
      return {
        backgroundImage: 'url(' + this.backgroundImage + ')'
      };
    }
  }
});

/***/ }),

/***/ "N8Qi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('index-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_sweetalert2__ = __webpack_require__("oYt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bluebird__ = __webpack_require__("0Qa9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_tinymce_editor__ = __webpack_require__("7SKw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_croppie__ = __webpack_require__("ujXI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_croppie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_croppie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_nav_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_nav_tabs_themes_vue_tabs_css__ = __webpack_require__("Jeve");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_nav_tabs_themes_vue_tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_nav_tabs_themes_vue_tabs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__light_bootstrap_main__ = __webpack_require__("28ys");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__routes_routes__ = __webpack_require__("T1vP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_v_mask__ = __webpack_require__("1I9z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_sanitize__ = __webpack_require__("d+7S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_sanitize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_sanitize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_datetime__ = __webpack_require__("QEVx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_datetime_dist_vue_datetime_css__ = __webpack_require__("suTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_datetime_dist_vue_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_luxon__ = __webpack_require__("H9QG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuedraggable__ = __webpack_require__("u4Bf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_cookies__ = __webpack_require__("ppUw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_youtube_embed__ = __webpack_require__("5/be");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_moment__);





/* eslint-disable no-unused-vars */























// plugin setup
__webpack_require__("k+5o");
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10__light_bootstrap_main__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_v_mask__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_sweetalert2__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_24_vue_youtube_embed__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('tinymce', __WEBPACK_IMPORTED_MODULE_6_vue_tinymce_editor__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('draggable', __WEBPACK_IMPORTED_MODULE_22_vuedraggable___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_nav_tabs___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_vue_croppie___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__webpack_require__("mjDs"), { moment: __WEBPACK_IMPORTED_MODULE_25_moment___default.a });
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_18_vue_sanitize___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_19_vue_datetime___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_23_vue_cookies___default.a);
__WEBPACK_IMPORTED_MODULE_21_luxon__["Settings"].defaultLocale = 'tr';

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: __WEBPACK_IMPORTED_MODULE_11__routes_routes__["a" /* default */],
    linkActiveClass: 'nav-item active'
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('icon', __WEBPACK_IMPORTED_MODULE_13_vue_awesome_components_Icon__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.mixin({
    methods: {
        mediaURL: function mediaURL() {
            if (location.protocol + '//' + location.hostname === 'https://panel.buzpateni.org.tr') {
                return 'https://www.buzpateni.org.tr/uploads/';
            }
            return 'http://buzpateni.sandbox/uploads/';
        },
        raceURL: function raceURL() {
            if (location.protocol + '//' + location.hostname === 'https://panel.buzpateni.org.tr') {
                return 'https://panel.buzpateni.org.tr/api/load-files/';
            }
            return 'http://localhost:8000/api/load-files/';
        },
        licenseURL: function licenseURL() {
            if (location.protocol + '//' + location.hostname === 'https://panel.buzpateni.org.tr') {
                return 'https://panel.buzpateni.org.tr/api/set-license/';
            }
            return 'http://localhost:8000/api/set-license/';
        },
        hesURL: function hesURL() {
            if (location.protocol + '//' + location.hostname === 'https://panel.buzpateni.org.tr') {
                return 'https://panel.buzpateni.org.tr/api/set-hes/';
            }
            return 'http://localhost:8000/api/set-hes/';
        },
        pdfURL: function pdfURL() {
            if (location.protocol + '//' + location.hostname === 'https://panel.buzpateni.org.tr') {
                return 'https://www.buzpateni.org.tr/uploads/pdf/';
            }
            return 'http://buzpateni.sandbox/uploads/pdf/';
        },
        excelURL: function excelURL() {
            if (location.protocol + '//' + location.hostname === 'https://panel.buzpateni.org.tr') {
                return 'https://www.buzpateni.org.tr/uploads/excel/';
            }
            return 'http://buzpateni.sandbox/uploads/excel/';
        },
        generalURL: function generalURL(path) {
            if (location.protocol + '//' + location.hostname === 'https://panel.buzpateni.org.tr') {
                return 'https://www.buzpateni.org.tr/uploads/' + path + '/';
            }
            return 'http://buzpateni.sandbox/uploads/' + path + '/';
        },
        getCurrentUserDetails: function getCurrentUserDetails() {
            if (localStorage.getItem('CurrentLoggedUserDetails')) {
                return JSON.parse(localStorage.getItem('CurrentLoggedUserDetails'));
            }
        },

        slugify: function slugify(text) {
            if (!text) {
                return null;
            }
            var trMap = {
                'çÇ': 'c',
                'ğĞ': 'g',
                'şŞ': 's',
                'üÜ': 'u',
                'ıİ': 'i',
                'öÖ': 'o'
            };
            for (var key in trMap) {
                text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
            }
            return text.replace(/[^-a-zA-Z0-9\s]+/ig, '').replace(/\s/gi, '-').replace(/[-]+/gi, '-').toLowerCase();
        },
        notifier: function notifier(verticalAlign, horizontalAlign, color, message) {
            var notification = {
                template: '<span>' + message + '</span>'
            };
            var icn = null;
            if (color === 'success') {
                icn = 'nc-check-2';
            } else if (color === 'danger') {
                icn = 'nc-simple-remove';
            } else if (color === 'warning') {
                icn = 'nc-bell-55';
            } else {
                icn = 'nc-send';
            }
            this.$notifications.notify({
                component: notification,
                icon: 'nc-icon ' + icn,
                horizontalAlign: horizontalAlign,
                verticalAlign: verticalAlign,
                type: color
            });
        },
        toggleLoader: function toggleLoader() {
            if (document.getElementById('loader').classList.contains('loader-hide')) {
                document.getElementById('loader').classList.add('loader-show');
                document.getElementById('loader').classList.remove('loader-hide');
            } else {
                document.getElementById('loader').classList.add('loader-hide');
                document.getElementById('loader').classList.remove('loader-show');
            }
        }
    }
});
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
    el: '#app',
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_3__App_vue__["a" /* default */]);
    },
    router: router,
    methods: {
        getLimit: function getLimit() {
            if (!localStorage.getItem('filterLimit')) {
                this.$http.get('/api/settings/get/filter_limit').then(function (response) {
                    localStorage.setItem('filterLimit', response.body.data);
                    location.reload();
                });
            } else {
                return localStorage.getItem('filterLimit');
            }
        }
    },
    beforeMount: function beforeMount() {
        this.getLimit();
    },
    mounted: function mounted() {
        this.$moment.locale('tr');
    }
});

/***/ }),

/***/ "NI8N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: [{
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: "leadergallery",
        order_number: null
      }],
      err: null,
      selectedType: null,
      types: ["URL", "Kategori", "Alt Kategori", "Yayın", "Etiket"],
      options: [],
      sliderItems: null,
      newSliderImage: {
        cropped: null,
        image_id: null,
        image_name: null,
        imageIndex: null
      },
      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "all",
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier("top", "right", "danger", "Slider Başarıyla silindi");
          _this.getSlider();
        }, function (e) {
          if (!e.body.Error) {
            _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          } else {
            _this.notifier("top", "right", "danger", e.body.Error);
          }
        });
      }
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post("/api/images/upload/new-gallery", this.newSliderImage).then(function (response) {
        var i = _this2.newSliderImage.n === 0 ? "image" : "image2";
        _this2.slider[_this2.newSliderImage.imageIndex][i] = response.body.Data.Response.name;
        _this2.toggleLoader();
        _this2.hideCroppieModal();
        _this2.update();
      }, function (e) {
        _this2.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this2.toggleLoader();
      });
    },
    addNew: function addNew() {
      this.slider.unshift({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: "leadergallery",
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      var newdis = this;
      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = "leadergallery";
      });
      this.$http.post("/api/images/edit/", this.slider).then(function (response) {
        _this3.notifier("top", "right", "success", "Değişiklikler Kaydedildi");
        _this3.getSlider();
      }, function (e) {
        if (!e.body.Error) {
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this3.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = "/api/images/get-with-type/leadergallery";
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
      }, function (er) {
        if (!er.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this4.err = er.body.Error;
          _this4.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    initiateCroppie: function initiateCroppie(id, i, n) {
      this.newSliderImage.image_id = id;
      this.newSliderImage.image_name = this.slugify(this.slider[i].title);
      this.newSliderImage.imageIndex = i;
      this.newSliderImage.n = n;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById("new-post").classList.contains("d-none")) {
        document.getElementById("new-post").classList.remove("d-none");
      } else {
        document.getElementById("new-post").classList.add("d-none");
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {
      this.crop();
    },
    crop: function crop() {
      var _this5 = this;

      var dis = this;
      this.toggleLoader();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: "jpeg" | "png" | "webp",
          backgroundColor: "#fff",
          size: {
            width: 600,
            height: 400
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this5.newSliderImage.cropped = output;
          _this5.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "NN78":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      publishTime: null,
      futurePost: false,
      socialMedia: true,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'Education',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          },
          meta4: {
            meta_key: 'view_count',
            meta_value: 0
          }
        }
      },
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        cropped: null
      },
      sliderImage: {
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post('/api/images/upload/' + this.post.url + '_inner-image', {
        cropped: i
      }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + '" />';
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push('Başlık');
      }
      if (!this.post.url) {
        this.errors.push('URL');
      }
      if (!this.content.content) {
        this.errors.push('İçerik');
      }
      if (!this.image.cropped) {
        this.errors.push('Resim');
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this2.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
        _this2.saveContent();
      });
    },
    saveContent: function saveContent() {
      var _this3 = this;

      var button = event.target;
      this.$http.post('/api/contents/add', this.content).then(function (response) {
        _this3.post.content_id = response.body.Data.Response.id;
        _this3.saveVideo();
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this3.toggleLoader();
      });
    },
    saveVideo: function saveVideo() {
      var _this4 = this;

      if (this.video.video_url !== null) {
        this.$http.post('/api/videos/add', this.video).then(function (response) {
          _this4.post.video_id = response.body.Data.Response.name;
          _this4.saveImage();
        }, function (e) {
          button.innerHTML = 'Kaydet';
          _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this4.toggleLoader();
        });
      } else {
        this.saveImage();
      }
    },
    saveImage: function saveImage() {
      var _this5 = this;

      this.$http.post('/api/images/upload/' + this.post.url, this.image).then(function (response) {
        _this5.post.image = response.body.Data.Response.name;
        _this5.savePost();
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this5.toggleLoader();
      });
    },
    savePost: function savePost() {
      var _this6 = this;

      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.$http.post('/api/posts/add', this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this6.post.id = pid;
        _this6.metas.post_id = pid;
        _this6.saveMetas();
      }, function (e) {
        _this6.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this6.toggleLoader();
      });
    },
    saveMetas: function saveMetas() {
      var _this7 = this;

      this.$http.post('/api/post-metas/add-bulk', this.metas).then(function (response) {
        _this7.notifier('top', 'right', 'success', 'Başarılı');
        _this7.$router.push('/educations');
        _this7.toggleLoader();
      }, function (e) {
        _this7.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this7.toggleLoader();
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name);
    },
    slugifyUrl: function slugifyUrl() {
      this.post.url = this.slugify(this.post.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this8 = this;

        request.$http.get('/api/filter/posts/url/' + request.post.url).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this8.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.url) {
        this.croppieType = type;
      } else {
        this.notifier('top', 'right', 'danger', 'Resim ekleyebilmek için bir başlık belirlemelisiniz.');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById('myImage').files.length) {
        oFReader.readAsDataURL(document.getElementById('myImage').files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this9 = this;

      var dis = this;
      var wdt = 1920;
      var hgt = 1080;
      if (this.croppieType === 'tinymce') {
        wdt = 960;
        hgt = 540;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: wdt,
            height: hgt
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this9.croppieType === 'main') {
            dis.image.cropped = output;
          } else if (_this9.croppieType === 'tinymce') {
            _this9.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this9.addImageToEditor(output);
          }
          _this9.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  }
});

/***/ }),

/***/ "NOs2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NQGi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("cYd8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1346674_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("S9jN");
function injectStyle (ssrContext) {
  __webpack_require__("goXD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1346674_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NhH7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O0jz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O4zg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_min_css__ = __webpack_require__("9BHd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_min_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: {
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'allnewgallery' + this.$route.params.id,
        order_number: null
      },
      selectedType: null,
      types: ['URL', 'Kategori', 'Alt Kategori', 'Yayın', 'Etiket'],
      options: [],
      sliderItems: null,
      newSliderImage: {
        cropped: null,
        image_id: null,
        image_name: null,
        imageIndex: null
      },
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: [],
      dropOptions: {
        url: "/api/images/upload-with-dropzone/" + this.$route.params.id + '/allnewgallery',
        addRemoveLinks: true,
        uploadMultiple: true,
        acceptedFiles: 'image/*',
        dictDefaultMessage: "Dosyaları yüklemek için sürükle bırak yapabilir veya bu alana tıklayabilirsiniz."
      }
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"],
    vueDropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a
  },

  methods: {
    afterComplete: function afterComplete(file) {
      var vm = this;
      vm.update();
      setTimeout(function () {
        vm.$refs.dropzone.removeAllFiles();
      }, 2500);
    },
    removeAllFiles: function removeAllFiles() {
      this.$refs.dropzone.removeAllFiles();
    },

    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier('top', 'right', 'danger', 'Slider Başarıyla silindi');
          _this.getSlider();
        }, function (e) {
          _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          _this.toggleLoader();
        });
      }
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post('/api/images/upload/new-gallery', this.newSliderImage).then(function (response) {
        var i = _this2.newSliderImage.n === 0 ? 'image' : 'image2';
        _this2.slider[_this2.newSliderImage.imageIndex][i] = response.body.Data.Response.name;
        _this2.toggleLoader();
        _this2.hideCroppieModal();
        _this2.update();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    addNew: function addNew() {
      this.slider.unshift({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'allnewgallery' + this.$route.params.id,
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      var newdis = this;
      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = 'allnewgallery' + newdis.$route.params.id;
      });
      this.$http.post('/api/images/edit/', this.slider).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi');
        _this3.getSlider();
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = '/api/images/allnewgallery/' + this.$route.params.id;
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
      }, function (er) {
        _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
      });
    },
    initiateCroppie: function initiateCroppie(id, i, n) {
      this.newSliderImage.image_id = id;
      this.newSliderImage.image_name = this.slugify(this.slider[i].title);
      this.newSliderImage.imageIndex = i;
      this.newSliderImage.n = n;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {

      this.crop();
    },
    crop: function crop() {
      var _this5 = this;

      var dis = this;
      this.toggleLoader();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg' | 'png' | 'webp',
          backgroundColor: '#fff',
          size: {
            width: 1600,
            height: 1200
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this5.newSliderImage.cropped = output;
          _this5.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "O590":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('h4',{staticClass:"card-title d-md-flex justify-content-between",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Yorumlar")])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('div',{staticClass:"filters my-3 d-flex justify-content-between"},[_c('b-button-group',{attrs:{"size":"sm"}},[_c('b-button',{staticClass:"btn-fill btn-success active type-button",attrs:{"id":"type-all"},on:{"click":function($event){return _vm.changeType('all')}}},[_vm._v("Tümü")]),_vm._v(" "),_c('b-button',{staticClass:"btn-fill btn-success type-button",attrs:{"id":"type-1"},on:{"click":function($event){return _vm.changeType(1)}}},[_vm._v("Aktif")]),_vm._v(" "),_c('b-button',{staticClass:"btn-fill btn-success type-button",attrs:{"id":"type-1"},on:{"click":function($event){return _vm.changeType(0)}}},[_vm._v("Pasif")])],1)],1),_vm._v(" "),_c('div',{staticClass:"filters my-3 d-flex ml-3 w-25 align-items-center position-relatice"},[_c('div',{staticClass:"input-group w-100 ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],staticClass:"form-control form-control-sm border-primary text-primary",attrs:{"type":"text","placeholder":"Arama"},domProps:{"value":(_vm.query)},on:{"keyup":function($event){return _vm.getPosts()},"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text bg-white border-primary text-primary",attrs:{"id":"basic-addon2"}},[_c('i',{staticClass:"fas fa-circle-notch fa-spin d-none",attrs:{"id":"small-spinner"}})])])])])]),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[(!_vm.query)?_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]):_vm._e(),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',{staticStyle:{"width":"60%"}},[_vm._v("Yorum")]),_vm._v(" "),_c('th',[_vm._v("Kullanıcı")]),_vm._v(" "),_c('th',[_vm._v("Sayfa")]),_vm._v(" "),_c('th',[_vm._v("İşlem")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.comment))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.user.username))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.post.name))]),_vm._v(" "),_c('td',{staticStyle:{"width":"15%"}},[(item.published)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Pasif Et","id":"deactivate-item.id"},on:{"click":function($event){return _vm.deactivate(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})]):_vm._e(),_vm._v(" "),(!item.published)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Aktif Et","id":"activate-item.id"},on:{"click":function($event){return _vm.activate(item.id)}}},[_c('i',{staticClass:"fas fa-check fa-fw"})]):_vm._e()])])}),0)]),_vm._v(" "),(!_vm.query)?_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O8EV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeInfos_vue__ = __webpack_require__("7NAF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2468b9ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeInfos_vue__ = __webpack_require__("kCLg");
function injectStyle (ssrContext) {
  __webpack_require__("D204")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeInfos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2468b9ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeInfos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OLFD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: [{
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'leaderarticlesslider' + this.$route.params.id,
        order_number: null
      }],
      selectedType: null,
      types: ['URL', 'Kategori', 'Alt Kategori', 'Yayın', 'Etiket'],
      options: [],
      sliderItems: null,
      newSliderImage: {
        cropped: null,
        image_id: null,
        image_name: null,
        imageIndex: null
      },
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier('top', 'right', 'danger', 'Slider Başarıyla silindi');
          _this.getSlider();
        }, function (e) {
          _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          _this.toggleLoader();
        });
      }
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post('/api/images/upload/leaderarticlesslider', this.newSliderImage).then(function (response) {
        var i = _this2.newSliderImage.n === 0 ? 'image' : 'image2';
        _this2.slider[_this2.newSliderImage.imageIndex][i] = response.body.Data.Response.name;
        _this2.toggleLoader();
        _this2.hideCroppieModal();
        _this2.update();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    addNew: function addNew() {
      this.slider.unshift({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'leaderarticlesslider' + this.$route.params.id,
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      var newdis = this;
      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = 'leaderarticlesslider' + newdis.$route.params.id;
      });
      this.$http.post('/api/images/edit/', this.slider).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi');
        _this3.getSlider();
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = '/api/images/leaderarticlesslider/' + this.$route.params.id;
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
      }, function (er) {
        _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
      });
    },
    initiateCroppie: function initiateCroppie(id, i, n) {
      this.newSliderImage.image_id = id;
      this.newSliderImage.image_name = this.slugify(this.slider[i].title);
      this.newSliderImage.imageIndex = i;
      this.newSliderImage.n = n;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {

      this.crop();
    },
    crop: function crop() {
      var _this5 = this;

      var dis = this;
      this.toggleLoader();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg' | 'png' | 'webp',
          backgroundColor: '#fff',
          size: {
            width: 1600,
            height: 800
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this5.newSliderImage.cropped = output;
          _this5.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "OV6+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OaMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card_vue__ = __webpack_require__("jEp+");


//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chart-card',
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_2__Card_vue__["a" /* default */]
  },
  props: {
    chartType: {
      type: String,
      default: 'Line' // Line | Pie | Bar
    },
    chartOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      default: function _default() {
        return {
          labels: [],
          series: []
        };
      }
    },
    responsiveOptions: [Object, Array]
  },
  data: function data() {
    return {
      chartId: 'no-id',
      $Chartist: null,
      chart: null
    };
  },

  methods: {
    /***
     * Initializes the chart by merging the chart options sent via props and the default chart options
     */
    initChart: function initChart() {
      var chartIdQuery = '#' + this.chartId;
      this.chart = this.$Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions, this.responsiveOptions);
      this.$emit('initialized', this.chart);
      if (this.chartType === 'Line') {
        this.animateLineChart();
      }
      if (this.chartType === 'Bar') {
        this.animateBarChart();
      }
    },

    /***
     * Assigns a random id to the chart
     */
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    animateLineChart: function animateLineChart() {
      var _this = this;

      var seq = 0;
      var durations = 500;
      var delays = 80;
      this.chart.on('draw', function (data) {
        if (data.type === 'line' || data.type === 'area') {
          data.element.animate({
            d: {
              begin: 600,
              dur: 700,
              from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
              to: data.path.clone().stringify(),
              easing: _this.$Chartist.Svg.Easing.easeOutQuint
            }
          });
        } else if (data.type === 'point') {
          seq++;
          data.element.animate({
            opacity: {
              begin: seq * delays,
              dur: durations,
              from: 0,
              to: 1,
              easing: 'ease'
            }
          });
        }
      });
      seq = 0;
    },
    animateBarChart: function animateBarChart() {
      var seq = 0;
      var durations = 500;
      var delays = 80;
      this.chart.on('draw', function (data) {
        if (data.type === 'bar') {
          seq++;
          data.element.animate({
            opacity: {
              begin: seq * delays,
              dur: durations,
              from: 0,
              to: 1,
              easing: 'ease'
            }
          });
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.updateChartId();
              _context.next = 3;
              return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "715g"));

            case 3:
              Chartist = _context.sent;

              _this2.$Chartist = Chartist;
              _this2.initChart();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),

/***/ "Od6J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostModules_Homeboxes_Index_vue__ = __webpack_require__("GUeS");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__PostModules_Homeboxes_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "Ond/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__ = __webpack_require__("eU1q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3988f6ab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__ = __webpack_require__("WOE+");
function injectStyle (ssrContext) {
  __webpack_require__("fuBC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3988f6ab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Opci":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OtbY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      user: {
        is_active: 0
      },
      table: null,
      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "all",
      query: null,
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeType: function changeType(t) {
      this.type = t;
      var buttons = Array.prototype.slice.call(document.getElementsByClassName("type-button"));
      buttons.forEach(function (b) {
        b.classList.remove("active");
      });
      event.target.classList.add("active");
      this.getPosts(1, this.type);
    },
    deactivate: function deactivate(id) {
      var _this = this;

      this.toggleLoader();
      this.user.is_active = 0;
      this.$http.post("/api/users/edit/" + id, this.user).then(function (response) {
        _this.sendMail(id);
      }, function (e) {
        _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this.toggleLoader();
      });
    },
    sendMail: function sendMail(id) {
      var _this2 = this;

      this.$http.post("/api/users/send-mail/" + id, this.user).then(function (response) {
        if (_this2.user.is_active == 1) {
          _this2.notifier("top", "right", "success", "Üye Aktif Edildi");
          _this2.getPosts(_this2.page, _this2.type);
          _this2.toggleLoader();
        } else if (_this2.user.is_active == 0) {
          _this2.notifier("top", "right", "warning", "Üye Pasif Edildi");
          _this2.getPosts(_this2.page, _this2.type);
          _this2.toggleLoader();
        }
      }, function (e) {
        _this2.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this2.toggleLoader();
      });
    },
    activate: function activate(id) {
      var _this3 = this;

      this.toggleLoader();
      this.user.is_active = 1;
      this.$http.post("/api/users/edit/" + id, this.user).then(function (response) {
        _this3.sendMail(id);
      }, function (e) {
        _this3.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this3.toggleLoader();
      });
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this4 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "all";

      if (this.query) {
        if (this.tmId) {
          clearTimeout(this.tmId);
        }
        this.tmId = setTimeout(function () {
          if (_this4.query) {
            document.getElementById("small-spinner").classList.remove("d-none");
            _this4.$http.get("/api/search-user/" + _this4.query).then(function (response) {
              document.getElementById("small-spinner").classList.add("d-none");
              _this4.table = response.body;
              clearTimeout(_this4.tmId);
            }, function (er) {
              _this4.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
              clearTimeout(_this4.tmId);
            });
          }
        }, 700);
      } else {
        this.type = t;
        var url = "/api/filter/users/user-type-id/3/limit/" + this.limit + "/page/" + p;
        if (this.type !== "all") {
          url = url + "/is-active/" + this.type;
        }

        this.$http.get(url).then(function (response) {
          _this4.table = response.body.data;
          _this4.total = response.body.meta.total;
          _this4.page = p;
          _this4.pageCount = [];
          for (var i = 0; i < _this4.total / _this4.limit; i++) {
            _this4.pageCount.push(i + 1);
          }
        }, function (er) {
          _this4.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        });
      }
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById("new-post").classList.contains("d-none")) {
        document.getElementById("new-post").classList.remove("d-none");
      } else {
        document.getElementById("new-post").classList.add("d-none");
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "Otqt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P36o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P3v9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__("UMDs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_471c4aac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__("s1lu");
function injectStyle (ssrContext) {
  __webpack_require__("XzoE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_471c4aac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PBKA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha__ = __webpack_require__("olAn");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['isLogged'],
	data: function data() {
		return {
			credentials: {
				email: null,
				password: null
			},
			isL: 'unknown',
			errors: []
		};
	},
	components: { VueRecaptcha: __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha__["a" /* default */] },
	methods: {
		checkForm: function checkForm() {
			this.errors = [];
			if (!this.credentials.email) {
				this.errors.push("E-Posta Alanı Boş");
			}
			if (!this.credentials.password) {
				this.errors.push("Şifre Alanı Boş");
			}
			if (!this.validEmail(this.credentials.email)) {
				this.errors.push("E-Posta Formatı Doğru Değil");
			}
			if (!this.errors.length) {
				this.toggleLoader();
				this.tryLogin();
			}
		},
		validEmail: function validEmail(email) {
			var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		},
		Submit: function Submit() {
			// this.$refs.invisibleRecaptcha.execute()
		},
		onVerify: function onVerify(response) {
			this.checkForm();
		},
		onExpired: function onExpired() {
			console.log('Recaptcha Expired');
		},
		tryLogin: function tryLogin() {
			var _this = this;

			this.$http.post('/api/users/login', this.credentials).then(function (response) {
				// Also can be achived with 'this.$parent.$data.isLoggedIn = true' but this is not a good idea
				_this.isL = 'yes';
				_this.$emit('changeState', _this.isL);
				localStorage.setItem('CurrentLoggedUserDetails', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.body.Data));
				_this.$router.push('/main');
				window.location.reload();
				_this.getLimit();
				_this.toggleLoader();
			}, function (e) {
				_this.errors.push(e.body.Error);
				_this.toggleLoader();
			});
			// this.$refs.invisibleRecaptcha.reset()
		},
		getLimit: function getLimit() {
			if (!localStorage.getItem('filterLimit')) {
				this.$http.get('/api/settings/get/filter_limit').then(function (response) {
					localStorage.setItem('filterLimit', response.body.data);
					location.reload();
				});
			} else {
				return localStorage.getItem('filterLimit');
			}
		}
	},
	mounted: function mounted() {
		this.$nextTick(function () {
			setTimeout(function () {
				document.getElementById('login-body').classList.add('show');
				document.getElementById('login-form').classList.add('transition');
				setTimeout(function () {
					document.getElementById('login-form').classList.add('shadowed');
				}, 1000);
			}, 500);
			this.isL = this.isLogged;
		});
	}

});

/***/ }),

/***/ "PKGG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostModules_CupPointPage_Index_vue__ = __webpack_require__("jbrF");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostsTable: __WEBPACK_IMPORTED_MODULE_0__PostModules_CupPointPage_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "POB4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PPMk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      publishTime: null,
      futurePost: false,
      socialMedia: true,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'Cuppointpage',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          },
          meta4: {
            meta_key: 'view_count',
            meta_value: 0
          }
        }
      },
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        cropped: null
      },
      sliderImage: {
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post('/api/images/upload/' + this.post.name + 'act_inner-image', {
        cropped: i
      }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + '" />';
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push('Başlık');
      }
      if (!this.image.cropped) {
        this.errors.push('Resim');
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this2.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
        _this2.saveImage();
      });
    },
    saveImage: function saveImage() {
      var _this3 = this;

      this.$http.post('/api/images/upload/' + this.slugify(this.post.name), this.image).then(function (response) {
        _this3.post.image = response.body.Data.Response.name;
        _this3.savePost();
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this3.toggleLoader();
      });
    },
    savePost: function savePost() {
      var _this4 = this;

      var newdate = new Date();
      if (!this.post.url) {
        this.post.url = this.post.name + newdate.getTime();
      }
      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.$http.post('/api/posts/add', this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this4.post.id = pid;
        _this4.metas.post_id = pid;
        _this4.saveMetas();
      }, function (e) {
        _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this4.toggleLoader();
      });
    },
    saveMetas: function saveMetas() {
      var _this5 = this;

      this.$http.post('/api/post-metas/add-bulk', this.metas).then(function (response) {
        _this5.notifier('top', 'right', 'success', 'Başarılı');
        _this5.$router.push('/cup-point-page');
        _this5.toggleLoader();
      }, function (e) {
        _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this5.toggleLoader();
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name);
    },
    slugifyUrl: function slugifyUrl() {
      this.post.url = this.slugify(this.post.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this6 = this;

        request.$http.get('/api/filter/posts/post-type/Cuppointpage/name/' + request.post.name).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this6.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.name) {
        this.croppieType = type;
      } else {
        this.notifier('top', 'right', 'danger', 'Resim ekleyebilmek için bir başlık belirlemelisiniz.');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById('myImage').files.length) {
        oFReader.readAsDataURL(document.getElementById('myImage').files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this7 = this;

      var dis = this;
      var wdt = 150;
      var hgt = 150;
      if (this.croppieType === 'tinymce') {
        wdt = 150;
        hgt = 150;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: wdt,
            height: hgt
          },
          quality: 1,
          backgroundColor: '#fff'
        };
        dis.$refs.main.result(options, function (output) {
          if (_this7.croppieType === 'main') {
            dis.image.cropped = output;
          } else if (_this7.croppieType === 'tinymce') {
            _this7.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this7.addImageToEditor(output);
          }
          _this7.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  }
});

/***/ }),

/***/ "Pfth":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CategoryModules_Main_vue__ = __webpack_require__("5RfT");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__CategoryModules_Main_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "Pn68":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PsYt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("IjpU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7443140_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("Kwkj");
function injectStyle (ssrContext) {
  __webpack_require__("9J5m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7443140_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PtIP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PuSc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllnewsPdfs_vue__ = __webpack_require__("ERSz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d840927_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllnewsPdfs_vue__ = __webpack_require__("pUEq");
function injectStyle (ssrContext) {
  __webpack_require__("DqtS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllnewsPdfs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d840927_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllnewsPdfs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q45c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllLeaders_vue__ = __webpack_require__("2JBm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_361a96f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllLeaders_vue__ = __webpack_require__("rnf2");
function injectStyle (ssrContext) {
  __webpack_require__("3Un7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllLeaders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_361a96f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllLeaders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q5IF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q7hz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comment_vue__ = __webpack_require__("aFjf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f982ced6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comment_vue__ = __webpack_require__("MQML");
function injectStyle (ssrContext) {
  __webpack_require__("HnS8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f982ced6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QDyf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'card'
});

/***/ }),

/***/ "QFXi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QIj9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      user: {
        is_active: 0
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    deactivate: function deactivate(id) {
      var _this = this;

      this.toggleLoader();
      this.user.is_active = 0;
      this.$http.post('/api/users/edit/' + id, this.user).then(function (response) {
        _this.notifier('top', 'right', 'warning', 'Üye Pasif Edildi');
        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    activate: function activate(id) {
      var _this2 = this;

      this.toggleLoader();
      this.user.is_active = 1;
      this.$http.post('/api/users/edit/' + id, this.user).then(function (response) {
        _this2.notifier('top', 'right', 'success', 'Üye Aktif Edildi');
        _this2.getPosts(_this2.page, _this2.type);
        _this2.toggleLoader();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this3 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';

      this.toggleLoader();
      this.type = t;
      var url = '/api/filter/users/exclude/user-type-id:3/limit/' + this.limit + '/page/' + p;

      this.$http.get(url).then(function (response) {
        _this3.table = response.body.data;
        _this3.total = response.body.meta.total;
        _this3.page = p;
        _this3.pageCount = [];
        for (var i = 0; i < _this3.total / _this3.limit; i++) {
          _this3.pageCount.push(i + 1);
        }
        _this3.toggleLoader();
      }, function (er) {
        _this3.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        _this3.toggleLoader();
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "QKLD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__("cZTQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fba172c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__("CMvA");
function injectStyle (ssrContext) {
  __webpack_require__("uW6q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fba172c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QTPT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/directors'}}},[_c('button',{staticClass:"btn btn-danger btn-sm px-2 mr-2",attrs:{"type":"submit"}},[_vm._v("Yönetim Kurulu")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/staffs'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Federasyon Personeli")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/all-leaders'}}},[_c('button',{staticClass:"btn btn-primary btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Başkanlarımız")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/history'}}},[_c('button',{staticClass:"btn btn-success btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Tarihçe")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/sub-board-categories'}}},[_c('button',{staticClass:"btn btn-warning btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Alt Kurullar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/provincial-offices'}}},[_c('button',{staticClass:"btn btn-secondary btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("İl Temsilcilikleri")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/bank-informations'}}},[_c('button',{staticClass:"btn btn-success btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Hesap Numaraları")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/main-status-instructions'}}},[_c('button',{staticClass:"btn btn-info active btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Ana Statü Talimatlar")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('div',{staticClass:"row"},[(!_vm.err)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("\n                Ana Statü Talimatlar\n                "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"mr-2 btn btn-danger btn-sm btn-fill",on:{"click":function($event){return _vm.addNew()}}},[_vm._v("Ekle")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm btn-fill",on:{"click":function($event){return _vm.update()}}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"row w-100"},[_c('div',{staticClass:"col-12 col-md-2 d-flex align-items-center"},[_c('button',{staticClass:"btn btn-warning activebtn-s mr-2 px-2",attrs:{"disabled":!item.image,"type":"submit"}},[(item.image)?_c('a',{staticClass:"text-warning",attrs:{"href":_vm.pdfURL()+item.image,"target":"_blank"}},[_vm._v("PDF AÇ")]):_vm._e(),_vm._v(" "),(!item.image)?_c('span',{staticClass:"text-danger text-light pdf-alert-text"},[_vm._v("Pdf Yüklenmedi")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-5"},[_c('label',[_vm._v("Açıklama")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.target_url),expression:"item.target_url"}],staticClass:"form-control",attrs:{"type":"text","name":""},domProps:{"value":(item.target_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "target_url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-5"},[_c('label',[_vm._v("Seçim")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.description),expression:"item.description"}],staticClass:"custom-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "description", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Seçim Yapınız")]),_vm._v(" "),_c('option',{attrs:{"value":"Güncel"}},[_vm._v("Güncel")]),_vm._v(" "),_c('option',{attrs:{"value":"Geçmiş"}},[_vm._v("Geçmiş")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{staticClass:"btn btn btn-sm",attrs:{"title":"PDF Değiştir"},on:{"click":function($event){return _vm.myPdf(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('input',{staticClass:"m-3",staticStyle:{"display":"none"},attrs:{"name":"myFile","id":'myPdf'+index,"type":"file"},on:{"change":function($event){return _vm.upload($event)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])])])])])])}),0)],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n        "+_vm._s(_vm.err)+"\n      ")]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QTl8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: [{
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'staffs',
        order_number: null
      }],
      err: null,
      selectedType: null,
      types: ['URL', 'Kategori', 'Alt Kategori', 'Yayın', 'Etiket'],
      options: [],
      sliderItems: null,
      newSliderImage: {
        cropped: null,
        image_id: null,
        image_name: null,
        imageIndex: null
      },
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier('top', 'right', 'danger', 'Slider Başarıyla silindi');
          _this.getSlider();
        }, function (e) {
          if (!e.body.Error) {
            _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          } else {
            _this.notifier("top", "right", "danger", e.body.Error);
          }
        });
      }
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post('/api/images/upload/' + this.newSliderImage.image_name + 'staffs-slider', this.newSliderImage).then(function (response) {
        var i = _this2.newSliderImage.n === 0 ? 'image' : 'image2';
        _this2.slider[_this2.newSliderImage.imageIndex][i] = response.body.Data.Response.name;
        _this2.toggleLoader();
        _this2.hideCroppieModal();
        _this2.update();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    addNew: function addNew() {
      this.slider.push({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'staffs',
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = 'staffs';
      });
      this.$http.post('/api/images/edit/', this.slider).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi');
        _this3.getSlider();
      }, function (e) {
        if (!e.body.Error) {
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this3.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = '/api/images/staffs';
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
      }, function (er) {
        if (!er.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this4.err = er.body.Error;
          _this4.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    initiateCroppie: function initiateCroppie(id, i, n, type) {
      this.newSliderImage.image_id = id;
      this.newSliderImage.image_name = this.slugify(this.slider[i].title);
      this.newSliderImage.imageIndex = i;
      this.croppieType = type;
      this.newSliderImage.n = n;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {

      this.crop();
    },
    crop: function crop() {
      var _this5 = this;

      var dis = this;
      var wdt = 300;
      var hgt = 300;
      if (this.croppieType === 'big') {
        wdt = 400;
        hgt = 450;
      }
      this.toggleLoader();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg' | 'png' | 'webp',
          backgroundColor: '#fff',
          size: {
            width: wdt,
            height: hgt
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this5.newSliderImage.cropped = output;
          _this5.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModalsmall');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "QVsv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        status: 1
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'Homeboxes',
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeStatus: function changeStatus(id, status) {
      var _this = this;

      this.toggleLoader();
      this.post.status = status;
      this.$http.post('/api/posts/edit/' + id, this.post).then(function (response) {
        if (!status) {
          _this.notifier('top', 'right', 'warning', 'Sayfa Yayından Kaldırıldı');
        } else {
          _this.notifier('top', 'right', 'success', 'Sayfa Yayınlandı');
        }

        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();
        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this2 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Homeboxes';

      this.toggleLoader();
      this.type = t;
      var url = '/api/filter/posts/post-type/' + this.type + '/limit/' + this.limit + '/page/' + p;
      this.$http.get(url).then(function (response) {
        _this2.table = response.body.data;
        _this2.total = response.body.meta.total;
        _this2.page = p;
        _this2.pageCount = [];
        for (var i = 0; i < _this2.total / _this2.limit; i++) {
          _this2.pageCount.push(i + 1);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.toggleLoader();

        if (!er.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this2.err = er.body.Error;
          _this2.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "Qkg6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'l-table',
  props: {
    columns: Array,
    data: Array
  },
  methods: {
    hasValue: function hasValue(item, column) {
      return item[column.toLowerCase()] !== 'undefined';
    },
    itemValue: function itemValue(item, column) {
      return item[column.toLowerCase()];
    }
  }
});

/***/ }),

/***/ "QoKa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      videoupdated: false,
      publishTime: null,
      futurePost: false,
      socialMedia: true,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: "DigitalPress",
        image: null,
        newvideo: null,
        newvideo_id: null,
        content_id: null,
        video_id: null
      },
      categories: null,
      category: {
        category_id: "",
        name: null,
        url: null,
        is_active: 1
      },
      subCategories: null,
      disableParent: false,
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      order: {
        post_id: null,
        slider_group: "DigitalPress",
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: "title",
            meta_value: null
          },
          meta3: {
            meta_key: "description",
            meta_value: null
          },
          meta4: {
            meta_key: "view_count",
            meta_value: 0
          }
        }
      },
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        cropped: null
      },
      sliderImage: {
        cropped: null
      },
      croppieType: "main",
      sliderImageLoaded: false,
      // end of post data
      users: null,
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post("/api/images/upload/" + this.post.url + "_digital-press", {
        cropped: i
      }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + _this.post.url + '" />';
      }, function (e) {
        _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      }
      if (!this.post.url) {
        this.errors.push("URL");
      }
      if (!this.content.content) {
        this.errors.push("İçerik");
      }
      if (!this.image.cropped) {
        this.errors.push("Resim");
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById("url").classList.add("is-invalid");
        document.getElementById("url").classList.remove("is-valid");
        document.getElementById("url-label").classList.add("is-invalid");
        document.getElementById("url-label").classList.remove("is-valid");
        _this2.notifier("top", "right", "danger", "URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin");
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
        _this2.saveContent();
      });
    },
    saveContent: function saveContent() {
      var _this3 = this;

      var button = event.target;
      this.$http.post("/api/contents/add", this.content).then(function (response) {
        _this3.post.content_id = response.body.Data.Response.id;
        _this3.saveVideo();
      }, function (e) {
        button.innerHTML = "Kaydet";
        _this3.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this3.toggleLoader();
      });
    },
    saveVideo: function saveVideo() {
      var _this4 = this;

      if (this.video.video_url !== null) {
        this.$http.post("/api/videos/add", this.video).then(function (response) {
          _this4.post.video_id = response.body.Data.Response.name;
          _this4.saveImage();
        }, function (e) {
          _this4.notifier("top", "right", "danger", "Bir Hata Oluştu");
          _this4.toggleLoader();
        });
      } else {
        this.saveImage();
      }
    },
    saveImage: function saveImage() {
      var _this5 = this;

      this.$http.post("/api/images/upload/" + this.post.url, this.image).then(function (response) {
        _this5.post.image = response.body.Data.Response.name;
        _this5.savePost();
      }, function (e) {
        _this5.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this5.toggleLoader();
      });
    },

    savePost: function savePost() {
      var _this6 = this;

      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ["br"] }).substring(0, 500);
      }
      if (this.videoupdated) {
        this.post.video = this.video;
      } else {
        this.post.video = null;
      }
      if (this.post.newvideo) {
        var newvideo_id = this.post.newvideo.split("v=")[1];
        var ampersandPosition = newvideo_id.indexOf("&");
        if (ampersandPosition != -1) {
          newvideo_id = newvideo_id.substring(0, ampersandPosition);
        }
        this.post.newvideo_id = newvideo_id;
      }

      this.$http.post("/api/posts/add", this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this6.post.id = pid;
        _this6.metas.post_id = pid;
        _this6.order.post_id = pid;
        _this6.saveOrder();
      }, function (e) {
        _this6.toggleLoader();

        if (!e.body.Error) {
          _this6.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {

          _this6.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveOrder: function saveOrder() {
      var _this7 = this;

      if (this.allposts && this.allposts.length) {
        this.order.order_number = this.allposts.length;
      } else {
        this.order.order_number = 0;
      }
      this.$http.post("/api/slider/add/DigitalPress", this.order).then(function (response) {
        _this7.saveMetas();
        _this7.notifier("top", "right", "success", "Başarılı");
      }, function (e) {
        _this7.toggleLoader();
        _this7.notifier("top", "right", "danger", "Bir Hata Oluştu");
      });
    },
    saveMetas: function saveMetas() {
      var _this8 = this;

      this.$http.post("/api/post-metas/add-bulk", this.metas).then(function (response) {
        _this8.notifier("top", "right", "success", "Başarılı");
        _this8.$router.push("/leader/digital-press");
        _this8.toggleLoader();
      }, function (e) {
        _this8.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this8.toggleLoader();
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name) + 'dp';
    },
    slugifyUrl: function slugifyUrl() {
      this.post.url = this.slugify(this.post.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById("url").classList.add("is-invalid");
        document.getElementById("url").classList.remove("is-valid");
        document.getElementById("url-label").classList.add("is-invalid");
        document.getElementById("url-label").classList.remove("is-valid");
      }).catch(function (er) {
        document.getElementById("url").classList.add("is-valid");
        document.getElementById("url").classList.remove("is-invalid");
        document.getElementById("url-label").classList.add("is-valid");
        document.getElementById("url-label").classList.remove("is-invalid");
      });
    },

    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this9 = this;

        request.$http.get("/api/filter/posts/url/" + request.post.url).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this9.notifier("top", "right", "danger", "Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.url) {
        this.croppieType = type;
      } else {
        this.notifier("top", "right", "danger", "Resim ekleyebilmek için bir başlık belirlemelisiniz.");
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this10 = this;

      var dis = this;
      var wdt = 1200;
      var hgt = 600;
      if (this.croppieType === "tinymce") {
        wdt = 1200;
        hgt = 600;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: "jpeg",
          size: {
            width: wdt,
            height: hgt
          },

          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this10.croppieType === "main") {
            dis.image.cropped = output;
          } else if (_this10.croppieType === "slider") {
            dis.sliderImage.cropped = output;
            dis.sliderImageLoaded = true;
          } else if (_this10.croppieType === "tinymce") {
            _this10.notifier("top", "right", "warning", "Lütfen resim yükleninceye kadar bekleyin.");
            _this10.addImageToEditor(output);
          }
          _this10.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result: function result(output) {
      return output;
    }
  }, mounted: function mounted() {
    var _this11 = this;

    this.$http.get("/api/posts/get-with-type/DigitalPress").then(function (response) {
      _this11.allposts = response.body;
    }, function (er) {
      _this11.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
      _this11.toggleLoader();
    });
  }
});

/***/ }),

/***/ "Qqcp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QrCh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n    Tüm Sayfalar \n    "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill float-md-right",attrs:{"title":"Yeni Sayfa Oluştur","to":{ path: 'page/add'},"tag":"li"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Yeni Sayfa")])],1),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Sayfa")]),_vm._v(" "),_c('th',[_vm._v("URL")]),_vm._v(" "),_c('th',[_vm._v("Yayın Tarihi")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return (item)?_c('tr',{key:item.id},[_c('td',[(item.name)?_c('span',[_vm._v(_vm._s(item.name))]):_vm._e()]),_vm._v(" "),_c('td',[(item.url)?_c('span',[_vm._v(_vm._s(item.url))]):_vm._e()]),_vm._v(" "),_c('td',[(item.created)?_c('span',[_vm._v(_vm._s(_vm._f("moment")(item.created,"Do/MM/YYYY HH:mm:ss")))]):_vm._e()]),_vm._v(" "),_c('td',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"to":{ path: 'page/edit/'+item.id},"title":"Düzenle","tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"#","title":"Önizleme"}},[_c('i',{staticClass:"fas fa-eye"}),_vm._v(" "+_vm._s(item.view_count))]),_vm._v(" "),(item.status)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"deactivate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,0)}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(!item.status)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,1)}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e(),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-dark btn-fill",attrs:{"href":"#","title":"Yorumlar"}},[_c('i',{staticClass:"far fa-comment-alt"}),_vm._v(" "+_vm._s(item.commentCount))])],1)]):_vm._e()}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R5Ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("Mca5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9292b9d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("3QED");
function injectStyle (ssrContext) {
  __webpack_require__("tV1W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9292b9d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R75h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      publishTime: null,
      futurePost: false,
      socialMedia: true,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'Informationbankspage',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          },
          meta4: {
            meta_key: 'view_count',
            meta_value: 0
          }
        }
      },
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        cropped: null
      },
      sliderImage: {
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post('/api/images/upload/' + this.post.name + 'ib_inner-image', {
        cropped: i
      }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + '" />';
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push('Başlık');
      }
      if (!this.image.cropped) {
        this.errors.push('Resim');
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this2.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
        _this2.saveImage();
      });
    },
    saveImage: function saveImage() {
      var _this3 = this;

      this.$http.post('/api/images/upload/' + this.slugify(this.post.name), this.image).then(function (response) {
        _this3.post.image = response.body.Data.Response.name;
        _this3.savePost();
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this3.toggleLoader();
      });
    },
    savePost: function savePost() {
      var _this4 = this;

      var newdate = new Date();
      if (!this.post.url) {
        this.post.url = this.post.name + newdate.getTime();
      }
      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.$http.post('/api/posts/add', this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this4.post.id = pid;
        _this4.metas.post_id = pid;
        _this4.saveMetas();
      }, function (e) {
        _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this4.toggleLoader();
      });
    },
    saveMetas: function saveMetas() {
      var _this5 = this;

      this.$http.post('/api/post-metas/add-bulk', this.metas).then(function (response) {
        _this5.notifier('top', 'right', 'success', 'Başarılı');
        _this5.$router.push('/information-banks-page');
        _this5.toggleLoader();
      }, function (e) {
        _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this5.toggleLoader();
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name);
    },
    slugifyUrl: function slugifyUrl() {
      this.post.url = this.slugify(this.post.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this6 = this;

        request.$http.get('/api/filter/posts/post-type/Informationbankspage/name/' + request.post.name).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this6.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.name) {
        this.croppieType = type;
      } else {
        this.notifier('top', 'right', 'danger', 'Resim ekleyebilmek için bir başlık belirlemelisiniz.');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById('myImage').files.length) {
        oFReader.readAsDataURL(document.getElementById('myImage').files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this7 = this;

      var dis = this;
      var wdt = 150;
      var hgt = 150;
      if (this.croppieType === 'tinymce') {
        wdt = 150;
        hgt = 150;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: wdt,
            height: hgt
          },
          quality: 1,
          backgroundColor: '#fff'
        };
        dis.$refs.main.result(options, function (output) {
          if (_this7.croppieType === 'main') {
            dis.image.cropped = output;
          } else if (_this7.croppieType === 'tinymce') {
            _this7.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this7.addImageToEditor(output);
          }
          _this7.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  }
});

/***/ }),

/***/ "RCAC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isEdit: false,
      post: {
        name: null,
        logo: null,
        content: null,
        url: null,
        target_url: null,
        is_active: 1
      },
      errors: [],
      image: {
        cropped: null
      },
      imageRecreated: false,
      croppieType: 'main',
      // end of post data
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      };
      if (!this.post.url) {
        this.errors.push("URL");
      };
      if (!this.post.content) {
        this.errors.push("İçerik");
      };
      if (!this.post.target_url) {
        this.errors.push("Başvuru Adresi");
      };
      if (!this.image.cropped) {
        this.errors.push("Resim");
      };
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
        _this.saveImage();
      });
    },
    saveImage: function saveImage() {
      var _this2 = this;

      if (this.imageRecreated) {
        this.$http.post('/api/images/upload/' + this.post.url, this.image).then(function (response) {
          _this2.post.logo = response.body.Data.Response.name;
          if (_this2.isEdit) {
            _this2.updatePost();
          } else {
            _this2.savePost();
          }
        }, function (e) {
          button.innerHTML = 'Kaydet';
          _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this2.toggleLoader();
        });
      } else {
        if (this.isEdit) {
          this.updatePost();
        } else {
          this.savePost();
        }
      }
    },
    savePost: function savePost() {
      var _this3 = this;

      this.$http.post('/api/job-postings/add', this.post).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Başarılı');
        _this3.$router.push('/job-postings');
        _this3.toggleLoader();
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this3.toggleLoader();
      });
    },
    updatePost: function updatePost() {
      var _this4 = this;

      this.post.url = this.post.url + '-' + this.post.id;
      this.$http.post('/api/job-postings/edit/' + this.post.id, this.post).then(function (response) {
        _this4.notifier('top', 'right', 'success', 'Başarılı');
        _this4.$router.push('/job-postings');
        _this4.toggleLoader();
      }, function (e) {
        _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this4.toggleLoader();
      });
    },
    createUrl: function createUrl() {
      if (!isEdit) {
        this.post.url = this.slugify(this.post.name);
      }
    },
    slugifyUrl: function slugifyUrl() {
      this.announcement.url = this.slugify(this.announcement.url);
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this5 = this;

        request.$http.get('/api/filter/job-postings/url/' + request.post.url).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this5.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      this.croppieType = type;
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this6 = this;

      var dis = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: 1920,
            height: 1080
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this6.croppieType === 'main') {
            dis.image.cropped = output;
            dis.imageRecreated = true;
          } else if (_this6.croppieType === 'slider') {
            dis.sliderimage.cropped = output;
            dis.sliderImageLoaded = true;
          }
          _this6.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },

    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var _this7 = this;

      if (this.$route.params.id) {
        this.toggleLoader();
        this.$http.get('/api/job-postings/get/' + this.$route.params.id).then(function (response) {
          _this7.isEdit = true;
          _this7.post = response.body;
          _this7.image.cropped = _this7.mediaURL() + _this7.post.logo;
          _this7.post.url = _this7.post.url.split('-')[0];
          _this7.toggleLoader();
        }, function (response) {
          _this7.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
          _this7.toggleLoader();
        });
      }
    });
  }
});

/***/ }),

/***/ "RL7+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RQHz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      featuredTitles: [{
        key: 'bellow_slider_1',
        title: null,
        details: null,
        link: null,
        image: null
      }, {
        key: 'bellow_slider_2',
        title: null,
        details: null,
        link: null,
        image: null
      }, {
        key: 'bellow_slider_3',
        title: null,
        details: null,
        link: null,
        image: null
      }],
      slider: {
        post_id: null,
        slider_group: 'Featured',
        order_number: null,
        is_active: 1
      },
      selectedType: null,
      types: ['URL', 'Kategori', 'Alt Kategori', 'Yayın', 'Etiket'],
      options: [],
      sliderItems: null,
      newFeaturedImage: {
        featured_id: null,
        cropped: null
      },
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      this.toggleLoader();
      this.$http.delete('/api/slider/delete/' + id).then(function (response) {
        _this.notifier('top', 'right', 'warning', 'Menu elemanı silindi');
        _this.getSlider();
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();

        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post('/api/images/upload/boxes-under-slider-' + this.newFeaturedImage.id, this.newFeaturedImage).then(function (response) {
        _this2.featuredTitles[_this2.newFeaturedImage.id].image = response.body.Data.Response.name;
        _this2.hideCroppieModal();
        document.getElementById('submit-image').innerHTML = 'Kaydet';
        _this2.toggleLoader();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    loadItems: function loadItems() {
      var _this3 = this;

      this.options = [];
      this.toggleLoader();
      var url = '/api/posts/latest';
      this.$http.get(url).then(function (response) {
        response = response.body;
        for (var i = 0; i < response.length; i++) {
          var temp = { value: response[i].id, text: response[i].name };
          _this3.options.push(temp);
        }
        _this3.toggleLoader();
      }, function (er) {
        _this3.toggleLoader();

        if (!er.body.Error) {
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this3.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    loadFeaturedTitles: function loadFeaturedTitles() {
      var _this4 = this;

      this.toggleLoader();
      this.$http.get('/api/settings/get-featured-under-slider').then(function (response) {
        var settings = response.body;
        _this4.featuredTitles = [];
        for (var i = 0; i < settings.length; i++) {
          var jsonData = JSON.parse(settings[i].data);
          jsonData.key = 'bellow_slider_' + (i + 1);
          _this4.featuredTitles.push(jsonData);
        }
        _this4.toggleLoader();
      }, function (er) {
        _this4.toggleLoader();
        if (!er.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this4.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    update: function update(id) {
      var _this5 = this;

      this.$http.post('/api/slider/edit/', this.sliderItems).then(function (response) {
        _this5.notifier('top', 'right', 'success', 'Sıralama güncellendi');
      }, function (e) {

        if (!e.body.Error) {
          _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this5.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    save: function save(id) {
      var _this6 = this;

      this.toggleLoader();
      this.$http.post('/api/slider/add/Featured', this.slider).then(function (response) {
        _this6.getSlider();
        _this6.toggleLoader();
        _this6.notifier('top', 'right', 'success', 'Başarılı');
      }, function (e) {
        _this6.toggleLoader();

        if (!e.body.Error) {
          _this6.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this6.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveSettings: function saveSettings() {
      var _this7 = this;

      this.toggleLoader();
      this.$http.post('/api/settings/edit-bulk/', this.featuredTitles).then(function (response) {
        _this7.toggleLoader();
        _this7.notifier('top', 'right', 'success', 'Başarılı');
      }, function (e) {
        _this7.toggleLoader();

        if (!e.body.Error) {
          _this7.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this7.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    getSlider: function getSlider() {
      var _this8 = this;

      this.toggleLoader();
      var url = '/api/slider/all/Featured';
      this.$http.get(url).then(function (response) {
        _this8.sliderItems = response.body;
        if (_this8.sliderItems.length > 0) {
          _this8.slider.order_number = _this8.sliderItems[0].order_number + 1;
          _this8.slider.post_id = 0;
        } else {
          _this8.slider.order_number = 0;
        }
        _this8.toggleLoader();
      }, function (er) {
        _this8.toggleLoader();

        if (!er.body.Error) {
          _this8.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this8.err = er.body.Error;
          _this8.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    initiateCroppie: function initiateCroppie(id) {
      this.newFeaturedImage.id = id;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById('myImage').files.length) {
        oFReader.readAsDataURL(document.getElementById('myImage').files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {
      document.getElementById('submit-image').innerHTML = "<i class='fas fa-circle-notch fa-spin'></i>";
      this.crop();
    },
    crop: function crop() {
      var _this9 = this;

      var dis = this;
      this.toggleLoader();
      var color = '#e17d00';
      if (this.newFeaturedImage.id === 0) {
        color = '#dc3545';
      } else if (this.newFeaturedImage.id === 1) {
        color = '#17a2b8';
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: 277,
            height: 244
          },
          backgroundColor: color,
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this9.newFeaturedImage.cropped = output;
          _this9.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
      this.loadItems();
      this.loadFeaturedTitles();
    });
  }
});

/***/ }),

/***/ "RVyi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Bilgi Düzenle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Detay Linki")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.link),expression:"post.link"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Link","aria-label":"Başlık","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "link", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("İçerik")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.content.content),expression:"content.content"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('İçerik')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.content.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.content, "content", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3 d-flex flex-column align-items-end"}),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("400 x 200 pixel")]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.file,"id":"main-i"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":true,"viewport":{width: 500, height: 250, type: 'suare'},"boundary":{width: 600, height: 300},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RWTJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rhc5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_search_select__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: [{
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'digitalpresspdf' + this.$route.params.id,
        order_number: null
      }],
      fullName: '',
      selectedType: null,
      types: ["URL", "Kategori", "Alt Kategori", "Yayın", "Etiket"],
      options: [],
      sliderItems: null,
      newPdf: {
        Pdf_id: null,
        Pdf_name: null,
        PdfIndex: null
      },

      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "all",
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_1_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier('top', 'right', 'danger', 'PDF Başarıyla silindi');
          _this.getSlider();
        }, function (e) {
          _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          _this.toggleLoader();
        });
      }
    },
    upload: function upload(event) {
      var _this2 = this;

      var file = event.target.files[0];
      if (file.type !== "application/pdf") return console.log(file);
      var data = new FormData();
      data.append("file", file);
      var newfile = file.name.split('.');
      var extension = '';
      var name = '';
      newfile.forEach(function (e, index) {
        if (index < newfile.length - 1) {
          name += e;
        }
        if (index == newfile.length - 1) {
          extension += e;
        }
      });

      var newName = name + new Date().getTime();
      this.fullName = newName + '.' + extension;
      data.append("fileName", this.fullName);

      this.$http.post("/api/files/upload-news-pdf/" + this.newPdf.Pdf_name, data).then(function (response) {
        var i = _this2.newPdf.n === 0 ? 'image' : 'image2';
        _this2.slider[_this2.newPdf.PdfIndex][i] = _this2.newPdf.Pdf_name;
        console.log(_this2.newPdf.Pdf_name);
        _this2.notifier('top', 'right', 'success', 'Pdf Başarıyla Yüklendi');
        _this2.update();
      }, function (er) {
        _this2.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
      });
    },
    myPdf: function myPdf(id, i, n) {
      this.newPdf.Pdf_id = id;
      if (this.slider[i].target_url) {
        this.newPdf.Pdf_name = this.slugify(this.slider[i].target_url) + new Date().getTime() + '.pdf';
      } else {
        this.newPdf.Pdf_name = 'dbasin' + new Date().getTime() + '.pdf';
      }
      this.newPdf.PdfIndex = i;
      this.newPdf.n = n;
      console.log(this.newPdf);
      document.getElementById('myPdf' + i).click();
    },
    addNew: function addNew() {
      this.slider.push({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'digitalpresspdf' + this.$route.params.id,
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      var newdis = this;
      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = 'digitalpresspdf' + newdis.$route.params.id;
      });
      this.$http.post('/api/images/edit/', this.slider).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi');
        _this3.getSlider();
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = "/api/images/digitalpresspdf/" + this.$route.params.id;
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
      }, function (er) {
        _this4.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
      });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "RiXL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/gallery'}}},[_c('button',{staticClass:"btn btn-info active btn-sm  px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Galeri")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/video-gallery'}}},[_c('button',{staticClass:"btn btn-warning btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Video Galeri")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('div',{staticClass:"row"},[(!_vm.err)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("\n                 Galeri\n                 "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"mr-2 btn btn-danger btn-sm btn-fill",on:{"click":function($event){return _vm.addNew()}}},[_vm._v("Ekle")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm btn-fill",on:{"click":function($event){return _vm.update()}}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("Resim boyutu 600 x 400 pixel")]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-11"},[_c('img',{staticClass:"img-fluid",attrs:{"width":"150px","src":_vm.mediaURL() + item.image}})]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn btn-sm",attrs:{"title":"Resmi Değiştir"},on:{"click":function($event){return _vm.initiateCroppie(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 border border-secondary p-2 d-none",attrs:{"src":_vm.newSliderImage.cropped}})])])])])}),0)],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n         "+_vm._s(_vm.err)+"\n       ")]):_vm._e()]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 480, height: 320, type: 'suare'},"boundary":{width: 600, height: 400},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rkh9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SendBulk_vue__ = __webpack_require__("kauu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9db18d7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SendBulk_vue__ = __webpack_require__("LoDK");
function injectStyle (ssrContext) {
  __webpack_require__("/Lme")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SendBulk_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9db18d7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SendBulk_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RleI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: [{
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: "sitegallery",
        order_number: null
      }],
      err: null,
      selectedType: null,
      types: ["URL", "Kategori", "Alt Kategori", "Yayın", "Etiket"],
      options: [],
      sliderItems: null,
      newSliderImage: {
        cropped: null,
        image_id: null,
        image_name: null,
        imageIndex: null
      },
      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "all",
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier("top", "right", "danger", "Slider Başarıyla silindi");
          _this.getSlider();
        }, function (e) {
          if (!e.body.Error) {
            _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          } else {
            _this.notifier("top", "right", "danger", e.body.Error);
          }
        });
      }
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post("/api/images/upload/new-gallery", this.newSliderImage).then(function (response) {
        var i = _this2.newSliderImage.n === 0 ? "image" : "image2";
        _this2.slider[_this2.newSliderImage.imageIndex][i] = response.body.Data.Response.name;
        _this2.toggleLoader();
        _this2.hideCroppieModal();
        _this2.update();
      }, function (e) {
        _this2.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this2.toggleLoader();
      });
    },
    addNew: function addNew() {
      this.slider.unshift({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: "sitegallery",
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      var newdis = this;
      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = "sitegallery";
      });
      this.$http.post("/api/images/edit/", this.slider).then(function (response) {
        _this3.notifier("top", "right", "success", "Değişiklikler Kaydedildi");
        _this3.getSlider();
      }, function (e) {
        if (!e.body.Error) {
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this3.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = "/api/images/get-with-type/sitegallery";
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
      }, function (er) {
        if (!er.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this4.err = er.body.Error;
          _this4.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    initiateCroppie: function initiateCroppie(id, i, n) {
      this.newSliderImage.image_id = id;
      this.newSliderImage.image_name = this.slugify(this.slider[i].title);
      this.newSliderImage.imageIndex = i;
      this.newSliderImage.n = n;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById("new-post").classList.contains("d-none")) {
        document.getElementById("new-post").classList.remove("d-none");
      } else {
        document.getElementById("new-post").classList.add("d-none");
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {
      this.crop();
    },
    crop: function crop() {
      var _this5 = this;

      var dis = this;
      this.toggleLoader();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: "jpeg" | "png" | "webp",
          backgroundColor: "#fff",
          size: {
            width: 600,
            height: 400
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this5.newSliderImage.cropped = output;
          _this5.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "RoxM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DirectorsModules_Index_vue__ = __webpack_require__("ScwQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__DirectorsModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "RrDU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Haber Ekle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('span'),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"change":_vm.validate,"keyup":_vm.createUrl,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"url-label"}},[_vm._v("URL")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.url),expression:"post.url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('URL')},attrs:{"type":"text","placeholder":"URL","aria-label":"URL","id":"url","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.url)},on:{"keyup":_vm.slugifyUrl,"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Kategori")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.category_id),expression:"post.category_id"}],staticClass:"custom-select",class:{'is-invalid' : _vm.errors.includes('Kategori')},attrs:{"disabled":_vm.disableParent},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.post, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.createUrl]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Kategori Seçimi Yapınız")]),_vm._v(" "),_vm._l((_vm.categories),function(cat){return _c('option',{key:cat.id,domProps:{"value":cat.id}},[_vm._v("\n              "+_vm._s(cat.name)+"\n            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3 d-flex flex-column align-items-end"},[_c('tinymce',{class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('vue-tabs',[_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Resim"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("600 x 450 pixel")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.cropped}})],1)])]),_vm._v(" "),_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Video"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 input-group px-5 m-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Video Adresi")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.newvideo),expression:"post.newvideo"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"https://www.youtube.com/watch?v=KZzON_7EQ70","aria-label":"Başlık","id":"title","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.newvideo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "newvideo", $event.target.value)}}})])])])],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 450, height: 300, type: 'suare'},"boundary":{width: 600, height: 450},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RxiA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S04p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S1jr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S9jN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{attrs:{"id":"app"}},[_c('vue-dropzone',{ref:"dropzone",attrs:{"id":"drop1","options":_vm.dropOptions},on:{"vdropzone-complete-multiple":_vm.afterComplete}})],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("Galeri \n              "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"})]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("Resim boyutu 1600 x 1200 pixel")]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-11"},[_c('img',{staticClass:"img-fluid",attrs:{"width":"150px","src":_vm.mediaURL() + item.image}})]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn btn-sm ",attrs:{"title":"Slider Resmini Değiştir"},on:{"click":function($event){return _vm.initiateCroppie(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 border border-secondary p-2 d-none",attrs:{"src":_vm.newSliderImage.cropped}})])])])])}),0)],1)],1)])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 688, height: 400, type: 'suare'},"boundary":{width: 700, height: 425},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SS9B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        status: 1
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'Activityprogrampage',
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeStatus: function changeStatus(id, status) {
      var _this = this;

      this.toggleLoader();
      this.post.status = status;
      this.$http.post('/api/posts/edit/' + id, this.post).then(function (response) {
        if (!status) {
          _this.notifier('top', 'right', 'warning', 'Sayfa Yayından Kaldırıldı');
        } else {
          _this.notifier('top', 'right', 'success', 'Sayfa Yayınlandı');
        }

        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();
        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this2 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Activityprogrampage';

      this.toggleLoader();
      this.type = t;
      var url = '/api/filter/posts/post-type/' + this.type + '/limit/' + this.limit + '/page/' + p;
      this.$http.get(url).then(function (response) {
        _this2.table = response.body.data;
        _this2.total = response.body.meta.total;
        _this2.page = p;
        _this2.pageCount = [];
        for (var i = 0; i < _this2.total / _this2.limit; i++) {
          _this2.pageCount.push(i + 1);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.toggleLoader();

        if (!er.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this2.err = er.body.Error;
          _this2.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "SVzr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: {
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'allnewslider' + this.$route.params.id,
        order_number: null
      },
      selectedType: null,
      types: ['URL', 'Kategori', 'Alt Kategori', 'Yayın', 'Etiket'],
      options: [],
      sliderItems: null,
      newSliderImage: {
        cropped: null,
        image_id: null,
        image_name: null,
        imageIndex: null
      },
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier('top', 'right', 'danger', 'Slider Başarıyla silindi');
          _this.getSlider();
        }, function (e) {
          _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          _this.toggleLoader();
        });
      }
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post('/api/images/upload/allnew-slider', this.newSliderImage).then(function (response) {
        var i = _this2.newSliderImage.n === 0 ? 'image' : 'image2';
        _this2.slider[_this2.newSliderImage.imageIndex][i] = response.body.Data.Response.name;
        _this2.toggleLoader();
        _this2.hideCroppieModal();
        _this2.update();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    addNew: function addNew() {
      this.slider.unshift({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'allnewslider' + this.$route.params.id,
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      var newdis = this;
      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = 'allnewslider' + newdis.$route.params.id;
      });
      this.$http.post('/api/images/edit/', this.slider).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi');
        _this3.getSlider();
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = '/api/images/allnewslider/' + this.$route.params.id;
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
      }, function (er) {
        _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
      });
    },
    initiateCroppie: function initiateCroppie(id, i, n) {
      this.newSliderImage.image_id = id;
      this.newSliderImage.image_name = this.slugify(this.slider[i].title);
      this.newSliderImage.imageIndex = i;
      this.newSliderImage.n = n;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {

      this.crop();
    },
    crop: function crop() {
      var _this5 = this;

      var dis = this;
      this.toggleLoader();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg' | 'png' | 'webp',
          backgroundColor: '#fff',
          size: {
            width: 1600,
            height: 800
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this5.newSliderImage.cropped = output;
          _this5.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "Sa9I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('posts-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ScwQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("uWRX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2218a154_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("jWTM");
function injectStyle (ssrContext) {
  __webpack_require__("T9Lh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2218a154_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Sczw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sffr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/races'}}},[_c('button',{staticClass:"btn btn-warning text-white active btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Yarışlar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/seasons'}}},[_c('button',{staticClass:"btn btn-info btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Sezonlar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/members'}}},[_c('button',{staticClass:"btn btn-danger btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Üyeler")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('div',[_c('b-tabs',{attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"title":"İçerik","active":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3 d-flex flex-column"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Ad Soyad:")]),_vm._v(" "),_c('span',{staticClass:"ml-3"},[_vm._v(_vm._s(_vm.race.full_name))])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3 d-flex flex-column"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Kulüp Adı :")]),_vm._v(" "),_c('span',{staticClass:"ml-3"},[_vm._v(_vm._s(_vm.race.club_name))])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3 d-flex flex-column"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Email :")]),_vm._v(" "),_c('span',{staticClass:"ml-3"},[_vm._v(_vm._s(_vm.race.email))])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3 d-flex flex-column"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Telefon Numarası :")]),_vm._v(" "),_c('span',{staticClass:"ml-3"},[_vm._v(_vm._s(_vm.race.phone))])])])]),_vm._v(" "),(_vm.race.general_music)?_c('div',{staticClass:"col-12 col-md-6 input-group mb-3 d-flex flex-column"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Element Formu:")]),_vm._v(" "),_c('a',{staticClass:"ml-3",attrs:{"href":_vm.setUrl(_vm.race.general_music,'/basvuru'),"target":"_blank"}},[_vm._v("Dosya Aç")])])])]):_vm._e(),_vm._v(" "),(_vm.race.document)?_c('div',{staticClass:"col-12 col-md-6 input-group mb-3 d-flex flex-column"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('span',{staticClass:"input-group-text"},[_vm._v("İl Müdürlük Belgesi:")]),_vm._v(" "),_c('a',{staticClass:"ml-3",attrs:{"href":_vm.setUrl(_vm.race.document,'/basvuru'),"target":"_blank"}},[_vm._v("Dosya Aç")])])])]):_vm._e(),_vm._v(" "),(_vm.race.club_list)?_c('div',{staticClass:"col-12 col-md-6 input-group mb-3 d-flex flex-column"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Kulüp Listesi:")]),_vm._v(" "),_c('a',{staticClass:"ml-3",attrs:{"href":_vm.setUrl(_vm.race.club_list,'/basvuru'),"target":"_blank"}},[_vm._v("Dosya Aç")])])])]):_vm._e(),_vm._v(" "),(_vm.race.extra_documents)?_c('div',{staticClass:"col-12 col-md-6 input-group mb-3 d-flex flex-column"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Extra Dosya:")]),_vm._v(" "),_c('a',{staticClass:"ml-3",attrs:{"href":_vm.setUrl(_vm.race.extra_documents,'/basvuru'),"target":"_blank"}},[_vm._v("Dosya Aç ")])])])]):_vm._e()])]),_vm._v(" "),_c('b-tab',{attrs:{"title":"Oyuncular"}},[(!_vm.loading)?_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0 race-inspect-table"},[_c('thead',{staticClass:"thead-dark"},[(_vm.categoryId==51)?_c('th',[_vm._v("Takım Adı")]):_vm._e(),_vm._v(" "),_c('th',[_vm._v("Ad Soyad")]),_vm._v(" "),_c('th',[_vm._v("Branş")]),_vm._v(" "),_c('th',[_vm._v("Kategori")]),_vm._v(" "),_c('th',[_vm._v("Opsiyonel Kategori")]),_vm._v(" "),_c('th',[_vm._v("Doğum Tarihi")]),_vm._v(" "),_c('th',[_vm._v("Cinsiyet")]),_vm._v(" "),_c('th',[_vm._v("Telefon No")]),_vm._v(" "),_c('th',[_vm._v("Kimlik No")]),_vm._v(" "),_c('th',[_vm._v("Lisans")]),_vm._v(" "),_c('th',[_vm._v("Lisans Durumu")]),_vm._v(" "),(_vm.categoryId!=50)?_c('th',[(_vm.categoryId!=51)?_c('span',[_vm._v("Oyuncu Kısa Müziği")]):_vm._e(),_vm._v(" "),(_vm.categoryId==51)?_c('span',[_vm._v("Takım Uzun Müziği")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.categoryId!=50)?_c('th',[(_vm.categoryId!=51)?_c('span',[_vm._v("Oyuncu Uzun Müziği")]):_vm._e(),_vm._v(" "),(_vm.categoryId==51)?_c('span',[_vm._v("Takım Uzun Müziği")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('th',[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.race.athletes),function(athletes,key){return _c('tr',{key:key},[(_vm.categoryId==51)?_c('td',[_vm._v(_vm._s(athletes.team))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(athletes.name)+" "+_vm._s(athletes.surname))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.branches[athletes.branch]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.categories[athletes.branch][athletes.category]))]),_vm._v(" "),_c('td',[(athletes.optionalCategory)?_c('span',[_vm._v(_vm._s(athletes.optionalCategory))]):_vm._e(),_vm._v(" "),(!athletes.optionalCategory)?_c('span',[_vm._v("Seçilmedi")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(athletes.birthdate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.genders[athletes.gender]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(athletes.phone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(athletes.tc))]),_vm._v(" "),_c('td',[(athletes.license)?_c('a',{attrs:{"href":_vm.license(athletes.license),"target":"_blank"}},[_vm._v("Lisans Aç")]):_vm._e()]),_vm._v(" "),_c('td',[(!athletes.status)?_c('span',[_vm._v("Beklemede")]):_vm._e(),_vm._v(" "),(athletes.status==2)?_c('span',[_vm._v("Revize Talep Edildi")]):_vm._e(),_vm._v(" "),(athletes.status==1)?_c('span',[_vm._v("Onaylandı")]):_vm._e()]),_vm._v(" "),(_vm.categoryId!=50)?_c('td',[(athletes.music)?_c('a',{attrs:{"href":_vm.setUrl(athletes.music,'/sporcump3'),"target":"_blank"}},[_vm._v("Kısa Müzik Aç")]):_vm._e(),_vm._v(" "),(!athletes.music)?_c('span',[_vm._v("Yok")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.categoryId!=50)?_c('td',[(athletes.longMusic)?_c('a',{attrs:{"href":_vm.setUrl(athletes.longMusic,'/sporcump3'),"target":"_blank"}},[_vm._v("Uzun Müzik Aç")]):_vm._e(),_vm._v(" "),(!athletes.longMusic)?_c('span',[_vm._v("Yok")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('td',[(athletes.status !== 2 || !athletes.status)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Lisans Revize Talep Et","id":"deactivate-athletes.status"},on:{"click":function($event){return _vm.changeStatus(_vm.race.id,key,2)}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(athletes.status != 1 || !athletes.status)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Lisans Kabul Et","id":"activate-athletes.status"},on:{"click":function($event){return _vm.changeStatus(_vm.race.id,key,1)}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e(),_vm._v(" "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-warning mb-0 text-white btn-fill btn-xs",attrs:{"to":{ path: '/race-logs/'+_vm.race.id},"title":"Logs","tag":"li"}},[_c('i',{staticClass:"fas fa-exchange-alt"})])],1)])}),0)]):_vm._e()])],1)],1)])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Sr19":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Supl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubBoards_vue__ = __webpack_require__("tlP6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c4af2fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubBoards_vue__ = __webpack_require__("UnvB");
function injectStyle (ssrContext) {
  __webpack_require__("n7ME")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubBoards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c4af2fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubBoards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Svim":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/leader'}}},[_c('button',{staticClass:"btn btn-info btn-sm  px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("İçerik")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/gallery'}}},[_c('button',{staticClass:"btn btn-warning btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Fotogaleri")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/pressgallery'}}},[_c('button',{staticClass:"btn btn-danger active btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Yazılı Basın")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/articles'}}},[_c('button',{staticClass:"btn btn-success btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Başkanın Yazıları")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/articlesorder'}}},[_c('button',{staticClass:"btn btn-primary btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Yazı Sıralama")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/digital-press'}}},[_c('button',{staticClass:"btn btn-secondary btn-sm  mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Dijital Basın")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/digital-press-order'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Dijital Basın Sıralama")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('div',{staticClass:"row"},[(!_vm.err)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("\n                 Başkanın Köşesi Yazılı Basın\n                 "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"mr-2 btn btn-danger btn-sm btn-fill",on:{"click":function($event){return _vm.addNew()}}},[_vm._v("Ekle")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm btn-fill",on:{"click":function($event){return _vm.update()}}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("Resim boyutu 600 x 400 pixel")]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-11"},[_c('img',{staticClass:"img-fluid",attrs:{"width":"150px","src":_vm.mediaURL() + item.image}})]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn btn-sm",attrs:{"title":"Resmi Değiştir"},on:{"click":function($event){return _vm.initiateCroppie(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 border border-secondary p-2 d-none",attrs:{"src":_vm.newSliderImage.cropped}})])])])])}),0)],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n         "+_vm._s(_vm.err)+"\n       ")]):_vm._e()]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 480, height: 320, type: 'suare'},"boundary":{width: 600, height: 400},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T1vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__ = __webpack_require__("eCSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__ = __webpack_require__("5FAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Main_vue__ = __webpack_require__("r4dt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Posts_vue__ = __webpack_require__("fMfY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Educations_vue__ = __webpack_require__("rzJ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_News_vue__ = __webpack_require__("MaVD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Races_vue__ = __webpack_require__("1Aya");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_LeaderArticles_vue__ = __webpack_require__("8zch");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_PostModules_LeaderArticles_Add_vue__ = __webpack_require__("8k//");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_PostModules_LeaderArticles_Edit_vue__ = __webpack_require__("6zzE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Announcements_vue__ = __webpack_require__("4OsH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_PostModules_Announcements_Add_vue__ = __webpack_require__("A9rn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_PostModules_Announcements_Edit_vue__ = __webpack_require__("4PGM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_ActivityProgram_vue__ = __webpack_require__("xOkz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_PostModules_ActivityProgram_Add_vue__ = __webpack_require__("guVi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_PostModules_ActivityProgram_Edit_vue__ = __webpack_require__("3CqE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_DigitalPress_vue__ = __webpack_require__("oH+u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_PostModules_DigitalPress_Add_vue__ = __webpack_require__("nHgb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_PostModules_DigitalPress_Edit_vue__ = __webpack_require__("mz7H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Allnews_vue__ = __webpack_require__("+/qu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_RaceLogs_vue__ = __webpack_require__("5lwa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_RaceApplications_vue__ = __webpack_require__("b21V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_RaceModules_Inspect_vue__ = __webpack_require__("riT3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_RaceModules_Edit_vue__ = __webpack_require__("I7jR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_ComingFromYou_vue__ = __webpack_require__("s0if");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_Archives_vue__ = __webpack_require__("Im1e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_StaticPages_vue__ = __webpack_require__("50CK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_JobPostings_vue__ = __webpack_require__("Kp7B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_Categories_vue__ = __webpack_require__("+iwA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_components_Dashboard_Views_RaceCategories_vue__ = __webpack_require__("j/ub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_components_Dashboard_Views_Newcategories_vue__ = __webpack_require__("sBYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_components_Dashboard_Views_Menus_vue__ = __webpack_require__("BZ9m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_src_components_Dashboard_Views_Feedbacks_vue__ = __webpack_require__("Ddip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_components_Dashboard_Views_Newsletter_vue__ = __webpack_require__("jNvC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_src_components_Dashboard_Views_Scores_vue__ = __webpack_require__("scED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_src_components_Dashboard_Views_Users_vue__ = __webpack_require__("WfUP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_src_components_Dashboard_Views_Settings_vue__ = __webpack_require__("AM9e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_src_components_Dashboard_Views_Leader_vue__ = __webpack_require__("KVwL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_src_components_Dashboard_Views_History_vue__ = __webpack_require__("Ckm2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_src_components_Dashboard_Views_ActivityProgramContent_vue__ = __webpack_require__("uxHi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_src_components_Dashboard_Views_ComingFromYouContent_vue__ = __webpack_require__("pNyA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_src_components_Dashboard_Views_IntroVideo_vue__ = __webpack_require__("ixBw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_src_components_Dashboard_Views_InformationBanksContent_vue__ = __webpack_require__("UmN+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_src_components_Dashboard_Views_Ads_vue__ = __webpack_require__("mouu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_src_components_Dashboard_Views_Slider_vue__ = __webpack_require__("5bLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_src_components_Dashboard_Views_Directors_vue__ = __webpack_require__("0MD3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_src_components_Dashboard_Views_AllLeaders_vue__ = __webpack_require__("Q45c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_src_components_Dashboard_Views_ProvincialOffices_vue__ = __webpack_require__("Wjwp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_src_components_Dashboard_Views_MainStatusInstructions_vue__ = __webpack_require__("+49+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_src_components_Dashboard_Views_SubBoards_vue__ = __webpack_require__("/dCU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_src_components_Dashboard_Views_Staffs_vue__ = __webpack_require__("WrXZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_src_components_Dashboard_Views_Members_vue__ = __webpack_require__("T461");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_src_components_Dashboard_Views_Comment_vue__ = __webpack_require__("Q7hz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_src_components_Dashboard_Views_Dictionary_vue__ = __webpack_require__("ysku");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_src_components_Dashboard_Views_Reports_vue__ = __webpack_require__("JniN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_src_components_Dashboard_Views_MemberModules_Search_vue__ = __webpack_require__("QKLD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_src_components_Dashboard_Views_JobPostingModules_add_edit_vue__ = __webpack_require__("ZSWq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_src_components_Dashboard_Views_NewsletterModules_NewSubscriber_vue__ = __webpack_require__("0016");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_src_components_Dashboard_Views_NewsletterModules_SendBulk_vue__ = __webpack_require__("Rkh9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_src_components_Dashboard_Views_PostModules_Pages_Add_vue__ = __webpack_require__("cIKw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_src_components_Dashboard_Views_PostModules_Education_Add_vue__ = __webpack_require__("087A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_src_components_Dashboard_Views_PostModules_News_Add_vue__ = __webpack_require__("dljt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_src_components_Dashboard_Views_PostModules_Races_Add_vue__ = __webpack_require__("scmS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_src_components_Dashboard_Views_PostModules_Allnews_Add_vue__ = __webpack_require__("yTRN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_src_components_Dashboard_Views_CategoryModules_AddEdit_vue__ = __webpack_require__("fSjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_src_components_Dashboard_Views_RaceCategoryModules_AddEdit_vue__ = __webpack_require__("3c77");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_src_components_Dashboard_Views_NewcategoryModules_AddEdit_vue__ = __webpack_require__("L86m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_src_components_Dashboard_Views_SubBoardsCategories_vue__ = __webpack_require__("dh+K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_src_components_Dashboard_Views_SubBoardCategoriesModules_AddEdit_vue__ = __webpack_require__("IS4u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_src_components_Dashboard_Views_UserModules_AddEdit_vue__ = __webpack_require__("qbM9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_src_components_Dashboard_Views_MemberModules_MemberAthletes_vue__ = __webpack_require__("fudw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_src_components_Dashboard_Views_StaticPageModules_SubModules_Add_vue__ = __webpack_require__("kBZk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_src_components_Dashboard_Views_StaticPageModules_SubModules_Edit_vue__ = __webpack_require__("wnzg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_src_components_Dashboard_Views_PostModules_Pages_Edit_vue__ = __webpack_require__("6U+M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_src_components_Dashboard_Views_PostModules_News_Edit_vue__ = __webpack_require__("AdK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_src_components_Dashboard_Views_PostModules_Races_Edit_vue__ = __webpack_require__("Ut3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_src_components_Dashboard_Views_PostModules_Allnews_Edit_vue__ = __webpack_require__("ncti");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_src_components_Dashboard_Views_PostModules_ComingFromYou_Edit_vue__ = __webpack_require__("adTx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_src_components_Dashboard_Views_NewGalleryModules_Index_vue__ = __webpack_require__("8Tiq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_src_components_Dashboard_Views_LeaderGalleryModules_Index_vue__ = __webpack_require__("/hgj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_src_components_Dashboard_Views_PressGalleryModules_Index_vue__ = __webpack_require__("YCk0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_src_components_Dashboard_Views_GalleryModules_Index_vue__ = __webpack_require__("n8xk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_src_components_Dashboard_Views_VideoGalleryModules_Index_vue__ = __webpack_require__("YjQd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_src_components_Dashboard_Views_AllnewGalleryModules_Index_vue__ = __webpack_require__("5CsY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_src_components_Dashboard_Views_AllnewsPdfsModules_AllnewsPdfs_vue__ = __webpack_require__("PuSc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_src_components_Dashboard_Views_NewsPdfsModules_NewsPdfs_vue__ = __webpack_require__("lp8N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_src_components_Dashboard_Views_LeaderPdfsModules_LeaderPdfs_vue__ = __webpack_require__("yDRE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_src_components_Dashboard_Views_DigitalPressPdfsModules_DigitalPressPdfs_vue__ = __webpack_require__("Ypi8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_src_components_Dashboard_Views_NewSliderModules_Index_vue__ = __webpack_require__("DHhI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_src_components_Dashboard_Views_AllnewSliderModules_Index_vue__ = __webpack_require__("a9sQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_src_components_Dashboard_Views_DigitalPressSliderModules_Index_vue__ = __webpack_require__("n0i5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_src_components_Dashboard_Views_LeaderArticlesSliderModules_Index_vue__ = __webpack_require__("+sSv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_src_components_Dashboard_Views_LeaderArticlesGalleryModules_Index_vue__ = __webpack_require__("lr28");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_src_components_Dashboard_Views_DigitalPressGalleryModules_Index_vue__ = __webpack_require__("NQGi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_src_components_Dashboard_Views_PostModules_Education_Edit_vue__ = __webpack_require__("ndZT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_src_components_Dashboard_Views_PostModules_ArchiveModules_EditArchive_vue__ = __webpack_require__("cpG7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_src_components_Dashboard_Views_UserModules_Permissions_vue__ = __webpack_require__("HwiA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_src_components_Dashboard_Views_FeaturedModules_Featured_vue__ = __webpack_require__("s/j1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98_src_components_Dashboard_Views_ArticlesOrderModules_ArticlesOrder_vue__ = __webpack_require__("pk3h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99_src_components_Dashboard_Views_AllnewsOrderModules_AllnewsOrder_vue__ = __webpack_require__("5lYI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100_src_components_Dashboard_Views_NewsOrderModules_NewsOrder_vue__ = __webpack_require__("LnsZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101_src_components_Dashboard_Views_DigitalPressOrderModules_DigitalPressOrder_vue__ = __webpack_require__("da/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102_src_components_Dashboard_Views_Facilities_vue__ = __webpack_require__("LF97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103_src_components_Dashboard_Views_PostModules_Facilities_Edit_vue__ = __webpack_require__("Dvrb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104_src_components_Dashboard_Views_PostModules_Facilities_Add_vue__ = __webpack_require__("PsYt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105_src_components_Dashboard_Views_BankInformations_vue__ = __webpack_require__("ufRY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106_src_components_Dashboard_Views_PostModules_BankInformations_Edit_vue__ = __webpack_require__("yyTq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107_src_components_Dashboard_Views_PostModules_BankInformations_Add_vue__ = __webpack_require__("8s++");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108_src_components_Dashboard_Views_Homeboxes_vue__ = __webpack_require__("k9ZB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109_src_components_Dashboard_Views_ActivityProgramPage_vue__ = __webpack_require__("lr5n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110_src_components_Dashboard_Views_PostModules_ActivityProgramPage_Edit_vue__ = __webpack_require__("yx9Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111_src_components_Dashboard_Views_PostModules_ActivityProgramPage_Add_vue__ = __webpack_require__("9QIj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112_src_components_Dashboard_Views_CupPointPage_vue__ = __webpack_require__("v2Ur");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113_src_components_Dashboard_Views_PostModules_CupPointPage_Edit_vue__ = __webpack_require__("Fzx+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114_src_components_Dashboard_Views_PostModules_CupPointPage_Add_vue__ = __webpack_require__("lqZX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115_src_components_Dashboard_Views_InformationBanksPage_vue__ = __webpack_require__("Jik1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116_src_components_Dashboard_Views_PostModules_InformationBanksPage_Edit_vue__ = __webpack_require__("ZpeN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117_src_components_Dashboard_Views_PostModules_InformationBanksPage_Add_vue__ = __webpack_require__("ZE1M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118_src_components_Dashboard_Views_PostModules_Homeboxes_Edit_vue__ = __webpack_require__("wgOX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119_src_components_Dashboard_Views_PostModules_Homeboxes_Add_vue__ = __webpack_require__("1ror");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120_src_components_Dashboard_Views_HomeInfos_vue__ = __webpack_require__("O8EV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121_src_components_Dashboard_Views_PostModules_HomeInfos_Edit_vue__ = __webpack_require__("fWgP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122_src_components_Dashboard_Views_PostModules_HomeInfos_Add_vue__ = __webpack_require__("r5cG");

// GeneralViews


// Admin pages


























































































































var routes = [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
    redirect: '/main'
}, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
    redirect: '/main',
    children: [{
        path: 'statistics',
        name: 'statistics',
        component: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Main_vue__["a" /* default */]
    }, {
        path: 'ads',
        name: 'Reklam Yönetimi',
        component: __WEBPACK_IMPORTED_MODULE_43_src_components_Dashboard_Views_Ads_vue__["a" /* default */]
    }, {
        path: 'featured',
        name: 'Vitrin',
        component: __WEBPACK_IMPORTED_MODULE_97_src_components_Dashboard_Views_FeaturedModules_Featured_vue__["a" /* default */]
    }, {
        path: '/leader/articlesorder',
        name: 'Yazıları Sırala',
        component: __WEBPACK_IMPORTED_MODULE_98_src_components_Dashboard_Views_ArticlesOrderModules_ArticlesOrder_vue__["a" /* default */]
    }, {
        path: '/allnews-order',
        name: 'Haberleri Sırala',
        component: __WEBPACK_IMPORTED_MODULE_99_src_components_Dashboard_Views_AllnewsOrderModules_AllnewsOrder_vue__["a" /* default */]
    }, {
        path: '/news-order',
        name: 'Bildirileri Sırala',
        component: __WEBPACK_IMPORTED_MODULE_100_src_components_Dashboard_Views_NewsOrderModules_NewsOrder_vue__["a" /* default */]
    }, {
        path: '/leader/digital-press-order',
        name: 'Yayınları Sırala',
        component: __WEBPACK_IMPORTED_MODULE_101_src_components_Dashboard_Views_DigitalPressOrderModules_DigitalPressOrder_vue__["a" /* default */]
    }, {
        path: 'dictionary',
        name: 'Sözlük',
        component: __WEBPACK_IMPORTED_MODULE_53_src_components_Dashboard_Views_Dictionary_vue__["a" /* default */]
    }, {
        path: 'main1',
        name: 'main1',
        component: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Posts_vue__["a" /* default */]
    }, {
        path: '/user/permissions/:id',
        name: 'Permission',
        component: __WEBPACK_IMPORTED_MODULE_96_src_components_Dashboard_Views_UserModules_Permissions_vue__["a" /* default */]
    }, {
        path: '/main',
        name: 'Slider',
        component: __WEBPACK_IMPORTED_MODULE_44_src_components_Dashboard_Views_Slider_vue__["a" /* default */]
    }, {
        path: '/directors',
        name: 'Directors',
        component: __WEBPACK_IMPORTED_MODULE_45_src_components_Dashboard_Views_Directors_vue__["a" /* default */]
    }, {
        path: '/all-leaders',
        name: 'AllLeaders',
        component: __WEBPACK_IMPORTED_MODULE_46_src_components_Dashboard_Views_AllLeaders_vue__["a" /* default */]
    }, {
        path: '/provincial-offices',
        name: 'ProvincialOffices',
        component: __WEBPACK_IMPORTED_MODULE_47_src_components_Dashboard_Views_ProvincialOffices_vue__["a" /* default */]
    }, {
        path: '/main-status-instructions',
        name: 'MainStatusInstructions',
        component: __WEBPACK_IMPORTED_MODULE_48_src_components_Dashboard_Views_MainStatusInstructions_vue__["a" /* default */]
    }, {
        path: '/sub-boards',
        name: 'SubBoards',
        component: __WEBPACK_IMPORTED_MODULE_49_src_components_Dashboard_Views_SubBoards_vue__["a" /* default */]
    }, {
        path: '/staffs',
        name: 'Staffs',
        component: __WEBPACK_IMPORTED_MODULE_50_src_components_Dashboard_Views_Staffs_vue__["a" /* default */]
    }, {
        path: 'settings',
        name: 'Ayarlar',
        component: __WEBPACK_IMPORTED_MODULE_36_src_components_Dashboard_Views_Settings_vue__["a" /* default */]
    }, {
        path: 'leader',
        name: 'Başkanın Bölümü',
        component: __WEBPACK_IMPORTED_MODULE_37_src_components_Dashboard_Views_Leader_vue__["a" /* default */]
    }, {
        path: 'history',
        name: 'Tarihçe',
        component: __WEBPACK_IMPORTED_MODULE_38_src_components_Dashboard_Views_History_vue__["a" /* default */]
    }, {
        path: 'activity-program-content',
        name: 'Activity Program Content',
        component: __WEBPACK_IMPORTED_MODULE_39_src_components_Dashboard_Views_ActivityProgramContent_vue__["a" /* default */]
    }, {
        path: 'coming-from-you-content',
        name: 'Coming From You Content',
        component: __WEBPACK_IMPORTED_MODULE_40_src_components_Dashboard_Views_ComingFromYouContent_vue__["a" /* default */]
    }, {
        path: 'intro-video',
        name: 'Intro Video',
        component: __WEBPACK_IMPORTED_MODULE_41_src_components_Dashboard_Views_IntroVideo_vue__["a" /* default */]
    }, {
        path: 'information-banks-content',
        name: 'Information Banks Content',
        component: __WEBPACK_IMPORTED_MODULE_42_src_components_Dashboard_Views_InformationBanksContent_vue__["a" /* default */]
    }, {
        path: 'homeboxes',
        name: 'Anasayfa Kutular',
        component: __WEBPACK_IMPORTED_MODULE_108_src_components_Dashboard_Views_Homeboxes_vue__["a" /* default */]
    }, {
        path: 'homeinfos',
        name: 'Anasayfa Bilgiler',
        component: __WEBPACK_IMPORTED_MODULE_120_src_components_Dashboard_Views_HomeInfos_vue__["a" /* default */]
    }, {
        path: '/bank-informations',
        name: 'Hesap Numaraları',
        component: __WEBPACK_IMPORTED_MODULE_105_src_components_Dashboard_Views_BankInformations_vue__["a" /* default */]
    }, {
        path: 'comments',
        name: 'Yorumlar',
        component: __WEBPACK_IMPORTED_MODULE_52_src_components_Dashboard_Views_Comment_vue__["a" /* default */]
    }, {
        path: 'reports',
        name: 'Şikayetler',
        component: __WEBPACK_IMPORTED_MODULE_54_src_components_Dashboard_Views_Reports_vue__["a" /* default */]
    }, {
        path: 'search-user',
        name: 'Üye Ara',
        component: __WEBPACK_IMPORTED_MODULE_55_src_components_Dashboard_Views_MemberModules_Search_vue__["a" /* default */]
    }, {
        path: 'news',
        name: 'News',
        component: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_News_vue__["a" /* default */]
    }, {
        path: 'races',
        name: 'Races',
        component: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Races_vue__["a" /* default */]
    }, {
        path: 'allnews',
        name: 'Allnews',
        component: __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Allnews_vue__["a" /* default */]
    }, {
        path: 'coming-from-you',
        name: 'ComingFromYou',
        component: __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_ComingFromYou_vue__["a" /* default */]
    }, {
        path: 'educations',
        name: 'educations',
        component: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Educations_vue__["a" /* default */]
    }, {
        path: 'archive',
        name: 'archive',
        component: __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_Archives_vue__["a" /* default */]
    }, {
        path: 'static-pages',
        name: 'Static Pages',
        component: __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_StaticPages_vue__["a" /* default */]
    }, {
        path: 'job-postings',
        name: 'Job Postings',
        component: __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_JobPostings_vue__["a" /* default */]
    }, {
        path: 'categories',
        name: 'Categories',
        component: __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_Categories_vue__["a" /* default */]
    }, {
        path: 'seasons',
        name: 'Seasons',
        component: __WEBPACK_IMPORTED_MODULE_29_src_components_Dashboard_Views_RaceCategories_vue__["a" /* default */]
    }, {
        path: 'newcategories',
        name: 'Newcategories',
        component: __WEBPACK_IMPORTED_MODULE_30_src_components_Dashboard_Views_Newcategories_vue__["a" /* default */]
    }, {
        path: '/sub-board-categories',
        name: 'SubBoardsCategories',
        component: __WEBPACK_IMPORTED_MODULE_67_src_components_Dashboard_Views_SubBoardsCategories_vue__["a" /* default */]
    }, {
        path: 'menus',
        name: 'menu',
        component: __WEBPACK_IMPORTED_MODULE_31_src_components_Dashboard_Views_Menus_vue__["a" /* default */]
    }, {
        path: 'feedbacks',
        name: 'Feedbacks',
        component: __WEBPACK_IMPORTED_MODULE_32_src_components_Dashboard_Views_Feedbacks_vue__["a" /* default */]
    }, {
        path: 'newsletter',
        name: 'Newsletter',
        component: __WEBPACK_IMPORTED_MODULE_33_src_components_Dashboard_Views_Newsletter_vue__["a" /* default */]
    }, {
        path: '/page/add',
        name: 'AddPage',
        component: __WEBPACK_IMPORTED_MODULE_59_src_components_Dashboard_Views_PostModules_Pages_Add_vue__["a" /* default */]
    }, {
        path: '/page/add',
        name: 'Add Page',
        component: __WEBPACK_IMPORTED_MODULE_59_src_components_Dashboard_Views_PostModules_Pages_Add_vue__["a" /* default */]
    }, {
        path: '/news/add',
        name: 'Add News',
        component: __WEBPACK_IMPORTED_MODULE_61_src_components_Dashboard_Views_PostModules_News_Add_vue__["a" /* default */]
    }, {
        path: '/races/add',
        name: 'Add Races',
        component: __WEBPACK_IMPORTED_MODULE_62_src_components_Dashboard_Views_PostModules_Races_Add_vue__["a" /* default */]
    }, {
        path: '/allnews/add',
        name: 'Add Allnews',
        component: __WEBPACK_IMPORTED_MODULE_63_src_components_Dashboard_Views_PostModules_Allnews_Add_vue__["a" /* default */]
    }, {
        path: '/education/add',
        name: 'Add Education',
        component: __WEBPACK_IMPORTED_MODULE_60_src_components_Dashboard_Views_PostModules_Education_Add_vue__["a" /* default */]
    }, {
        path: '/users',
        name: 'Users',
        component: __WEBPACK_IMPORTED_MODULE_35_src_components_Dashboard_Views_Users_vue__["a" /* default */]
    }, {
        path: '/members',
        name: 'Members',
        component: __WEBPACK_IMPORTED_MODULE_51_src_components_Dashboard_Views_Members_vue__["a" /* default */]
    }, {
        path: '/member/athletes/:id',
        name: 'View Athletes',
        component: __WEBPACK_IMPORTED_MODULE_70_src_components_Dashboard_Views_MemberModules_MemberAthletes_vue__["a" /* default */]
    }, {
        path: '/static-page/add',
        name: 'Add Static Page',
        component: __WEBPACK_IMPORTED_MODULE_71_src_components_Dashboard_Views_StaticPageModules_SubModules_Add_vue__["a" /* default */]
    }, {
        path: '/job-posting/add-edit/',
        name: 'AddJob',
        component: __WEBPACK_IMPORTED_MODULE_56_src_components_Dashboard_Views_JobPostingModules_add_edit_vue__["a" /* default */]
    }, {
        path: '/user/add-edit/',
        name: 'Add User',
        component: __WEBPACK_IMPORTED_MODULE_69_src_components_Dashboard_Views_UserModules_AddEdit_vue__["a" /* default */]
    }, {
        path: '/category/add-edit/',
        name: 'Add Category',
        component: __WEBPACK_IMPORTED_MODULE_64_src_components_Dashboard_Views_CategoryModules_AddEdit_vue__["a" /* default */]
    }, {
        path: '/category/add-edit/:id/:type',
        name: 'Edit Category',
        component: __WEBPACK_IMPORTED_MODULE_64_src_components_Dashboard_Views_CategoryModules_AddEdit_vue__["a" /* default */]
    }, {
        path: 'race-applications/:id',
        name: 'RaceApplications',
        component: __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_RaceApplications_vue__["a" /* default */]
    }, {
        path: 'race-logs/:id',
        name: 'RaceLogs',
        component: __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_RaceLogs_vue__["a" /* default */]
    }, {
        path: 'race-applications/inspect/:id',
        name: 'RaceApplicationsInspect',
        component: __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_RaceModules_Inspect_vue__["a" /* default */]
    }, {
        path: 'race-applications/edit/:id',
        name: 'RaceApplicationsEdit',
        component: __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_RaceModules_Edit_vue__["a" /* default */]
    }, {
        path: '/seasons/add-edit/',
        name: 'Add Season',
        component: __WEBPACK_IMPORTED_MODULE_65_src_components_Dashboard_Views_RaceCategoryModules_AddEdit_vue__["a" /* default */]
    }, {
        path: '/seasons/add-edit/:id/:type',
        name: 'Edit Season',
        component: __WEBPACK_IMPORTED_MODULE_65_src_components_Dashboard_Views_RaceCategoryModules_AddEdit_vue__["a" /* default */]
    }, {
        path: '/newcategory/add-edit/',
        name: 'Add Newcategory',
        component: __WEBPACK_IMPORTED_MODULE_66_src_components_Dashboard_Views_NewcategoryModules_AddEdit_vue__["a" /* default */]
    }, {
        path: '/newcategory/add-edit/:id/:type',
        name: 'Edit Newcategory',
        component: __WEBPACK_IMPORTED_MODULE_66_src_components_Dashboard_Views_NewcategoryModules_AddEdit_vue__["a" /* default */]
    }, {
        path: '/sub-board-categories/add-edit/',
        name: 'Add SubBoardCategories',
        component: __WEBPACK_IMPORTED_MODULE_68_src_components_Dashboard_Views_SubBoardCategoriesModules_AddEdit_vue__["a" /* default */]
    }, {
        path: '/sub-board-categories/add-edit/:id/:type',
        name: 'Edit SubBoardCategories',
        component: __WEBPACK_IMPORTED_MODULE_68_src_components_Dashboard_Views_SubBoardCategoriesModules_AddEdit_vue__["a" /* default */]
    }, {
        path: '/newsletter/send-bulk-email/',
        name: 'Send Bulk',
        component: __WEBPACK_IMPORTED_MODULE_58_src_components_Dashboard_Views_NewsletterModules_SendBulk_vue__["a" /* default */]
    }, {
        path: '/newsletter/new-subscriber/',
        name: 'New Subscriber',
        component: __WEBPACK_IMPORTED_MODULE_57_src_components_Dashboard_Views_NewsletterModules_NewSubscriber_vue__["a" /* default */]
    }, {
        path: '/job-posting/add-edit/:id',
        name: 'EditJob',
        component: __WEBPACK_IMPORTED_MODULE_56_src_components_Dashboard_Views_JobPostingModules_add_edit_vue__["a" /* default */]
    }, {
        path: '/archive/edit/:id',
        name: 'Edit Archive',
        component: __WEBPACK_IMPORTED_MODULE_95_src_components_Dashboard_Views_PostModules_ArchiveModules_EditArchive_vue__["a" /* default */]
    }, {
        path: '/user/add-edit/:id',
        name: 'Edit User',
        component: __WEBPACK_IMPORTED_MODULE_69_src_components_Dashboard_Views_UserModules_AddEdit_vue__["a" /* default */]
    }, {
        path: '/user/add-edit/:id/:type',
        name: 'Edit User',
        component: __WEBPACK_IMPORTED_MODULE_69_src_components_Dashboard_Views_UserModules_AddEdit_vue__["a" /* default */]
    }, {
        path: '/education/edit/:id',
        name: 'Edit Education',
        component: __WEBPACK_IMPORTED_MODULE_94_src_components_Dashboard_Views_PostModules_Education_Edit_vue__["a" /* default */]
    }, {
        path: '/page/edit/:id',
        name: 'Edit Page',
        component: __WEBPACK_IMPORTED_MODULE_73_src_components_Dashboard_Views_PostModules_Pages_Edit_vue__["a" /* default */]
    }, {
        path: '/news/edit/:id',
        name: 'Edit News',
        component: __WEBPACK_IMPORTED_MODULE_74_src_components_Dashboard_Views_PostModules_News_Edit_vue__["a" /* default */]
    }, {
        path: '/races/edit/:id',
        name: 'Edit Races',
        component: __WEBPACK_IMPORTED_MODULE_75_src_components_Dashboard_Views_PostModules_Races_Edit_vue__["a" /* default */]
    }, {
        path: '/coming-from-you/edit/:id',
        name: 'Edit ComingFromYou',
        component: __WEBPACK_IMPORTED_MODULE_77_src_components_Dashboard_Views_PostModules_ComingFromYou_Edit_vue__["a" /* default */]
    }, {
        path: '/allnews/edit/:id',
        name: 'Edit EditAllnews',
        component: __WEBPACK_IMPORTED_MODULE_76_src_components_Dashboard_Views_PostModules_Allnews_Edit_vue__["a" /* default */]
    }, {
        path: '/news/gallery/:id',
        name: 'Edit News Gallery',
        component: __WEBPACK_IMPORTED_MODULE_78_src_components_Dashboard_Views_NewGalleryModules_Index_vue__["a" /* default */]
    }, {
        path: '/leader/gallery',
        name: 'Edit Leader Gallery',
        component: __WEBPACK_IMPORTED_MODULE_79_src_components_Dashboard_Views_LeaderGalleryModules_Index_vue__["a" /* default */]
    }, {
        path: '/leader/pressgallery',
        name: 'Edit Press Gallery',
        component: __WEBPACK_IMPORTED_MODULE_80_src_components_Dashboard_Views_PressGalleryModules_Index_vue__["a" /* default */]
    }, {
        path: '/gallery',
        name: 'Edit Gallery',
        component: __WEBPACK_IMPORTED_MODULE_81_src_components_Dashboard_Views_GalleryModules_Index_vue__["a" /* default */]
    }, {
        path: '/video-gallery',
        name: 'Edit Video Gallery',
        component: __WEBPACK_IMPORTED_MODULE_82_src_components_Dashboard_Views_VideoGalleryModules_Index_vue__["a" /* default */]
    }, {
        path: '/allnews/gallery/:id',
        name: 'Edit Allnews Gallery',
        component: __WEBPACK_IMPORTED_MODULE_83_src_components_Dashboard_Views_AllnewGalleryModules_Index_vue__["a" /* default */]
    }, {
        path: '/allnews/pdf/:id',
        name: 'Edit Allnews Pdf',
        component: __WEBPACK_IMPORTED_MODULE_84_src_components_Dashboard_Views_AllnewsPdfsModules_AllnewsPdfs_vue__["a" /* default */]
    }, {
        path: '/news/pdf/:id',
        name: 'Edit News Pdf',
        component: __WEBPACK_IMPORTED_MODULE_85_src_components_Dashboard_Views_NewsPdfsModules_NewsPdfs_vue__["a" /* default */]
    }, {
        path: '/leader/pdf/:id',
        name: 'Edit Leader Pdf',
        component: __WEBPACK_IMPORTED_MODULE_86_src_components_Dashboard_Views_LeaderPdfsModules_LeaderPdfs_vue__["a" /* default */]
    }, {
        path: '/leader/digital-press/pdf/:id',
        name: 'Edit Digital Press Pdf',
        component: __WEBPACK_IMPORTED_MODULE_87_src_components_Dashboard_Views_DigitalPressPdfsModules_DigitalPressPdfs_vue__["a" /* default */]
    }, {
        path: '/news/slider/:id',
        name: 'Edit News Slider',
        component: __WEBPACK_IMPORTED_MODULE_88_src_components_Dashboard_Views_NewSliderModules_Index_vue__["a" /* default */]
    }, {
        path: '/allnews/slider/:id',
        name: 'Edit Allnews Slider',
        component: __WEBPACK_IMPORTED_MODULE_89_src_components_Dashboard_Views_AllnewSliderModules_Index_vue__["a" /* default */]
    }, {
        path: '/leader/articles/slider/:id',
        name: 'Edit LeaderArticles Slider',
        component: __WEBPACK_IMPORTED_MODULE_91_src_components_Dashboard_Views_LeaderArticlesSliderModules_Index_vue__["a" /* default */]
    }, {
        path: '/leader/articles/Gallery/:id',
        name: 'Edit LeaderArticles Gallery',
        component: __WEBPACK_IMPORTED_MODULE_92_src_components_Dashboard_Views_LeaderArticlesGalleryModules_Index_vue__["a" /* default */]
    }, {
        path: '/leader/digital-press/slider/:id',
        name: 'Edit DigitalPress Slider',
        component: __WEBPACK_IMPORTED_MODULE_90_src_components_Dashboard_Views_DigitalPressSliderModules_Index_vue__["a" /* default */]
    }, {
        path: '/leader/digital-press/Gallery/:id',
        name: 'Edit DigitalPress Gallery',
        component: __WEBPACK_IMPORTED_MODULE_93_src_components_Dashboard_Views_DigitalPressGalleryModules_Index_vue__["a" /* default */]
    }, {
        path: '/static-page/edit/:id',
        name: 'Edit Static Page',
        component: __WEBPACK_IMPORTED_MODULE_72_src_components_Dashboard_Views_StaticPageModules_SubModules_Edit_vue__["a" /* default */]
    }, {
        path: 'facilities',
        name: 'facilities',
        component: __WEBPACK_IMPORTED_MODULE_102_src_components_Dashboard_Views_Facilities_vue__["a" /* default */]
    }, {
        path: '/facilities/add',
        name: 'Add facilities',
        component: __WEBPACK_IMPORTED_MODULE_104_src_components_Dashboard_Views_PostModules_Facilities_Add_vue__["a" /* default */]
    }, {
        path: '/facilities/edit/:id',
        name: 'Edit facilities',
        component: __WEBPACK_IMPORTED_MODULE_103_src_components_Dashboard_Views_PostModules_Facilities_Edit_vue__["a" /* default */]
    }, {
        path: 'homeboxes',
        name: 'homeboxes',
        component: __WEBPACK_IMPORTED_MODULE_102_src_components_Dashboard_Views_Facilities_vue__["a" /* default */]
    }, {
        path: 'activity-program-page',
        name: 'ActivityProgramPage',
        component: __WEBPACK_IMPORTED_MODULE_109_src_components_Dashboard_Views_ActivityProgramPage_vue__["a" /* default */]
    }, {
        path: 'information-banks-page',
        name: 'InformationBanksPage',
        component: __WEBPACK_IMPORTED_MODULE_115_src_components_Dashboard_Views_InformationBanksPage_vue__["a" /* default */]
    }, {
        path: '/homeboxes/add',
        name: 'Add homeboxes',
        component: __WEBPACK_IMPORTED_MODULE_119_src_components_Dashboard_Views_PostModules_Homeboxes_Add_vue__["a" /* default */]
    }, {
        path: '/activity-program-page/add',
        name: 'Add ActivityProgramPage',
        component: __WEBPACK_IMPORTED_MODULE_111_src_components_Dashboard_Views_PostModules_ActivityProgramPage_Add_vue__["a" /* default */]
    }, {
        path: '/information-banks-page/add',
        name: 'Add InformationBanksPage',
        component: __WEBPACK_IMPORTED_MODULE_117_src_components_Dashboard_Views_PostModules_InformationBanksPage_Add_vue__["a" /* default */]
    }, {
        path: '/homeinfos/add',
        name: 'Add homeinfos',
        component: __WEBPACK_IMPORTED_MODULE_122_src_components_Dashboard_Views_PostModules_HomeInfos_Add_vue__["a" /* default */]
    }, {
        path: '/bank-informations/add',
        name: 'Add BankInformation',
        component: __WEBPACK_IMPORTED_MODULE_107_src_components_Dashboard_Views_PostModules_BankInformations_Add_vue__["a" /* default */]
    }, {
        path: '/leader/articles',
        name: 'LeaderArticles',
        component: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_LeaderArticles_vue__["a" /* default */]
    }, {
        path: '/leader/articles/edit/:id',
        name: 'Edit LeaderArticles',
        component: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_PostModules_LeaderArticles_Edit_vue__["a" /* default */]
    }, {
        path: '/leader/articles/add',
        name: 'Add LeaderArticles',
        component: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_PostModules_LeaderArticles_Add_vue__["a" /* default */]
    }, {
        path: '/announcements',
        name: 'Announcements',
        component: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Announcements_vue__["a" /* default */]
    }, {
        path: '/announcements/edit/:id',
        name: 'Edit Announcements',
        component: __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_PostModules_Announcements_Edit_vue__["a" /* default */]
    }, {
        path: '/announcements/add',
        name: 'Add Announcements',
        component: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_PostModules_Announcements_Add_vue__["a" /* default */]
    }, {
        path: '/activity-program',
        name: 'ActivityProgram',
        component: __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_ActivityProgram_vue__["a" /* default */]
    }, {
        path: '/activity-program/edit/:id',
        name: 'Edit ActivityProgram',
        component: __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_PostModules_ActivityProgram_Edit_vue__["a" /* default */]
    }, {
        path: '/activity-program/add',
        name: 'Add ActivityProgram',
        component: __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_PostModules_ActivityProgram_Add_vue__["a" /* default */]
    }, {
        path: '/leader/digital-press',
        name: 'DigitalPress',
        component: __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_DigitalPress_vue__["a" /* default */]
    }, {
        path: '/leader/digital-press/edit/:id',
        name: 'Edit DigitalPress',
        component: __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_PostModules_DigitalPress_Edit_vue__["a" /* default */]
    }, {
        path: '/leader/digital-press/add',
        name: 'Add DigitalPress',
        component: __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_PostModules_DigitalPress_Add_vue__["a" /* default */]
    }, {
        path: '/homeboxes/edit/:id',
        name: 'Edit homeboxes',
        component: __WEBPACK_IMPORTED_MODULE_118_src_components_Dashboard_Views_PostModules_Homeboxes_Edit_vue__["a" /* default */]
    }, {
        path: '/activity-program-page/edit/:id',
        name: 'Edit ActivityProgramPage',
        component: __WEBPACK_IMPORTED_MODULE_110_src_components_Dashboard_Views_PostModules_ActivityProgramPage_Edit_vue__["a" /* default */]
    }, {
        path: '/information-banks-page/edit/:id',
        name: 'Edit InformationBanksPage',
        component: __WEBPACK_IMPORTED_MODULE_116_src_components_Dashboard_Views_PostModules_InformationBanksPage_Edit_vue__["a" /* default */]
    }, {
        path: '/homeinfos/edit/:id',
        name: 'Edit homeinfos',
        component: __WEBPACK_IMPORTED_MODULE_121_src_components_Dashboard_Views_PostModules_HomeInfos_Edit_vue__["a" /* default */]
    }, {
        path: '/bank-informations/edit/:id',
        name: 'Edit BankInformations',
        component: __WEBPACK_IMPORTED_MODULE_106_src_components_Dashboard_Views_PostModules_BankInformations_Edit_vue__["a" /* default */]
    }, {
        path: '/cup-point-page',
        name: 'CupPointPage',
        component: __WEBPACK_IMPORTED_MODULE_112_src_components_Dashboard_Views_CupPointPage_vue__["a" /* default */]
    }, {
        path: '/cup-point-page/add',
        name: 'Add CupPointPage',
        component: __WEBPACK_IMPORTED_MODULE_114_src_components_Dashboard_Views_PostModules_CupPointPage_Add_vue__["a" /* default */]
    }, {
        path: '/cup-point-page/edit/:id',
        name: 'Edit CupPointPage',
        component: __WEBPACK_IMPORTED_MODULE_113_src_components_Dashboard_Views_PostModules_CupPointPage_Edit_vue__["a" /* default */]
    }, {
        path: '/scores',
        name: 'Scores',
        component: __WEBPACK_IMPORTED_MODULE_34_src_components_Dashboard_Views_Scores_vue__["a" /* default */]
    }]
}, { path: '*', component: __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__["a" /* default */] }];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
 };**/

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "T461":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Members_vue__ = __webpack_require__("7eDO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f66fd2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Members_vue__ = __webpack_require__("hqMp");
function injectStyle (ssrContext) {
  __webpack_require__("Pn68")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Members_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f66fd2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Members_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T64n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/information-banks-page'}}},[_c('button',{staticClass:"btn btn-info active btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Bilgi Bankası")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/information-banks-content'}}},[_c('button',{staticClass:"btn btn-danger  btn-sm  px-2 mr-2",attrs:{"type":"submit"}},[_vm._v("İçerik")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[(!_vm.err)?_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Bilgi Bankası\n      ")]),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Sayfa")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',{staticClass:"d-flex justify-content-around align-items-center"},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"to":{ path: 'information-banks-page/edit/'+item.id},"title":"Düzenle","tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})])],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n  "+_vm._s(_vm.err)+"\n")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T6lL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      settings: {
        name: null,
        meta: {
          title: null
        },
        data: null
      },
      imageIndex: -1,
      image: {
        cropped: null
      },
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      },
      err: null
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    getSettings: function getSettings() {
      var _this = this;

      this.toggleLoader();
      this.$http.get("/api/settings/get-information-banks/").then(function (response) {
        _this.settings = response.body;
        _this.settings.meta = JSON.parse(_this.settings.meta);

        // for (var i = 0; i < this.settings.length; i++) {
        //   this.settings[i].meta = JSON.parse(this.settings[i].meta);
        // }

        _this.toggleLoader();
      }, function (er) {
        if (!er.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this.err = er.body.Error;
          _this.notifier('top', 'right', 'danger', er.body.Error);
        }
        _this.toggleLoader();
      });
    },
    submit: function submit() {
      var _this2 = this;

      event.preventDefault();
      this.$http.post("/api/settings/update-one/", this.settings).then(function (response) {
        _this2.notifier("top", "right", "success", "Başarıyla güncellendi");
        _this2.getSettings();
      }, function (e) {
        if (!e.body.Error) {
          _this2.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        } else {
          _this2.notifier("top", "right", "danger", e.body.Error);
        }
      });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSettings();
    });
  }
});

/***/ }),

/***/ "T73y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      // post data
      videoupdated: false,
      post: {
        id: null,
        newvideo: null,
        user_id: this.getCurrentUserDetails(),
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'DigitalPress',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        file: null,
        cropped: null
      },
      sliderImage: {
        file: null,
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      },
      firstSlider: false
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post('/api/images/upload/' + this.post.url + '_digital-press', {
        cropped: i
      }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + _this.post.url + '" />';
      }, function (e) {
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push('Başlık');
      }
      if (!this.post.url) {
        this.errors.push('URL');
      }
      if (!this.content.content) {
        this.errors.push('İçerik');
      }
      if (!this.image.cropped && !this.image.file) {
        this.errors.push('Resim');
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this2.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'
        _this2.saveContent();
      });
    },
    saveContent: function saveContent() {
      var _this3 = this;

      var button = event.target;
      this.$http.post('/api/contents/edit/' + this.post.content.id, this.content).then(function (response) {
        _this3.saveImage();
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this3.toggleLoader();
      });
    },
    saveImage: function saveImage() {
      var _this4 = this;

      if (this.image.cropped) {
        this.$http.post('/api/images/upload/' + this.post.url, this.image).then(function (response) {
          _this4.post.image = response.body.Data.Response.name;
          _this4.savePost();
        }, function (e) {
          button.innerHTML = 'Kaydet';
          _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this4.toggleLoader();
        });
      } else {
        this.savePost();
      }
    },
    savePost: function savePost() {
      var _this5 = this;

      this.post.comments = null;
      this.post.menus = null;
      this.post.slider = null;
      this.tempMetas = this.post.post_metas;
      this.post.post_metas = null;
      this.post.post_tags = null;
      this.post.category = null;
      this.post.sub_category = null;
      this.post.user = null;
      this.post.content = null;
      if (this.videoupdated) {
        this.post.video = this.video;
      } else {
        this.post.video = null;
      }

      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      if (this.post.newvideo) {
        var newvideo_id = this.post.newvideo.split('v=')[1];
        var ampersandPosition = newvideo_id.indexOf('&');
        if (ampersandPosition != -1) {
          newvideo_id = newvideo_id.substring(0, ampersandPosition);
        }
        this.post.newvideo_id = newvideo_id;
      } else {
        this.post.newvideo_id = null;
      }
      this.$http.post('/api/posts/edit/' + this.post.id, this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this5.post.id = pid;
        _this5.slider.post_id = pid;
        _this5.slider.order_number = pid;
        _this5.metas.post_id = pid;
        _this5.saveMetas();
      }, function (e) {
        _this5.toggleLoader();

        if (!e.body.Error) {
          _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this5.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveMetas: function saveMetas() {
      var _this6 = this;

      this.$http.put('/api/post-metas/edit-bulk/', this.metas).then(function (response) {
        _this6.notifier('top', 'right', 'success', 'Başarılı');
        _this6.$router.push('/leader/digital-press');
        _this6.toggleLoader();
      }, function (e) {
        _this6.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this6.toggleLoader();
      });
    },
    getInitialData: function getInitialData() {
      var _this7 = this;

      this.toggleLoader();
      this.$http.get('/api/posts/get/' + this.id).then(function (response) {
        _this7.post = response.body;
        _this7.content = _this7.post.content;
        _this7.image.file = _this7.mediaURL() + _this7.post.image;
        if (_this7.post.video) {
          _this7.video = _this7.post.video;
        } else {
          _this7.post.video = {
            video_url: null
          };
        }
        if (_this7.post.slider == null) {
          _this7.firstSlider = true;
        }
        _this7.metas = {
          post_id: _this7.post.id,
          items: {
            meta2: {
              meta_id: _this7.post.post_metas[_this7.post.meta_title].id,
              meta_key: 'title',
              meta_value: _this7.post.post_metas[_this7.post.meta_title].meta_value
            },
            meta3: {
              meta_id: _this7.post.post_metas[_this7.post.meta_description].id,
              meta_key: 'description',
              meta_value: _this7.post.post_metas[_this7.post.meta_description].meta_value
            }
          }
        };
        _this7.toggleLoader();
      }, function (er) {
        _this7.toggleLoader();
        _this7.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name) + 'dp';
    },
    slugifyUrl: function slugifyUrl() {
      this.announcement.url = this.slugify(this.announcement.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this8 = this;

        request.$http.get('/api/filter/posts/exclude/id:' + this.id + '/url/' + request.post.url).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this8.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      this.croppieType = type;
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById('myImage').files.length) {
        oFReader.readAsDataURL(document.getElementById('myImage').files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    loadItems: function loadItems() {
      var _this9 = this;

      this.subCategories = null;
      this.createUrl();
      this.$http.get('/api/sub-categories/getsubcategories/' + this.post.category_id).then(function (response) {

        _this9.subCategories = response.body;
        _this9.createUrl();
      }, function (er) {
        _this9.toggleLoader();
        _this9.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    },
    crop: function crop() {
      var _this10 = this;

      var dis = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: 1200,
            height: 600
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this10.croppieType === 'main') {
            dis.image.cropped = output;
            document.getElementById('main-i').src = dis.image.cropped;
          } else if (_this10.croppieType === 'slider') {
            dis.sliderImage.cropped = output;
            dis.sliderImageLoaded = true;
            document.getElementById('slider-i').src = dis.sliderImage.cropped;
          } else if (_this10.croppieType === 'tinymce') {
            _this10.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this10.addImageToEditor(output);
          }
          _this10.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.getInitialData();
  }
});

/***/ }),

/***/ "T9Lh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "THPi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      comment: {
        is_active: 0
      },
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js'
      },
      newWord: {
        letter: null,
        word: null,
        description: null
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      query: null,
      navigation: true,
      type: 'all',
      viewCounts: [],
      letters: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeType: function changeType(t) {
      this.type = t;
      var buttons = Array.prototype.slice.call(document.getElementsByClassName('type-button'));
      buttons.forEach(function (b) {
        b.classList.remove('active');
      });
      event.target.classList.add('active');
      this.getPosts(1, this.type);
    },
    sil: function sil(id) {
      var _this = this;

      this.toggleLoader();
      this.comment.published = 0;
      this.$http.post('/api/dictionary/delete/' + id).then(function (response) {
        _this.notifier('top', 'right', 'warning', 'Başarılı');
        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getLetters: function getLetters() {
      var _this2 = this;

      this.$http.get('/api/dictionary/get-letters').then(function (response) {
        _this2.letters = response.body;
      }, function (er) {
        _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        clearTimeout(_this2.tmId);
      });
    },
    saveWord: function saveWord() {
      var _this3 = this;

      this.newWord.letter = this.newWord.word.substring(0, 1).replace(/I/g, 'ı').replace(/İ/g, 'i').toLowerCase();
      this.$http.post('/api/dictionary/add', this.newWord).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Başarılı');
        _this3.newWord.word = null;
        _this3.newWord.description = null;
        _this3.$refs.tm.editor.setContent('');
        _this3.getPosts();
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
      });
    },
    getPosts: function getPosts() {
      var _this4 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';

      if (this.query) {
        if (this.tmId) {
          clearTimeout(this.tmId);
        }
        this.tmId = setTimeout(function () {
          if (_this4.query) {
            document.getElementById('small-spinner').classList.remove('d-none');
            _this4.$http.get('/api/search-dictionary/' + _this4.query).then(function (response) {
              document.getElementById('small-spinner').classList.add('d-none');
              _this4.table = response.body;
              _this4.table.forEach(function (i) {
                i.comment = _this4.$sanitize(i.comment, { allowedTags: ['user-reference'] }).replace(/<user-reference>/g, '@').replace(/<\/user-reference>/g, ' ');
              });
              clearTimeout(_this4.tmId);
            }, function (er) {
              _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
              clearTimeout(_this4.tmId);
            });
          }
        }, 700);
      } else {
        this.type = t;
        var url = '/api/filter/dictionary/orderby/word:asc/limit/' + this.limit + '/page/' + p;
        if (this.type !== 'all') {
          url = url + '/letter/' + this.type;
        }

        this.$http.get(url).then(function (response) {
          _this4.table = response.body.data;
          _this4.total = response.body.meta.total;
          _this4.page = p;
          _this4.pageCount = [];
          for (var i = 0; i < _this4.total / _this4.limit; i++) {
            _this4.pageCount.push(i + 1);
          }
        }, function (er) {
          _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      }
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
      this.getLetters();
    });
  }
});

/***/ }),

/***/ "TQ5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__ = __webpack_require__("2aTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Content_vue__ = __webpack_require__("bwpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MobileMenu_vue__ = __webpack_require__("0AsC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TopNavbar: __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__["a" /* default */],
    ContentFooter: __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__["a" /* default */],
    DashboardContent: __WEBPACK_IMPORTED_MODULE_2__Content_vue__["a" /* default */],
    MobileMenu: __WEBPACK_IMPORTED_MODULE_3__MobileMenu_vue__["a" /* default */]
  },
  methods: {
    toggleSidebar: function toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
});

/***/ }),

/***/ "TYI8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TaiZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TbJv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "To5b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ToUn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tov1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostModules_PostsTable_vue__ = __webpack_require__("YE0H");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostsTable: __WEBPACK_IMPORTED_MODULE_0__PostModules_PostsTable_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "TyP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RaceModules_Logs_vue__ = __webpack_require__("xqWx");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    RaceTable: __WEBPACK_IMPORTED_MODULE_0__RaceModules_Logs_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "TyVL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Tesis Düzenle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3  d-flex flex-column align-items-end"},[_c('tinymce',{class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("550 x 311 pixel")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.file,"id":"main-i"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 480, height: 270, type: 'suare'},"boundary":{width: 640, height: 360},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TyWY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('textarea',{attrs:{"id":_vm.id}},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TzH1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UBhg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UMDs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: {
        is_active: 0
      },
      categories: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    deactivate: function deactivate(id, type) {
      var _this = this;

      this.toggleLoader();
      this.category.is_active = 0;
      this.$http.post('/api/' + type + '/edit/' + id, this.category).then(function (response) {
        _this.notifier('top', 'right', 'warning', 'Sezon Yayından Kaldırıldı');
        _this.getPosts();
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();
        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    remove: function remove(id, type) {
      var _this2 = this;

      this.toggleLoader();
      this.$http.post('/api/' + type + '/delete/' + id, this.category).then(function (response) {
        _this2.notifier('top', 'right', 'warning', 'Sezon Silindi');
        _this2.getPosts();
        _this2.toggleLoader();
      }, function (e) {
        _this2.toggleLoader();
        if (!e.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this2.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    activate: function activate(id, type) {
      var _this3 = this;

      this.toggleLoader();
      this.category.is_active = 1;
      this.$http.post('/api/' + type + '/edit/' + id, this.category).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Sezon Yayına Alındı');
        _this3.getPosts();
        _this3.toggleLoader();
      }, function (e) {
        _this3.toggleLoader();
        if (!e.body.Error) {
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this3.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },

    getPosts: function getPosts() {
      var _this4 = this;

      this.toggleLoader();
      var url = '/api/categories/all-with-joins-seasons/';
      this.$http.get(url).then(function (response) {
        _this4.categories = response.body;
        _this4.toggleLoader();
      }, function (er) {
        _this4.toggleLoader();

        if (!er.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this4.err = er.body.Error;
          _this4.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "UUzA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostModules_ActivityProgramPage_Index_vue__ = __webpack_require__("Hwcx");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__PostModules_ActivityProgramPage_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "UXYM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        status: 1
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'Education',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeStatus: function changeStatus(id, status) {
      var _this = this;

      this.toggleLoader();
      this.post.status = status;
      this.$http.post('/api/posts/edit/' + id, this.post).then(function (response) {
        if (!status) {
          _this.notifier('top', 'right', 'warning', 'Sayfa Yayından Kaldırıldı');
        } else {
          _this.notifier('top', 'right', 'success', 'Sayfa Yayınlandı');
        }

        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this2 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Education';

      this.toggleLoader();
      this.type = t;
      var url = '/api/filter/posts/post-type/' + this.type + '/limit/' + this.limit + '/page/' + p;
      this.$http.get(url).then(function (response) {
        _this2.table = response.body.data;
        _this2.total = response.body.meta.total;
        _this2.page = p;
        _this2.pageCount = [];
        for (var i = 0; i < _this2.total / _this2.limit; i++) {
          _this2.pageCount.push(i + 1);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        _this2.toggleLoader();
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "UdIB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UiSI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UmN+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformationBanksContent_vue__ = __webpack_require__("hoLH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_234ddeb7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformationBanksContent_vue__ = __webpack_require__("9R4Y");
function injectStyle (ssrContext) {
  __webpack_require__("KRtd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformationBanksContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_234ddeb7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformationBanksContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UnvB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/directors'}}},[_c('button',{staticClass:"btn btn-danger  btn-sm  px-2 mr-2",attrs:{"type":"submit"}},[_vm._v("Yönetim Kurulu")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/staffs'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Federasyon Personeli")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/all-leaders'}}},[_c('button',{staticClass:"btn btn-primary  btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Başkanlarımız")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/history'}}},[_c('button',{staticClass:"btn btn-success btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Tarihçe")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/sub-board-categories'}}},[_c('button',{staticClass:"btn btn-warning active btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Alt Kurullar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/provincial-offices'}}},[_c('button',{staticClass:"btn btn-secondary  btn-sm  mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("İl Temsilcilikleri")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/bank-informations'}}},[_c('button',{staticClass:"btn btn-success btn-sm  mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Hesap Numaraları")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/digital-press-order'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Ana Statü Talimatlar")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/sub-board-categories'}}},[_c('button',{staticClass:"btn btn-danger  btn-sm  px-5 mr-4",attrs:{"type":"submit"}},[_vm._v("Alt Kurullar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/sub-boards'}}},[_c('button',{staticClass:"btn btn-warning active text-white btn-sm mr-4 px-5",attrs:{"type":"submit"}},[_vm._v("Kişiler")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[(!_vm.err)?_c('div',[_c('small',[_vm._v("Resim Boyutu 580x388px")]),_vm._v(" "),_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("Kişiler\n                "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"mr-2 btn btn-danger btn-sm btn-fill",on:{"click":function($event){return _vm.addNew()}}},[_vm._v("\n                  Ekle\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm btn-fill",on:{"click":function($event){return _vm.update()}}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.mediaURL() + item.image}})]),_vm._v(" "),_c('div',{staticClass:"col-9 d-flex align-items-center"},[_c('div',{staticClass:"row w-100"},[_c('div',{staticClass:"col-12 col-md-4"},[_c('label',[_vm._v("Ad Soyad")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.title),expression:"item.title"}],staticClass:"form-control",attrs:{"type":"text","name":""},domProps:{"value":(item.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('label',[_vm._v("Tarih")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.target_url),expression:"item.target_url"}],staticClass:"form-control",attrs:{"type":"text","name":""},domProps:{"value":(item.target_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "target_url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('label',[_vm._v("Kategori")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.description),expression:"item.description"}],staticClass:"custom-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "description", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Kategori Seçimi Yapınız")]),_vm._v(" "),_vm._l((_vm.categories),function(cat){return _c('option',{key:cat.id,domProps:{"value":cat.id}},[_vm._v("\n                "+_vm._s(cat.name)+"\n              ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn btn-sm ",attrs:{"title":"Slider Resmini Değiştir"},on:{"click":function($event){return _vm.initiateCroppie(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 border border-secondary p-2 d-none",attrs:{"src":_vm.newSliderImage.cropped}})])])])])}),0)],1)],1):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n              "+_vm._s(_vm.err)+"\n            ")]):_vm._e()])])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 522, height: 350, type: 'suare'},"boundary":{width: 580, height: 388},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ut3u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("FXdQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b903e46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("gEQT");
function injectStyle (ssrContext) {
  __webpack_require__("S1jr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b903e46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ut9U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Sizden Gelenler İncele")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3 d-flex flex-column"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Ad Soyad :")]),_vm._v(" "),_c('span',{staticClass:"ml-3"},[_vm._v(" "+_vm._s(_vm.post.name))])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3 d-flex flex-column"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Email :")]),_vm._v(" "),_c('span',{staticClass:"ml-3"},[_vm._v(" "+_vm._s(_vm.post.link))])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3 d-flex flex-column"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Telefon Numarası :")]),_vm._v(" "),_c('span',{staticClass:"ml-3"},[_vm._v(" "+_vm._s(_vm.post.subtitle))])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3 d-flex flex-column"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Mesaj :")]),_vm._v(" "),_c('span',{staticClass:"ml-3"},[_vm._v(" "+_vm._s(_vm.content.content))])])])]),_vm._v(" "),(_vm.post.newvideo !=0)?_c('div',{staticClass:"col-12 col-md-6 input-group mb-3 d-flex flex-column"},[(_vm.post.newvideo==1)?_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"d-flex flex-column"},[_c('span',{staticClass:"input-group-text d-flex align-items-center justify-content-center"},[_vm._v("Video")]),_vm._v(" "),_c('youtube',{attrs:{"video-id":_vm.post.newvideo_id}})],1)]):_vm._e(),_vm._v(" "),(_vm.post.newvideo==2)?_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"d-flex flex-column"},[_c('span',{staticClass:"input-group-text d-flex align-items-center justify-content-center"},[_vm._v("Resim")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.generalURL('sizdengelenler')+_vm.post.image,"alt":""}})])]):_vm._e()]):_vm._e()])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UvUG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({tag:"component",attrs:{"tag":"li"},nativeOn:{"click":function($event){return _vm.hideSidebar($event)}}},'component',_vm.$attrs,false),[_c('a',{staticClass:"nav-link"},[_vm._t("default",[(_vm.link.icon)?_c('i',{class:_vm.link.icon}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name))])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UwXn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        status: 1
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'Informationbankspage',
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeStatus: function changeStatus(id, status) {
      var _this = this;

      this.toggleLoader();
      this.post.status = status;
      this.$http.post('/api/posts/edit/' + id, this.post).then(function (response) {
        if (!status) {
          _this.notifier('top', 'right', 'warning', 'Sayfa Yayından Kaldırıldı');
        } else {
          _this.notifier('top', 'right', 'success', 'Sayfa Yayınlandı');
        }

        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();
        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this2 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Informationbankspage';

      this.toggleLoader();
      this.type = t;
      var url = '/api/filter/posts/post-type/' + this.type + '/limit/' + this.limit + '/page/' + p;
      this.$http.get(url).then(function (response) {
        _this2.table = response.body.data;
        _this2.total = response.body.meta.total;
        _this2.page = p;
        _this2.pageCount = [];
        for (var i = 0; i < _this2.total / _this2.limit; i++) {
          _this2.pageCount.push(i + 1);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.toggleLoader();

        if (!er.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this2.err = er.body.Error;
          _this2.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "UyNu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('posts-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UyT9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('posts-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VJFq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{attrs:{"id":"app"}},[_c('vue-dropzone',{ref:"dropzone",attrs:{"id":"drop1","options":_vm.dropOptions},on:{"vdropzone-complete-multiple":_vm.afterComplete}})],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("Slider \n              "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"})]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("Resim boyutu 1600 x 1200 pixel")]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-11"},[_c('img',{staticClass:"img-fluid",attrs:{"width":"150px","src":_vm.mediaURL() + item.image}})]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn btn-sm ",attrs:{"title":"Slider Resmini Değiştir"},on:{"click":function($event){return _vm.initiateCroppie(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 border border-secondary p-2 d-none",attrs:{"src":_vm.newSliderImage.cropped}})])])])])}),0)],1)],1)])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 688, height: 400, type: 'suare'},"boundary":{width: 700, height: 425},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VnhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "VtsW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        status: 1
      },
      table: null,
      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "DigitalPress",
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeStatus: function changeStatus(id, status) {
      var _this = this;

      this.toggleLoader();
      this.post.status = status;
      this.$http.post("/api/posts/edit/" + id, this.post).then(function (response) {
        if (status !== 1) {
          _this.notifier("top", "right", "warning", "Sayfa Yayından Kaldırıldı");
        } else {
          _this.notifier("top", "right", "success", "Sayfa Yayınlandı");
        }

        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();
        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this2 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "DigitalPress";

      this.toggleLoader();
      this.type = t;
      var url = "/api/filter/posts/post-type/" + this.type + "/limit/" + this.limit + "/page/" + p;
      this.$http.get(url).then(function (response) {
        _this2.table = response.body.data;
        _this2.total = response.body.meta.total;
        _this2.page = p;
        _this2.pageCount = [];
        for (var i = 0; i < _this2.total / _this2.limit; i++) {
          _this2.pageCount.push(i + 1);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.toggleLoader();

        if (!er.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this2.err = er.body.Error;
          _this2.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById("new-post").classList.contains("d-none")) {
        document.getElementById("new-post").classList.remove("d-none");
      } else {
        document.getElementById("new-post").classList.add("d-none");
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "VyI3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/leader'}}},[_c('button',{staticClass:"btn btn-info btn-sm  px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("İçerik")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/gallery'}}},[_c('button',{staticClass:"btn btn-warning btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Fotogaleri")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/pressgallery'}}},[_c('button',{staticClass:"btn btn-danger  btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Yazılı Basın")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/articles'}}},[_c('button',{staticClass:"btn btn-success  btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Başkanın Yazıları")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/articlesorder'}}},[_c('button',{staticClass:"btn btn-primary  btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Yazı Sıralama")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/digital-press'}}},[_c('button',{staticClass:"btn btn-secondary btn-sm  mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Dijital Basın")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/digital-press-order'}}},[_c('button',{staticClass:"btn active btn-info btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Dijital Basın Sıralama")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('div',{staticClass:"row"},[(!_vm.err)?_c('div',{staticClass:"col-12 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',[_vm._v("\n              Yazıları Sırala\n              "),_c('small',{staticClass:"text-info"},[_vm._v("Haberlerin sıralamasını değiştirmek için sürükleyin.")])]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.sliderItems),callback:function ($$v) {_vm.sliderItems=$$v},expression:"sliderItems"}},[_c('transition-group',_vm._l((_vm.sliderItems),function(item){return _c('div',{key:item.id},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-12 d-flex align-items-center"},[_vm._v(_vm._s(item.post.name))])])])])}),0)],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n        "+_vm._s(_vm.err)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('p',{staticClass:"text-danger mb-0"},[_vm._v("Genişlik(277) Yükseklik(244). PNG ve arkası şeffaf olacak şekilde")]),_vm._v(" "),_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 277, height: 244, type: 'suare'},"boundary":{width: 400, height: 400},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W/s6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("qI8Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e16a0066_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("IckI");
function injectStyle (ssrContext) {
  __webpack_require__("j9fa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e16a0066_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W172":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllLeaders_vue__ = __webpack_require__("Dlmg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a2fe312_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllLeaders_vue__ = __webpack_require__("gQhL");
function injectStyle (ssrContext) {
  __webpack_require__("Z7sA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllLeaders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a2fe312_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllLeaders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WDWs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WLsg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostModules_LeaderArticles_Index_vue__ = __webpack_require__("YDv7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostsTable: __WEBPACK_IMPORTED_MODULE_0__PostModules_LeaderArticles_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "WNEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: [{
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: "pressgallery",
        order_number: null
      }],
      err: null,
      selectedType: null,
      types: ["URL", "Kategori", "Alt Kategori", "Yayın", "Etiket"],
      options: [],
      sliderItems: null,
      newSliderImage: {
        cropped: null,
        image_id: null,
        image_name: null,
        imageIndex: null
      },
      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "all",
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier("top", "right", "danger", "Slider Başarıyla silindi");
          _this.getSlider();
        }, function (e) {
          if (!e.body.Error) {
            _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          } else {
            _this.notifier("top", "right", "danger", e.body.Error);
          }
        });
      }
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post("/api/images/upload/new-gallery", this.newSliderImage).then(function (response) {
        var i = _this2.newSliderImage.n === 0 ? "image" : "image2";
        _this2.slider[_this2.newSliderImage.imageIndex][i] = response.body.Data.Response.name;
        _this2.toggleLoader();
        _this2.hideCroppieModal();
        _this2.update();
      }, function (e) {
        _this2.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this2.toggleLoader();
      });
    },
    addNew: function addNew() {
      this.slider.unshift({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: "pressgallery",
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      var newdis = this;
      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = "pressgallery";
      });
      this.$http.post("/api/images/edit/", this.slider).then(function (response) {
        _this3.notifier("top", "right", "success", "Değişiklikler Kaydedildi");
        _this3.getSlider();
      }, function (e) {
        if (!e.body.Error) {
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this3.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = "/api/images/get-with-type/pressgallery";
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
      }, function (er) {
        if (!er.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this4.err = er.body.Error;
          _this4.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    initiateCroppie: function initiateCroppie(id, i, n) {
      this.newSliderImage.image_id = id;
      this.newSliderImage.image_name = this.slugify(this.slider[i].title);
      this.newSliderImage.imageIndex = i;
      this.newSliderImage.n = n;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById("new-post").classList.contains("d-none")) {
        document.getElementById("new-post").classList.remove("d-none");
      } else {
        document.getElementById("new-post").classList.add("d-none");
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {
      this.crop();
    },
    crop: function crop() {
      var _this5 = this;

      var dis = this;
      this.toggleLoader();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: "jpeg" | "png" | "webp",
          backgroundColor: "#fff",
          size: {
            width: 600,
            height: 400
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this5.newSliderImage.cropped = output;
          _this5.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "WNzT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostModules_News_Index_vue__ = __webpack_require__("ZqWZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostsTable: __WEBPACK_IMPORTED_MODULE_0__PostModules_News_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "WOE+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:{'input-group': _vm.hasIcon}},[_vm._t("label",[(_vm.label)?_c('label',{staticClass:"control-label"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]):_vm._e()]),_vm._v(" "),_vm._t("addonLeft",[(_vm.addonLeftIcon)?_c('span',{staticClass:"input-group-addon"},[_c('i',{class:_vm.addonLeftIcon})]):_vm._e()]),_vm._v(" "),_c('input',_vm._b({staticClass:"form-control",attrs:{"aria-describedby":"addon-right addon-left"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input',$event.target.value)}}},'input',_vm.$attrs,false)),_vm._v(" "),_vm._t("default"),_vm._v(" "),_vm._t("addonRight",[(_vm.addonRightIcon)?_c('span',{staticClass:"input-group-addon"},[_c('i',{class:_vm.addonRightIcon})]):_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WQnx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/races'}}},[_c('button',{staticClass:"btn btn-warning text-white active btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Yarışlar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/seasons'}}},[_c('button',{staticClass:"btn btn-info  btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Sezonlar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/members'}}},[_c('button',{staticClass:"btn btn-danger btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Üyeler")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[(!_vm.err)?_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Tüm Yarışlar \n      "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill float-md-right",attrs:{"title":"Yeni Sayfa Oluştur","to":{ path: 'races/add'},"tag":"li"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Yeni Yarış")])],1),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Sayfa")]),_vm._v(" "),_c('th',[_vm._v("URL")]),_vm._v(" "),_c('th',[_vm._v("Kategori")]),_vm._v(" "),_c('th',[_vm._v("Sezon")]),_vm._v(" "),_c('th',[_vm._v("Yayın Tarihi")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.url))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.category.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.sub_category.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(item.created,"Do/MM/YYYY HH:mm:ss"))+" ")]),_vm._v(" "),_c('td',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"to":{ path: 'races/edit/'+item.id},"title":"Düzenle","tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-warning btn-fill btn-xs",attrs:{"to":{ path: 'race-applications/'+item.id},"title":"Başvurular","tag":"li"}},[_c('i',{staticClass:"fas fa-exchange-alt"})]),_vm._v(" "),(item.status !== 4 )?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"deactivate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,4)}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(item.status === 4)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,1)}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e()],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n      "+_vm._s(_vm.err)+"\n    ")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WV8w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      settings: null,
      imageIndex: -1,
      image: {
        cropped: null
      },
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post("/api/images/upload/" + this.post.url + "leader-image", {
        cropped: i
      }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + _this.post.url + '" />';
      }, function (e) {
        _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this.toggleLoader();
      });
    },
    getSettings: function getSettings() {
      var _this2 = this;

      this.toggleLoader();
      this.$http.get("/api/settings/get-leader-settings/").then(function (response) {
        _this2.settings = response.body;
        for (var i = 0; i < _this2.settings.length; i++) {
          _this2.settings[i].meta = JSON.parse(_this2.settings[i].meta);
        }

        _this2.toggleLoader();
      }, function (er) {
        _this2.toggleLoader();
        if (!er.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this2.err = er.body.Error;
          _this2.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    submit: function submit() {
      var _this3 = this;

      event.preventDefault();
      this.$http.post("/api/settings/update-bulk-leader/", this.settings).then(function (response) {
        _this3.notifier("top", "right", "success", "Başarıyla güncellendi");
        _this3.getSettings();
      }, function (e) {
        if (!e.body.Error) {
          _this3.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        } else {
          _this3.notifier("top", "right", "danger", e.body.Error);
        }
      });
    },
    getImageName: function getImageName() {
      for (var i = 0; i < this.settings.length; i++) {
        if (this.settings[i].meta.isimage) {
          this.imageIndex = i;
          break;
        }
      }
    },
    saveImage: function saveImage() {
      var _this4 = this;

      if (!this.image.cropped) return this.submit();
      this.getImageName();
      this.$http.post("/api/images/upload/" + this.settings[this.imageIndex].name, this.image).then(function (response) {
        _this4.settings[_this4.imageIndex].data = response.body.Data.Response.name;
        _this4.image.cropped = null;
        _this4.submit();
      }, function (e) {
        _this4.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this4.toggleLoader();
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      this.croppieType = type;
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        var refz = this.$refs;
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        oFReader.onload = function (oFREvent) {
          refz.main[0].bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this5 = this;

      var dis = this;
      var wdt = 400;
      var hgt = 450;
      if (this.croppieType === "tinymce") {
        wdt = 400;
        hgt = 450;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: "jpeg",
          size: {
            width: wdt,
            height: hgt
          },

          quality: 1
        };
        dis.$refs.main[0].result(options, function (output) {
          if (_this5.croppieType === "main") {
            dis.image.cropped = output;
          } else if (_this5.croppieType === "slider") {
            dis.sliderImage.cropped = output;
            dis.sliderImageLoaded = true;
          } else if (_this5.croppieType === "tinymce") {
            _this5.notifier("top", "right", "warning", "Lütfen resim yükleninceye kadar bekleyin.");
            _this5.addImageToEditor(output);
          }
          _this5.hideCroppieModal();
          dis.$refs.main[0].refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result: function result(output) {
      return output;
    },

    changePosition: function changePosition(e) {
      this.position.lat = e.lat();
      this.position.lng = e.lng();
      for (var i = 0; i < this.settings.length; i++) {
        if (this.settings[i].name === "latitude") {
          this.settings[i].data = e.lat();
        }
        if (this.settings[i].name === "longitude") {
          this.settings[i].data = e.lng();
        }
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSettings();
    });
  }
});

/***/ }),

/***/ "WY2n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('race-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WfUP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__("wUzn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4233418a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__("N8Qi");
function injectStyle (ssrContext) {
  __webpack_require__("oGcg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4233418a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WgEv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("İçerik Düzenle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Alt Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.subtitle),expression:"post.subtitle"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Alt Başlık","aria-label":"Alt Başlık","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.subtitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "subtitle", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("150 x 150 pixel")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.file,"id":"main-i"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 150, height: 150, type: 'suare'},"boundary":{width: 200, height: 200},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wjwp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProvincialOffices_vue__ = __webpack_require__("HiXn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84154d2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProvincialOffices_vue__ = __webpack_require__("kYNT");
function injectStyle (ssrContext) {
  __webpack_require__("xROX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProvincialOffices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84154d2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProvincialOffices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Wlp/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,

      // post data
      videoupdated: false,
      post: {
        id: null,
        newvideo: null,
        user_id: this.getCurrentUserDetails(),
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'Allnews',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        file: null,
        cropped: null
      },
      sliderImage: {
        file: null,
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      },
      firstSlider: false
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post('/api/images/upload/' + this.post.url + '_inner-image', {
        cropped: i
      }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + _this.post.url + '" />';
      }, function (e) {
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push('Başlık');
      }
      if (!this.post.url) {
        this.errors.push('URL');
      }
      if (!this.content.content) {
        this.errors.push('İçerik');
      }
      if (!this.image.cropped && !this.image.file) {
        this.errors.push('Resim');
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this2.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'
        _this2.saveContent();
      });
    },
    uploadPdf: function uploadPdf(event) {
      var _this3 = this;

      this.file = event.target.files[0];
      if (this.file.type !== "application/pdf") {
        this.notifier('top', 'right', 'danger', 'Lütfen excel formatında bir dosya seçiniz');
      } else {
        var data = new FormData();
        data.append("file", this.file);
        var fileName = this.file.name.split(".");
        var extension = "";
        var newName = "";
        fileName.forEach(function (e, index) {
          if (index < fileName.length - 1) {
            newName += e;
          }
          if (index == fileName.length - 1) {
            extension += e;
          }
        });
        newName += new Date().getTime();
        var fullName = newName + "." + extension;
        data.append("fileName", fullName);
        this.$http.post("/api/files/upload-news-pdf/" + fullName, data).then(function (response) {
          _this3.post.link = fullName;
          _this3.notifier("top", "right", "success", "Pdf başarıyla kaydedildi");
        }, function (er) {
          _this3.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        });
      }
    },
    saveContent: function saveContent() {
      var _this4 = this;

      var button = event.target;
      this.$http.post('/api/contents/edit/' + this.post.content.id, this.content).then(function (response) {
        _this4.saveImage();
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this4.toggleLoader();
      });
    },
    saveImage: function saveImage() {
      var _this5 = this;

      if (this.image.cropped) {
        this.$http.post('/api/images/upload/' + this.post.url, this.image).then(function (response) {
          _this5.post.image = response.body.Data.Response.name;
          _this5.savePost();
        }, function (e) {
          button.innerHTML = 'Kaydet';
          _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this5.toggleLoader();
        });
      } else {
        this.savePost();
      }
    },
    savePost: function savePost() {
      var _this6 = this;

      this.post.comments = null;
      this.post.menus = null;
      this.post.slider = null;
      this.tempMetas = this.post.post_metas;
      this.post.post_metas = null;
      this.post.post_tags = null;
      this.post.category = null;
      this.post.sub_category = null;
      this.post.user = null;
      this.post.content = null;
      if (this.videoupdated) {
        this.post.video = this.video;
      } else {
        this.post.video = null;
      }

      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      if (this.post.newvideo) {
        var newvideo_id = this.post.newvideo.split('v=')[1];
        var ampersandPosition = newvideo_id.indexOf('&');
        if (ampersandPosition != -1) {
          newvideo_id = newvideo_id.substring(0, ampersandPosition);
        }
        this.post.newvideo_id = newvideo_id;
      } else {
        this.post.newvideo_id = null;
      }
      this.$http.post('/api/posts/edit/' + this.post.id, this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this6.post.id = pid;
        _this6.slider.post_id = pid;
        _this6.slider.order_number = pid;
        _this6.metas.post_id = pid;
        _this6.saveMetas();
      }, function (e) {
        _this6.toggleLoader();

        if (!e.body.Error) {
          _this6.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this6.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveMetas: function saveMetas() {
      var _this7 = this;

      this.$http.put('/api/post-metas/edit-bulk/', this.metas).then(function (response) {
        _this7.notifier('top', 'right', 'success', 'Başarılı');
        _this7.$router.push('/allnews');
        _this7.toggleLoader();
      }, function (e) {
        _this7.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this7.toggleLoader();
      });
    },
    getInitialData: function getInitialData() {
      var _this8 = this;

      this.toggleLoader();
      this.$http.get('/api/posts/get/' + this.id).then(function (response) {
        _this8.post = response.body;
        _this8.content = _this8.post.content;
        console.log(_this8.mediaURL() + _this8.post.image);
        _this8.image.file = _this8.mediaURL() + _this8.post.image;
        if (_this8.post.video) {
          _this8.video = _this8.post.video;
        } else {
          _this8.post.video = {
            video_url: null
          };
        }
        if (_this8.post.slider == null) {
          _this8.firstSlider = true;
        }
        _this8.metas = {
          post_id: _this8.post.id,
          items: {
            meta2: {
              meta_id: _this8.post.post_metas[_this8.post.meta_title].id,
              meta_key: 'title',
              meta_value: _this8.post.post_metas[_this8.post.meta_title].meta_value
            },
            meta3: {
              meta_id: _this8.post.post_metas[_this8.post.meta_description].id,
              meta_key: 'description',
              meta_value: _this8.post.post_metas[_this8.post.meta_description].meta_value
            }
          }
        };
        _this8.toggleLoader();
      }, function (er) {
        _this8.toggleLoader();
        _this8.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name) + '-' + this.post.category_id + '-' + this.post.sub_category_id;
    },
    slugifyUrl: function slugifyUrl() {
      this.announcement.url = this.slugify(this.announcement.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this9 = this;

        request.$http.get('/api/filter/posts/exclude/id:' + this.id + '/url/' + request.post.url).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this9.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      this.croppieType = type;
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById('myImage').files.length) {
        oFReader.readAsDataURL(document.getElementById('myImage').files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    loadItems: function loadItems() {
      var _this10 = this;

      this.subCategories = null;
      this.createUrl();
      this.$http.get('/api/sub-categories/getsubcategories/' + this.post.category_id).then(function (response) {

        _this10.subCategories = response.body;
        _this10.createUrl();
      }, function (er) {
        _this10.toggleLoader();
        _this10.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    },
    crop: function crop() {
      var _this11 = this;

      var dis = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: 600,
            height: 450
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this11.croppieType === 'main') {
            dis.image.cropped = output;
            document.getElementById('main-i').src = dis.image.cropped;
          } else if (_this11.croppieType === 'slider') {
            dis.sliderImage.cropped = output;
            dis.sliderImageLoaded = true;
            document.getElementById('slider-i').src = dis.sliderImage.cropped;
          } else if (_this11.croppieType === 'tinymce') {
            _this11.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this11.addImageToEditor(output);
          }
          _this11.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    var _this12 = this;

    this.getInitialData(), this.$http.get('/api/categories/allnews').then(function (response) {
      _this12.categories = response.body;
    }, function (er) {
      _this12.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
      _this12.toggleLoader();
    });
  }
});

/***/ }),

/***/ "WlsZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WrXZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Staffs_vue__ = __webpack_require__("qWp6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_320616c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Staffs_vue__ = __webpack_require__("0ffJ");
function injectStyle (ssrContext) {
  __webpack_require__("KhoY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Staffs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_320616c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Staffs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X4Is":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      // post data
      videoupdated: false,
      post: {
        id: null,
        newvideo: null,
        user_id: this.getCurrentUserDetails(),
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'LeaderArticles',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        file: null,
        cropped: null
      },
      sliderImage: {
        file: null,
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      },
      firstSlider: false
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post('/api/images/upload/' + this.post.url + '_inner-image', {
        cropped: i
      }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + _this.post.url + '" />';
      }, function (e) {
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push('Başlık');
      }
      if (!this.post.url) {
        this.errors.push('URL');
      }
      if (!this.content.content) {
        this.errors.push('İçerik');
      }
      if (!this.image.cropped && !this.image.file) {
        this.errors.push('Resim');
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this2.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'
        _this2.saveContent();
      });
    },
    saveContent: function saveContent() {
      var _this3 = this;

      var button = event.target;
      this.$http.post('/api/contents/edit/' + this.post.content.id, this.content).then(function (response) {
        _this3.saveImage();
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this3.toggleLoader();
      });
    },
    saveImage: function saveImage() {
      var _this4 = this;

      if (this.image.cropped) {
        this.$http.post('/api/images/upload/' + this.post.url, this.image).then(function (response) {
          _this4.post.image = response.body.Data.Response.name;
          _this4.savePost();
        }, function (e) {
          button.innerHTML = 'Kaydet';
          _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this4.toggleLoader();
        });
      } else {
        this.savePost();
      }
    },
    savePost: function savePost() {
      var _this5 = this;

      this.post.comments = null;
      this.post.menus = null;
      this.post.slider = null;
      this.tempMetas = this.post.post_metas;
      this.post.post_metas = null;
      this.post.post_tags = null;
      this.post.category = null;
      this.post.sub_category = null;
      this.post.user = null;
      this.post.content = null;
      if (this.videoupdated) {
        this.post.video = this.video;
      } else {
        this.post.video = null;
      }

      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      if (this.post.newvideo) {
        var newvideo_id = this.post.newvideo.split('v=')[1];
        var ampersandPosition = newvideo_id.indexOf('&');
        if (ampersandPosition != -1) {
          newvideo_id = newvideo_id.substring(0, ampersandPosition);
        }
        this.post.newvideo_id = newvideo_id;
      } else {
        this.post.newvideo_id = null;
      }
      this.$http.post('/api/posts/edit/' + this.post.id, this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this5.post.id = pid;
        _this5.slider.post_id = pid;
        _this5.slider.order_number = pid;
        _this5.metas.post_id = pid;
        _this5.saveMetas();
      }, function (e) {
        _this5.toggleLoader();

        if (!e.body.Error) {
          _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this5.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveMetas: function saveMetas() {
      var _this6 = this;

      this.$http.put('/api/post-metas/edit-bulk/', this.metas).then(function (response) {
        _this6.notifier('top', 'right', 'success', 'Başarılı');
        _this6.$router.push('/leader/articles');
        _this6.toggleLoader();
      }, function (e) {
        _this6.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this6.toggleLoader();
      });
    },
    getInitialData: function getInitialData() {
      var _this7 = this;

      this.toggleLoader();
      this.$http.get('/api/posts/get/' + this.id).then(function (response) {
        _this7.post = response.body;
        _this7.content = _this7.post.content;
        _this7.image.file = _this7.mediaURL() + _this7.post.image;
        if (_this7.post.video) {
          _this7.video = _this7.post.video;
        } else {
          _this7.post.video = {
            video_url: null
          };
        }
        if (_this7.post.slider == null) {
          _this7.firstSlider = true;
        }
        _this7.metas = {
          post_id: _this7.post.id,
          items: {
            meta2: {
              meta_id: _this7.post.post_metas[_this7.post.meta_title].id,
              meta_key: 'title',
              meta_value: _this7.post.post_metas[_this7.post.meta_title].meta_value
            },
            meta3: {
              meta_id: _this7.post.post_metas[_this7.post.meta_description].id,
              meta_key: 'description',
              meta_value: _this7.post.post_metas[_this7.post.meta_description].meta_value
            }
          }
        };
        _this7.toggleLoader();
      }, function (er) {
        _this7.toggleLoader();
        _this7.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name) + '-la';
    },
    slugifyUrl: function slugifyUrl() {
      this.announcement.url = this.slugify(this.announcement.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this8 = this;

        request.$http.get('/api/filter/posts/exclude/id:' + this.id + '/url/' + request.post.url).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this8.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      this.croppieType = type;
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById('myImage').files.length) {
        oFReader.readAsDataURL(document.getElementById('myImage').files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    loadItems: function loadItems() {
      var _this9 = this;

      this.subCategories = null;
      this.createUrl();
      this.$http.get('/api/sub-categories/getsubcategories/' + this.post.category_id).then(function (response) {

        _this9.subCategories = response.body;
        _this9.createUrl();
      }, function (er) {
        _this9.toggleLoader();
        _this9.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    },
    crop: function crop() {
      var _this10 = this;

      var dis = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: 1200,
            height: 600
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this10.croppieType === 'main') {
            dis.image.cropped = output;
            document.getElementById('main-i').src = dis.image.cropped;
          } else if (_this10.croppieType === 'slider') {
            dis.sliderImage.cropped = output;
            dis.sliderImageLoaded = true;
            document.getElementById('slider-i').src = dis.sliderImage.cropped;
          } else if (_this10.croppieType === 'tinymce') {
            _this10.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this10.addImageToEditor(output);
          }
          _this10.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.getInitialData();
  }
});

/***/ }),

/***/ "XXzi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Kutu Düzenle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Alt Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.subtitle),expression:"post.subtitle"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Alt Başlık","aria-label":"Başlık","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.subtitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "subtitle", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Kutu Linki")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.link),expression:"post.link"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Link","aria-label":"Başlık","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "link", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("150 x 150 pixel")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.file,"id":"main-i"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 350, height: 350, type: 'suare'},"boundary":{width: 400, height: 400},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XaZC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_min_css__ = __webpack_require__("9BHd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_min_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: {
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'leaderarticlegallery' + this.$route.params.id,
        order_number: null
      },
      selectedType: null,
      types: ['URL', 'Kategori', 'Alt Kategori', 'Yayın', 'Etiket'],
      options: [],
      sliderItems: null,
      newSliderImage: {
        cropped: null,
        image_id: null,
        image_name: null,
        imageIndex: null
      },
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: [],
      dropOptions: {
        url: "/api/images/upload-with-dropzone/" + this.$route.params.id + '/leaderarticlegallery',
        addRemoveLinks: true,
        uploadMultiple: true,
        acceptedFiles: 'image/*',
        dictDefaultMessage: "Dosyaları yüklemek için sürükle bırak yapabilir veya bu alana tıklayabilirsiniz."
      }
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"],
    vueDropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a
  },

  methods: {
    afterComplete: function afterComplete(file) {
      var vm = this;
      vm.update();
      setTimeout(function () {
        vm.$refs.dropzone.removeAllFiles();
      }, 2500);
    },
    removeAllFiles: function removeAllFiles() {
      this.$refs.dropzone.removeAllFiles();
    },

    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier('top', 'right', 'danger', 'Slider Başarıyla silindi');
          _this.getSlider();
        }, function (e) {
          _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          _this.toggleLoader();
        });
      }
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post('/api/images/upload/new-gallery', this.newSliderImage).then(function (response) {
        var i = _this2.newSliderImage.n === 0 ? 'image' : 'image2';
        _this2.slider[_this2.newSliderImage.imageIndex][i] = response.body.Data.Response.name;
        _this2.toggleLoader();
        _this2.hideCroppieModal();
        _this2.update();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    addNew: function addNew() {
      this.slider.unshift({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'leaderarticlegallery' + this.$route.params.id,
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      var newdis = this;
      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = 'leaderarticlegallery' + newdis.$route.params.id;
      });
      this.$http.post('/api/images/edit/', this.slider).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi');
        _this3.getSlider();
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = '/api/images/leaderarticlegallery/' + this.$route.params.id;
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
      }, function (er) {
        _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
      });
    },
    initiateCroppie: function initiateCroppie(id, i, n) {
      this.newSliderImage.image_id = id;
      this.newSliderImage.image_name = this.slugify(this.slider[i].title);
      this.newSliderImage.imageIndex = i;
      this.newSliderImage.n = n;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {

      this.crop();
    },
    crop: function crop() {
      var _this5 = this;

      var dis = this;
      this.toggleLoader();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg' | 'png' | 'webp',
          backgroundColor: '#fff',
          size: {
            width: 1600,
            height: 1200
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this5.newSliderImage.cropped = output;
          _this5.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "Xdm/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        status: 1
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'Facilities',
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeStatus: function changeStatus(id, status) {
      var _this = this;

      this.toggleLoader();
      this.post.status = status;
      this.$http.post('/api/posts/edit/' + id, this.post).then(function (response) {
        if (!status) {
          _this.notifier('top', 'right', 'warning', 'Sayfa Yayından Kaldırıldı');
        } else {
          _this.notifier('top', 'right', 'success', 'Sayfa Yayınlandı');
        }

        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();
        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this2 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Facilities';

      this.toggleLoader();
      this.type = t;
      var url = '/api/filter/posts/post-type/' + this.type + '/limit/' + this.limit + '/page/' + p;
      this.$http.get(url).then(function (response) {
        _this2.table = response.body.data;
        _this2.total = response.body.meta.total;
        _this2.page = p;
        _this2.pageCount = [];
        for (var i = 0; i < _this2.total / _this2.limit; i++) {
          _this2.pageCount.push(i + 1);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.toggleLoader();

        if (!er.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this2.err = er.body.Error;
          _this2.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "XmhP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('h4',{staticClass:"card-title d-md-flex justify-content-between",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Abone Listesi")]),_vm._v(" "),_c('div',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary",attrs:{"title":"Yeni Abone Ekle","to":{ path: 'newsletter/new-subscriber/'},"tag":"li"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Yeni Abone Ekle")]),_vm._v(" "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-success btn-fill",attrs:{"title":"Toplu E-Posta Gönder","to":{ path: 'newsletter/send-bulk-email/'},"tag":"li"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Toplu E-Posta Gönder")])],1)]),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("E-Posta")]),_vm._v(" "),_c('th',[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.email))]),_vm._v(" "),_c('td',{staticStyle:{"width":"15%"}},[(item.is_subscribed)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Aboneliği Kaldır","id":"deactivate-item.id"},on:{"click":function($event){return _vm.deactivate(item.id)}}},[_c('i',{staticClass:"fas fa-unlink"}),_vm._v(" Aboneliği İptal Et")]):_vm._e(),_vm._v(" "),(!item.is_subscribed)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Aboneliğe al","id":"activate-item.id"},on:{"click":function($event){return _vm.activate(item.id)}}},[_c('i',{staticClass:"fas fa-link"}),_vm._v(" Aboneliği Aktif Et")]):_vm._e()])])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return _c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current)}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])])}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xo6s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/coming-from-you'}}},[_c('button',{staticClass:"btn btn-info active btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Sizden Gelenler Onay")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/coming-from-you-content'}}},[_c('button',{staticClass:"btn btn-danger btn-sm px-2 mr-2",attrs:{"type":"submit"}},[_vm._v("Gönderi Oluştur İçerik")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[(!_vm.err)?_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Sizden Gelenler")]),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Sayfa")]),_vm._v(" "),_c('th',[_vm._v("Talep Tarihi")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(item.created,"Do/MM/YYYY HH:mm:ss")))]),_vm._v(" "),_c('td',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"to":{ path: 'coming-from-you/edit/'+item.id},"title":"İncele","tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",class:{disabled:item.status == 1},attrs:{"href":"javascript:void(0)","title":"Onayla"},on:{"click":function($event){return _vm.changeStatus(item.id,1)}}},[_c('i',{staticClass:"fas fa-check"})]),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Reddet"},on:{"click":function($event){return _vm.changeStatus(item.id,4)}}},[_c('i',{staticClass:"fas fa-times"})])],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n  "+_vm._s(_vm.err)+"\n")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xqkb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XzoE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y65B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        status: 1
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'Sayfa',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeStatus: function changeStatus(id, status) {
      var _this = this;

      this.toggleLoader();
      this.post.status = status;
      this.$http.post('/api/posts/edit/' + id, this.post).then(function (response) {
        if (!status) {
          _this.notifier('top', 'right', 'warning', 'Sayfa Yayından Kaldırıldı');
        } else {
          _this.notifier('top', 'right', 'success', 'Sayfa Yayınlandı');
        }

        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this2 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Sayfa';

      this.toggleLoader();
      this.type = t;
      var url = '/api/filter/posts/post-type/' + this.type + '/limit/' + this.limit + '/page/' + p;
      this.$http.get(url).then(function (response) {
        _this2.table = response.body.data;
        _this2.total = response.body.meta.total;
        _this2.page = p;
        _this2.pageCount = [];
        for (var i = 0; i < _this2.total / _this2.limit; i++) {
          _this2.pageCount.push(i + 1);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        _this2.toggleLoader();
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "YBie":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("/H5H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c92e9cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("yhjo");
function injectStyle (ssrContext) {
  __webpack_require__("Sr19")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c92e9cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YCk0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("WNEF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f75a09_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("Svim");
function injectStyle (ssrContext) {
  __webpack_require__("+xnJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f75a09_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YDv7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("96Jg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35295122_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("I1r1");
function injectStyle (ssrContext) {
  __webpack_require__("hbup")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35295122_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YE0H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostsTable_vue__ = __webpack_require__("Y65B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a42e6caa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostsTable_vue__ = __webpack_require__("QrCh");
function injectStyle (ssrContext) {
  __webpack_require__("mTeq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a42e6caa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YGN6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/information-banks-page'}}},[_c('button',{staticClass:"btn btn-info  btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Bilgi Bankası")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/information-banks-content'}}},[_c('button',{staticClass:"btn btn-danger active btn-sm  px-2 mr-2",attrs:{"type":"submit"}},[_vm._v("İçerik")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('form',{staticClass:"w-100",on:{"submit":_vm.submit}},[(!_vm.err)?_c('div',[_c('h1',{staticClass:"h4 mt-0 d-flex justify-content-between"},[_c('span',[_vm._v("Bilgi Bankası İçerik")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-sm btn-fill",attrs:{"type":"submit"}},[_vm._v("Kaydet")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"d-flex flex-column"},[_c('label',{attrs:{"for":_vm.settings.name}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.settings.meta.title))])]),_vm._v(" "),_c('tinymce',{staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.settings.data),callback:function ($$v) {_vm.$set(_vm.settings, "data", $$v)},expression:"settings.data"}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n  "+_vm._s(_vm.err)+"\n")]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YX3a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        status: 1
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'Cuppointpage',
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeStatus: function changeStatus(id, status) {
      var _this = this;

      this.toggleLoader();
      this.post.status = status;
      this.$http.post('/api/posts/edit/' + id, this.post).then(function (response) {
        if (!status) {
          _this.notifier('top', 'right', 'warning', 'Sayfa Yayından Kaldırıldı');
        } else {
          _this.notifier('top', 'right', 'success', 'Sayfa Yayınlandı');
        }

        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();
        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this2 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Cuppointpage';

      this.toggleLoader();
      this.type = t;
      var url = '/api/filter/posts/post-type/' + this.type + '/limit/' + this.limit + '/page/' + p;
      this.$http.get(url).then(function (response) {
        _this2.table = response.body.data;
        _this2.total = response.body.meta.total;
        _this2.page = p;
        _this2.pageCount = [];
        for (var i = 0; i < _this2.total / _this2.limit; i++) {
          _this2.pageCount.push(i + 1);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.toggleLoader();

        if (!er.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this2.err = er.body.Error;
          _this2.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "Yeki":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.image)?_c('div',{staticClass:"card-image"},[_vm._t("image")],2):_vm._e(),_vm._v(" "),(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YjQd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("md1e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a92539ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("rBzL");
function injectStyle (ssrContext) {
  __webpack_require__("KYtH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a92539ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YkKb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        status: 1
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'News',
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeStatus: function changeStatus(id, status) {
      var _this = this;

      this.toggleLoader();
      this.post.status = status;
      this.$http.post('/api/posts/edit/' + id, this.post).then(function (response) {
        if (!status) {
          _this.notifier('top', 'right', 'warning', 'Sayfa Yayından Kaldırıldı');
        } else {
          _this.notifier('top', 'right', 'success', 'Sayfa Yayınlandı');
        }

        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();
        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this2 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'News';

      this.toggleLoader();
      this.type = t;
      var url = '/api/filter/posts/post-type/' + this.type + '/limit/' + this.limit + '/page/' + p;
      this.$http.get(url).then(function (response) {
        _this2.table = response.body.data;
        _this2.total = response.body.meta.total;
        _this2.page = p;
        _this2.pageCount = [];
        for (var i = 0; i < _this2.total / _this2.limit; i++) {
          _this2.pageCount.push(i + 1);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.toggleLoader();

        if (!er.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this2.err = er.body.Error;
          _this2.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "YnxV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("İçerik Düzenle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Button Linki")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.link),expression:"post.link"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Link","aria-label":"Başlık","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "link", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Alt Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.subtitle),expression:"post.subtitle"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Alt Başlık","aria-label":"Alt Başlık","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.subtitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "subtitle", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("150 x 150 pixel")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.file,"id":"main-i"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 150, height: 150, type: 'suare'},"boundary":{width: 200, height: 200},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ypi8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalPressPdfs_vue__ = __webpack_require__("Rhc5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18691273_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalPressPdfs_vue__ = __webpack_require__("wHFo");
function injectStyle (ssrContext) {
  __webpack_require__("sFf/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalPressPdfs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18691273_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalPressPdfs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z3Sp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z5Ph":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Kutu Düzenle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Sembol")]),_vm._v(" "),(_vm.post.subtitle)?_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_c('i',{class:_vm.post.subtitle})]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.subtitle),expression:"post.subtitle"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.subtitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "subtitle", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3 d-flex flex-column align-items-end"},[_c('tinymce',{ref:"tm",class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("300 x 139 pixel")]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),(_vm.image.file)?_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.file}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":true,"viewport":{width: 300, height: 139, type: 'suare'},"boundary":{width: 600, height: 278},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z7sA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZDDP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/main'}}},[_c('button',{staticClass:"btn btn-danger  btn-sm  px-2 mr-2",attrs:{"type":"submit"}},[_vm._v("Anasayfa Slider")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/intro-video'}}},[_c('button',{staticClass:"btn btn-primary btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("İntro Videosu")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/homeboxes'}}},[_c('button',{staticClass:"btn btn-info active btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Anasayfa Kutular")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/homeinfos'}}},[_c('button',{staticClass:"btn btn-warning btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Anasayfa Bilgiler")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/announcements'}}},[_c('button',{staticClass:"btn btn-success btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Anasayfa Duyurular")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[(!_vm.err)?_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Anasayfa Kutular\n      ")]),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Sayfa")]),_vm._v(" "),_c('th',[_vm._v("Yayın Tarihi")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(item.created,"Do/MM/YYYY HH:mm:ss"))+" ")]),_vm._v(" "),_c('td',{staticClass:"d-flex justify-content-around align-items-center"},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"to":{ path: 'homeboxes/edit/'+item.id},"title":"Düzenle","tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),(item.status !== 4 )?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"deactivate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,4)}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(item.status === 4)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,1)}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e()],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n"+_vm._s(_vm.err)+"\n")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZDLM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("UXYM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f374981_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("r/nR");
function injectStyle (ssrContext) {
  __webpack_require__("B4lv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f374981_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZE1M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("R75h");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69267389_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("wckU");
function injectStyle (ssrContext) {
  __webpack_require__("S04p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69267389_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZO0v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__("sQGm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73630bc3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__("i6U0");
function injectStyle (ssrContext) {
  __webpack_require__("jGYM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73630bc3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73630bc3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZSWq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_add_edit_vue__ = __webpack_require__("RCAC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e496084_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_edit_vue__ = __webpack_require__("LUlP");
function injectStyle (ssrContext) {
  __webpack_require__("y///")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_add_edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e496084_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZTIy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zcut":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_search_select__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: [{
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'leaderpdf' + this.$route.params.id,
        order_number: null
      }],
      fullName: '',
      selectedType: null,
      types: ["URL", "Kategori", "Alt Kategori", "Yayın", "Etiket"],
      options: [],
      sliderItems: null,
      newPdf: {
        Pdf_id: null,
        Pdf_name: null,
        PdfIndex: null
      },

      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "all",
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_1_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier('top', 'right', 'danger', 'PDF Başarıyla silindi');
          _this.getSlider();
        }, function (e) {
          _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          _this.toggleLoader();
        });
      }
    },
    upload: function upload(event) {
      var _this2 = this;

      var file = event.target.files[0];
      if (file.type !== "application/pdf") return console.log(file);
      var data = new FormData();
      data.append("file", file);
      var newfile = file.name.split('.');
      var extension = '';
      var name = '';
      newfile.forEach(function (e, index) {
        if (index < newfile.length - 1) {
          name += e;
        }
        if (index == newfile.length - 1) {
          extension += e;
        }
      });

      var newName = name + new Date().getTime();
      this.fullName = newName + '.' + extension;
      data.append("fileName", this.fullName);

      this.$http.post("/api/files/upload-news-pdf/" + this.newPdf.Pdf_name, data).then(function (response) {
        var i = _this2.newPdf.n === 0 ? 'image' : 'image2';
        _this2.slider[_this2.newPdf.PdfIndex][i] = _this2.newPdf.Pdf_name;
        console.log(_this2.newPdf.Pdf_name);
        _this2.notifier('top', 'right', 'success', 'Pdf Başarıyla Yüklendi');
        _this2.update();
      }, function (er) {
        _this2.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
      });
    },
    myPdf: function myPdf(id, i, n) {
      this.newPdf.Pdf_id = id;
      if (this.slider[i].target_url) {
        this.newPdf.Pdf_name = this.slugify(this.slider[i].target_url) + new Date().getTime() + '.pdf';
      } else {
        this.newPdf.Pdf_name = 'baskaninyazilari' + new Date().getTime() + '.pdf';
      }
      this.newPdf.PdfIndex = i;
      this.newPdf.n = n;
      console.log(this.newPdf);
      document.getElementById('myPdf' + i).click();
    },
    addNew: function addNew() {
      this.slider.push({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'leaderpdf' + this.$route.params.id,
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      var newdis = this;
      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = 'leaderpdf' + newdis.$route.params.id;
      });
      this.$http.post('/api/images/edit/', this.slider).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi');
        _this3.getSlider();
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = "/api/images/leaderpdf/" + this.$route.params.id;
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
      }, function (er) {
        _this4.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
      });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "ZhT1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{attrs:{"id":"app"}},[_c('vue-dropzone',{ref:"dropzone",attrs:{"id":"drop1","options":_vm.dropOptions},on:{"vdropzone-complete-multiple":_vm.afterComplete}})],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("Slider \n              "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"})]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("Resim boyutu 1600 x 1200 pixel")]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-11"},[_c('img',{staticClass:"img-fluid",attrs:{"width":"150px","src":_vm.mediaURL() + item.image}})]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn btn-sm ",attrs:{"title":"Slider Resmini Değiştir"},on:{"click":function($event){return _vm.initiateCroppie(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 border border-secondary p-2 d-none",attrs:{"src":_vm.newSliderImage.cropped}})])])])])}),0)],1)],1)])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 688, height: 400, type: 'suare'},"boundary":{width: 700, height: 425},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZpeN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("MELt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f64e428_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("YnxV");
function injectStyle (ssrContext) {
  __webpack_require__("wB93")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f64e428_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZqWZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("YkKb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_189f1d42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("chfB");
function injectStyle (ssrContext) {
  __webpack_require__("caoH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_189f1d42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zx8T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("nJt6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d62abdea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("3yox");
function injectStyle (ssrContext) {
  __webpack_require__("JGrp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d62abdea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZzSH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostModules_Announcements_Index_vue__ = __webpack_require__("+0IY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostsTable: __WEBPACK_IMPORTED_MODULE_0__PostModules_Announcements_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "a20b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"change":_vm.validate,"keyup":_vm.createUrl,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"id":"url-label"}},[_vm._v("URL")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.url),expression:"post.url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('URL')},attrs:{"type":"text","placeholder":"URL","aria-label":"URL","id":"url","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.url)},on:{"keyup":_vm.slugifyUrl,"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3"},[_c('tinymce',{class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('vue-tabs',[_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Resim"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.cropped}})],1)])]),_vm._v(" "),_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"SEO"}},[_c('div',{staticClass:"row settings my-4"},[_c('div',{staticClass:"col-12 input-group px-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.metas.items.meta2.meta_value),expression:"metas.items.meta2.meta_value"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Meta Başlığı","aria-label":"Başlık","id":"title","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.metas.items.meta2.meta_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.metas.items.meta2, "meta_value", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v(" - Statik Site Başlığı")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group px-5 mt-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Meta Açıklaması")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.metas.items.meta3.meta_value),expression:"metas.items.meta3.meta_value"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.metas.items.meta3.meta_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.metas.items.meta3, "meta_value", $event.target.value)}}})])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 480, height: 270, type: 'suare'},"boundary":{width: 640, height: 360},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a9sQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("SVzr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea462940_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("c1IM");
function injectStyle (ssrContext) {
  __webpack_require__("gNFC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea462940_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aAG9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("Qkg6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e81c4f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("bzSD");
function injectStyle (ssrContext) {
  __webpack_require__("xZNU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e81c4f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aBO7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aDtE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      featuredTitles: [{
        key: "bellow_slider_1",
        title: null,
        details: null,
        link: null,
        image: null
      }, {
        key: "bellow_slider_2",
        title: null,
        details: null,
        link: null,
        image: null
      }, {
        key: "bellow_slider_3",
        title: null,
        details: null,
        link: null,
        image: null
      }],
      slider: {
        post_id: null,
        slider_group: "News",
        order_number: null,
        is_active: 1
      },
      selectedType: null,
      types: ["URL", "Kategori", "Alt Kategori", "Yayın", "Etiket"],
      options: [],
      sliderItems: null,
      newFeaturedImage: {
        featured_id: null,
        cropped: null
      },
      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "all",
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      this.toggleLoader();
      this.$http.delete("/api/slider/delete/" + id).then(function (response) {
        _this.notifier("top", "right", "warning", "Menu elemanı silindi");
        _this.getSlider();
        _this.toggleLoader();
      }, function (e) {
        _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this.toggleLoader();
      });
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post("/api/images/upload/boxes-under-slider-" + this.newFeaturedImage.id, this.newFeaturedImage).then(function (response) {
        _this2.featuredTitles[_this2.newFeaturedImage.id].image = response.body.Data.Response.name;
        _this2.hideCroppieModal();
        document.getElementById("submit-image").innerHTML = "Kaydet";
        _this2.toggleLoader();
      }, function (e) {
        _this2.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this2.toggleLoader();
      });
    },
    loadItems: function loadItems() {
      var _this3 = this;

      this.options = [];
      this.toggleLoader();
      var url = "/api/posts/latest";
      this.$http.get(url).then(function (response) {
        response = response.body;
        for (var i = 0; i < response.length; i++) {
          var temp = { value: response[i].id, text: response[i].name };
          _this3.options.push(temp);
        }
        _this3.toggleLoader();
      }, function (er) {
        _this3.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        _this3.toggleLoader();
      });
    },
    loadFeaturedTitles: function loadFeaturedTitles() {
      var _this4 = this;

      this.toggleLoader();
      this.$http.get("/api/settings/get-featured-under-slider").then(function (response) {
        var settings = response.body;
        _this4.featuredTitles = [];
        for (var i = 0; i < settings.length; i++) {
          var jsonData = JSON.parse(settings[i].data);
          jsonData.key = "bellow_slider_" + (i + 1);
          _this4.featuredTitles.push(jsonData);
        }
        _this4.toggleLoader();
      }, function (er) {
        _this4.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        _this4.toggleLoader();
      });
    },
    update: function update(id) {
      var _this5 = this;

      this.$http.post("/api/slider/edit/", this.sliderItems).then(function (response) {
        _this5.notifier("top", "right", "success", "Sıralama güncellendi");
      }, function (e) {
        if (!e.body.Error) {
          _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this5.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    save: function save(id) {
      var _this6 = this;

      this.toggleLoader();
      this.$http.post("/api/slider/add/News", this.slider).then(function (response) {
        _this6.getSlider();
        _this6.toggleLoader();
        _this6.notifier("top", "right", "success", "Başarılı");
      }, function (e) {
        _this6.toggleLoader();
        if (!e.body.Error) {
          _this6.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this6.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveSettings: function saveSettings() {
      var _this7 = this;

      this.toggleLoader();
      this.$http.post("/api/settings/edit-bulk/", this.featuredTitles).then(function (response) {
        _this7.toggleLoader();
        _this7.notifier("top", "right", "success", "Başarılı");
      }, function (e) {
        _this7.toggleLoader();
        if (!e.body.Error) {
          _this7.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this7.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    getSlider: function getSlider() {
      var _this8 = this;

      this.toggleLoader();
      var url = "/api/slider/all/News";
      this.$http.get(url).then(function (response) {
        _this8.sliderItems = response.body;
        if (_this8.sliderItems.length > 0) {
          _this8.slider.order_number = _this8.sliderItems[0].order_number + 1;
          _this8.slider.post_id = 0;
        } else {
          _this8.slider.order_number = 0;
        }
        _this8.toggleLoader();
      }, function (er) {
        _this8.toggleLoader();
        if (!er.body.Error) {
          _this8.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this8.err = er.body.Error;
          _this8.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    initiateCroppie: function initiateCroppie(id) {
      this.newFeaturedImage.id = id;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById("new-post").classList.contains("d-none")) {
        document.getElementById("new-post").classList.remove("d-none");
      } else {
        document.getElementById("new-post").classList.add("d-none");
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {
      document.getElementById("submit-image").innerHTML = "<i class='fas fa-circle-notch fa-spin'></i>";
      this.crop();
    },
    crop: function crop() {
      var _this9 = this;

      var dis = this;
      this.toggleLoader();
      var color = "#e17d00";
      if (this.newFeaturedImage.id === 0) {
        color = "#dc3545";
      } else if (this.newFeaturedImage.id === 1) {
        color = "#17a2b8";
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: "jpeg",
          size: {
            width: 277,
            height: 244
          },
          backgroundColor: color,
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this9.newFeaturedImage.cropped = output;
          _this9.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
      this.loadItems();
      this.loadFeaturedTitles();
    });
  }
});

/***/ }),

/***/ "aFjf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommentModules_Index_vue__ = __webpack_require__("5wM0");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    IndexTable: __WEBPACK_IMPORTED_MODULE_0__CommentModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "aGCs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Dijital Basın Düzenle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata\n        ")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"url-label"}},[_vm._v("URL")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.url),expression:"post.url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('URL')},attrs:{"type":"text","placeholder":"URL","aria-label":"URL","id":"url","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.url)},on:{"keyup":_vm.slugifyUrl,"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3 d-flex flex-column align-items-end"},[_c('tinymce',{class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('vue-tabs',[_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Resim"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("1200 x 600 pixel")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.file,"id":"main-i"}})],1)])]),_vm._v(" "),_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Video"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 input-group px-5 m-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Video Adresi")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.newvideo),expression:"post.newvideo"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"https://www.youtube.com/watch?v=KZzON_7EQ70","aria-label":"Başlık","id":"title","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.newvideo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "newvideo", $event.target.value)}}})])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 480, height: 270, type: 'suare'},"boundary":{width: 640, height: 360},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aGu9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aJSr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostModules_ActivityProgram_Index_vue__ = __webpack_require__("7KM9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostsTable: __WEBPACK_IMPORTED_MODULE_0__PostModules_ActivityProgram_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "aM90":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        status: 1
      },
      table: null,
      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "ComingFromYou",
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeStatus: function changeStatus(id, status) {
      var _this = this;

      this.toggleLoader();
      this.post.status = status;
      this.$http.post("/api/posts/edit/" + id, this.post).then(function (response) {
        _this.$http.post("/api/posts/send-mail/" + id + '/' + status, _this.post).then(function (response) {}, function (e) {});
        if (!status) {
          _this.notifier("top", "right", "warning", "Sayfa Yayından Kaldırıldı");
        } else {
          _this.notifier("top", "right", "success", "Sayfa Yayınlandı");
        }

        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();
        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this2 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ComingFromYou";

      this.toggleLoader();
      this.type = t;
      var url = "/api/filter/posts/post-type/" + this.type + "/limit/" + this.limit + "/page/" + p;
      this.$http.get(url).then(function (response) {
        _this2.table = response.body.data;
        _this2.total = response.body.meta.total;
        _this2.page = p;
        _this2.pageCount = [];
        for (var i = 0; i < _this2.total / _this2.limit; i++) {
          _this2.pageCount.push(i + 1);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.toggleLoader();

        if (!er.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this2.err = er.body.Error;
          _this2.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById("new-post").classList.contains("d-none")) {
        document.getElementById("new-post").classList.remove("d-none");
      } else {
        document.getElementById("new-post").classList.add("d-none");
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "aRo4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    changes: function changes() {
      var players = [];
      if (this.logs && this.logs.length) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.logs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var log = _step.value;

            var oldDatas = JSON.parse(log.old_datas);
            var newDatas = JSON.parse(log.new_datas);

            for (var i in oldDatas) {
              players.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, log, { newPlayer: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newDatas[i])), oldPlayer: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(oldDatas[i])) }));
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return players;
    }
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      // post data
      logs: [],
      datas: []
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    getInitialData: function getInitialData() {
      var _this = this;

      this.toggleLoader();
      this.$http.get("/api/race-logs/get/" + this.id).then(function (response) {
        _this.logs = response.body;
        console.log(_this.logs);
        _this.loading = false;
        _this.toggleLoader();
      }, function (er) {
        console.log(er);
        _this.toggleLoader();
        _this.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        return;
      });
    }

  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getInitialData();
    });
  }
});

/***/ }),

/***/ "aWsS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Eğitim Ekle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"change":_vm.validate,"keyup":_vm.createUrl,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"url-label"}},[_vm._v("URL")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.url),expression:"post.url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('URL')},attrs:{"type":"text","placeholder":"URL","aria-label":"URL","id":"url","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.url)},on:{"keyup":_vm.slugifyUrl,"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3 d-flex flex-column align-items-end"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],staticClass:"btn btn-primary btn-sm btn-fill",staticStyle:{"margin-bottom":"-34px","z-index":"2"},on:{"click":function($event){return _vm.initiateCroppie('tinymce')}}},[_vm._v("Resim Ekle")]),_vm._v(" "),_c('tinymce',{ref:"tm",class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('vue-tabs',[_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Resim"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.cropped}})],1)])]),_vm._v(" "),_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Video"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 input-group px-5 m-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Video Adresi")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.video.video_url),expression:"video.video_url"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"https://www.youtube.com/watch?v=KZzON_7EQ70","aria-label":"Başlık","id":"title","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.video.video_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.video, "video_url", $event.target.value)}}})])])]),_vm._v(" "),_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"SEO"}},[_c('div',{staticClass:"row settings my-4"},[_c('div',{staticClass:"col-12 input-group px-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.metas.items.meta2.meta_value),expression:"metas.items.meta2.meta_value"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Meta Başlığı","aria-label":"Başlık","id":"title","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.metas.items.meta2.meta_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.metas.items.meta2, "meta_value", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v(" - Statik Site Başlığı")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group px-5 mt-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Meta Açıklaması")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.metas.items.meta3.meta_value),expression:"metas.items.meta3.meta_value"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.metas.items.meta3.meta_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.metas.items.meta3, "meta_value", $event.target.value)}}})])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 480, height: 270, type: 'suare'},"boundary":{width: 640, height: 360},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "abi/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainStatusInstructions_vue__ = __webpack_require__("LpoR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22c46134_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainStatusInstructions_vue__ = __webpack_require__("QTPT");
function injectStyle (ssrContext) {
  __webpack_require__("nEiz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainStatusInstructions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22c46134_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainStatusInstructions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "adTx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("hT6u");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ffcf0f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("Ut9U");
function injectStyle (ssrContext) {
  __webpack_require__("04S3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ffcf0f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "arGQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StaticPageModules_PostsTable_vue__ = __webpack_require__("4fcA");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostsTable: __WEBPACK_IMPORTED_MODULE_0__StaticPageModules_PostsTable_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "as5a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('posts-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "axsZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b21V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaceApplications_vue__ = __webpack_require__("zX2c");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec3ed64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaceApplications_vue__ = __webpack_require__("4n3r");
function injectStyle (ssrContext) {
  __webpack_require__("2ub+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaceApplications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec3ed64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaceApplications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bIFN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bj7Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostModules_ArchiveModules_Archives_vue__ = __webpack_require__("jm8F");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostsTable: __WEBPACK_IMPORTED_MODULE_0__PostModules_ArchiveModules_Archives_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "bnkv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      race: {
        status: 1
      },
      table: null,
      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      post_id: null,
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeStatus: function changeStatus(id, status) {
      var _this = this;

      this.toggleLoader();
      this.race.status = status;
      this.$http.post("/api/race/edit/" + id, this.race).then(function (response) {
        _this.$http.post("/api/race/send-mail/" + id + '/' + status, _this.race).then(function (response) {}, function (e) {});
        if (status == 1) {
          _this.notifier("top", "right", "success", "Talep Kabul Edildi");
        } else if (status == 4) {
          _this.notifier("top", "right", "warning", "Talep Reddedildi");
        }

        _this.getRaces(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();
        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getRaces: function getRaces() {
      var _this2 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.toggleLoader();
      var url = "/api/filter/race/post_id/" + this.id + "/limit/" + this.limit + "/page/" + p;
      this.$http.get(url).then(function (response) {
        _this2.table = response.body.data;
        _this2.total = response.body.meta.total;
        _this2.page = p;
        _this2.pageCount = [];
        for (var i = 0; i < _this2.total / _this2.limit; i++) {
          _this2.pageCount.push(i + 1);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.toggleLoader();

        if (!er.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this2.err = er.body.Error;
          _this2.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewRacePanel: function toggleNewRacePanel(event) {
      event.stopPropagation();
      if (document.getElementById("new-post").classList.contains("d-none")) {
        document.getElementById("new-post").classList.remove("d-none");
      } else {
        document.getElementById("new-post").classList.add("d-none");
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getRaces();
    });
  }
});

/***/ }),

/***/ "bwpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__("VnhA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20ea8e9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__("FGMu");
function injectStyle (ssrContext) {
  __webpack_require__("GjBJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20ea8e9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bzSD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('thead',[_vm._t("columns",_vm._l((_vm.columns),function(column){return _c('th',[_vm._v(_vm._s(column))])}))],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",_vm._l((_vm.columns),function(column){return (_vm.hasValue(item, column))?_c('td',[_vm._v(_vm._s(_vm.itemValue(item, column)))]):_vm._e()}),{"row":item})],2)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c0Rt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c1IM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("Slider \n              "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"mr-2 btn btn-danger btn-sm btn-fill",on:{"click":function($event){return _vm.addNew()}}},[_vm._v("\n                Ekle\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm btn-fill",on:{"click":function($event){return _vm.update()}}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("Resim boyutu 1600 x 800 pixel")]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-11"},[_c('img',{staticClass:"img-fluid",attrs:{"width":"150px","src":_vm.mediaURL() + item.image}})]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn btn-sm ",attrs:{"title":"Slider Resmini Değiştir"},on:{"click":function($event){return _vm.initiateCroppie(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 border border-secondary p-2 d-none",attrs:{"src":_vm.newSliderImage.cropped}})])])])])}),0)],1)],1)])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 450, height: 240, type: 'suare'},"boundary":{width: 600, height: 320},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cCUz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("İçerik Düzenle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Button Linki")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.link),expression:"post.link"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Link","aria-label":"Başlık","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "link", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Alt Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.subtitle),expression:"post.subtitle"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Alt Başlık","aria-label":"Alt Başlık","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.subtitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "subtitle", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("150 x 150 pixel")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.file,"id":"main-i"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 150, height: 150, type: 'suare'},"boundary":{width: 200, height: 200},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cGQf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cIKw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("/yJn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a11d1fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("5S9i");
function injectStyle (ssrContext) {
  __webpack_require__("7WKp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a11d1fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cYd8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_min_css__ = __webpack_require__("9BHd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_min_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: {
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'digitalpressgallery' + this.$route.params.id,
        order_number: null
      },
      selectedType: null,
      types: ['URL', 'Kategori', 'Alt Kategori', 'Yayın', 'Etiket'],
      options: [],
      sliderItems: null,
      newSliderImage: {
        cropped: null,
        image_id: null,
        image_name: null,
        imageIndex: null
      },
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: [],
      dropOptions: {
        url: "/api/images/upload-with-dropzone/" + this.$route.params.id + '/digitalpressgallery',
        addRemoveLinks: true,
        uploadMultiple: true,
        acceptedFiles: 'image/*',
        dictDefaultMessage: "Dosyaları yüklemek için sürükle bırak yapabilir veya bu alana tıklayabilirsiniz."
      }
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"],
    vueDropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a

  },

  methods: {
    afterComplete: function afterComplete(file) {
      var vm = this;
      vm.update();
      setTimeout(function () {
        vm.$refs.dropzone.removeAllFiles();
      }, 2500);
    },
    removeAllFiles: function removeAllFiles() {
      this.$refs.dropzone.removeAllFiles();
    },

    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier('top', 'right', 'danger', 'Slider Başarıyla silindi');
          _this.getSlider();
        }, function (e) {
          _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          _this.toggleLoader();
        });
      }
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post('/api/images/upload/digital-press-gallery', this.newSliderImage).then(function (response) {
        var i = _this2.newSliderImage.n === 0 ? 'image' : 'image2';
        _this2.slider[_this2.newSliderImage.imageIndex][i] = response.body.Data.Response.name;
        _this2.toggleLoader();
        _this2.hideCroppieModal();
        _this2.update();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    addNew: function addNew() {
      this.slider.unshift({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'digitalpressgallery' + this.$route.params.id,
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      var newdis = this;
      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = 'digitalpressgallery' + newdis.$route.params.id;
      });
      this.$http.post('/api/images/edit/', this.slider).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi');
        _this3.getSlider();
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = '/api/images/digitalpressgallery/' + this.$route.params.id;
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
      }, function (er) {
        _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
      });
    },
    initiateCroppie: function initiateCroppie(id, i, n) {
      this.newSliderImage.image_id = id;
      this.newSliderImage.image_name = this.slugify(this.slider[i].title);
      this.newSliderImage.imageIndex = i;
      this.newSliderImage.n = n;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {

      this.crop();
    },
    crop: function crop() {
      var _this5 = this;

      var dis = this;
      this.toggleLoader();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg' | 'png' | 'webp',
          backgroundColor: '#fff',
          size: {
            width: 1600,
            height: 1200
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this5.newSliderImage.cropped = output;
          _this5.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "cZTQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      user: {
        is_active: 0
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      query: null,
      tmId: null,
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    deactivate: function deactivate(id) {
      var _this = this;

      this.toggleLoader();
      this.user.is_active = 0;
      this.$http.post('/api/users/edit/' + id, this.user).then(function (response) {
        _this.notifier('top', 'right', 'warning', 'Üye Pasif Edildi');
        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    activate: function activate(id) {
      var _this2 = this;

      this.toggleLoader();
      this.user.is_active = 1;
      this.$http.post('/api/users/edit/' + id, this.user).then(function (response) {
        _this2.notifier('top', 'right', 'success', 'Üye Aktif Edildi');
        _this2.getPosts(_this2.page, _this2.type);
        _this2.toggleLoader();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this3 = this;

      if (this.tmId) {
        clearTimeout(this.tmId);
      }
      this.tmId = setTimeout(function () {
        if (_this3.query) {
          document.getElementById('small-spinner').classList.remove('d-none');
          _this3.$http.get('/api/search-user/' + _this3.query).then(function (response) {
            document.getElementById('small-spinner').classList.add('d-none');
            _this3.table = response.body;
            clearTimeout(_this3.tmId);
          }, function (er) {
            _this3.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
            clearTimeout(_this3.tmId);
          });
        }
      }, 700);
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  }
});

/***/ }),

/***/ "caoH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "chfB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/news'}}},[_c('button',{staticClass:"btn btn-info active btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Bildiriler")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/news-order'}}},[_c('button',{staticClass:"btn btn-warning btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Bildiri Sıralaması")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[(!_vm.err)?_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Tüm Bildiriler \n      "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill float-md-right",attrs:{"title":"Yeni Sayfa Oluştur","to":{ path: 'news/add'},"tag":"li"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Yeni Bildiri")])],1),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Sayfa")]),_vm._v(" "),_c('th',[_vm._v("URL")]),_vm._v(" "),_c('th',[_vm._v("Kategori")]),_vm._v(" "),_c('th',[_vm._v("Alt Kategori")]),_vm._v(" "),_c('th',[_vm._v("Yayın Tarihi")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.url))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.category.name))]),_vm._v(" "),_c('td',[(item.sub_category)?_c('span',[_vm._v(_vm._s(item.sub_category.name))]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(item.created,"Do/MM/YYYY HH:mm:ss"))+" ")]),_vm._v(" "),_c('td',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"to":{ path: 'news/edit/'+item.id},"title":"Düzenle","tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-warning btn-fill btn-xs",attrs:{"to":{ path: 'news/slider/'+item.id},"title":"Slider","tag":"li"}},[_c('i',{staticClass:"fas fa-images"})]),_vm._v(" "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-success btn-fill btn-xs",attrs:{"to":{ path: 'news/gallery/'+item.id},"title":"Galeri","tag":"li"}},[_c('i',{staticClass:"far fa-image"})]),_vm._v(" "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-info btn-fill btn-xs",attrs:{"to":{ path: 'news/pdf/'+item.id},"title":"Pdf","tag":"li"}},[_c('i',{staticClass:"far fa-file-pdf"})]),_vm._v(" "),(item.status !== 4 )?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"deactivate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,4)}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(item.status === 4)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,1)}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e(),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-dark btn-fill",attrs:{"href":"#","title":"Okunma Sayısı"}},[_c('i',{staticClass:"fa fa-book"}),_vm._v(" "+_vm._s(item.readed))])],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n"+_vm._s(_vm.err)+"\n  ")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ck91":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoggedIn === 'no')?_c('div',{attrs:{"id":"login-area"}},[_c('login-area',{attrs:{"isLogged":_vm.isLoggedIn},on:{"changeState":_vm.changeLoggedState}})],1):_vm._e(),_vm._v(" "),(_vm.isLoggedIn === 'yes')?_c('div',{class:{'nav-open': _vm.$sidebar.showSidebar},attrs:{"id":"panel-area"}},[_c('notifications'),_vm._v(" "),_c('router-view')],1):_vm._e(),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader loader-hide justify-content-center align-items-center",attrs:{"id":"loader"}},[_c('div',{staticClass:"content text-center"},[_c('h1',{staticClass:"text-white"},[_c('i',{staticClass:"fas fa-circle-notch fa-spin fa-4x"})]),_vm._v(" "),_c('h3',{staticClass:"text-white"},[_vm._v("Lütfen Bekleyiniz...")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cpG7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditArchive_vue__ = __webpack_require__("oHMb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51847c85_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditArchive_vue__ = __webpack_require__("8fFC");
function injectStyle (ssrContext) {
  __webpack_require__("pkPW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditArchive_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51847c85_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditArchive_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "csJO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cwbb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cxu9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{staticClass:"card-stats"},[_c('div',{staticClass:"row"},[(_vm.$slots.header)?_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"icon-big text-center"},[_vm._t("header")],2)]):_vm._e(),_vm._v(" "),(_vm.$slots.content)?_c('div',{staticClass:"col-7"},[_c('div',{staticClass:"numbers"},[_vm._t("content")],2)]):_vm._e()]),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"stats",attrs:{"slot":"footer"},slot:"footer"},[_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "czl6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d3Fl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Sayfa Düzenle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Param Birimi")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currency1),expression:"currency1"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Para Birimi')},attrs:{"type":"text","placeholder":"Para Birimi","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.currency1)},on:{"keyup":_vm.setName,"input":function($event){if($event.target.composing){ return; }_vm.currency1=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Karşı Param Birimi")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currency2),expression:"currency2"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Karşı Para Birimi')},attrs:{"type":"text","placeholder":"Karşı Para Birimi","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.currency2)},on:{"keyup":_vm.setName,"input":function($event){if($event.target.composing){ return; }_vm.currency2=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Sayfa Başlığı")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.metas.items.meta2.meta_value),expression:"metas.items.meta2.meta_value"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Site Başlığı')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.metas.items.meta2.meta_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.metas.items.meta2, "meta_value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"url-label"}},[_vm._v("URL")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.url),expression:"post.url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('URL')},attrs:{"type":"text","placeholder":"URL","aria-label":"URL","id":"url","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.url)},on:{"keyup":_vm.slugifyUrl,"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Canlı Grafik")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.content.content),expression:"content.content"}],staticClass:"form-control",domProps:{"value":(_vm.content.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.content, "content", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Meta Açıklaması")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.metas.items.meta3.meta_value),expression:"metas.items.meta3.meta_value"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.metas.items.meta3.meta_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.metas.items.meta3, "meta_value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('vue-tabs',[_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Ayarlar"}},[_c('div',{staticClass:"row settings my-4"},[_c('div',{staticClass:"col-12"})])]),_vm._v(" "),_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Yorumlar"}},[_c('div',{staticClass:"row settings my-4"},[_c('div',{staticClass:"col-12"})])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d8DU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("QIj9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cc7ebc4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("9IEI");
function injectStyle (ssrContext) {
  __webpack_require__("Qqcp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cc7ebc4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d9Nr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('label',{staticClass:"input-group-text border-0 bg-white",attrs:{"for":"inputGroupSelect01"}},[_vm._v("Üst Kategori")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.category_id),expression:"category.category_id"}],staticClass:"custom-select",attrs:{"disabled":_vm.disableParent},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.category, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Üst Kategori Yok")]),_vm._v(" "),_vm._l((_vm.categories),function(cat){return _c('option',{key:cat.id,domProps:{"value":cat.id}},[_vm._v("\n              "+_vm._s(cat.name)+"\n            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.name),expression:"category.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.category.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.category, "name", $event.target.value)}}})]),_vm._v(" "),(_vm.category.category_id === '')?_c('div',{staticClass:"col-12 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Alt Kategoriler Ekle")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.subCategories),expression:"subCategories"}],staticClass:"form-control",staticStyle:{"height":"200px"},attrs:{"type":"text","placeholder":"Her satırda bir alt kategori","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.subCategories)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subCategories=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dF6d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,

      // post data
      videoupdated: false,
      post: {
        id: null,
        newvideo: null,
        user_id: this.getCurrentUserDetails(),
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: "News",
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: "title",
            meta_value: null
          },
          meta3: {
            meta_key: "description",
            meta_value: null
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        file: null,
        cropped: null
      },
      sliderImage: {
        file: null,
        cropped: null
      },
      croppieType: "main",
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      },
      firstSlider: false
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post("/api/images/upload/" + this.post.url + "_inner-image", {
        cropped: i
      }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + _this.post.url + '" />';
      }, function (e) {
        _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      }
      if (!this.post.category_id) {
        this.errors.push('Kategori');
      }
      if (!this.post.sub_category_id) {
        this.errors.push('Alt Kategori');
      }
      if (!this.post.url) {
        this.errors.push("URL");
      }
      if (!this.content.content) {
        this.errors.push("İçerik");
      }
      if (!this.image.cropped && !this.image.file) {
        this.errors.push("Resim");
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    uploadPdf: function uploadPdf(event) {
      var _this2 = this;

      this.file = event.target.files[0];
      if (this.file.type !== "application/pdf") {
        this.notifier('top', 'right', 'danger', 'Lütfen excel formatında bir dosya seçiniz');
      } else {
        var data = new FormData();
        data.append("file", this.file);
        var fileName = this.file.name.split(".");
        var extension = "";
        var newName = "";
        fileName.forEach(function (e, index) {
          if (index < fileName.length - 1) {
            newName += e;
          }
          if (index == fileName.length - 1) {
            extension += e;
          }
        });
        newName += new Date().getTime();
        var fullName = newName + "." + extension;
        data.append("fileName", fullName);
        this.$http.post("/api/files/upload-news-pdf/" + fullName, data).then(function (response) {
          _this2.post.link = fullName;
          _this2.notifier("top", "right", "success", "Pdf başarıyla kaydedildi");
        }, function (er) {
          _this2.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        });
      }
    },
    save: function save() {
      var _this3 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById("url").classList.add("is-invalid");
        document.getElementById("url").classList.remove("is-valid");
        document.getElementById("url-label").classList.add("is-invalid");
        document.getElementById("url-label").classList.remove("is-valid");
        _this3.notifier("top", "right", "danger", "URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin");
        _this3.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
        _this3.saveContent();
      });
    },
    saveContent: function saveContent() {
      var _this4 = this;

      var button = event.target;
      this.$http.post("/api/contents/edit/" + this.post.content.id, this.content).then(function (response) {
        _this4.saveImage();
      }, function (e) {
        button.innerHTML = "Kaydet";
        _this4.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this4.toggleLoader();
      });
    },
    saveImage: function saveImage() {
      var _this5 = this;

      if (this.image.cropped) {
        this.$http.post("/api/images/upload/" + this.post.url, this.image).then(function (response) {
          _this5.post.image = response.body.Data.Response.name;
          _this5.savePost();
        }, function (e) {
          button.innerHTML = "Kaydet";
          _this5.notifier("top", "right", "danger", "Bir Hata Oluştu");
          _this5.toggleLoader();
        });
      } else {
        this.savePost();
      }
    },
    savePost: function savePost() {
      var _this6 = this;

      this.post.comments = null;
      this.post.menus = null;
      this.post.slider = null;
      this.tempMetas = this.post.post_metas;
      this.post.post_metas = null;
      this.post.post_tags = null;
      this.post.category = null;
      this.post.sub_category = null;
      this.post.user = null;
      this.post.content = null;
      if (this.videoupdated) {
        this.post.video = this.video;
      } else {
        this.post.video = null;
      }

      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ["br"] }).substring(0, 500);
      }
      if (this.post.newvideo) {
        var newvideo_id = this.post.newvideo.split("v=")[1];
        var ampersandPosition = newvideo_id.indexOf("&");
        if (ampersandPosition != -1) {
          newvideo_id = newvideo_id.substring(0, ampersandPosition);
        }
        this.post.newvideo_id = newvideo_id;
      } else {
        this.post.newvideo_id = null;
      }
      this.$http.post("/api/posts/edit/" + this.post.id, this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this6.post.id = pid;
        _this6.slider.post_id = pid;
        _this6.slider.order_number = pid;
        _this6.metas.post_id = pid;
        _this6.saveMetas();
      }, function (e) {
        _this6.toggleLoader();

        if (!e.body.Error) {
          _this6.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this6.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveMetas: function saveMetas() {
      var _this7 = this;

      this.$http.put("/api/post-metas/edit-bulk/", this.metas).then(function (response) {
        _this7.notifier("top", "right", "success", "Başarılı");
        _this7.$router.push("/news");
        _this7.toggleLoader();
      }, function (e) {
        _this7.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this7.toggleLoader();
      });
    },
    getInitialData: function getInitialData() {
      var _this8 = this;

      this.toggleLoader();
      this.$http.get("/api/posts/get/" + this.id).then(function (response) {
        _this8.post = response.body;
        _this8.content = _this8.post.content;
        _this8.image.file = _this8.mediaURL() + _this8.post.image;
        if (_this8.post.video) {
          _this8.video = _this8.post.video;
        } else {
          _this8.post.video = {
            video_url: null
          };
        }
        if (_this8.post.slider == null) {
          _this8.firstSlider = true;
        }
        _this8.metas = {
          post_id: _this8.post.id,
          items: {
            meta2: {
              meta_id: _this8.post.post_metas[_this8.post.meta_title].id,
              meta_key: "title",
              meta_value: _this8.post.post_metas[_this8.post.meta_title].meta_value
            },
            meta3: {
              meta_id: _this8.post.post_metas[_this8.post.meta_description].id,
              meta_key: "description",
              meta_value: _this8.post.post_metas[_this8.post.meta_description].meta_value
            }
          }
        };
        _this8.toggleLoader();
      }, function (er) {
        _this8.toggleLoader();
        _this8.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        return;
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name) + "-" + this.post.category_id + "-" + this.post.sub_category_id;
    },
    slugifyUrl: function slugifyUrl() {
      this.announcement.url = this.slugify(this.announcement.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById("url").classList.add("is-invalid");
        document.getElementById("url").classList.remove("is-valid");
        document.getElementById("url-label").classList.add("is-invalid");
        document.getElementById("url-label").classList.remove("is-valid");
      }).catch(function (er) {
        document.getElementById("url").classList.add("is-valid");
        document.getElementById("url").classList.remove("is-invalid");
        document.getElementById("url-label").classList.add("is-valid");
        document.getElementById("url-label").classList.remove("is-invalid");
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this9 = this;

        request.$http.get("/api/filter/posts/exclude/id:" + this.id + "/url/" + request.post.url).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this9.notifier("top", "right", "danger", "Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      this.croppieType = type;
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    loadItems: function loadItems() {
      var _this10 = this;

      this.subCategories = null;
      this.createUrl();
      this.$http.get("/api/sub-categories/getsubcategories/" + this.post.category_id).then(function (response) {
        _this10.subCategories = response.body;
        _this10.createUrl();
      }, function (er) {
        _this10.toggleLoader();
        _this10.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        return;
      });
    },
    crop: function crop() {
      var _this11 = this;

      var dis = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: "jpeg",
          size: {
            width: 600,
            height: 450
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this11.croppieType === "main") {
            dis.image.cropped = output;
            document.getElementById("main-i").src = dis.image.cropped;
          } else if (_this11.croppieType === "slider") {
            dis.sliderImage.cropped = output;
            dis.sliderImageLoaded = true;
            document.getElementById("slider-i").src = dis.sliderImage.cropped;
          } else if (_this11.croppieType === "tinymce") {
            _this11.notifier("top", "right", "warning", "Lütfen resim yükleninceye kadar bekleyin.");
            _this11.addImageToEditor(output);
          }
          _this11.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    var _this12 = this;

    this.getInitialData(), this.$http.get("/api/categories/all").then(function (response) {
      _this12.categories = response.body;
    }, function (er) {
      _this12.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
      _this12.toggleLoader();
    });
  }
});

/***/ }),

/***/ "dH+H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/races'}}},[_c('button',{staticClass:"btn btn-warning text-white active btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Yarışlar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/seasons'}}},[_c('button',{staticClass:"btn btn-info btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Sezonlar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/members'}}},[_c('button',{staticClass:"btn btn-danger btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Üyeler")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('div',{staticClass:"col-12 input-group mb-3 d-flex flex-column align-items-start"},[_c('div',{staticClass:"input-group-prepend mb-3"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Revize Sebebi")])]),_vm._v(" "),_c('tinymce',{class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1"},model:{value:(_vm.race.notes),callback:function ($$v) {_vm.$set(_vm.race, "notes", $$v)},expression:"race.notes"}}),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-end"},[_c('button',{staticClass:"btn btn-primary btn-fill mt-2",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])],1)])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dLYe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: {
        is_active: 0
      },
      categories: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    deactivate: function deactivate(id, type) {
      var _this = this;

      this.toggleLoader();
      this.category.is_active = 0;
      this.$http.post('/api/' + type + '/edit/' + id, this.category).then(function (response) {
        _this.notifier('top', 'right', 'warning', 'Kategori Yayından Kaldırıldı');
        _this.getPosts();
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();
        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    remove: function remove(id, type) {
      var _this2 = this;

      this.toggleLoader();
      this.$http.post('/api/' + type + '/delete/' + id, this.category).then(function (response) {
        _this2.notifier('top', 'right', 'warning', 'Kategori Silindi');
        _this2.getPosts();
        _this2.toggleLoader();
      }, function (e) {
        _this2.toggleLoader();
        if (!e.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this2.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    activate: function activate(id, type) {
      var _this3 = this;

      this.toggleLoader();
      this.category.is_active = 1;
      this.$http.post('/api/' + type + '/edit/' + id, this.category).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Kategori Yayına Alındı');
        _this3.getPosts();
        _this3.toggleLoader();
      }, function (e) {
        _this3.toggleLoader();
        if (!e.body.Error) {
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this3.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },

    getPosts: function getPosts() {
      var _this4 = this;

      this.toggleLoader();
      var url = '/api/categories/all-with-joins-news/';
      this.$http.get(url).then(function (response) {
        _this4.categories = response.body;
        _this4.toggleLoader();
      }, function (er) {
        _this4.toggleLoader();

        if (!er.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this4.err = er.body.Error;
          _this4.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "dXrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.name && this.$children.length === 0) {
      console.warn('Invalid prop: prop "name" is required.');
      return;
    }

    if (this.icon) {
      return;
    }

    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;

      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ "da/f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalPressOrder_vue__ = __webpack_require__("oQc+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc606f7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalPressOrder_vue__ = __webpack_require__("VyI3");
function injectStyle (ssrContext) {
  __webpack_require__("jYlG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalPressOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc606f7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalPressOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ddgI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__ = __webpack_require__("OaMs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b3465d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__ = __webpack_require__("LvYP");
function injectStyle (ssrContext) {
  __webpack_require__("D2Ge")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b3465d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dh+K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubBoardsCategories_vue__ = __webpack_require__("77Ng");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5732ea83_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubBoardsCategories_vue__ = __webpack_require__("+rbr");
function injectStyle (ssrContext) {
  __webpack_require__("CTT9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubBoardsCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5732ea83_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubBoardsCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dljt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("0jKv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ffb1f5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("CCCg");
function injectStyle (ssrContext) {
  __webpack_require__("ew99")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ffb1f5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "duuz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        status: 1
      },
      table: null,
      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "ActivityProgram",
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeStatus: function changeStatus(id, status) {
      var _this = this;

      this.toggleLoader();
      this.post.status = status;
      this.$http.post("/api/posts/edit/" + id, this.post).then(function (response) {
        if (status !== 1) {
          _this.notifier("top", "right", "warning", "Sayfa Yayından Kaldırıldı");
        } else {
          _this.notifier("top", "right", "success", "Sayfa Yayınlandı");
        }

        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();
        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this2 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ActivityProgram";

      this.toggleLoader();
      this.type = t;
      var url = "/api/filter/posts/post-type/" + this.type + "/limit/" + this.limit + "/page/" + p;
      this.$http.get(url).then(function (response) {
        _this2.table = response.body.data;
        _this2.total = response.body.meta.total;
        _this2.pageCount = [];
        for (var i = 0; i < _this2.total / _this2.limit; i++) {
          _this2.pageCount.push(i + 1);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.toggleLoader();

        if (!er.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this2.err = er.body.Error;
          _this2.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById("new-post").classList.contains("d-none")) {
        document.getElementById("new-post").classList.remove("d-none");
      } else {
        document.getElementById("new-post").classList.add("d-none");
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "e+/Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DictionaryModules_Index_vue__ = __webpack_require__("8SDh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__DictionaryModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "eAxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "eCSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__ = __webpack_require__("TQ5B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26b77914_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__ = __webpack_require__("m61p");
function injectStyle (ssrContext) {
  __webpack_require__("+mpZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26b77914_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eU1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  inheritAttrs: false,
  name: 'fg-input',
  props: {
    label: String,
    value: [String, Number],
    addonRightIcon: String,
    addonLeftIcon: String
  },
  computed: {
    hasIcon: function hasIcon() {
      var _$slots = this.$slots,
          addonRight = _$slots.addonRight,
          addonLeft = _$slots.addonLeft;

      return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined;
    }
  }
});

/***/ }),

/***/ "esuq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us full-screen"},[_c('nav',{staticClass:"navbar navbar-ct-default",attrs:{"role":"navigation-demo"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{path:'/'}}},[_vm._v("Site title")])],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navigation-example-2"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('footer',{staticClass:"footer-demo"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:'/register'}}},[_vm._v("Register")])],1)])]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page section content"},[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v("Çok yakında hizmetinizde")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright pull-right"},[_vm._v("\n        © 2017, made with\n        "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by Paper admin\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "evSb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/leader'}}},[_c('button',{staticClass:"btn btn-info btn-sm  px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("İçerik")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/gallery'}}},[_c('button',{staticClass:"btn btn-warning active text-white btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Fotogaleri")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/pressgallery'}}},[_c('button',{staticClass:"btn btn-danger btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Yazılı Basın")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/articles'}}},[_c('button',{staticClass:"btn btn-success btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Başkanın Yazıları")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/articlesorder'}}},[_c('button',{staticClass:"btn btn-primary btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Yazı Sıralama")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/digital-press'}}},[_c('button',{staticClass:"btn btn-secondary btn-sm  mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Dijital Basın")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/digital-press-order'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Dijital Basın Sıralama")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('div',{staticClass:"row"},[(!_vm.err)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("\n                Başkanın Köşesi Fotogaleri\n                "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"mr-2 btn btn-danger btn-sm btn-fill",on:{"click":function($event){return _vm.addNew()}}},[_vm._v("Ekle")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm btn-fill",on:{"click":function($event){return _vm.update()}}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("Resim boyutu 600 x 400 pixel")]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-11"},[_c('img',{staticClass:"img-fluid",attrs:{"width":"150px","src":_vm.mediaURL() + item.image}})]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn btn-sm",attrs:{"title":"Resmi Değiştir"},on:{"click":function($event){return _vm.initiateCroppie(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 border border-secondary p-2 d-none",attrs:{"src":_vm.newSliderImage.cropped}})])])])])}),0)],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n        "+_vm._s(_vm.err)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 480, height: 320, type: 'suare'},"boundary":{width: 600, height: 400},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ew99":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f0G8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Yarış Ekle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata\n        ")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"change":_vm.validate,"keyup":_vm.createUrl,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"url-label"}},[_vm._v("URL")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.url),expression:"post.url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('URL')},attrs:{"type":"text","placeholder":"URL","aria-label":"URL","id":"url","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.url)},on:{"keyup":_vm.slugifyUrl,"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Branş")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.category_id),expression:"post.category_id"}],staticClass:"custom-select",attrs:{"disabled":_vm.disableParent},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.post, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.loadItems]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Üst Branş Seçimi Yapınız")]),_vm._v(" "),_vm._l((_vm.categories),function(cat){return _c('option',{key:cat.id,domProps:{"value":cat.id}},[_vm._v(_vm._s(cat.name))])})],2)]),_vm._v(" "),(_vm.subCategories)?_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Sezon")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.sub_category_id),expression:"post.sub_category_id"}],staticClass:"custom-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.post, "sub_category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.createUrl]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Sezon Seçimi Yapınız")]),_vm._v(" "),_vm._l((_vm.subCategories),function(cat){return _c('option',{key:cat.id,domProps:{"value":cat.id}},[_vm._v(_vm._s(cat.name))])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Yer")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.content.content),expression:"content.content"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Yer","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.content.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.content, "content", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlangıç Tarihi")])]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##-##-####'),expression:"'##-##-####'"},{name:"model",rawName:"v-model",value:(_vm.post.start_date),expression:"post.start_date"}],staticClass:"form-control",attrs:{"type":"text","aria-label":"Başlangıç Tarihi","placeholder":"26-08-1991"},domProps:{"value":(_vm.post.start_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "start_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Bitiş Tarihi")])]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##-##-####'),expression:"'##-##-####'"},{name:"model",rawName:"v-model",value:(_vm.post.finish_date),expression:"post.finish_date"}],staticClass:"form-control",attrs:{"type":"text","aria-label":"Bitiş Tarihi","placeholder":"26-08-1991"},domProps:{"value":(_vm.post.finish_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "finish_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('vue-tabs',[_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Resim"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("500 x 300 pixel")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.cropped}})],1)])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 480, height: 270, type: 'suare'},"boundary":{width: 640, height: 360},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f71D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fAVW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      // post data
      post: {
        id: null,
        link: null,
        subtitle: null,
        user_id: this.getCurrentUserDetails(),
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'Homeboxes',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        file: null,
        cropped: null
      },
      sliderImage: {
        file: null,
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      },
      firstSlider: false
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post('/api/images/upload/' + this.post.name + '_inner-image', { cropped: i }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + _this.post.name + '" />';
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      };
      if (!this.content.content) {
        this.errors.push("İçerik");
      };
      if (!this.image.cropped && !this.image.file) {
        this.errors.push("Resim");
      };
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this2.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'
        _this2.saveImage();
      });
    },
    saveImage: function saveImage() {
      var _this3 = this;

      if (this.image.cropped) {
        this.$http.post('/api/images/upload/' + this.slugify(this.post.name), this.image).then(function (response) {
          _this3.post.image = response.body.Data.Response.name;
          _this3.savePost();
        }, function (e) {
          button.innerHTML = 'Kaydet';
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this3.toggleLoader();
        });
      } else {
        this.savePost();
      }
    },
    savePost: function savePost() {
      var _this4 = this;

      this.post.comments = null;
      this.post.menus = null;
      this.post.slider = null;
      this.tempMetas = this.post.post_metas;
      this.post.post_metas = null;
      this.post.post_tags = null;
      this.post.category = null;
      this.post.sub_category = null;
      this.post.user = null;
      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.$http.post('/api/posts/edit/' + this.post.id, this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this4.post.id = pid;
        _this4.slider.post_id = pid;
        _this4.slider.order_number = pid;
        _this4.metas.post_id = pid;
        _this4.saveMetas();
      }, function (e) {
        _this4.toggleLoader();

        if (!e.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          var button = event.target;
          button.innerHTML = '<i class="fas fa-circle-notch fa-spin">asdasd</i>';
          _this4.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveMetas: function saveMetas() {
      var _this5 = this;

      this.$http.put('/api/post-metas/edit-bulk/', this.metas).then(function (response) {
        _this5.notifier('top', 'right', 'success', 'Başarılı');
        _this5.$router.push('/homeboxes');
        _this5.toggleLoader();
      }, function (e) {
        _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this5.toggleLoader();
      });
    },
    getInitialData: function getInitialData() {
      var _this6 = this;

      this.toggleLoader();
      this.$http.get('/api/posts/get/' + this.id).then(function (response) {
        _this6.post = response.body;
        _this6.content = _this6.post.content;
        _this6.image.file = _this6.mediaURL() + _this6.post.image;
        if (_this6.post.video !== null) {
          _this6.video = _this6.post.video;
        }
        if (_this6.post.slider == null) {
          _this6.firstSlider = true;
        }
        _this6.metas = {
          post_id: _this6.post.id,
          items: {
            meta2: {
              meta_id: _this6.post.post_metas[_this6.post.meta_title].id,
              meta_key: 'title',
              meta_value: _this6.post.post_metas[_this6.post.meta_title].meta_value
            },
            meta3: {
              meta_id: _this6.post.post_metas[_this6.post.meta_description].id,
              meta_key: 'description',
              meta_value: _this6.post.post_metas[_this6.post.meta_description].meta_value
            }
          }
        };
        _this6.toggleLoader();
      }, function (er) {
        _this6.toggleLoader();
        _this6.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name);
    },
    slugifyUrl: function slugifyUrl() {
      this.announcement.url = this.slugify(this.announcement.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this7 = this;

        request.$http.get('/api/filter/posts/exclude/id:' + this.id + '/post-type/Homeboxes/name/' + request.post.name).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this7.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.name) {
        this.croppieType = type;
      } else {
        this.notifier('top', 'right', 'danger', 'Resim ekleyebilmek için bir başlık belirlemelisiniz.');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this8 = this;

      var dis = this;
      var wdt = 150;
      var hgt = 150;
      if (this.croppieType === "tinymce") {
        wdt = 150;
        hgt = 150;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          backgroundColor: '#fff',
          size: {
            width: wdt,
            height: hgt
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this8.croppieType === 'main') {
            dis.image.cropped = output;
            document.getElementById('main-i').src = dis.image.cropped;
          } else if (_this8.croppieType === 'tinymce') {
            _this8.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this8.addImageToEditor(output);
          }
          _this8.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.getInitialData();
  }
});

/***/ }),

/***/ "fBuy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      videoupdated: false,
      publishTime: null,
      futurePost: false,
      socialMedia: true,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: "Races",
        image: null,
        newvideo: null,
        newvideo_id: null,
        content_id: null,
        video_id: null,
        start_date: null,
        finish_date: null,
        changed_date: null
      },
      categories: null,
      category: {
        category_id: "",
        name: null,
        url: null,
        is_active: 1
      },
      subCategories: null,
      disableParent: false,
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: "title",
            meta_value: null
          },
          meta3: {
            meta_key: "description",
            meta_value: null
          },
          meta4: {
            meta_key: "view_count",
            meta_value: 0
          }
        }
      },
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        cropped: null
      },
      sliderImage: {
        cropped: null
      },
      croppieType: "main",
      sliderImageLoaded: false,
      // end of post data
      users: null,
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post("/api/images/upload/" + this.post.url + "races_inner-image", {
        cropped: i
      }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + _this.post.url + '" />';
      }, function (e) {
        _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      }
      if (!this.post.url) {
        this.errors.push("URL");
      }
      if (!this.content.content) {
        this.errors.push("İçerik");
      }
      if (!this.image.cropped) {
        this.errors.push("Resim");
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById("url").classList.add("is-invalid");
        document.getElementById("url").classList.remove("is-valid");
        document.getElementById("url-label").classList.add("is-invalid");
        document.getElementById("url-label").classList.remove("is-valid");
        _this2.notifier("top", "right", "danger", "URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin");
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
        _this2.saveContent();
      });
    },
    saveContent: function saveContent() {
      var _this3 = this;

      var button = event.target;
      this.$http.post("/api/contents/add", this.content).then(function (response) {
        _this3.post.content_id = response.body.Data.Response.id;
        _this3.saveVideo();
      }, function (e) {
        button.innerHTML = "Kaydet";
        _this3.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this3.toggleLoader();
      });
    },
    saveVideo: function saveVideo() {
      var _this4 = this;

      if (this.video.video_url !== null) {
        this.$http.post("/api/videos/add", this.video).then(function (response) {
          _this4.post.video_id = response.body.Data.Response.name;
          _this4.saveImage();
        }, function (e) {
          _this4.notifier("top", "right", "danger", "Bir Hata Oluştu");
          _this4.toggleLoader();
        });
      } else {
        this.saveImage();
      }
    },
    saveImage: function saveImage() {
      var _this5 = this;

      this.$http.post("/api/images/upload/" + this.post.url, this.image).then(function (response) {
        _this5.post.image = response.body.Data.Response.name;
        _this5.savePost();
      }, function (e) {
        _this5.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this5.toggleLoader();
      });
    },

    savePost: function savePost() {
      var _this6 = this;

      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ["br"] }).substring(0, 500);
      }
      if (this.videoupdated) {
        this.post.video = this.video;
      } else {
        this.post.video = null;
      }

      this.post.changed_date = this.post.finish_date;
      this.$http.post("/api/posts/add", this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this6.post.id = pid;
        _this6.metas.post_id = pid;
        _this6.saveMetas();
      }, function (e) {
        _this6.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this6.toggleLoader();
      });
    },
    saveMetas: function saveMetas() {
      var _this7 = this;

      this.$http.post("/api/post-metas/add-bulk", this.metas).then(function (response) {
        _this7.notifier("top", "right", "success", "Başarılı");
        _this7.$router.push("/races");
        _this7.toggleLoader();
      }, function (e) {
        _this7.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this7.toggleLoader();
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name) + "-" + this.post.category_id + "-r" + this.post.sub_category_id;
    },
    slugifyUrl: function slugifyUrl() {
      this.post.url = this.slugify(this.post.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById("url").classList.add("is-invalid");
        document.getElementById("url").classList.remove("is-valid");
        document.getElementById("url-label").classList.add("is-invalid");
        document.getElementById("url-label").classList.remove("is-valid");
      }).catch(function (er) {
        document.getElementById("url").classList.add("is-valid");
        document.getElementById("url").classList.remove("is-invalid");
        document.getElementById("url-label").classList.add("is-valid");
        document.getElementById("url-label").classList.remove("is-invalid");
      });
    },
    allPosts: function allPosts() {
      var _this8 = this;

      this.$http.get("/api/posts/get-with-type/Races").then(function (response) {
        _this8.allposts = response.body;
      }, function (er) {
        _this8.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        _this8.toggleLoader();
      });
    },
    loadItems: function loadItems() {
      var _this9 = this;

      this.subCategories = null;
      this.createUrl();
      this.$http.get("/api/sub-categories/getsubcategories/" + this.post.category_id).then(function (response) {
        _this9.subCategories = response.body;
        _this9.createUrl();
      }, function (er) {
        _this9.toggleLoader();
        _this9.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        return;
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this10 = this;

        request.$http.get("/api/filter/posts/url/" + request.post.url).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this10.notifier("top", "right", "danger", "Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.url) {
        this.croppieType = type;
      } else {
        this.notifier("top", "right", "danger", "Resim ekleyebilmek için bir başlık belirlemelisiniz.");
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this11 = this;

      var dis = this;
      var wdt = 500;
      var hgt = 300;
      if (this.croppieType === "tinymce") {
        wdt = 500;
        hgt = 300;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: "jpeg",
          size: {
            width: wdt,
            height: hgt
          },

          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this11.croppieType === "main") {
            dis.image.cropped = output;
          } else if (_this11.croppieType === "slider") {
            dis.sliderImage.cropped = output;
            dis.sliderImageLoaded = true;
          } else if (_this11.croppieType === "tinymce") {
            _this11.notifier("top", "right", "warning", "Lütfen resim yükleninceye kadar bekleyin.");
            _this11.addImageToEditor(output);
          }
          _this11.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    var _this12 = this;

    this.allPosts();
    if (this.post.video) {
      this.video = this.post.video;
    } else {
      this.post.video = {
        video_url: null
      };
    }
    this.$http.get("/api/categories/seasons").then(function (response) {
      _this12.categories = response.body;
    }, function (er) {
      _this12.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
      _this12.toggleLoader();
    });
  }
});

/***/ }),

/***/ "fEgH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('posts-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fFLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('label',{staticClass:"input-group-text border-0 bg-white",attrs:{"for":"inputGroupSelect01"}},[_vm._v("Branş")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.category_id),expression:"category.category_id"}],staticClass:"custom-select",attrs:{"disabled":_vm.disableParent},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.category, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Branş Yok(Direk Branş Eklenecek)")]),_vm._v(" "),_vm._l((_vm.categories),function(cat){return _c('option',{key:cat.id,domProps:{"value":cat.id}},[_vm._v("\n              "+_vm._s(cat.name)+"\n            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.name),expression:"category.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.category.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.category, "name", $event.target.value)}}})]),_vm._v(" "),(_vm.category.category_id === '')?_c('div',{staticClass:"col-12 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Sezonlara Ekle")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.subCategories),expression:"subCategories"}],staticClass:"form-control",staticStyle:{"height":"200px"},attrs:{"type":"text","placeholder":"Her satırda bir alt kategori","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.subCategories)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subCategories=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fIVt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fLY8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fMfY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Posts_vue__ = __webpack_require__("Tov1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c2defb9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Posts_vue__ = __webpack_require__("fEgH");
function injectStyle (ssrContext) {
  __webpack_require__("ToUn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Posts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c2defb9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Posts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fSjc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEdit_vue__ = __webpack_require__("n8CO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ffc190e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEdit_vue__ = __webpack_require__("d9Nr");
function injectStyle (ssrContext) {
  __webpack_require__("RxiA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ffc190e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fWgP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("JSCY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05ee2a7d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("RVyi");
function injectStyle (ssrContext) {
  __webpack_require__("OV6+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05ee2a7d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fonp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('h4',{staticClass:"card-title d-md-flex justify-content-between",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Şikayetler")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[(!_vm.query)?_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]):_vm._e(),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Yorum")]),_vm._v(" "),_c('th',[_vm._v("Şikayetçi")]),_vm._v(" "),_c('th',[_vm._v("Sebep")]),_vm._v(" "),_c('th',[_vm._v("İşlem")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.comment.comment))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.user.username))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.reason))]),_vm._v(" "),_c('td',{staticStyle:{"width":"15%"}},[_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yorumu Kaldır","id":"deactivate-item.id"},on:{"click":function($event){return _vm.deleteComment(item.comment.id)}}},[_c('i',{staticClass:"fas fa-trash fa-fw"})]),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Şikayeti Yoksay","id":"activate-item.id"},on:{"click":function($event){return _vm.deleteReport(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])])])}),0)]),_vm._v(" "),(!_vm.query)?_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return _c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current)}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])])}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "frfY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('posts-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fuBC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fudw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberAthletes_vue__ = __webpack_require__("F04T");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bfd10e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberAthletes_vue__ = __webpack_require__("0Emb");
function injectStyle (ssrContext) {
  __webpack_require__("+a0N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberAthletes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bfd10e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberAthletes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fz+a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card',[(!_vm.err)?_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Kupa Puanları\n      ")]),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Sayfa")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',{staticClass:"d-flex justify-content-around align-items-center"},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"to":{ path: 'cup-point-page/edit/'+item.id},"title":"Düzenle","tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})])],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n    "+_vm._s(_vm.err)+"\n  ")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g8Lp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Yazı Ekle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata\n        ")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"change":_vm.validate,"keyup":_vm.createUrl,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"url-label"}},[_vm._v("URL")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.url),expression:"post.url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('URL')},attrs:{"type":"text","placeholder":"URL","aria-label":"URL","id":"url","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.url)},on:{"keyup":_vm.slugifyUrl,"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3 d-flex flex-column align-items-end"},[_c('tinymce',{class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('vue-tabs',[_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Resim"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("1200 x 600 pixel")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.cropped}})],1)])]),_vm._v(" "),_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Video"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 input-group px-5 m-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Video Adresi")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.newvideo),expression:"post.newvideo"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"https://www.youtube.com/watch?v=KZzON_7EQ70","aria-label":"Başlık","id":"title","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.newvideo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "newvideo", $event.target.value)}}})])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 480, height: 270, type: 'suare'},"boundary":{width: 640, height: 360},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gD8N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gEQT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Yarış Düzenle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata\n        ")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"url-label"}},[_vm._v("URL")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.url),expression:"post.url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('URL')},attrs:{"type":"text","placeholder":"URL","aria-label":"URL","id":"url","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.url)},on:{"keyup":_vm.slugifyUrl,"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Branş")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.category_id),expression:"post.category_id"}],staticClass:"custom-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.post, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.loadItems]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Üst Kategori Seçimi Yapınız")]),_vm._v(" "),_vm._l((_vm.categories),function(cat){return _c('option',{key:cat.id,domProps:{"value":cat.id}},[_vm._v(_vm._s(cat.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Sezon")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.sub_category_id),expression:"post.sub_category_id"}],staticClass:"custom-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.post, "sub_category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.createUrl]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Alt Kategori Seçimi Yapınız")]),_vm._v(" "),_vm._l((_vm.subCategories),function(cat){return _c('option',{key:cat.id,domProps:{"value":cat.id}},[_vm._v(_vm._s(cat.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Yer")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.content.content),expression:"content.content"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Yer","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.content.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.content, "content", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlangıç Tarihi")])]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##-##-####'),expression:"'##-##-####'"},{name:"model",rawName:"v-model",value:(_vm.post.start_date),expression:"post.start_date"}],staticClass:"form-control",attrs:{"type":"text","aria-label":"Başlangıç Tarihi","placeholder":"26-08-1991"},domProps:{"value":(_vm.post.start_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "start_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Bitiş Tarihi")])]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##-##-####'),expression:"'##-##-####'"},{name:"model",rawName:"v-model",value:(_vm.post.changed_date),expression:"post.changed_date"}],staticClass:"form-control",attrs:{"type":"text","aria-label":"Bitiş Tarihi","placeholder":"26-08-1991"},domProps:{"value":(_vm.post.changed_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "changed_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('vue-tabs',[_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Resim"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("500 x 300 pixel")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.file,"id":"main-i"}})],1)])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 400, height: 240, type: 'suare'},"boundary":{width: 500, height: 300},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gNFC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gNn8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainStatusInstructionsModules_MainStatusInstructions_vue__ = __webpack_require__("abi/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__MainStatusInstructionsModules_MainStatusInstructions_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "gQhL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/directors'}}},[_c('button',{staticClass:"btn btn-danger  btn-sm  px-2 mr-2",attrs:{"type":"submit"}},[_vm._v("Yönetim Kurulu")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/staffs'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Federasyon Personeli")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/all-leaders'}}},[_c('button',{staticClass:"btn btn-primary active btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Başkanlarımız")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/history'}}},[_c('button',{staticClass:"btn btn-success btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Tarihçe")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/sub-board-categories'}}},[_c('button',{staticClass:"btn btn-warning btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Alt Kurullar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/provincial-offices'}}},[_c('button',{staticClass:"btn btn-secondary btn-sm  mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("İl Temsilcilikleri")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/bank-informations'}}},[_c('button',{staticClass:"btn btn-success btn-sm  mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Hesap Numaraları")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/main-status-instructions'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Ana Statü Talimatlar")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[(!_vm.err)?_c('div',[_c('small',[_vm._v("Resim Boyutu 580x388px")]),_vm._v(" "),_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("Başkanlarımız\n                "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"mr-2 btn btn-danger btn-sm btn-fill",on:{"click":function($event){return _vm.addNew()}}},[_vm._v("\n                  Ekle\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm btn-fill",on:{"click":function($event){return _vm.update()}}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.mediaURL() + item.image}})]),_vm._v(" "),_c('div',{staticClass:"col-9 d-flex align-items-center"},[_c('div',{staticClass:"row w-100"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Ad Soyad")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.title),expression:"item.title"}],staticClass:"form-control",attrs:{"type":"text","name":""},domProps:{"value":(item.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Tarih")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.target_url),expression:"item.target_url"}],staticClass:"form-control",attrs:{"type":"text","name":""},domProps:{"value":(item.target_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "target_url", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn btn-sm ",attrs:{"title":"Slider Resmini Değiştir"},on:{"click":function($event){return _vm.initiateCroppie(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 border border-secondary p-2 d-none",attrs:{"src":_vm.newSliderImage.cropped}})])])])])}),0)],1)],1):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n              "+_vm._s(_vm.err)+"\n            ")]):_vm._e()])])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 522, height: 350, type: 'suare'},"boundary":{width: 580, height: 388},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gRhf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/races'}}},[_c('button',{staticClass:"btn btn-warning text-white active btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Yarışlar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/seasons'}}},[_c('button',{staticClass:"btn btn-info btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Sezonlar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/members'}}},[_c('button',{staticClass:"btn btn-danger btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Üyeler")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('div',[_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0 race-inspect-table"},[_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Yarış Adı")]),_vm._v(" "),_c('th',[_vm._v("Oyuncu Adı")]),_vm._v(" "),_c('th',[_vm._v("Değişikliği Yapan")]),_vm._v(" "),_c('th',[_vm._v("Önceki Veri")]),_vm._v(" "),_c('th',[_vm._v("Veri")]),_vm._v(" "),_c('th',[_vm._v("Tarih")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.changes),function(log,key){return _c('tr',{key:key},[_c('td',[_vm._v(_vm._s(log.posts.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.oldPlayer.name)+" "+_vm._s(log.oldPlayer.surname))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.user.name)+" "+_vm._s(log.user.surname))]),_vm._v(" "),_c('td',[(!log.oldPlayer.status)?_c('span',[_vm._v("Beklemede")]):_vm._e(),_vm._v(" "),(log.oldPlayer.status==2)?_c('span',[_vm._v("Revize Talep Edildi")]):_vm._e(),_vm._v(" "),(log.oldPlayer.status==1)?_c('span',[_vm._v("Onaylandı")]):_vm._e()]),_vm._v(" "),_c('td',[(!log.newPlayer.status)?_c('span',[_vm._v("Beklemede")]):_vm._e(),_vm._v(" "),(log.newPlayer.status==2)?_c('span',[_vm._v("Revize Talep Edildi")]):_vm._e(),_vm._v(" "),(log.newPlayer.status==1)?_c('span',[_vm._v("Onaylandı")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(log.created,"Do/MM/YYYY HH:mm:ss")))])])}),0)])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "giiS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("bnkv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84dcd5c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("MGj4");
function injectStyle (ssrContext) {
  __webpack_require__("ikuU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84dcd5c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gnfa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SliderModules_Index_vue__ = __webpack_require__("kAFa");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__SliderModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "goXD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gppO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "guVi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("Jr+q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05aba35a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("IiAb");
function injectStyle (ssrContext) {
  __webpack_require__("qVTn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05aba35a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h0DP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hCvF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hIkQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      table: null,
      post: {
        status: 0
      },
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'static',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    deactivate: function deactivate(id) {
      var _this = this;

      this.toggleLoader();
      this.post.status = 0;
      this.$http.post('/api/posts/edit/' + id, this.post).then(function (response) {
        _this.notifier('top', 'right', 'warning', 'Sayfa Yayından Kaldırıldı');
        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    activate: function activate(id) {
      var _this2 = this;

      this.toggleLoader();
      this.post.status = 1;
      this.$http.post('/api/posts/edit/' + id, this.post).then(function (response) {
        _this2.notifier('top', 'right', 'success', 'Sayıfa Yayınlandı');
        _this2.getPosts(_this2.page, _this2.type);
        _this2.toggleLoader();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this3 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'static';

      this.toggleLoader();
      this.type = t;
      var url = '/api/filter/posts/exclude/post-type:static/limit/' + this.limit + '/page/' + p;
      if (this.type !== 'all') {
        url = '/api/filter/posts/post-type/' + this.type + '/limit/' + this.limit + '/page/' + p;
      }
      this.$http.get(url).then(function (response) {
        _this3.table = response.body.data;
        _this3.total = response.body.meta.total;
        _this3.page = p;
        _this3.pageCount = [];
        for (var i = 0; i < _this3.total / _this3.limit; i++) {
          _this3.pageCount.push(i + 1);
        }
        _this3.toggleLoader();
      }, function (er) {
        _this3.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        _this3.toggleLoader();
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "hP3b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hQWh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hT6u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,

      // post data
      videoupdated: false,
      post: {
        id: null,
        newvideo: null,
        user_id: this.getCurrentUserDetails(),
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: "ComingFromYou",
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: "title",
            meta_value: null
          },
          meta3: {
            meta_key: "description",
            meta_value: null
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      croppieType: "main",
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      },
      firstSlider: false
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {

    getInitialData: function getInitialData() {
      var _this = this;

      this.toggleLoader();
      this.$http.get("/api/posts/get/" + this.id).then(function (response) {
        _this.post = response.body;
        _this.content = _this.post.content;
        _this.toggleLoader();
      }, function (er) {
        _this.toggleLoader();
        _this.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        return;
      });
    }

  },
  mounted: function mounted() {
    this.getInitialData();
  }
});

/***/ }),

/***/ "hY3A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hbup":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hmwy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hn6S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    LTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      editTooltip: 'Edit Task',
      deleteTooltip: 'Remove',
      pieChart: {
        data: {
          labels: ['40%', '20%', '40%'],
          series: [40, 20, 40]
        }
      },
      lineChart: {
        data: {
          labels: ['9:00AM', '12:00AM', '3:00PM', '6:00PM', '9:00PM', '12:00PM', '3:00AM', '6:00AM'],
          series: [[287, 385, 490, 492, 554, 586, 698, 695], [67, 152, 143, 240, 287, 335, 435, 437], [23, 113, 67, 108, 190, 239, 307, 308]]
        },
        options: {
          low: 0,
          high: 800,
          showArea: false,
          height: '245px',
          axisX: {
            showGrid: false
          },
          lineSmooth: true,
          showLine: true,
          showPoint: true,
          fullWidth: true,
          chartPadding: {
            right: 50
          }
        },
        responsiveOptions: [['screen and (max-width: 640px)', {
          axisX: {
            labelInterpolationFnc: function labelInterpolationFnc(value) {
              return value[0];
            }
          }
        }]]
      },
      barChart: {
        data: {
          labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          series: [[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895], [412, 243, 280, 580, 453, 353, 300, 364, 368, 410, 636, 695]]
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false
          },
          height: '245px'
        },
        responsiveOptions: [['screen and (max-width: 640px)', {
          seriesBarDistance: 5,
          axisX: {
            labelInterpolationFnc: function labelInterpolationFnc(value) {
              return value[0];
            }
          }
        }]]
      },
      tableData: {
        data: [{ title: 'Sign contract for "What are conference organizers afraid of?"', checked: false }, { title: 'Lines From Great Russian Literature? Or E-mails From My Boss?', checked: true }, {
          title: 'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit',
          checked: true
        }, { title: 'Create 4 Invisible User Experiences you Never Knew About', checked: false }, { title: 'Read "Following makes Medium better"', checked: false }, { title: 'Unfollow 5 enemies from twitter', checked: false }]
      }
    };
  }
});

/***/ }),

/***/ "hoLH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InformationBanksContentModules_Index_vue__ = __webpack_require__("rqLU");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__InformationBanksContentModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "hqMp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('index-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hqgg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i+ho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        status: 1
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'BankInformations',
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeStatus: function changeStatus(id, status) {
      var _this = this;

      this.toggleLoader();
      this.post.status = status;
      this.$http.post('/api/posts/edit/' + id, this.post).then(function (response) {
        if (status !== 1) {
          _this.notifier('top', 'right', 'warning', 'Sayfa Yayından Kaldırıldı');
        } else {
          _this.notifier('top', 'right', 'success', 'Sayfa Yayınlandı');
        }

        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();
        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this2 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'BankInformations';

      this.toggleLoader();
      this.type = t;
      var url = '/api/filter/posts/post-type/' + this.type + '/limit/' + this.limit + '/page/' + p;
      this.$http.get(url).then(function (response) {
        _this2.table = response.body.data;
        _this2.total = response.body.meta.total;
        _this2.page = p;
        _this2.pageCount = [];
        for (var i = 0; i < _this2.total / _this2.limit; i++) {
          _this2.pageCount.push(i + 1);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.toggleLoader();

        if (!er.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this2.err = er.body.Error;
          _this2.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "i3p5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i6U0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],tag:"li",staticClass:"dropdown nav-item",class:{show: _vm.isOpen},attrs:{"aria-haspopup":"true","aria-expanded":_vm.isOpen},on:{"click":_vm.toggleDropDown}},[_c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"data-toggle":"dropdown"}},[_vm._t("title",[_c('i',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"no-icon"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('b',{staticClass:"caret"})])],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"dropdown-menu",staticStyle:{"position":"absolute"}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i7fd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iGsp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      videoupdated: false,
      publishTime: null,
      futurePost: false,
      socialMedia: true,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'Allnews',
        image: null,
        newvideo: null,
        newvideo_id: null,
        content_id: null,
        video_id: null
      },
      order: {
        post_id: null,
        slider_group: "Allnews",
        is_active: 1
      },
      featuredOrder: {
        post_id: null,
        slider_group: "Featured",
        is_active: 1
      },
      categories: null,
      category: {
        category_id: "",
        name: null,
        url: null,
        is_active: 1
      },
      subCategories: null,
      disableParent: false,
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      sliderItems: null,
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          },
          meta4: {
            meta_key: 'view_count',
            meta_value: 0
          }
        }
      },
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        cropped: null
      },
      sliderImage: {
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post('/api/images/upload/' + this.post.url + '_inner-image', {
        cropped: i
      }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + _this.post.url + '" />';
      }, function (e) {
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push('Başlık');
      }
      if (!this.post.url) {
        this.errors.push('URL');
      }
      if (!this.content.content) {
        this.errors.push('İçerik');
      }
      if (!this.image.cropped) {
        this.errors.push('Resim');
      }
      if (!this.post.category_id) {
        this.errors.push('Kategori');
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    uploadPdf: function uploadPdf(event) {
      var _this2 = this;

      this.file = event.target.files[0];
      if (this.file.type !== "application/pdf") {
        this.notifier('top', 'right', 'danger', 'Lütfen excel formatında bir dosya seçiniz');
      } else {
        var data = new FormData();
        data.append("file", this.file);
        var fileName = this.file.name.split(".");
        var extension = "";
        var newName = "";
        fileName.forEach(function (e, index) {
          if (index < fileName.length - 1) {
            newName += e;
          }
          if (index == fileName.length - 1) {
            extension += e;
          }
        });
        newName += new Date().getTime();
        var fullName = newName + "." + extension;
        data.append("fileName", fullName);
        this.$http.post("/api/files/upload-news-pdf/" + fullName, data).then(function (response) {
          _this2.post.link = fullName;
          _this2.notifier("top", "right", "success", "Pdf başarıyla kaydedildi");
        }, function (er) {
          _this2.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        });
      }
    },
    save: function save() {
      var _this3 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this3.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this3.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'
        _this3.saveContent();
      });
    },
    saveContent: function saveContent() {
      var _this4 = this;

      var button = event.target;
      this.$http.post('/api/contents/add', this.content).then(function (response) {
        _this4.post.content_id = response.body.Data.Response.id;
        _this4.saveVideo();
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this4.toggleLoader();
      });
    },
    saveVideo: function saveVideo() {
      var _this5 = this;

      if (this.video.video_url !== null) {

        this.$http.post('/api/videos/add', this.video).then(function (response) {
          _this5.post.video_id = response.body.Data.Response.name;
          _this5.saveImage();
        }, function (e) {
          _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this5.toggleLoader();
        });
      } else {
        this.saveImage();
      }
    },
    saveImage: function saveImage() {
      var _this6 = this;

      this.$http.post('/api/images/upload/' + this.post.url, this.image).then(function (response) {
        _this6.post.image = response.body.Data.Response.name;
        _this6.savePost();
      }, function (e) {
        _this6.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this6.toggleLoader();
      });
    },

    savePost: function savePost() {
      var _this7 = this;

      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      if (this.videoupdated) {
        this.post.video = this.video;
      } else {
        this.post.video = null;
      }
      if (this.post.newvideo) {
        var newvideo_id = this.post.newvideo.split('v=')[1];
        var ampersandPosition = newvideo_id.indexOf('&');
        if (ampersandPosition != -1) {
          newvideo_id = newvideo_id.substring(0, ampersandPosition);
        }
        this.post.newvideo_id = newvideo_id;
      }
      this.$http.post('/api/posts/add', this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this7.post.id = pid;
        _this7.metas.post_id = pid;
        _this7.order.post_id = pid;
        _this7.featuredOrder.post_id = pid;
        _this7.saveOrder();
      }, function (e) {
        _this7.toggleLoader();

        if (!e.body.Error) {
          _this7.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {

          _this7.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveOrder: function saveOrder() {
      var _this8 = this;

      if (this.allposts && this.allposts.length) {
        this.order.order_number = this.allposts.length;
      } else {
        this.order.order_number = 0;
      }
      this.$http.post("/api/slider/add/Allnews", this.order).then(function (response) {
        _this8.saveFeatured();
      }, function (e) {
        _this8.toggleLoader();
        _this8.notifier("top", "right", "danger", "Bir Hata Oluştu");
      });
    },
    saveFeatured: function saveFeatured() {
      var _this9 = this;

      if (this.sliderItems.length) {
        this.featuredOrder.order_number = this.sliderItems.length;
      } else {
        this.featuredOrder.order_number = 0;
      }
      this.$http.post("/api/slider/add/Featured", this.featuredOrder).then(function (response) {
        _this9.saveMetas();
      }, function (e) {
        _this9.toggleLoader();
        _this9.notifier("top", "right", "danger", "Bir Hata Oluştu");
      });
    },
    saveMetas: function saveMetas() {
      var _this10 = this;

      this.$http.post('/api/post-metas/add-bulk', this.metas).then(function (response) {
        _this10.notifier('top', 'right', 'success', 'Başarılı');
        _this10.$router.push('/allnews');
        _this10.toggleLoader();
      }, function (e) {
        _this10.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this10.toggleLoader();
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name) + '-' + this.post.category_id;
    },
    slugifyUrl: function slugifyUrl() {
      this.post.url = this.slugify(this.post.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    getFeatured: function getFeatured() {
      var _this11 = this;

      this.toggleLoader();
      var url = '/api/slider/get-featured/Featured';
      this.$http.get(url).then(function (response) {
        _this11.sliderItems = response.body;
        console.log(_this11.sliderItems.length);
        _this11.toggleLoader();
      }, function (er) {
        _this11.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        _this11.toggleLoader();
      });
    },
    allPosts: function allPosts() {
      var _this12 = this;

      this.$http.get("/api/posts/get-with-type/Allnews").then(function (response) {
        _this12.allposts = response.body;
      }, function (er) {
        _this12.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        _this12.toggleLoader();
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this13 = this;

        request.$http.get('/api/filter/posts/url/' + request.post.url).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this13.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.url) {
        this.croppieType = type;
      } else {
        this.notifier('top', 'right', 'danger', 'Resim ekleyebilmek için bir başlık belirlemelisiniz.');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById('myImage').files.length) {
        oFReader.readAsDataURL(document.getElementById('myImage').files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this14 = this;

      var dis = this;
      var wdt = 600;
      var hgt = 450;
      if (this.croppieType === 'tinymce') {
        wdt = 600;
        hgt = 450;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: wdt,
            height: hgt
          },

          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this14.croppieType === 'main') {
            dis.image.cropped = output;
          } else if (_this14.croppieType === 'slider') {
            dis.sliderImage.cropped = output;
            dis.sliderImageLoaded = true;
          } else if (_this14.croppieType === 'tinymce') {
            _this14.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this14.addImageToEditor(output);
          }
          _this14.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    var _this15 = this;

    this.allPosts();
    this.getFeatured();
    if (this.post.video) {
      this.video = this.post.video;
    } else {
      this.post.video = {
        video_url: null
      };
    }
    this.$http.get('/api/categories/allnews').then(function (response) {
      _this15.categories = response.body;
    }, function (er) {
      _this15.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
      _this15.toggleLoader();
    });
  }

});

/***/ }),

/***/ "ikqp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("Slider \n              "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"mr-2 btn btn-danger btn-sm btn-fill",on:{"click":function($event){return _vm.addNew()}}},[_vm._v("\n                Ekle\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm btn-fill",on:{"click":function($event){return _vm.update()}}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("Resim boyutu 1600 x 800 pixel")]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-11"},[_c('img',{staticClass:"img-fluid",attrs:{"width":"150px","src":_vm.mediaURL() + item.image}})]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn btn-sm ",attrs:{"title":"Slider Resmini Değiştir"},on:{"click":function($event){return _vm.initiateCroppie(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 border border-secondary p-2 d-none",attrs:{"src":_vm.newSliderImage.cropped}})])])])])}),0)],1)],1)])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 450, height: 240, type: 'suare'},"boundary":{width: 600, height: 320},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ikuU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ixBw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntroVideo_vue__ = __webpack_require__("weuY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f928b0e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntroVideo_vue__ = __webpack_require__("weKa");
function injectStyle (ssrContext) {
  __webpack_require__("sRP8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntroVideo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f928b0e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntroVideo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j/ub":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaceCategories_vue__ = __webpack_require__("2TPd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f437de4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaceCategories_vue__ = __webpack_require__("UBhg");
function injectStyle (ssrContext) {
  __webpack_require__("hQWh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaceCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f437de4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaceCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j7pr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j88V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j9fa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jB+/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jEp+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__("QDyf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55e0a8ed_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__("Yeki");
function injectStyle (ssrContext) {
  __webpack_require__("TzH1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55e0a8ed_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jEs8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jG28":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jGYM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jNvC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Newsletter_vue__ = __webpack_require__("8ewU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba165b16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Newsletter_vue__ = __webpack_require__("+S5Q");
function injectStyle (ssrContext) {
  __webpack_require__("zqom")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Newsletter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba165b16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Newsletter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jOGH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jWTM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/directors'}}},[_c('button',{staticClass:"btn btn-danger active btn-sm  px-2 mr-2",attrs:{"type":"submit"}},[_vm._v("Yönetim Kurulu")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/staffs'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Federasyon Personeli")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/all-leaders'}}},[_c('button',{staticClass:"btn btn-primary btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Başkanlarımız")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/history'}}},[_c('button',{staticClass:"btn btn-success btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Tarihçe")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/sub-board-categories'}}},[_c('button',{staticClass:"btn btn-warning btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Alt Kurullar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/provincial-offices'}}},[_c('button',{staticClass:"btn btn-secondary btn-sm  mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("İl Temsilcilikleri")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/bank-informations'}}},[_c('button',{staticClass:"btn btn-success btn-sm  mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Hesap Numaraları")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/main-status-instructions'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Ana Statü Talimatlar")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[(!_vm.err)?_c('div',[_c('small',[_vm._v("Resim Boyutu 400x450px ")]),_vm._v(" "),_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("Yönetim Kurulu \n                "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"mr-2 btn btn-danger btn-sm btn-fill",on:{"click":function($event){return _vm.addNew()}}},[_vm._v("\n                  Ekle\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm btn-fill",on:{"click":function($event){return _vm.update()}}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.mediaURL() + item.image}})]),_vm._v(" "),_c('div',{staticClass:"col-9 d-flex align-items-center"},[_c('div',{staticClass:"row w-100"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Ad Soyad")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.title),expression:"item.title"}],staticClass:"form-control",attrs:{"type":"text","name":""},domProps:{"value":(item.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Görevi")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.target_url),expression:"item.target_url"}],staticClass:"form-control",attrs:{"type":"text","name":""},domProps:{"value":(item.target_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "target_url", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn btn-sm ",attrs:{"title":"Slider Resmini Değiştir"},on:{"click":function($event){return _vm.initiateCroppie(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 border border-secondary p-2 d-none",attrs:{"src":_vm.newSliderImage.cropped}})])])])])}),0)],1)],1):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n"+_vm._s(_vm.err)+"\n")]):_vm._e()])])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 360, height: 405, type: 'suare'},"boundary":{width: 400, height: 450},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jYlG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jbrF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("YX3a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a47d0b5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("fz+a");
function injectStyle (ssrContext) {
  __webpack_require__("TYI8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a47d0b5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jm8F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Archives_vue__ = __webpack_require__("2jDg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1288c480_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Archives_vue__ = __webpack_require__("rm2T");
function injectStyle (ssrContext) {
  __webpack_require__("IjiV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Archives_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1288c480_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Archives_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k+xj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_search_select__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: [{
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'newspdf' + this.$route.params.id,
        order_number: null
      }],
      fullName: '',
      selectedType: null,
      types: ["URL", "Kategori", "Alt Kategori", "Yayın", "Etiket"],
      options: [],
      sliderItems: null,
      newPdf: {
        Pdf_id: null,
        Pdf_name: null,
        PdfIndex: null
      },

      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "all",
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_1_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier('top', 'right', 'danger', 'PDF Başarıyla silindi');
          _this.getSlider();
        }, function (e) {
          _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          _this.toggleLoader();
        });
      }
    },
    upload: function upload(event) {
      var _this2 = this;

      var file = event.target.files[0];
      if (file.type !== "application/pdf") return console.log(file);
      var data = new FormData();
      data.append("file", file);
      var newfile = file.name.split('.');
      var extension = '';
      var name = '';
      newfile.forEach(function (e, index) {
        if (index < newfile.length - 1) {
          name += e;
        }
        if (index == newfile.length - 1) {
          extension += e;
        }
      });

      var newName = name + new Date().getTime();
      this.fullName = newName + '.' + extension;
      data.append("fileName", this.fullName);

      this.$http.post("/api/files/upload-news-pdf/" + this.newPdf.Pdf_name, data).then(function (response) {
        var i = _this2.newPdf.n === 0 ? 'image' : 'image2';
        _this2.slider[_this2.newPdf.PdfIndex][i] = _this2.newPdf.Pdf_name;
        console.log(_this2.newPdf.Pdf_name);
        _this2.notifier('top', 'right', 'success', 'Pdf Başarıyla Yüklendi');
        _this2.update();
      }, function (er) {
        _this2.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
      });
    },
    myPdf: function myPdf(id, i, n) {
      this.newPdf.Pdf_id = id;
      if (this.slider[i].target_url) {
        this.newPdf.Pdf_name = this.slugify(this.slider[i].target_url) + new Date().getTime() + '.pdf';
      } else {
        this.newPdf.Pdf_name = 'bildiriler' + new Date().getTime() + '.pdf';
      }
      this.newPdf.PdfIndex = i;
      this.newPdf.n = n;
      console.log(this.newPdf);
      document.getElementById('myPdf' + i).click();
    },
    addNew: function addNew() {
      this.slider.push({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'newspdf' + this.$route.params.id,
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      var newdis = this;
      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = 'newspdf' + newdis.$route.params.id;
      });
      this.$http.post('/api/images/edit/', this.slider).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi');
        _this3.getSlider();
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = "/api/images/newspdf/" + this.$route.params.id;
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
      }, function (er) {
        _this4.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
      });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "k9ZB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homeboxes_vue__ = __webpack_require__("Od6J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7aab7554_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Homeboxes_vue__ = __webpack_require__("G3wS");
function injectStyle (ssrContext) {
  __webpack_require__("wg+L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homeboxes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7aab7554_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Homeboxes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kAFa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("nB75");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bbc93db_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("umZt");
function injectStyle (ssrContext) {
  __webpack_require__("o0oD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bbc93db_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kBZk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("lp4/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_075002b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("a20b");
function injectStyle (ssrContext) {
  __webpack_require__("wizZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_075002b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kCLg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kNVK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScoresModules_Index_vue__ = __webpack_require__("/s7h");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__ScoresModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "kQM8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("\n                Başkanın Yazıları Pdf\n                "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"mr-2 btn btn-danger btn-sm btn-fill",on:{"click":function($event){return _vm.addNew()}}},[_vm._v("Ekle")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm btn-fill",on:{"click":function($event){return _vm.update()}}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"row w-100"},[_c('div',{staticClass:"col-12 col-md-2 d-flex align-items-center"},[_c('button',{staticClass:"btn btn-warning activebtn-s mr-2 px-2",attrs:{"disabled":!item.image,"type":"submit"}},[(item.image)?_c('a',{staticClass:"text-warning",attrs:{"href":_vm.generalURL('haberler')+item.image,"target":"_blank"}},[_vm._v("PDF AÇ")]):_vm._e(),_vm._v(" "),(!item.image)?_c('span',{staticClass:"text-danger text-light pdf-alert-text"},[_vm._v("Pdf Yüklenmedi")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-9"},[_c('label',[_vm._v("Açıklama")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.target_url),expression:"item.target_url"}],staticClass:"form-control",attrs:{"type":"text","name":""},domProps:{"value":(item.target_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "target_url", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{staticClass:"btn btn btn-sm",attrs:{"title":"PDF Değiştir"},on:{"click":function($event){return _vm.myPdf(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('input',{staticClass:"m-3",staticStyle:{"display":"none"},attrs:{"name":"myFile","id":'myPdf'+index,"type":"file"},on:{"change":function($event){return _vm.upload($event)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])])])])])])}),0)],1)],1)])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kRT6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kTPG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('posts-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kVx9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__("uEKC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d29092a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__("H3L1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d29092a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kYNT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kauu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: {
        subject: null,
        body: null
      },
      errors: [],
      // end of post data
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.email.subject) {
        this.errors.push("Başlık");
      };
      if (!this.email.body) {
        this.errors.push("Başlık");
      };
      if (!this.errors.length) {
        this.sendBulkEmail();
      }
    },
    sendBulkEmail: function sendBulkEmail() {
      var _this = this;

      this.notifier('top', 'right', 'info', 'Toplu E-Posta Gönderimi Başladı. Lütfen bittiğini gösteren bildirimi almadan sayfayı kapatmayın.');
      this.$router.push('/newsletter');
      this.$http.post('/api/newsletter/send-bulk-email', this.email).then(function (response) {
        _this.notifier('top', 'right', 'success', 'Toplu E-Posta Gönderimi Başarılı');
      }, function (e) {
        _this.notifier('top', 'right', 'danger', 'Toplu E-Posta Gönderimi Başarısız Oldu. Problem Devam Ederse Destek Ekibine Başvurun.');
      });
    }
  }
});

/***/ }),

/***/ "ksUs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/races'}}},[_c('button',{staticClass:"btn btn-warning btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Yarışlar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/seasons'}}},[_c('button',{staticClass:"btn btn-info btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Sezonlar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/members'}}},[_c('button',{staticClass:"btn btn-danger active btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Üyeler")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[(!_vm.err)?_c('div',[_c('h4',{staticClass:"card-title d-md-flex justify-content-between",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Üyeler")])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('div',{staticClass:"filters my-3 d-flex justify-content-between"},[_c('b-button-group',{attrs:{"size":"sm"}},[_c('b-button',{staticClass:"btn-fill btn-success active type-button",attrs:{"id":"type-all"},on:{"click":function($event){return _vm.changeType('all')}}},[_vm._v("Tümü")]),_vm._v(" "),_c('b-button',{staticClass:"btn-fill btn-success type-button",attrs:{"id":"type-1"},on:{"click":function($event){return _vm.changeType(1)}}},[_vm._v("Aktif")]),_vm._v(" "),_c('b-button',{staticClass:"btn-fill btn-success type-button",attrs:{"id":"type-1"},on:{"click":function($event){return _vm.changeType(0)}}},[_vm._v("Pasif")])],1)],1),_vm._v(" "),_c('div',{staticClass:"filters my-3 d-flex ml-3 w-25 align-items-center position-relatice"},[_c('div',{staticClass:"input-group w-100 ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],staticClass:"form-control form-control-sm border-primary text-primary",attrs:{"type":"text","placeholder":"Arama"},domProps:{"value":(_vm.query)},on:{"keyup":function($event){return _vm.getPosts()},"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text bg-white border-primary text-primary",attrs:{"id":"basic-addon2"}},[_c('i',{staticClass:"fas fa-circle-notch fa-spin d-none",attrs:{"id":"small-spinner"}})])])])])]),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[(!_vm.query)?_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]):_vm._e(),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("E-Posta")]),_vm._v(" "),_c('th',[_vm._v("İsim")]),_vm._v(" "),_c('th',[_vm._v("Kulüp Adı")]),_vm._v(" "),_c('th',[_vm._v("Telefon Numarası")]),_vm._v(" "),_c('th',[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name)+" "+_vm._s(item.surname))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.club_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.phone))]),_vm._v(" "),_c('td',{staticStyle:{"width":"15%"}},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"title":"Düzenle","to":{ path: 'user/add-edit/'+item.id+'/member'},"tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),(item.athletes)?_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-warning btn-fill btn-xs",attrs:{"title":"Sporcular","to":{ path: 'member/athletes/'+item.id},"tag":"li"}},[_c('i',{staticClass:"fas fa-users"})]):_vm._e(),_vm._v(" "),(item.is_active)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Pasif Et","id":"deactivate-item.id"},on:{"click":function($event){return _vm.deactivate(item.id)}}},[_c('i',{staticClass:"fas fa-unlink"})]):_vm._e(),_vm._v(" "),(!item.is_active)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Aktif Et","id":"activate-item.id"},on:{"click":function($event){return _vm.activate(item.id)}}},[_c('i',{staticClass:"fas fa-link"})]):_vm._e()],1)])}),0)]),_vm._v(" "),(!_vm.query)?_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return _c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current)}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])])}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n            "+_vm._s(_vm.err)+"\n          ")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kx+k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('vue-tabs',{attrs:{"active-tab-color":"#9b59b6","active-text-color":"white"}},_vm._l((_vm.AdItems),function(item,index){return _c('v-tab',{key:item.id,staticClass:"card border-top-0",attrs:{"title":item.name}},[_c('div',{staticClass:"row p-3"},[_c('div',{staticClass:"col-11 d-flex flex-column"},[_c('div',{staticClass:"w-100 d-flex justify-content-between"},[_c('div',[_c('label',[_vm._v("Tür")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.type),expression:"item.type"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Kod"}},[_vm._v("Kod")]),_vm._v(" "),_c('option',{attrs:{"value":"Resim"}},[_vm._v("Resim")])])]),_vm._v(" "),(item.type=='Resim')?_c('div',{staticClass:"w-25 d-flex justify-content-end align-items-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.width),expression:"item.width"},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"mr-2 form-control d-inline-block w-25",attrs:{"placeholder":"Genişlik","disabled":"","title":"Genişlik"},domProps:{"value":(item.width)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "width", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v("X")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.height),expression:"item.height"},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"form-control ml-2 d-inline-block w-25",attrs:{"placeholder":"Yükseklik","disabled":"","title":"Yükseklik"},domProps:{"value":(item.height)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "height", $event.target.value)}}})]):_vm._e()]),_vm._v(" "),(item.type=='Kod')?_c('div',[_c('label',[_vm._v("Kod")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-3",attrs:{"v0":""}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(item.content),expression:"item.content"}],staticClass:"form-control",domProps:{"value":(item.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "content", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),(item.type=='Resim')?_c('div',[_c('img',{staticClass:"rounded m-2",staticStyle:{"width":"300px"},attrs:{"src":_vm.mediaURL() + item.image}}),_vm._v(" "),_c('label',{staticClass:"text-danger d-block",attrs:{"for":""}},[_vm._v("Önemli: Reklama tıklandığında kullanıcı aşağıdaki sayfaya yönlendirilecektir.")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Link")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.link),expression:"item.link"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Link ","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(item.link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "link", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn btn-xs btn-success btn-fill",on:{"click":function($event){return _vm.initiateUpload(index)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',[_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-primary btn-fill",attrs:{"href":"javascript:void(0)","title":"Kaydet"},on:{"click":function($event){return _vm.save(item.id,index)}}},[_c('i',{staticClass:"fas fa-save fa-fw"})])]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 border border-secondary p-2 d-none",attrs:{"src":_vm.newAdImage.cropped}})])])])}),1),_vm._v(" "),(_vm.newFileUploading.active)?_c('label',{staticClass:"btn btn btn-xs btn-success btn-fill",attrs:{"for":"newFile"}},[_c('input',{ref:"newFile",staticClass:"d-none",attrs:{"type":"file","name":"newFile","id":"newFile"},on:{"change":function($event){return _vm.uploadFile()}}}),_vm._v("\n              Dosya Yükle\n            ")]):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":_vm.viewport,"boundary":_vm.boundary,"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l0a+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isEdit: false,
      categories: null,
      category: {
        category_id: "",
        name: null,
        url: null,
        is_active: 1
      },
      subCategories: null,
      disableParent: false,
      errors: [],
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.category.name) {
        this.errors.push("Başlık");
      };
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      this.toggleLoader();
      if (this.isEdit) {
        this.updateCategory();
      } else {
        this.saveCategory();
      }
    },
    saveCategory: function saveCategory() {
      var _this = this;

      if (this.category.category_id === "") {
        if (this.subCategories !== null) {
          this.subCategories = this.subCategories.split(/\n/g);
          var sub_categories = [];
          for (var i = 0; i < this.subCategories.length; i++) {
            var subCategory = {
              name: this.subCategories[i],
              url: this.slugify(this.subCategories[i]) + '-' + Math.floor(Math.random() * (99999 - 0) + 0),
              is_active: 1
            };
            sub_categories.push(subCategory);
          }
          this.category.sub_categories = sub_categories;
        }
        this.category.url = this.slugify(this.category.name + '-' + Math.floor(Math.random() * (999 - 0) + 0));
        this.category.category_type = "subboards";
        delete this.category.category_id;
        this.$http.post('/api/categories/add', this.category).then(function (response) {
          _this.notifier('top', 'right', 'success', 'Başarılı');
          _this.$router.push('/sub-board-categories');
          _this.toggleLoader();
        }, function (e) {
          _this.toggleLoader();

          if (!e.body.Error) {
            _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          } else {
            _this.notifier("top", "right", "danger", e.body.Error);
          }
        });
      } else {
        this.category.url = this.slugify(this.category.name + '-' + Math.floor(Math.random() * (999 - 0) + 0));
        this.$http.post('/api/sub-categories/add', this.category).then(function (response) {
          _this.notifier('top', 'right', 'success', 'Başarılı');
          _this.$router.push('/sub-board-categories');
          _this.toggleLoader();
        }, function (e) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this.toggleLoader();
        });
      }
    },
    updateCategory: function updateCategory() {
      var _this2 = this;

      if (this.category.category_id === "") {
        if (this.subCategories !== null) {
          this.subCategories = this.subCategories.split(/\n/g);
          var sub_categories = [];
          for (var i = 0; i < this.subCategories.length; i++) {
            var subCategory = {
              name: this.subCategories[i],
              url: this.slugify(this.subCategories[i]) + '-' + Math.floor(Math.random() * (99999 - 0) + 0),
              is_active: 1
            };
            sub_categories.push(subCategory);
          }
          this.category.sub_categories = sub_categories;
        }
        this.category.url = this.slugify(this.category.name + '-' + Math.floor(Math.random() * (999 - 0) + 0));
        delete this.category.category_id;
        this.category.category_type = "subboards";
        this.$http.post('/api/categories/edit/' + this.$route.params.id, this.category).then(function (response) {
          _this2.notifier('top', 'right', 'success', 'Başarılı');
          _this2.$router.push('/sub-board-categories');
          _this2.toggleLoader();
        }, function (e) {
          _this2.toggleLoader();

          if (!e.body.Error) {
            _this2.notifier("top", "right", "danger", "Bir Hata Oluştu");
          } else {
            _this2.notifier("top", "right", "danger", e.body.Error);
          }
        });
      } else {
        this.category.url = this.slugify(this.category.name + '-' + Math.floor(Math.random() * (999 - 0) + 0));
        this.$http.post('/api/sub-categories/edit/' + this.$route.params.id, this.category).then(function (response) {
          _this2.notifier('top', 'right', 'success', 'Başarılı');
          _this2.$router.push('/sub-board-categories');
          _this2.toggleLoader();
        }, function (e) {
          _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this2.toggleLoader();
        });
      }
    },
    createUrl: function createUrl() {
      if (!isEdit) {
        this.category.url = this.slugify(this.category.name);
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var _this3 = this;

      this.toggleLoader();
      this.$http.get('/api/categories/allsubboards').then(function (response) {
        _this3.categories = response.body;
        if (_this3.$route.params.id && _this3.$route.params.type) {
          var controller = null;
          if (parseInt(_this3.$route.params.type)) {
            controller = 'sub-categories';
          } else {
            controller = 'categories';
            _this3.disableParent = true;
          }
          _this3.$http.get('/api/' + controller + '/get-without-joins/' + _this3.$route.params.id).then(function (response) {
            _this3.isEdit = true;
            _this3.category = response.body;
            delete _this3.category.sub_categories;
            if (controller === 'categories') {
              _this3.category.category_id = '';
            }
            _this3.toggleLoader();
          }, function (response) {
            _this3.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
            _this3.toggleLoader();
          });
        } else {
          _this3.toggleLoader();
        }
      }, function (er) {
        _this3.toggleLoader();
        _this3.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    });
  }
});

/***/ }),

/***/ "l4xO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      // post data
      post: {
        id: null,
        link: null,
        subtitle: null,
        user_id: this.getCurrentUserDetails(),
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'BankInformations',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        file: null,
        cropped: null
      },
      sliderImage: {
        file: null,
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      },
      firstSlider: false
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post('/api/images/upload/' + this.post.name + '_bank-informations', { cropped: i }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + _this.post.name + '" />';
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      };
      if (!this.content.content) {
        this.errors.push("İçerik");
      };
      if (!this.image.cropped && !this.image.file) {
        this.errors.push("Resim");
      };
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this2.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'
        _this2.saveImage();
      });
    },
    saveImage: function saveImage() {
      var _this3 = this;

      if (this.image.cropped) {
        this.$http.post('/api/images/upload/' + this.slugify(this.post.name), this.image).then(function (response) {
          _this3.post.image = response.body.Data.Response.name;
          _this3.savePost();
        }, function (e) {
          button.innerHTML = 'Kaydet';
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this3.toggleLoader();
        });
      } else {
        this.savePost();
      }
    },
    savePost: function savePost() {
      var _this4 = this;

      this.post.comments = null;
      this.post.menus = null;
      this.post.slider = null;
      this.tempMetas = this.post.post_metas;
      this.post.post_metas = null;
      this.post.post_tags = null;
      this.post.category = null;
      this.post.sub_category = null;
      this.post.user = null;
      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.$http.post('/api/posts/edit/' + this.post.id, this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this4.post.id = pid;
        _this4.slider.post_id = pid;
        _this4.slider.order_number = pid;
        _this4.metas.post_id = pid;
        _this4.saveMetas();
      }, function (e) {
        _this4.toggleLoader();

        if (!e.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this4.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveMetas: function saveMetas() {
      var _this5 = this;

      this.$http.put('/api/post-metas/edit-bulk/', this.metas).then(function (response) {
        _this5.notifier('top', 'right', 'success', 'Başarılı');
        _this5.$router.push('/bank-informations');
        _this5.toggleLoader();
      }, function (e) {
        _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this5.toggleLoader();
      });
    },
    getInitialData: function getInitialData() {
      var _this6 = this;

      this.toggleLoader();
      this.$http.get('/api/posts/get/' + this.id).then(function (response) {
        _this6.post = response.body;
        _this6.content = _this6.post.content;
        _this6.image.file = _this6.mediaURL() + _this6.post.image;
        if (_this6.post.video !== null) {
          _this6.video = _this6.post.video;
        }
        if (_this6.post.slider == null) {
          _this6.firstSlider = true;
        }
        _this6.metas = {
          post_id: _this6.post.id,
          items: {
            meta2: {
              meta_id: _this6.post.post_metas[_this6.post.meta_title].id,
              meta_key: 'title',
              meta_value: _this6.post.post_metas[_this6.post.meta_title].meta_value
            },
            meta3: {
              meta_id: _this6.post.post_metas[_this6.post.meta_description].id,
              meta_key: 'description',
              meta_value: _this6.post.post_metas[_this6.post.meta_description].meta_value
            }
          }
        };
        _this6.toggleLoader();
      }, function (er) {
        _this6.toggleLoader();
        _this6.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name);
    },
    slugifyUrl: function slugifyUrl() {
      this.announcement.url = this.slugify(this.announcement.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this7 = this;

        request.$http.get('/api/filter/posts/exclude/id:' + this.id + '/post-type/Homeboxes/name/' + request.post.name).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this7.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.name) {
        this.croppieType = type;
      } else {
        this.notifier('top', 'right', 'danger', 'Resim ekleyebilmek için bir başlık belirlemelisiniz.');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this8 = this;

      var dis = this;
      var wdt = 300;
      var hgt = 139;
      if (this.croppieType === "tinymce") {
        wdt = 300;
        hgt = 139;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          backgroundColor: '#fff',
          size: {
            width: wdt,
            height: hgt
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this8.croppieType === 'main') {
            dis.image.cropped = output;
            document.getElementById('main-i').src = dis.image.cropped;
          } else if (_this8.croppieType === 'tinymce') {
            _this8.notifier('top', 'right', 'warning', 'Lütfen resim yükleninceye kadar bekleyin.');
            _this8.addImageToEditor(output);
          }
          _this8.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.getInitialData();
  }
});

/***/ }),

/***/ "lG1W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lLQs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lNku":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActivityProgramContentModules_Index_vue__ = __webpack_require__("tJ6G");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__ActivityProgramContentModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "lcz4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HistoryModules_Index_vue__ = __webpack_require__("ouHw");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__HistoryModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "liWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ljUl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Banka Hesabı Ekle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Sembol")]),_vm._v(" "),(_vm.post.subtitle)?_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_c('i',{class:_vm.post.subtitle})]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.subtitle),expression:"post.subtitle"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.subtitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "subtitle", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3 d-flex flex-column align-items-end"},[_c('tinymce',{ref:"tm",class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("300 x 139 pixel")]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),(_vm.image.cropped)?_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.cropped}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":true,"viewport":{width: 300, height: 139, type: 'suare'},"boundary":{width: 600, height: 278},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lp4/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {

      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'static',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          },
          meta4: {
            meta_key: 'view_count',
            meta_value: 0
          }
        }
      },
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        cropped: null
      },
      sliderImage: {
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      };
      if (!this.post.url) {
        this.errors.push("URL");
      };
      if (!this.content.content) {
        this.errors.push("İçerik");
      };
      if (!this.image.cropped) {
        this.errors.push("Resim");
      };
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
        _this.saveContent();
      });
    },
    saveContent: function saveContent() {
      var _this2 = this;

      var button = event.target;
      this.$http.post('/api/contents/add', this.content).then(function (response) {
        _this2.post.content_id = response.body.Data.Response.id;
        _this2.saveImage();
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    saveImage: function saveImage() {
      var _this3 = this;

      this.$http.post('/api/images/upload/' + this.post.url, this.image).then(function (response) {
        _this3.post.image = response.body.Data.Response.name;
        _this3.savePost();
      }, function (e) {
        button.innerHTML = 'Kaydet';
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this3.toggleLoader();
      });
    },
    savePost: function savePost() {
      var _this4 = this;

      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.$http.post('/api/posts/add', this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this4.post.id = pid;
        _this4.slider.post_id = pid;
        _this4.slider.order_number = pid;
        _this4.metas.post_id = pid;
        _this4.saveMetas(null);
      }, function (e) {
        _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this4.toggleLoader();
      });
    },
    saveMetas: function saveMetas(image) {
      var _this5 = this;

      if (image !== null) {
        this.metas.items.meta1 = {
          meta_key: 'slider_image',
          meta_value: image
        };
      }
      this.$http.post('/api/post-metas/add-bulk', this.metas).then(function (response) {
        _this5.$router.push('/static-pages');
        _this5.toggleLoader();
      }, function (e) {
        _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this5.toggleLoader();
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name);
    },
    slugifyUrl: function slugifyUrl() {
      this.announcement.url = this.slugify(this.announcement.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this6 = this;

        request.$http.get('/api/filter/urls/name/' + request.post.url).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this6.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      this.croppieType = type;
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this7 = this;

      var dis = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: 1920,
            height: 1080
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this7.croppieType === 'main') {
            dis.image.cropped = output;
          } else if (_this7.croppieType === 'slider') {
            dis.sliderImage.cropped = output;
            dis.sliderImageLoaded = true;
          }
          _this7.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "lp8N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsPdfs_vue__ = __webpack_require__("k+xj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_144b6b54_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsPdfs_vue__ = __webpack_require__("AdDj");
function injectStyle (ssrContext) {
  __webpack_require__("BFq9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsPdfs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_144b6b54_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsPdfs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lqZX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("PPMk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dbb7942_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("LGXr");
function injectStyle (ssrContext) {
  __webpack_require__("q4qH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dbb7942_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lr28":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("XaZC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdb51c0e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("068J");
function injectStyle (ssrContext) {
  __webpack_require__("QFXi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdb51c0e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lr5n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivityProgramPage_vue__ = __webpack_require__("UUzA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60d770ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivityProgramPage_vue__ = __webpack_require__("/Ug1");
function injectStyle (ssrContext) {
  __webpack_require__("HXyF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivityProgramPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60d770ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivityProgramPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m/23":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m/di":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/leader'}}},[_c('button',{staticClass:"btn btn-info btn-sm  px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("İçerik")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/gallery'}}},[_c('button',{staticClass:"btn btn-warning btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Fotogaleri")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/pressgallery'}}},[_c('button',{staticClass:"btn btn-danger  btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Yazılı Basın")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/articles'}}},[_c('button',{staticClass:"btn btn-success  btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Başkanın Yazıları")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/articlesorder'}}},[_c('button',{staticClass:"btn btn-primary active btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Yazı Sıralama")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/digital-press'}}},[_c('button',{staticClass:"btn btn-secondary btn-sm  mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Dijital Basın")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/digital-press-order'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Dijital Basın Sıralama")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('div',{staticClass:"row"},[(!_vm.err)?_c('div',{staticClass:"col-12 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',[_vm._v("\n              Yazıları Sırala\n              "),_c('small',{staticClass:"text-info"},[_vm._v("Haberlerin sıralamasını değiştirmek için sürükleyin.")])]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.sliderItems),callback:function ($$v) {_vm.sliderItems=$$v},expression:"sliderItems"}},[_c('transition-group',_vm._l((_vm.sliderItems),function(item){return _c('div',{key:item.id},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-12 d-flex align-items-center"},[_vm._v(_vm._s(item.post.name))])])])])}),0)],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n        "+_vm._s(_vm.err)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('p',{staticClass:"text-danger mb-0"},[_vm._v("Genişlik(277) Yükseklik(244). PNG ve arkası şeffaf olacak şekilde")]),_vm._v(" "),_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 277, height: 244, type: 'suare'},"boundary":{width: 400, height: 400},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m61p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('side-bar',[_c('mobile-menu',{attrs:{"slot":"content"},slot:"content"}),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/main"}},[_c('i',{staticClass:"nc-icon nc-album-2"}),_vm._v(" "),_c('p',[_vm._v("Anasayfa")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/directors"}},[_c('i',{staticClass:"nc-icon nc-align-center"}),_vm._v(" "),_c('p',[_vm._v("Kurumsal")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/leader"}},[_c('i',{staticClass:"nc-icon nc-single-copy-04"}),_vm._v(" "),_c('p',[_vm._v("Başkanın Bölümü")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/gallery"}},[_c('i',{staticClass:"nc-icon nc-single-02"}),_vm._v(" "),_c('p',[_vm._v("Galeri")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/categories"}},[_c('i',{staticClass:"nc-icon nc-bold"}),_vm._v(" "),_c('p',[_vm._v("Bildiri Kategorileri")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/newcategories"}},[_c('i',{staticClass:"nc-icon nc-bullet-list-67"}),_vm._v(" "),_c('p',[_vm._v("Haber Kategorileri")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/races"}},[_c('i',{staticClass:"nc-icon nc-delivery-fast"}),_vm._v(" "),_c('p',[_vm._v("Yarışlar")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/news"}},[_c('i',{staticClass:"nc-icon nc-notification-70"}),_vm._v(" "),_c('p',[_vm._v("Bildiriler")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/allnews"}},[_c('i',{staticClass:"nc-icon nc-paper-2"}),_vm._v(" "),_c('p',[_vm._v("Haberler")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/coming-from-you"}},[_c('i',{staticClass:"nc-icon nc-email-85"}),_vm._v(" "),_c('p',[_vm._v("Sizden Gelenler")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/featured"}},[_c('i',{staticClass:"nc-icon nc-quote"}),_vm._v(" "),_c('p',[_vm._v("Vitrin")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/activity-program-page"}},[_c('i',{staticClass:"nc-icon nc-bus-front-12"}),_vm._v(" "),_c('p',[_vm._v("Faaliyet Programı")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/cup-point-page"}},[_c('i',{staticClass:"nc-icon nc-bus-front-12"}),_vm._v(" "),_c('p',[_vm._v("Kupa Puanları")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/information-banks-page"}},[_c('i',{staticClass:"nc-icon nc-grid-45"}),_vm._v(" "),_c('p',[_vm._v("Bilgi Bankası")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/facilities"}},[_c('i',{staticClass:"nc-icon nc-bank"}),_vm._v(" "),_c('p',[_vm._v("Tesisler")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/newsletter"}},[_c('i',{staticClass:"nc-icon nc-email-85"}),_vm._v(" "),_c('p',[_vm._v("E-Bülten")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/activity-program"}},[_c('i',{staticClass:"nc-icon nc-cloud-upload-94"}),_vm._v(" "),_c('p',[_vm._v("Excel Yüklemeleri")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/users"}},[_c('i',{staticClass:"nc-icon nc-circle-09"}),_vm._v(" "),_c('p',[_vm._v("Kullanıcılar")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/settings"}},[_c('i',{staticClass:"nc-icon nc-settings-gear-64"}),_vm._v(" "),_c('p',[_vm._v("Ayarlar")])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/scores"}},[_c('i',{staticClass:"nc-icon nc-chart-pie-35"}),_vm._v(" "),_c('p',[_vm._v("Sonuçlar")])])],1),_vm._v(" "),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_vm._v(" "),_c('dashboard-content',{on:{"click":_vm.toggleSidebar}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mKUl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('posts-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mMns":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('posts-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mTeq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mVQN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        status: 0
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    deactivate: function deactivate(id) {
      var _this = this;

      this.toggleLoader();
      this.post.status = 0;
      this.$http.post('/api/posts/edit/' + id, this.post).then(function (response) {
        _this.notifier('top', 'right', 'warning', 'Geri bildirim silindi');
        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this2 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';

      this.toggleLoader();
      this.type = t;
      var url = '/api/filter/posts/post-type/feedback/status/1/limit/' + this.limit + '/page/' + p;

      this.$http.get(url).then(function (response) {
        _this2.table = response.body.data;
        _this2.total = response.body.meta.total;
        _this2.page = p;
        _this2.pageCount = [];
        for (var i = 0; i < _this2.total / _this2.limit; i++) {
          _this2.pageCount.push(i + 1);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        _this2.toggleLoader();
      });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {

      this.getPosts();
    });
  }
});

/***/ }),

/***/ "md1e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_search_select__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: [{
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: "videogallery",
        order_number: null
      }],
      err: null,
      selectedType: null,
      types: ["URL", "Kategori", "Alt Kategori", "Yayın", "Etiket"],
      options: [],
      sliderItems: null,
      newVideo: {
        url: null,
        image_id: null,
        image_name: null,
        imageIndex: null
      },
      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "all",
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_1_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier("top", "right", "danger", "Slider Başarıyla silindi");
          _this.getSlider();
        }, function (e) {
          if (!e.body.Error) {
            _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          } else {
            _this.notifier("top", "right", "danger", e.body.Error);
          }
        });
      }
    },
    addNew: function addNew() {
      this.slider.unshift({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: "videogallery",
        order_number: null
      });
    },
    update: function update() {
      var _this2 = this;

      var newdis = this;

      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = "videogallery";
      });
      this.$http.post("/api/images/edit/", this.slider).then(function (response) {
        _this2.notifier("top", "right", "success", "Değişiklikler Kaydedildi");
        _this2.slider = [];
        _this2.getSlider();
      }, function (e) {
        if (!e.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this2.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    getSlider: function getSlider() {
      var _this3 = this;

      var url = "/api/images/get-with-type/videogallery";
      this.$http.get(url).then(function (response) {
        _this3.slider = response.body;
      }, function (er) {
        if (!er.body.Error) {
          _this3.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this3.err = er.body.Error;
          _this3.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    initiateCroppie: function initiateCroppie(id, i, n) {
      this.newVideo.image_id = id;
      this.newVideo.image_name = this.slugify(this.slider[i].title);
      this.newVideo.imageIndex = i;
      this.newVideo.n = n;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById("new-post").classList.contains("d-none")) {
        document.getElementById("new-post").classList.remove("d-none");
      } else {
        document.getElementById("new-post").classList.add("d-none");
      }
    },

    changeButtonText: function changeButtonText() {
      var i = this.newVideo.n === 0 ? "image" : "image2";
      var newvideo_id = this.newVideo.url.split('v=')[1];
      var ampersandPosition = newvideo_id.indexOf('&');
      if (ampersandPosition != -1) {
        newvideo_id = newvideo_id.substring(0, ampersandPosition);
      }
      this.slider[this.newVideo.imageIndex][i] = newvideo_id;
      this.hideCroppieModal();
      this.update();
    },

    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "videoModal");
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "mlwD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mouu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ads_vue__ = __webpack_require__("zeK9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d448de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ads_vue__ = __webpack_require__("1ZkG");
function injectStyle (ssrContext) {
  __webpack_require__("vIvT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ads_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d448de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ads_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mt4Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/leader'}}},[_c('button',{staticClass:"btn btn-info btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("İçerik")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/gallery'}}},[_c('button',{staticClass:"btn btn-warning btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Fotogaleri")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/pressgallery'}}},[_c('button',{staticClass:"btn btn-danger btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Yazılı Basın")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/articles'}}},[_c('button',{staticClass:"btn btn-success btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Başkanın Yazıları")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/articlesorder'}}},[_c('button',{staticClass:"btn btn-primary btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Yazı Sıralama")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/digital-press'}}},[_c('button',{staticClass:"btn btn-secondary btn-sm active mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Dijital Basın")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/leader/digital-press-order'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Dijital Basın Sıralama")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[(!_vm.err)?_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Tüm Yazılar\n      "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill float-md-right",attrs:{"title":"Yeni Sayfa Oluştur","to":{ path: '/leader/digital-press/add'},"tag":"li"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Yeni Yazı\n      ")])],1),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Sayfa")]),_vm._v(" "),_c('th',[_vm._v("URL")]),_vm._v(" "),_c('th',[_vm._v("Yayın Tarihi")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.url))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(item.created,"Do/MM/YYYY HH:mm:ss")))]),_vm._v(" "),_c('td',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"to":{ path: '/leader/digital-press/edit/'+item.id},"title":"Düzenle","tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-warning btn-fill btn-xs",attrs:{"to":{ path: '/leader/digital-press/slider/'+item.id},"title":"Slider","tag":"li"}},[_c('i',{staticClass:"fas fa-images"})]),_vm._v(" "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-success btn-fill btn-xs",attrs:{"to":{ path: '/leader/digital-press/gallery/'+item.id},"title":"Galeri","tag":"li"}},[_c('i',{staticClass:"far fa-image"})]),_vm._v(" "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-info btn-fill btn-xs",attrs:{"to":{ path: '/leader/digital-press/pdf/'+item.id},"title":"Pdf","tag":"li"}},[_c('i',{staticClass:"far fa-file-pdf"})]),_vm._v(" "),(item.status !== 4 )?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"deactivate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,4)}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(item.status === 4)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,1)}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e(),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-dark btn-fill",attrs:{"href":"#","title":"Okunma Sayısı"}},[_c('i',{staticClass:"fa fa-book"}),_vm._v(" "+_vm._s(item.readed))])],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n  "+_vm._s(_vm.err)+"\n")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mwiY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mz7H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("T73y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb4b0f7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("aGCs");
function injectStyle (ssrContext) {
  __webpack_require__("vw+w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb4b0f7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n0i5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("sj4t");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_086dadee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("tLUC");
function injectStyle (ssrContext) {
  __webpack_require__("rPO1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_086dadee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n7ME":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n8CO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isEdit: false,
      categories: null,
      category: {
        category_id: "",
        name: null,
        url: null,
        is_active: 1
      },
      subCategories: null,
      disableParent: false,
      errors: [],
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.category.name) {
        this.errors.push("Başlık");
      };
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      this.toggleLoader();
      if (this.isEdit) {
        this.updateCategory();
      } else {
        this.saveCategory();
      }
    },
    saveCategory: function saveCategory() {
      var _this = this;

      if (this.category.category_id === "") {
        if (this.subCategories !== null) {
          this.subCategories = this.subCategories.split(/\n/g);
          var sub_categories = [];
          for (var i = 0; i < this.subCategories.length; i++) {
            var subCategory = {
              name: this.subCategories[i],
              url: this.slugify(this.subCategories[i]) + '-' + Math.floor(Math.random() * (99999 - 0) + 0),
              is_active: 1
            };
            sub_categories.push(subCategory);
          }
          this.category.sub_categories = sub_categories;
        }
        this.category.url = this.slugify(this.category.name + '-' + Math.floor(Math.random() * (999 - 0) + 0));
        this.category.category_type = "reports";
        delete this.category.category_id;
        this.$http.post('/api/categories/add', this.category).then(function (response) {
          _this.notifier('top', 'right', 'success', 'Başarılı');
          _this.$router.push('/categories');
          _this.toggleLoader();
        }, function (e) {
          _this.toggleLoader();
          if (!e.body.Error) {
            _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          } else {
            _this.notifier('top', 'right', 'danger', e.body.Error);
          }
        });
      } else {
        this.category.url = this.slugify(this.category.name + '-' + Math.floor(Math.random() * (999 - 0) + 0));
        this.$http.post('/api/sub-categories/add', this.category).then(function (response) {
          _this.notifier('top', 'right', 'success', 'Başarılı');
          _this.$router.push('/categories');
          _this.toggleLoader();
        }, function (e) {
          _this.toggleLoader();
          if (!e.body.Error) {
            _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          } else {
            _this.notifier('top', 'right', 'danger', e.body.Error);
          }
        });
      }
    },
    updateCategory: function updateCategory() {
      var _this2 = this;

      if (this.category.category_id === "") {
        if (this.subCategories !== null) {
          this.subCategories = this.subCategories.split(/\n/g);
          var sub_categories = [];
          for (var i = 0; i < this.subCategories.length; i++) {
            var subCategory = {
              name: this.subCategories[i],
              url: this.slugify(this.subCategories[i]) + '-' + Math.floor(Math.random() * (99999 - 0) + 0),
              is_active: 1
            };
            sub_categories.push(subCategory);
          }
          this.category.sub_categories = sub_categories;
        }
        this.category.url = this.slugify(this.category.name + '-' + Math.floor(Math.random() * (999 - 0) + 0));
        delete this.category.category_id;
        this.category.category_type = "reports";
        this.$http.post('/api/categories/edit/' + this.$route.params.id, this.category).then(function (response) {
          _this2.notifier('top', 'right', 'success', 'Başarılı');
          _this2.$router.push('/categories');
          _this2.toggleLoader();
        }, function (e) {
          _this2.toggleLoader();
          if (!e.body.Error) {
            _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          } else {
            _this2.notifier('top', 'right', 'danger', e.body.Error);
          }
        });
      } else {
        this.category.url = this.slugify(this.category.name + '-' + Math.floor(Math.random() * (999 - 0) + 0));
        this.$http.post('/api/sub-categories/edit/' + this.$route.params.id, this.category).then(function (response) {
          _this2.notifier('top', 'right', 'success', 'Başarılı');
          _this2.$router.push('/categories');
          _this2.toggleLoader();
        }, function (e) {
          _this2.toggleLoader();
          if (!e.body.Error) {
            _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          } else {
            _this2.notifier('top', 'right', 'danger', e.body.Error);
          }
        });
      }
    },
    createUrl: function createUrl() {
      if (!isEdit) {
        this.category.url = this.slugify(this.category.name);
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var _this3 = this;

      this.toggleLoader();
      this.$http.get('/api/categories/all').then(function (response) {
        _this3.categories = response.body;
        if (_this3.$route.params.id && _this3.$route.params.type) {
          var controller = null;
          if (parseInt(_this3.$route.params.type)) {
            controller = 'sub-categories';
          } else {
            controller = 'categories';
            _this3.disableParent = true;
          }
          _this3.$http.get('/api/' + controller + '/get-without-joins/' + _this3.$route.params.id).then(function (response) {
            _this3.isEdit = true;
            _this3.category = response.body;
            delete _this3.category.sub_categories;
            if (controller === 'categories') {
              _this3.category.category_id = '';
            }
            _this3.toggleLoader();
          }, function (response) {
            _this3.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
            _this3.toggleLoader();
          });
        } else {
          _this3.toggleLoader();
        }
      }, function (er) {
        _this3.toggleLoader();
        _this3.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    });
  }
});

/***/ }),

/***/ "n8xk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("RleI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_655b416e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("RiXL");
function injectStyle (ssrContext) {
  __webpack_require__("3+FW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_655b416e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nB75":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: [{
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'homeslide',
        order_number: null
      }],
      err: null,
      selectedType: null,
      types: ['URL', 'Kategori', 'Alt Kategori', 'Yayın', 'Etiket'],
      options: [],
      sliderItems: null,
      newSliderImage: {
        cropped: null,
        image_id: null,
        image_name: null,
        imageIndex: null
      },
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier('top', 'right', 'danger', 'Slider Başarıyla silindi');
          _this.getSlider();
        }, function (e) {
          if (!e.body.Error) {
            _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          } else {
            _this.notifier("top", "right", "danger", e.body.Error);
          }
        });
      }
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post('/api/images/upload/' + this.newSliderImage.image_name + '-slider', this.newSliderImage).then(function (response) {
        var i = _this2.newSliderImage.n === 0 ? 'image' : 'image2';
        _this2.slider[_this2.newSliderImage.imageIndex][i] = response.body.Data.Response.name;
        _this2.toggleLoader();
        _this2.hideCroppieModal();
        _this2.update();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    addNew: function addNew() {
      this.slider.unshift({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'homeslide',
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = 'homeslide';
      });
      this.$http.post('/api/images/edit/', this.slider).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi');
        _this3.getSlider();
      }, function (e) {
        if (!e.body.Error) {

          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this3.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = '/api/images/homeslide';
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
        _this4.err = null;
      }, function (er) {

        if (!er.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this4.err = er.body.Error;
          _this4.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    initiateCroppie: function initiateCroppie(id, i, n) {
      this.newSliderImage.image_id = id;
      this.newSliderImage.image_name = this.slugify(this.slider[i].title);
      this.newSliderImage.imageIndex = i;
      this.newSliderImage.n = n;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {

      this.crop();
    },
    crop: function crop() {
      var _this5 = this;

      var dis = this;
      this.toggleLoader();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg' | 'png' | 'webp',
          backgroundColor: '#fff',
          size: {
            width: 1110,
            height: 465
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this5.newSliderImage.cropped = output;
          _this5.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "nEiz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nHgb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("QoKa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b214c6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("6cK5");
function injectStyle (ssrContext) {
  __webpack_require__("mlwD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b214c6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nJt6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        status: 1
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'News',
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeStatus: function changeStatus(id, status) {
      var _this = this;

      this.toggleLoader();
      this.post.status = status;
      this.$http.post('/api/posts/edit/' + id, this.post).then(function (response) {
        if (!status) {
          _this.notifier('top', 'right', 'warning', 'Sayfa Yayından Kaldırıldı');
        } else {
          _this.notifier('top', 'right', 'success', 'Sayfa Yayınlandı');
        }

        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();
        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this2 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Allnews';

      this.toggleLoader();
      this.type = t;
      var url = '/api/filter/posts/post-type/' + this.type + '/limit/' + this.limit + '/page/' + p;
      this.$http.get(url).then(function (response) {
        _this2.table = response.body.data;
        _this2.total = response.body.meta.total;
        _this2.page = p;
        _this2.pageCount = [];
        for (var i = 0; i < _this2.total / _this2.limit; i++) {
          _this2.pageCount.push(i + 1);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.toggleLoader();

        if (!er.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this2.err = er.body.Error;
          _this2.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "nS6x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nTpl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostModules_Races_Index_vue__ = __webpack_require__("KJSC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostsTable: __WEBPACK_IMPORTED_MODULE_0__PostModules_Races_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "nakg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ncti":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("Wlp/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1ef09de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("BJ9F");
function injectStyle (ssrContext) {
  __webpack_require__("vp1I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1ef09de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ndZT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("3XGD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68772188_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("0RVX");
function injectStyle (ssrContext) {
  __webpack_require__("RWTJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68772188_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nwHT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.name),expression:"category.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.category.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.category, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o/oS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Tesis Ekle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Alt Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.subtitle),expression:"post.subtitle"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.subtitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "subtitle", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Kutu Linki")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.link),expression:"post.link"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Link","aria-label":"Başlık","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "link", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3 d-flex flex-column align-items-end"},[_c('tinymce',{ref:"tm",class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("150 x 150 pixel")]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),(_vm.image.cropped)?_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.cropped}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":true,"viewport":{width: 480, height: 270, type: 'suare'},"boundary":{width: 640, height: 360},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o0oD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oGcg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oH+u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalPress_vue__ = __webpack_require__("AqsR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32ef17e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalPress_vue__ = __webpack_require__("ot/8");
function injectStyle (ssrContext) {
  __webpack_require__("qTdf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalPress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32ef17e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalPress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oHMb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 0,
        name: null,
        url: null,
        post_type: 'Haber',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          },
          meta4: {
            meta_key: 'view_count',
            meta_value: 0
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        file: null,
        cropped: null
      },
      sliderImage: {
        file: null,
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      },
      firstSlider: false
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.title) {
        this.errors.push("Başlık");
      };
      if (!this.post.url) {
        this.errors.push("URL");
      };
      if (!this.post.category_id) {
        this.errors.push("Kategori");
      };
      if (!this.post.sub_category_id) {
        this.errors.push("Alt Kategori");
      };
      if (!this.content.content) {
        this.errors.push("İçerik");
      };
      if (!this.image.cropped && !this.image.file) {
        this.errors.push("Resim");
      };
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
        _this.saveImage();
      });
    },
    saveImage: function saveImage() {
      var _this2 = this;

      if (this.image.cropped) {
        this.$http.post('/api/images/upload/' + this.post.url, this.image).then(function (response) {
          _this2.post.image = response.body.Data.Response.name;
          _this2.savePost();
        }, function (e) {
          button.innerHTML = 'Kaydet';
          _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this2.toggleLoader();
        });
      } else {
        this.savePost();
      }
    },
    saveDraft: function saveDraft() {
      var _this3 = this;

      this.toggleLoader();
      this.$http.post('/api/archive/edit/' + this.$route.params.id, this.post).then(function (response) {
        _this3.toggleLoader();
        _this3.$router.push('/archive');
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this3.toggleLoader();
      });
    },
    savePost: function savePost() {
      var _this4 = this;

      this.post.content = this.content;
      this.post.post_type = 'Haber';
      this.post.user_id = this.getCurrentUserDetails().id;
      this.post.name = this.post.title;
      this.post.status = 1;
      this.post.created = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.post.timestamp).format("YYYY-MM-D HH:mm:ss");
      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.title.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.metas.items.meta4.meta_value = this.post.hits;
      this.$http.post('/api/posts/add', this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this4.post.id = pid;
        _this4.slider.post_id = pid;
        _this4.slider.order_number = pid;
        _this4.metas.post_id = pid;
        _this4.saveMetas();
      }, function (e) {
        _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this4.toggleLoader();
      });
    },
    saveMetas: function saveMetas() {
      var _this5 = this;

      this.$http.post('/api/post-metas/add-bulk', this.metas).then(function (response) {
        _this5.saveURL();
      }, function (e) {
        _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this5.toggleLoader();
      });
    },
    saveURL: function saveURL() {
      var _this6 = this;

      this.post.url !== this.url.name + '-' + this.post.id;
      if (this.post.url !== this.url.name + '-' + this.post.id) {
        this.url.name = this.post.url;
        this.$http.post('/api/urls/add', this.url).then(function (response) {
          _this6.deleteFromArchive();
        }, function (e) {
          _this6.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this6.toggleLoader();
        });
      } else {
        this.deleteFromArchive();
      }
    },
    deleteFromArchive: function deleteFromArchive() {
      var _this7 = this;

      this.$http.post('/api/archive/delete/' + this.$route.params.id).then(function (response) {
        _this7.notifier('top', 'right', 'success', 'Başarılı');
        _this7.$router.push('/archive');
        _this7.toggleLoader();
      }, function (e) {
        _this7.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this7.toggleLoader();
      });
    },
    getInitialData: function getInitialData() {
      var _this8 = this;

      this.toggleLoader();
      this.$http.get('/api/categories/all').then(function (response) {
        _this8.categories = response.body;
        _this8.$http.get('/api/archive/get/' + _this8.id).then(function (response) {

          _this8.post = response.body;
          _this8.post.timestamp = __WEBPACK_IMPORTED_MODULE_3_moment___default()(_this8.post.timestamp).format("YYYY-MM-D HH:mm:ss");
          _this8.content.content = _this8.post.detail;
          _this8.showOnSlider = false;
          _this8.$http.get('/api/filter/sub-categories/limit/1000000/page/1/category-id/' + _this8.post.category_id).then(function (response) {
            _this8.subCategories = response.body.data;
            _this8.toggleLoader();
          }, function (er) {
            _this8.toggleLoader();
            _this8.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
          });
        }, function (er) {
          _this8.toggleLoader();
          _this8.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
          return;
        });
      }, function (er) {
        _this8.toggleLoader();
        _this8.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    },
    getSubCategories: function getSubCategories() {
      var _this9 = this;

      this.toggleLoader();
      this.$http.get('/api/filter/sub-categories/limit/1000000/page/1/category-id/' + this.post.category_id).then(function (response) {
        _this9.subCategories = response.body.data;
        document.getElementById('sub-category').removeAttribute('disabled');
        _this9.toggleLoader();
      }, function (er) {
        _this9.toggleLoader();
        _this9.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.title);
    },
    slugifyUrl: function slugifyUrl() {
      this.announcement.url = this.slugify(this.announcement.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this10 = this;

        request.$http.get('/api/filter/urls/name/' + request.post.url).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this10.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      this.croppieType = type;
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this11 = this;

      var dis = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: 1920,
            height: 1080
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this11.croppieType === 'main') {
            dis.image.cropped = output;
            document.getElementById('main-i').src = dis.image.cropped;
          } else if (_this11.croppieType === 'slider') {
            dis.sliderImage.cropped = output;
            dis.sliderImageLoaded = true;
            document.getElementById('slider-i').src = dis.sliderImage.cropped;
          }
          _this11.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.getInitialData();
  }
});

/***/ }),

/***/ "oQc+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      featuredTitles: [{
        key: "bellow_slider_1",
        title: null,
        details: null,
        link: null,
        image: null
      }, {
        key: "bellow_slider_2",
        title: null,
        details: null,
        link: null,
        image: null
      }, {
        key: "bellow_slider_3",
        title: null,
        details: null,
        link: null,
        image: null
      }],
      slider: {
        post_id: null,
        slider_group: "DigitalPress",
        order_number: null,
        is_active: 1
      },
      selectedType: null,
      types: ["URL", "Kategori", "Alt Kategori", "Yayın", "Etiket"],
      options: [],
      sliderItems: null,
      newFeaturedImage: {
        featured_id: null,
        cropped: null
      },
      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "all",
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      this.toggleLoader();
      this.$http.delete("/api/slider/delete/" + id).then(function (response) {
        _this.notifier("top", "right", "warning", "Menu elemanı silindi");
        _this.getSlider();
        _this.toggleLoader();
      }, function (e) {
        _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this.toggleLoader();
      });
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post("/api/images/upload/boxes-under-slider-" + this.newFeaturedImage.id, this.newFeaturedImage).then(function (response) {
        _this2.featuredTitles[_this2.newFeaturedImage.id].image = response.body.Data.Response.name;
        _this2.hideCroppieModal();
        document.getElementById("submit-image").innerHTML = "Kaydet";
        _this2.toggleLoader();
      }, function (e) {
        _this2.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this2.toggleLoader();
      });
    },
    loadItems: function loadItems() {
      var _this3 = this;

      this.options = [];
      this.toggleLoader();
      var url = "/api/posts/latest";
      this.$http.get(url).then(function (response) {
        response = response.body;
        for (var i = 0; i < response.length; i++) {
          var temp = { value: response[i].id, text: response[i].name };
          _this3.options.push(temp);
        }
        _this3.toggleLoader();
      }, function (er) {
        _this3.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        _this3.toggleLoader();
      });
    },
    loadFeaturedTitles: function loadFeaturedTitles() {
      var _this4 = this;

      this.toggleLoader();
      this.$http.get("/api/settings/get-featured-under-slider").then(function (response) {
        var settings = response.body;
        _this4.featuredTitles = [];
        for (var i = 0; i < settings.length; i++) {
          var jsonData = JSON.parse(settings[i].data);
          jsonData.key = "bellow_slider_" + (i + 1);
          _this4.featuredTitles.push(jsonData);
        }
        _this4.toggleLoader();
      }, function (er) {
        _this4.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        _this4.toggleLoader();
      });
    },
    update: function update(id) {
      var _this5 = this;

      this.$http.post("/api/slider/edit/", this.sliderItems).then(function (response) {
        _this5.notifier("top", "right", "success", "Sıralama güncellendi");
      }, function (e) {
        if (!e.body.Error) {
          _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this5.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    save: function save(id) {
      var _this6 = this;

      this.toggleLoader();
      this.$http.post("/api/slider/add/DigitalPress", this.slider).then(function (response) {
        _this6.getSlider();
        _this6.toggleLoader();
        _this6.notifier("top", "right", "success", "Başarılı");
      }, function (e) {
        _this6.toggleLoader();
        if (!e.body.Error) {
          _this6.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this6.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveSettings: function saveSettings() {
      var _this7 = this;

      this.toggleLoader();
      this.$http.post("/api/settings/edit-bulk/", this.featuredTitles).then(function (response) {
        _this7.toggleLoader();
        _this7.notifier("top", "right", "success", "Başarılı");
      }, function (e) {
        _this7.toggleLoader();
        _this7.notifier("top", "right", "danger", "Bir Hata Oluştu");
      });
    },
    getSlider: function getSlider() {
      var _this8 = this;

      this.toggleLoader();
      var url = "/api/slider/all/DigitalPress";
      this.$http.get(url).then(function (response) {
        _this8.sliderItems = response.body;
        if (_this8.sliderItems.length > 0) {
          _this8.slider.order_number = _this8.sliderItems[0].order_number + 1;
          _this8.slider.post_id = 0;
        } else {
          _this8.slider.order_number = 0;
        }
        _this8.toggleLoader();
      }, function (er) {
        _this8.toggleLoader();
        if (!er.body.Error) {
          _this8.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this8.err = er.body.Error;
          _this8.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    initiateCroppie: function initiateCroppie(id) {
      this.newFeaturedImage.id = id;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById("new-post").classList.contains("d-none")) {
        document.getElementById("new-post").classList.remove("d-none");
      } else {
        document.getElementById("new-post").classList.add("d-none");
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {
      document.getElementById("submit-image").innerHTML = "<i class='fas fa-circle-notch fa-spin'></i>";
      this.crop();
    },
    crop: function crop() {
      var _this9 = this;

      var dis = this;
      this.toggleLoader();
      var color = "#e17d00";
      if (this.newFeaturedImage.id === 0) {
        color = "#dc3545";
      } else if (this.newFeaturedImage.id === 1) {
        color = "#17a2b8";
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: "jpeg",
          size: {
            width: 277,
            height: 244
          },
          backgroundColor: color,
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this9.newFeaturedImage.cropped = output;
          _this9.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
      this.loadItems();
      this.loadFeaturedTitles();
    });
  }
});

/***/ }),

/***/ "oTup":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostModules_BankInformations_Index_vue__ = __webpack_require__("zzQR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__PostModules_BankInformations_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "ob/Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ot/8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('posts-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ouHw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("/Iak");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6e8b07c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("5Guz");
function injectStyle (ssrContext) {
  __webpack_require__("kRT6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6e8b07c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p0VG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      settings: {
        name: null,
        meta: {
          title: null
        },
        data: null
      },
      imageIndex: -1,
      image: {
        cropped: null
      },
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      },
      err: null
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    getSettings: function getSettings() {
      var _this = this;

      this.toggleLoader();
      this.$http.get("/api/settings/get-coming-from-you/").then(function (response) {
        _this.settings = response.body;
        _this.settings.meta = JSON.parse(_this.settings.meta);

        // for (var i = 0; i < this.settings.length; i++) {
        //   this.settings[i].meta = JSON.parse(this.settings[i].meta);
        // }

        _this.toggleLoader();
      }, function (er) {
        if (!er.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this.err = er.body.Error;
          _this.notifier('top', 'right', 'danger', er.body.Error);
        }
        _this.toggleLoader();
      });
    },
    submit: function submit() {
      var _this2 = this;

      event.preventDefault();
      this.$http.post("/api/settings/update-one/", this.settings).then(function (response) {
        _this2.notifier("top", "right", "success", "Başarıyla güncellendi");
        _this2.getSettings();
      }, function (e) {
        if (!e.body.Error) {
          _this2.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        } else {
          _this2.notifier("top", "right", "danger", e.body.Error);
        }
      });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSettings();
    });
  }
});

/***/ }),

/***/ "pJnW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pNyA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComingFromYouContent_vue__ = __webpack_require__("8sm4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f05d458e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComingFromYouContent_vue__ = __webpack_require__("NhH7");
function injectStyle (ssrContext) {
  __webpack_require__("Gp7W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComingFromYouContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f05d458e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComingFromYouContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pUEq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("\n                Haberler Pdf\n                "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"mr-2 btn btn-danger btn-sm btn-fill",on:{"click":function($event){return _vm.addNew()}}},[_vm._v("Ekle")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm btn-fill",on:{"click":function($event){return _vm.update()}}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"row w-100"},[_c('div',{staticClass:"col-12 col-md-2 d-flex align-items-center"},[_c('button',{staticClass:"btn btn-warning activebtn-s mr-2 px-2",attrs:{"disabled":!item.image,"type":"submit"}},[(item.image)?_c('a',{staticClass:"text-warning",attrs:{"href":_vm.generalURL('haberler')+item.image,"target":"_blank"}},[_vm._v("PDF AÇ")]):_vm._e(),_vm._v(" "),(!item.image)?_c('span',{staticClass:"text-danger text-light pdf-alert-text"},[_vm._v("Pdf Yüklenmedi")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-9"},[_c('label',[_vm._v("Açıklama")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.target_url),expression:"item.target_url"}],staticClass:"form-control",attrs:{"type":"text","name":""},domProps:{"value":(item.target_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "target_url", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{staticClass:"btn btn btn-sm",attrs:{"title":"PDF Değiştir"},on:{"click":function($event){return _vm.myPdf(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('input',{ref:"pdf",refInFor:true,staticClass:"m-3",staticStyle:{"display":"none"},attrs:{"name":"myFile","id":'myPdf'+index,"type":"file"},on:{"change":function($event){return _vm.upload($event)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])])])])])])}),0)],1)],1)])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pk3h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticlesOrder_vue__ = __webpack_require__("6sYh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4d1a342_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticlesOrder_vue__ = __webpack_require__("m/di");
function injectStyle (ssrContext) {
  __webpack_require__("1Dgy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticlesOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4d1a342_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticlesOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pkPW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "po1X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostModules_Facilities_Index_vue__ = __webpack_require__("1YMZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostsTable: __WEBPACK_IMPORTED_MODULE_0__PostModules_Facilities_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "q0Ix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q0PG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__("uAhs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7f4a480_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__("y0U8");
function injectStyle (ssrContext) {
  __webpack_require__("vW6o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7f4a480_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q4qH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qI8Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      settings: {
        name: null,
        meta: {
          title: null
        },
        data: null
      },
      err: null,
      file: null,
      imageIndex: -1,
      image: {
        cropped: null
      },
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    generatePreview: function generatePreview() {
      if (this.$refs.video) {
        this.$refs.video.innerHTML = '';
        var video = document.createElement('video');
        var source = document.createElement('source');
        source.type = 'video/mp4';
        source.src = this.generalURL('introvideo') + this.settings.data;
        video.appendChild(source);
        video.controls = true;
        video.loop = true;
        video.load();
        video.play();
        this.$refs.video.appendChild(video);
      }
    },
    getSettings: function getSettings() {
      var _this = this;

      this.toggleLoader();
      this.$http.get("/api/settings/get-intro-video/").then(function (response) {
        _this.settings = response.body;
        _this.settings.meta = JSON.parse(_this.settings.meta);
        _this.generatePreview();
        // for (var i = 0; i < this.settings.length; i++) {
        //   this.settings[i].meta = JSON.parse(this.settings[i].meta);
        // }

        _this.toggleLoader();
      }, function (er) {

        if (!er.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this.err = er.body.Error;
          _this.notifier('top', 'right', 'danger', er.body.Error);
        }
        _this.toggleLoader();
      });
    },
    uploadVideo: function uploadVideo(event) {
      var _this2 = this;

      this.file = event.target.files[0];
      if (!(this.file.type === "video/mpeg" || this.file.type === "video/webm" || this.file.type === "video/mp4" || this.file.type === "video/quicktime")) {
        this.notifier("top", "right", "danger", "Lütfen mp4 formatında bir dosya seçiniz");
      } else {
        var data = new FormData();
        data.append("file", this.file);
        var fileName = this.file.name.split(".");
        var extension = "";
        var newName = "";
        fileName.forEach(function (e, index) {
          if (index < fileName.length - 1) {
            newName += e;
          }
          if (index == fileName.length - 1) {
            extension += e;
          }
        });
        newName = this.slugify(newName);
        newName += new Date().getTime();
        var fullName = newName + "." + extension;
        this.settings.data = fullName;
        data.append("fileName", fullName);
        this.notifier("top", "right", "warning", "Dosya yüklenirken lütfen bekleyiniz.Yüklemeden sonra sayfa yenilenecektir");
        this.$http.post("api/files/upload-intro-video/" + fullName, data).then(function (response) {
          _this2.notifier("top", "right", "success", "Video başarıyla kaydedildi");
          _this2.submit();
          // this.$router.go();
        }, function (er) {
          if (!er.body.Error) {
            _this2.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
          } else {
            _this2.notifier("top", "right", "danger", er.body.Error);
          }
        });
      }
    },
    submit: function submit() {
      var _this3 = this;

      event.preventDefault();
      this.$http.post("/api/settings/update-one/", this.settings).then(function (response) {
        _this3.notifier("top", "right", "success", "Başarıyla güncellendi");
        _this3.getSettings();
      }, function (e) {
        _this3.notifier("top", "right", "danger", "Bir Hata Oluştu");
      });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSettings();
    });
  }
});

/***/ }),

/***/ "qNYv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qSbS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qTdf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qVTn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qWp6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StaffsModules_Staffs_vue__ = __webpack_require__("2ByX");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__StaffsModules_Staffs_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "qbM9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEdit_vue__ = __webpack_require__("403M");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39d132d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEdit_vue__ = __webpack_require__("D3dw");
function injectStyle (ssrContext) {
  __webpack_require__("j7pr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39d132d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qg9l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReportModules_Index_vue__ = __webpack_require__("1L4k");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    IndexTable: __WEBPACK_IMPORTED_MODULE_0__ReportModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "qgkf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qvnn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SettingModules_Index_vue__ = __webpack_require__("751y");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__SettingModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "qwHR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qwbg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        is_subscribed: 0
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    deactivate: function deactivate(id) {
      var _this = this;

      this.toggleLoader();
      this.post.is_subscribed = 0;
      this.$http.post('/api/newsletter/edit/' + id, this.post).then(function (response) {
        _this.notifier('top', 'right', 'warning', 'Abonelik İptal Edildi');
        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this.toggleLoader();
      });
    },
    activate: function activate(id) {
      var _this2 = this;

      this.toggleLoader();
      this.post.is_subscribed = 1;
      this.$http.post('/api/newsletter/edit/' + id, this.post).then(function (response) {
        _this2.notifier('top', 'right', 'success', 'Abonelik Aktif Edildi');
        _this2.getPosts(_this2.page, _this2.type);
        _this2.toggleLoader();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this3 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';

      this.toggleLoader();
      this.type = t;
      var url = '/api/filter/newsletter/limit/' + this.limit + '/page/' + p;

      this.$http.get(url).then(function (response) {
        _this3.table = response.body.data;
        _this3.total = response.body.meta.total;
        _this3.page = p;
        _this3.pageCount = [];
        console.log(response.body);
        for (var i = 0; i < _this3.total / _this3.limit; i++) {
          _this3.pageCount.push(i + 1);
        }
        _this3.toggleLoader();
      }, function (er) {
        _this3.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        _this3.toggleLoader();
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "r/6C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: {
        status: 1
      },
      table: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'Homeinfos',
      viewCounts: [],
      err: null
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    changeStatus: function changeStatus(id, status) {
      var _this = this;

      this.toggleLoader();
      this.post.status = status;
      this.$http.post('/api/posts/edit/' + id, this.post).then(function (response) {
        if (!status) {
          _this.notifier('top', 'right', 'warning', 'Sayfa Yayından Kaldırıldı');
        } else {
          _this.notifier('top', 'right', 'success', 'Sayfa Yayınlandı');
        }

        _this.getPosts(_this.page, _this.type);
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();
        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    isInScope: function isInScope(c) {
      if (c === 1) {
        return true;
      }
      if (c === this.pageCount.length) {
        return true;
      }
      if (c - this.page > 3 || this.page - c > 3) {
        return false;
      }
      return true;
    },
    isActive: function isActive(v) {
      return v === this.page;
    },
    isFirst: function isFirst() {
      return this.page === 1;
    },
    isLast: function isLast() {
      return this.page === Math.ceil(this.total / this.limit);
    },
    getPosts: function getPosts() {
      var _this2 = this;

      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Homeinfos';

      this.toggleLoader();
      this.type = t;
      var url = '/api/filter/posts/post-type/' + this.type + '/limit/' + this.limit + '/page/' + p;
      this.$http.get(url).then(function (response) {
        _this2.table = response.body.data;
        _this2.total = response.body.meta.total;
        _this2.page = p;
        _this2.pageCount = [];
        for (var i = 0; i < _this2.total / _this2.limit; i++) {
          _this2.pageCount.push(i + 1);
        }
        _this2.toggleLoader();
      }, function (er) {
        _this2.toggleLoader();

        if (!er.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this2.err = er.body.Error;
          _this2.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "r/j7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r/nR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n    Tüm Eğitimler \n    "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill float-md-right",attrs:{"title":"Yeni Sayfa Oluştur","to":{ path: 'education/add'},"tag":"li"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Yeni Eğitim")])],1),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Sayfa")]),_vm._v(" "),_c('th',[_vm._v("URL")]),_vm._v(" "),_c('th',[_vm._v("Yayın Tarihi")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.url))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(item.created,"Do/MM/YYYY HH:mm:ss"))+" ")]),_vm._v(" "),_c('td',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"to":{ path: 'education/edit/'+item.id},"title":"Düzenle","tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"#","title":"Önizleme"}},[_c('i',{staticClass:"fas fa-eye"}),_vm._v(" "+_vm._s(item.view_count))]),_vm._v(" "),(item.status !== 4 )?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"deactivate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,4)}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(item.status === 4)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,1)}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e(),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-dark btn-fill",attrs:{"href":"#","title":"Yorumlar"}},[_c('i',{staticClass:"far fa-comment-alt"}),_vm._v(" "+_vm._s(item.commentCount))])],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r4dt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__("hn6S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_683dd849_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__("BZxW");
function injectStyle (ssrContext) {
  __webpack_require__("WDWs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_683dd849_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r5Uy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_c('drop-down',{attrs:{"tag":"li"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"nc-icon nc-support-17"}),_vm._v(" "),_c('b',{staticClass:"caret"}),_vm._v(" "),_c('span',{staticClass:"notification"},[_vm._v("5")]),_vm._v(" Bildirim\n        ")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Notification 1")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Notification 2")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Notification 3")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Notification 4")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Another notification")])],2),_vm._v(" "),_c('drop-down',{attrs:{"tag":"li"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"nc-icon nc-circle-09"}),_vm._v(" Hesabim\n          "),_c('b',{staticClass:"caret"})]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Profilim")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Ayarlarım")])],2),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#pablo"}},[_c('span',{staticClass:"nc-button-power"},[_vm._v("Çıkış")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r5cG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("wHvC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eaa33c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("Al/j");
function injectStyle (ssrContext) {
  __webpack_require__("9XOi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eaa33c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rBzL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/gallery'}}},[_c('button',{staticClass:"btn btn-info  btn-sm  px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Galeri")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/video-gallery'}}},[_c('button',{staticClass:"btn btn-warning active text-white btn-sm mr-3 px-3",attrs:{"type":"submit"}},[_vm._v("Video Galeri")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('div',{staticClass:"row"},[(!_vm.err)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("\n                 Video Galeri\n                 "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"mr-2 btn btn-danger btn-sm btn-fill",on:{"click":function($event){return _vm.addNew()}}},[_vm._v("Ekle")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm btn-fill",on:{"click":function($event){return _vm.update()}}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-11"},[_c('div',{staticClass:"videos"},[_c('youtube',{attrs:{"video-id":item.image}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.videoModal",modifiers:{"videoModal":true}},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn btn-sm",attrs:{"title":"Video Değiştir"},on:{"click":function($event){return _vm.initiateCroppie(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])])])])])])}),0)],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n         "+_vm._s(_vm.err)+"\n       ")]):_vm._e()]),_vm._v(" "),_c('b-modal',{attrs:{"id":"videoModal","hide-footer":"","size":"lg","title":"Video Url'si"}},[_c('div',{staticClass:"d-flex flex-column"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newVideo.url),expression:"newVideo.url"}],staticClass:"m-3",attrs:{"name":"myVideo","id":"myImage","type":"text"},domProps:{"value":(_vm.newVideo.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newVideo, "url", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row justify-content-around"},[_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rPO1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rPrJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: {
        is_active: 0
      },
      err: null,
      categories: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    deactivate: function deactivate(id, type) {
      var _this = this;

      this.toggleLoader();
      this.category.is_active = 0;
      this.$http.post('/api/' + type + '/edit/' + id, this.category).then(function (response) {
        _this.notifier('top', 'right', 'warning', 'Kategori Yayından Kaldırıldı');
        _this.getPosts();
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();
        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    remove: function remove(id, type) {
      var _this2 = this;

      this.toggleLoader();
      this.$http.post('/api/' + type + '/delete/' + id, this.category).then(function (response) {
        _this2.notifier('top', 'right', 'warning', 'Kategori Silindi');
        _this2.getPosts();
        _this2.toggleLoader();
      }, function (e) {
        _this2.toggleLoader();
        if (!e.body.Error) {
          _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this2.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    activate: function activate(id, type) {
      var _this3 = this;

      this.toggleLoader();
      this.category.is_active = 1;
      this.$http.post('/api/' + type + '/edit/' + id, this.category).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Kategori Yayına Alındı');
        _this3.getPosts();
        _this3.toggleLoader();
      }, function (e) {
        _this3.toggleLoader();
        if (!e.body.Error) {
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this3.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },

    getPosts: function getPosts() {
      var _this4 = this;

      this.toggleLoader();
      var url = '/api/categories/all-with-joins/';
      this.$http.get(url).then(function (response) {
        _this4.categories = response.body;
        _this4.toggleLoader();
      }, function (er) {
        _this4.toggleLoader();

        if (!er.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this4.err = er.body.Error;
          _this4.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "rRCd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('index-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rS5H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostModules_InformationBanksPage_Index_vue__ = __webpack_require__("7583");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__PostModules_InformationBanksPage_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "rWyS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'Haber',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        file: null,
        cropped: null
      },
      sliderImage: {
        file: null,
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      },
      firstSlider: false
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      };
      if (!this.post.url) {
        this.errors.push("URL");
      };
      if (!this.content.content) {
        this.errors.push("İçerik");
      };
      if (!this.image.cropped && !this.image.file) {
        this.errors.push("Resim");
      };
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this = this;

      this.toggleLoader();
      if (this.post.url !== this.url.name) {
        this.validateUrl().then(function (resolve) {
          document.getElementById('url').classList.add('is-invalid');
          document.getElementById('url').classList.remove('is-valid');
          document.getElementById('url-label').classList.add('is-invalid');
          document.getElementById('url-label').classList.remove('is-valid');
          _this.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
          _this.toggleLoader();
        }).catch(function (er) {
          var button = event.target;
          button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
          _this.saveImage();
        });
      } else {
        this.saveImage();
      }
    },
    saveImage: function saveImage() {
      var _this2 = this;

      if (this.image.cropped) {
        this.$http.post('/api/images/upload/' + this.post.url, this.image).then(function (response) {
          _this2.post.image = response.body.Data.Response.name;
          _this2.savePost();
        }, function (e) {
          button.innerHTML = 'Kaydet';
          _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this2.toggleLoader();
        });
      } else {
        this.savePost();
      }
    },
    savePost: function savePost() {
      var _this3 = this;

      this.post.comments = null;
      this.post.menus = null;
      this.post.slider = null;
      this.tempMetas = this.post.post_metas;
      this.post.post_metas = null;
      this.post.post_tags = null;
      this.post.category = null;
      this.post.sub_category = null;
      this.post.user = null;
      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.$http.post('/api/posts/edit/' + this.post.id, this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this3.post.id = pid;
        _this3.slider.post_id = pid;
        _this3.slider.order_number = pid;
        _this3.metas.post_id = pid;
        _this3.saveMetas(null);
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this3.toggleLoader();
      });
    },
    saveMetas: function saveMetas(image) {
      var _this4 = this;

      if (image !== null) {
        var mid = null;
        if (this.post.hasOwnProperty('meta_slider_image')) {
          mid = this.tempMetas[this.post.meta_slider_image].id;
        }
        this.metas.items.meta1 = {
          meta_id: mid,
          meta_key: 'slider_image',
          meta_value: image
        };
      }
      this.$http.put('/api/post-metas/edit-bulk/', this.metas).then(function (response) {
        _this4.notifier('top', 'right', 'success', 'Başarılı');
        _this4.$router.push('/static-pages');
        _this4.toggleLoader();
      }, function (e) {
        _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this4.toggleLoader();
      });
    },
    getInitialData: function getInitialData() {
      var _this5 = this;

      this.toggleLoader();
      this.$http.get('/api/posts/get/' + this.id).then(function (response) {
        _this5.post = response.body;
        _this5.content = _this5.post.content;
        _this5.image.file = _this5.mediaURL() + _this5.post.image;
        if (_this5.post.slider.length) {
          _this5.showOnSlider = true;
        } else {
          _this5.showOnSlider = false;
        }
        if (_this5.post.video !== null) {
          _this5.video = _this5.post.video;
        }
        if (_this5.post.hasOwnProperty('meta_slider_image')) {
          _this5.sliderImage.file = _this5.mediaURL() + _this5.post.post_metas[_this5.post.meta_slider_image].meta_value;
        }
        if (_this5.post.slider == null) {
          _this5.firstSlider = true;
        }
        _this5.post.url = _this5.post.url.split('-')[0];
        _this5.url.name = _this5.post.url;
        _this5.metas = {
          post_id: _this5.post.id,
          items: {
            meta2: {
              meta_id: _this5.post.post_metas[_this5.post.meta_title].id,
              meta_key: 'title',
              meta_value: _this5.post.post_metas[_this5.post.meta_title].meta_value
            },
            meta3: {
              meta_id: _this5.post.post_metas[_this5.post.meta_description].id,
              meta_key: 'description',
              meta_value: _this5.post.post_metas[_this5.post.meta_description].meta_value
            }
          }
        };
        _this5.toggleLoader();
      }, function (er) {
        _this5.toggleLoader();
        _this5.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    },
    getSubCategories: function getSubCategories() {
      var _this6 = this;

      this.toggleLoader();
      this.$http.get('/api/filter/sub-categories/category-id/' + this.post.category_id).then(function (response) {
        _this6.subCategories = response.body.data;
        document.getElementById('sub-category').removeAttribute('disabled');
        _this6.toggleLoader();
      }, function (er) {
        _this6.toggleLoader();
        _this6.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name);
    },
    slugifyUrl: function slugifyUrl() {
      this.announcement.url = this.slugify(this.announcement.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this7 = this;

        request.$http.get('/api/filter/urls/name/' + request.post.url).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this7.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      this.croppieType = type;
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this8 = this;

      var dis = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: 1920,
            height: 1080
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this8.croppieType === 'main') {
            dis.image.cropped = output;
            document.getElementById('main-i').src = dis.image.cropped;
          } else if (_this8.croppieType === 'slider') {
            dis.sliderImage.cropped = output;
            dis.sliderImageLoaded = true;
            document.getElementById('slider-i').src = dis.sliderImage.cropped;
          }
          _this8.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.getInitialData();
  }
});

/***/ }),

/***/ "rbdJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[(!_vm.err)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-7"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',[_vm._v("Vitrin\n            "),_c('small',{staticClass:"text-info"},[_vm._v("Haberlerin sıralamasını değiştirmek için sürükleyin. En üstteki 12 Haber yayında olacak")])]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.sliderItems),callback:function ($$v) {_vm.sliderItems=$$v},expression:"sliderItems"}},[_c('transition-group',_vm._l((_vm.sliderItems),function(item,index){return _c('div',{key:item.id},[_c('div',{staticClass:"card mb-2 menu-item",class:{ 'bg-gray': index > 11 }},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-8 d-flex align-items-center"},[_vm._v(_vm._s(item.post.name))]),_vm._v(" "),_c('div',{staticClass:"col-4 d-flex justify-content-end align-items-center"},[_c('div',[_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Sil"},on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])])])])])])}),0)],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-5"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',[_vm._v("Ekle")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_c('model-select',{staticClass:"form-control",attrs:{"options":_vm.options,"placeholder":"Yayın"},model:{value:(_vm.slider.post_id),callback:function ($$v) {_vm.$set(_vm.slider, "post_id", $$v)},expression:"slider.post_id"}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill mt-3",on:{"click":function($event){return _vm.save()}}},[_vm._v("Ekle")])])])])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n    "+_vm._s(_vm.err)+"\n  ")]):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('p',{staticClass:"text-danger mb-0"},[_vm._v("Genişlik(277) Yükseklik(244). PNG ve arkası şeffaf olacak şekilde")]),_vm._v(" "),_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 277, height: 244, type: 'suare'},"boundary":{width: 400, height: 400},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rg9P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "riT3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inspect_vue__ = __webpack_require__("Ie5C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb838d10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inspect_vue__ = __webpack_require__("Sffr");
function injectStyle (ssrContext) {
  __webpack_require__("nS6x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inspect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb838d10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inspect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rm2T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Arşiv")]),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Başlık")]),_vm._v(" "),_c('th',[_vm._v("Tarih")]),_vm._v(" "),_c('th',[_vm._v("Okunma Sayısı")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(item.timestamp,"Do/MM/YYYY HH:mm:ss")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.hits))]),_vm._v(" "),_c('td',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"to":{ path: 'archive/edit/'+item.id},"title":"Düzenle","tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-danger btn-fill btn-xs",attrs:{"title":"Sil"},on:{"click":function($event){return _vm.deactivate(item.id)}}},[_c('i',{staticClass:"fas fa-times"})])],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rnf2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rp+z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,

      // post data
      race: {
        id: null,
        athletes: null,
        general_music: null,
        document: null,
        club_list: null,
        extra_documents: null,
        status: null,
        notes: null,
        club_name: null,
        email: null,
        phone: null,
        full_name: null
      },
      errors: []
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.race.notes) {
        this.errors.push("İçerik");
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this = this;

      if (this.race.status == 5 || this.race.status == 6 || this.race.status == 7) {
        this.race.status = 6;
      } else {

        this.race.status = 2;
      }
      this.$http.post("/api/race/edit/" + this.race.id, this.race).then(function (response) {
        _this.sendMail();
      }, function (e) {

        if (!e.body.Error) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    sendMail: function sendMail() {
      var _this2 = this;

      this.$http.post("/api/race/send-rev-mail/" + this.race.id, this.race).then(function (response) {
        _this2.notifier("top", "right", "success", "Başarılı");
        _this2.$router.push("/race-applications/" + _this2.race.post_id);
      }, function (e) {
        _this2.notifier("top", "right", "danger", "Bir Hata Oluştu");
      });
    },
    getInitialData: function getInitialData() {
      var _this3 = this;

      this.toggleLoader();
      this.$http.get("/api/race/get/" + this.id).then(function (response) {
        _this3.race = response.body;

        _this3.toggleLoader();
      }, function (er) {
        _this3.toggleLoader();
        _this3.notifier("top", "right", "danger", "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        return;
      });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getInitialData();
    });
  }
});

/***/ }),

/***/ "rqLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("T6lL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e2a4751_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("YGN6");
function injectStyle (ssrContext) {
  __webpack_require__("hP3b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e2a4751_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rxXD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/main'}}},[_c('button',{staticClass:"btn btn-danger  btn-sm  px-2 mr-2",attrs:{"type":"submit"}},[_vm._v("Anasayfa Slider")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/intro-video'}}},[_c('button',{staticClass:"btn btn-primary btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("İntro Videosu")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/homeboxes'}}},[_c('button',{staticClass:"btn btn-info  btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Anasayfa Kutular")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/homeinfos'}}},[_c('button',{staticClass:"btn btn-warning text-white active btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Anasayfa Bilgiler")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/announcements'}}},[_c('button',{staticClass:"btn btn-success btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Anasayfa Duyurular")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[(!_vm.err)?_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Anasayfa Bilgiler\n      "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill float-md-right",attrs:{"title":"Yeni Sayfa Oluştur","to":{ path: 'homeinfos/add'},"tag":"li"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Yeni Bilgi")])],1),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Sayfa")]),_vm._v(" "),_c('th',[_vm._v("Yayın Tarihi")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(item.created,"Do/MM/YYYY HH:mm:ss"))+" ")]),_vm._v(" "),_c('td',{staticClass:"d-flex justify-content-around align-items-center"},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"to":{ path: 'homeinfos/edit/'+item.id},"title":"Düzenle","tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),(item.status !== 4 )?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"deactivate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,4)}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(item.status === 4)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.changeStatus(item.id,1)}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e()],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return (_vm.isInScope(current))?_c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current), 'mr-2': current == 1, 'ml-2': current == _vm.pageCount.length}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])]):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n"+_vm._s(_vm.err)+"\n")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rzJ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Educations_vue__ = __webpack_require__("5tTk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6338a197_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Educations_vue__ = __webpack_require__("frfY");
function injectStyle (ssrContext) {
  __webpack_require__("1S5a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Educations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6338a197_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Educations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s/j1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Featured_vue__ = __webpack_require__("RQHz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2199f047_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Featured_vue__ = __webpack_require__("rbdJ");
function injectStyle (ssrContext) {
  __webpack_require__("PtIP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Featured_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2199f047_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Featured_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s0if":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComingFromYou_vue__ = __webpack_require__("096f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61db9fb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComingFromYou_vue__ = __webpack_require__("mMns");
function injectStyle (ssrContext) {
  __webpack_require__("Z3Sp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComingFromYou_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61db9fb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComingFromYou_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s1lu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/races'}}},[_c('button',{staticClass:"btn btn-warning btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Yarışlar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/seasons'}}},[_c('button',{staticClass:"btn btn-info active btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Sezonlar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/members'}}},[_c('button',{staticClass:"btn btn-danger btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Üyeler")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[(!_vm.err)?_c('div',[_c('h4',{staticClass:"card-title d-md-flex justify-content-between",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Branşlar")]),_vm._v(" "),_c('div',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary",attrs:{"title":"Yeni Branş Ekle","to":{ path: 'seasons/add-edit/'},"tag":"li"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Yeni Branş")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h6',{staticClass:"ml-3"},[_vm._v("Branşlar")]),_vm._v(" "),_c('b-tabs',{attrs:{"pills":"","card":"","vertical":""}},_vm._l((_vm.categories),function(category,index){return _c('b-tab',{key:index,attrs:{"title":category.name}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"d-md-flex justify-content-between"},[_c('span',[_vm._v(_vm._s(category.name))]),_vm._v(" "),_c('div',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"title":"Düzenle","to":{ path: 'seasons/add-edit/'+category.id+'/0'},"tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-danger btn-xs",attrs:{"title":"Sil"},on:{"click":function($event){return _vm.remove(category.id,'categories')}}},[_c('i',{staticClass:"fas fa-eye-slash"})]),_vm._v(" "),(category.is_active)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"remove-item.id"},on:{"click":function($event){return _vm.deactivate(category.id,'categories')}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(!category.is_active)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.activate(category.id,'categories')}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"w-100 card card-body"},[_c('h6',[_vm._v("Sezonlar")]),_vm._v(" "),_vm._l((_vm.categories[index].sub_categories),function(subCategory,i){return _c('div',{key:i,staticClass:"card mb-2"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-9"},[_vm._v(_vm._s(subCategory.name))]),_vm._v(" "),_c('div',{staticClass:"col-3 d-flex justify-content-end"},[_c('div',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"title":"Düzenle","to":{ path: 'category/add-edit/'+subCategory.id+'/1'},"tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-danger btn-xs",attrs:{"title":"Sil"},on:{"click":function($event){return _vm.remove(subCategory.id,'SubCategories')}}},[_c('i',{staticClass:"fas fa-eye-slash"})]),_vm._v(" "),(subCategory.is_active)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"deactivate-item.id"},on:{"click":function($event){return _vm.deactivate(subCategory.id,'sub-categories')}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(!subCategory.is_active)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.activate(subCategory.id,'sub-categories')}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e()],1)])])])})],2)])])])])}),1)],1)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n  "+_vm._s(_vm.err)+"\n")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sBYi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Newcategories_vue__ = __webpack_require__("8pnP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f1ff42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Newcategories_vue__ = __webpack_require__("aGu9");
function injectStyle (ssrContext) {
  __webpack_require__("7j+8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Newcategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f1ff42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Newcategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sFf/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sLXE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sNgK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sQGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drop-down',
  props: {
    title: String,
    icon: String,
    tag: {
      type: String,
      default: 'li'
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
      this.$emit('change', this.isOpen);
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
      this.$emit('change', this.isOpen);
    }
  }
});

/***/ }),

/***/ "sRP8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "scED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scores_vue__ = __webpack_require__("kNVK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a94e6b9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scores_vue__ = __webpack_require__("svtq");
function injectStyle (ssrContext) {
  __webpack_require__("+kWA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scores_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a94e6b9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scores_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "scmS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("fBuy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61b88401_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("f0G8");
function injectStyle (ssrContext) {
  __webpack_require__("NOs2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61b88401_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sj4t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: {
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'digitalpresssslider' + this.$route.params.id,
        order_number: null
      },
      selectedType: null,
      types: ['URL', 'Kategori', 'Alt Kategori', 'Yayın', 'Etiket'],
      options: [],
      sliderItems: null,
      newSliderImage: {
        cropped: null,
        image_id: null,
        image_name: null,
        imageIndex: null
      },
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier('top', 'right', 'danger', 'Slider Başarıyla silindi');
          _this.getSlider();
        }, function (e) {
          _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          _this.toggleLoader();
        });
      }
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post('/api/images/upload/digitalpresssslider', this.newSliderImage).then(function (response) {
        var i = _this2.newSliderImage.n === 0 ? 'image' : 'image2';
        _this2.slider[_this2.newSliderImage.imageIndex][i] = response.body.Data.Response.name;
        _this2.toggleLoader();
        _this2.hideCroppieModal();
        _this2.update();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    addNew: function addNew() {
      this.slider.unshift({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'digitalpresssslider' + this.$route.params.id,
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      var newdis = this;
      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = 'digitalpresssslider' + newdis.$route.params.id;
      });
      this.$http.post('/api/images/edit/', this.slider).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi');
        _this3.getSlider();
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = '/api/images/digitalpressslider/' + this.$route.params.id;
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
      }, function (er) {
        _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
      });
    },
    initiateCroppie: function initiateCroppie(id, i, n) {
      this.newSliderImage.image_id = id;
      this.newSliderImage.image_name = this.slugify(this.slider[i].title);
      this.newSliderImage.imageIndex = i;
      this.newSliderImage.n = n;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {

      this.crop();
    },
    crop: function crop() {
      var _this5 = this;

      var dis = this;
      this.toggleLoader();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg' | 'png' | 'webp',
          backgroundColor: '#fff',
          size: {
            width: 1600,
            height: 800
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this5.newSliderImage.cropped = output;
          _this5.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "suTU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "svtq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t5XZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tCuB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tJ6G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("1l9q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7beb9a19_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("BZdN");
function injectStyle (ssrContext) {
  __webpack_require__("uecc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7beb9a19_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tLUC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("Slider \n              "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"mr-2 btn btn-danger btn-sm btn-fill",on:{"click":function($event){return _vm.addNew()}}},[_vm._v("\n                Ekle\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm btn-fill",on:{"click":function($event){return _vm.update()}}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("Resim boyutu 1600 x 800 pixel")]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-11"},[_c('img',{staticClass:"img-fluid",attrs:{"width":"150px","src":_vm.mediaURL() + item.image}})]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn btn-sm ",attrs:{"title":"Slider Resmini Değiştir"},on:{"click":function($event){return _vm.initiateCroppie(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 border border-secondary p-2 d-none",attrs:{"src":_vm.newSliderImage.cropped}})])])])])}),0)],1)],1)])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 450, height: 240, type: 'suare'},"boundary":{width: 600, height: 320},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tN3x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('posts-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tPn6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-body",attrs:{"id":"login-body"}},[_c('div',{staticClass:"login-page"},[_c('div',{staticClass:"form",attrs:{"id":"login-form"}},[_c('form',{staticClass:"login-form",on:{"submit":function($event){$event.preventDefault();return _vm.Submit($event)}}},[_c('h1',[_vm._v("Türkiye Buz Pateni Federasyonu")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_c('ul',{staticClass:"m-0 p-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_vm._v(_vm._s(e))])}),0)]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.email),expression:"credentials.email"}],attrs:{"type":"text","autofocus":"","placeholder":"E-Posta"},domProps:{"value":(_vm.credentials.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "email", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.password),expression:"credentials.password"}],attrs:{"type":"password","placeholder":"Şifre"},domProps:{"value":(_vm.credentials.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "password", $event.target.value)}}}),_vm._v(" "),_c('button',{attrs:{"type":"submit"},on:{"click":_vm.checkForm}},[_vm._v("Giriş")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tV1W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tcE3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      newFileUploading: {
        active: false,
        index: -1
      },
      slider: {
        post_id: null,
        slider_group: 'Main',
        order_number: null,
        is_active: 1
      },
      viewport: {
        width: 480,
        height: 270,
        type: 'suare'
      },
      boundary: {
        width: 640,
        height: 360
      },
      selectedType: null,
      types: ['URL', 'Kategori', 'Alt Kategori', 'Yayın', 'Etiket'],
      options: [],
      AdItems: null,
      newAdImage: {
        cropped: null,
        index: null
      },
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"]
  },

  methods: {
    initiateUpload: function initiateUpload(i) {
      this.newFileUploading = {
        active: true,
        index: i
      };
    },
    uploadFile: function uploadFile() {
      var _this = this;

      var item = this.AdItems[this.newFileUploading.index];
      var slug = this.slugify(item.name);
      var file = this.$refs.newFile.files[0];
      var ext = file.name.split('.').pop();
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        _this.$http.post('/api/images/upload-file/ad-' + slug + '-image-' + new Date().getTime(), {
          file: reader.result,
          ext: ext
        }).then(function (response) {
          item.image = response.body.Data.Response.name;
          _this.newFileUploading = {
            active: false,
            index: -1
          };
        }, function (e) {
          _this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
          _this.toggleLoader();
        });
      };
    },
    remove: function remove(id) {
      var _this2 = this;

      this.toggleLoader();
      this.$http.delete('/api/slider/delete/' + id).then(function (response) {
        _this2.notifier('top', 'right', 'warning', 'Menu elemanı silindi');
        _this2.getAds();
        _this2.toggleLoader();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    uploadImage: function uploadImage() {
      var _this3 = this;

      this.$http.post('/api/images/upload/ad-' + this.newAdImage.index + '-image', this.newAdImage).then(function (response) {
        _this3.AdItems[_this3.newAdImage.index].image = response.body.Data.Response.name;
        _this3.hideCroppieModal();
        document.getElementById('submit-image').innerHTML = 'Kaydet';
        _this3.toggleLoader();
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this3.toggleLoader();
      });
    },
    update: function update(id) {
      var _this4 = this;

      this.$http.post('/api/slider/edit/', this.AdItems).then(function (response) {
        _this4.notifier('top', 'right', 'success', 'Sıralama güncellendi');
      }, function (e) {
        _this4.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
      });
    },
    save: function save(id, i) {
      var _this5 = this;

      this.toggleLoader();
      if (this.AdItems[i].type === 'Resim') {
        this.AdItems[i].content = null;
      } else {
        this.AdItems[i].image = null;
        this.AdItems[i].link = null;
      }
      this.$http.post('/api/ad-places/edit/' + id, this.AdItems[i]).then(function (response) {
        _this5.getAds();
        _this5.toggleLoader();
        _this5.notifier('top', 'right', 'success', 'Sıralama güncellendi');
      }, function (e) {
        _this5.toggleLoader();
        _this5.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
      });
    },
    getAds: function getAds() {
      var _this6 = this;

      this.toggleLoader();
      var url = '/api/ad-places/all';
      this.$http.get(url).then(function (response) {
        _this6.AdItems = response.body;
        if (_this6.AdItems.length > 0) {
          _this6.slider.order_number = _this6.AdItems[0].order_number + 1;
          _this6.slider.post_id = 0;
        } else {
          _this6.slider.order_number = 0;
        }
        _this6.toggleLoader();
      }, function (er) {
        _this6.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        _this6.toggleLoader();
      });
    },
    initiateCroppie: function initiateCroppie(i) {
      this.newAdImage.index = i;
      this.viewport.width = this.AdItems[i].width / 2;
      this.viewport.height = this.AdItems[i].height / 2;
      this.boundary.width = this.AdItems[i].width / 1.7;
      this.boundary.height = this.AdItems[i].height / 1.7;
      this.$refs.main.refresh();
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById('myImage').files.length) {
        oFReader.readAsDataURL(document.getElementById('myImage').files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {
      document.getElementById('submit-image').innerHTML = "<i class='fas fa-circle-notch fa-spin'></i>";
      this.crop();
    },
    crop: function crop() {
      var _this7 = this;

      var dis = this;
      this.toggleLoader();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg',
          size: {
            width: _this7.AdItems[_this7.newAdImage.index].width,
            height: _this7.AdItems[_this7.newAdImage.index].height
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this7.newAdImage.cropped = output;
          _this7.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getAds();
    });
  }
});

/***/ }),

/***/ "tk/b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('form',{staticClass:"w-100",on:{"submit":_vm.submit}},[(!_vm.err)?_c('div',[_c('h1',{staticClass:"h4 mt-0 d-flex justify-content-between"},[_c('span',[_vm._v("Genel Ayarlar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-sm btn-fill",attrs:{"type":"submit"}},[_vm._v("Kaydet")])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.settings),function(item){return _c('div',{key:item.id,staticClass:"col-4"},[_c('label',{class:item.meta.labelClass,attrs:{"id":item.meta.id,"for":item.name}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(item.meta.title))]),_vm._v(" "),(item.meta.subTitle)?_c('span',[_vm._v("("+_vm._s(item.meta.subTitle)+")")]):_vm._e()]),_vm._v(" "),((item.meta.type)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.data),expression:"item.data"}],staticClass:"form-control",class:item.meta.class,attrs:{"disabled":item.meta.disabled,"id":item.name,"type":"checkbox"},domProps:{"checked":Array.isArray(item.data)?_vm._i(item.data,null)>-1:(item.data)},on:{"change":function($event){var $$a=item.data,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "data", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "data", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "data", $$c)}}}}):((item.meta.type)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.data),expression:"item.data"}],staticClass:"form-control",class:item.meta.class,attrs:{"disabled":item.meta.disabled,"id":item.name,"type":"radio"},domProps:{"checked":_vm._q(item.data,null)},on:{"change":function($event){return _vm.$set(item, "data", null)}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.data),expression:"item.data"}],staticClass:"form-control",class:item.meta.class,attrs:{"disabled":item.meta.disabled,"id":item.name,"type":item.meta.type},domProps:{"value":(item.data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "data", $event.target.value)}}}),_vm._v(" "),(item.meta.ismap)?_c('iframe',{attrs:{"width":"100%","height":"315","src":item.data,"frameborder":"0"}}):_vm._e()])}),0)]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n"+_vm._s(_vm.err)+"\n")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tlP6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: [{
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'subboards',
        order_number: null
      }],
      err: null,
      categories: null,
      category: {
        category_id: "",
        name: null,
        url: null,
        is_active: 1
      },
      selectedType: null,
      types: ['URL', 'Kategori', 'Alt Kategori', 'Yayın', 'Etiket'],
      options: [],
      sliderItems: null,
      newSliderImage: {
        cropped: null,
        image_id: null,
        image_name: null,
        imageIndex: null
      },
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier('top', 'right', 'danger', 'Slider Başarıyla silindi');
          _this.getSlider();
        }, function (e) {
          if (!e.body.Error) {
            _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          } else {
            _this.notifier("top", "right", "danger", e.body.Error);
          }
        });
      }
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post('/api/images/upload/' + this.newSliderImage.image_name + 'subboards-slider', this.newSliderImage).then(function (response) {
        var i = _this2.newSliderImage.n === 0 ? 'image' : 'image2';
        _this2.slider[_this2.newSliderImage.imageIndex][i] = response.body.Data.Response.name;
        _this2.toggleLoader();
        _this2.hideCroppieModal();
        _this2.update();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    addNew: function addNew() {
      this.slider.push({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'subboards',
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = 'subboards';
      });
      this.$http.post('/api/images/edit/', this.slider).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi');
        _this3.getSlider();
      }, function (e) {
        if (!e.body.Error) {
          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this3.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = '/api/images/subboards';
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
      }, function (er) {
        if (!er.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this4.err = er.body.Error;
          _this4.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    getCategories: function getCategories() {
      var _this5 = this;

      this.$http.get('/api/categories/allsubboards').then(function (response) {
        _this5.categories = response.body;
      }, function (er) {
        _this5.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        _this5.toggleLoader();
      });
    },
    initiateCroppie: function initiateCroppie(id, i, n) {
      this.newSliderImage.image_id = id;
      this.newSliderImage.image_name = this.slugify(this.slider[i].title);
      this.newSliderImage.imageIndex = i;
      this.newSliderImage.n = n;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {

      this.crop();
    },
    crop: function crop() {
      var _this6 = this;

      var dis = this;
      this.toggleLoader();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg' | 'png' | 'webp',
          backgroundColor: '#fff',
          size: {
            width: 580,
            height: 388
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this6.newSliderImage.cropped = output;
          _this6.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
      this.getCategories();
    });
  }
});

/***/ }),

/***/ "u2Qy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uAhs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      category: {
        is_active: 0
      },
      err: null,
      categories: null,
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },

  methods: {
    deactivate: function deactivate(id, type) {
      var _this = this;

      this.toggleLoader();
      this.category.is_active = 0;
      this.$http.post('/api/' + type + '/edit/' + id, this.category).then(function (response) {
        _this.notifier('top', 'right', 'warning', 'Kategori Yayından Kaldırıldı');
        _this.getPosts();
        _this.toggleLoader();
      }, function (e) {
        _this.toggleLoader();

        if (!e.body.Error) {
          _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
        } else {
          _this.notifier("top", "right", "danger", e.body.Error);
        }
      });
    },
    remove: function remove(id, type) {
      var _this2 = this;

      this.toggleLoader();
      this.$http.post('/api/' + type + '/delete/' + id, this.category).then(function (response) {
        _this2.notifier('top', 'right', 'warning', 'Kategori Silindi');
        _this2.getPosts();
        _this2.toggleLoader();
      }, function (e) {
        _this2.toggleLoader();

        if (!e.body.Error) {
          _this2.notifier("top", "right", "danger", "Bir Hata Oluştu");
        } else {
          _this2.notifier("top", "right", "danger", e.body.Error);
        }
      });
    },
    activate: function activate(id, type) {
      var _this3 = this;

      this.toggleLoader();
      this.category.is_active = 1;
      this.$http.post('/api/' + type + '/edit/' + id, this.category).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Kategori Yayına Alındı');
        _this3.getPosts();
        _this3.toggleLoader();
      }, function (e) {
        _this3.toggleLoader();

        if (!e.body.Error) {
          _this3.notifier("top", "right", "danger", "Bir Hata Oluştu");
        } else {
          _this3.notifier("top", "right", "danger", e.body.Error);
        }
      });
    },

    getPosts: function getPosts() {
      var _this4 = this;

      this.toggleLoader();
      var url = '/api/categories/all-with-joins-sub-boards/';
      this.$http.get(url).then(function (response) {
        _this4.categories = response.body;
        _this4.toggleLoader();
      }, function (er) {
        _this4.toggleLoader();

        if (!er.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this4.err = er.body.Error;
          _this4.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getPosts();
    });
  }
});

/***/ }),

/***/ "uEKC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-checkbox',
  model: {
    prop: 'checked'
  },
  props: {
    checked: [Array, Boolean],
    disabled: [Boolean, String],
    inline: Boolean
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.checked;
      },
      set: function set(check) {
        this.$emit('input', check);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'checkbox-inline';
      }
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "uF2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("r/6C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4505bc1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("rxXD");
function injectStyle (ssrContext) {
  __webpack_require__("16UY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4505bc1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uIpp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uW6q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uWRX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      slider: [{
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'directors',
        order_number: null
      }],
      err: null,
      selectedType: null,
      types: ['URL', 'Kategori', 'Alt Kategori', 'Yayın', 'Etiket'],
      options: [],
      sliderItems: null,
      newSliderImage: {
        cropped: null,
        image_id: null,
        image_name: null,
        imageIndex: null
      },
      total: 0,
      limit: localStorage.getItem('filterLimit'),
      page: 1,
      pageCount: null,
      navigation: true,
      type: 'all',
      viewCounts: []
    };
  },
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelSelect"]
  },

  methods: {
    remove: function remove(id) {
      var _this = this;

      if (confirm("Silmek İstediğinize eminmisiniz?")) {
        this.$http.delete("/api/images/delete/" + id).then(function (response) {
          _this.notifier('top', 'right', 'danger', 'Slider Başarıyla silindi');
          _this.getSlider();
        }, function (e) {
          if (!e.body.Error) {
            _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          } else {
            _this.notifier("top", "right", "danger", e.body.Error);
          }
        });
      }
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      this.$http.post('/api/images/upload/' + this.newSliderImage.image_name + 'directors-slider', this.newSliderImage).then(function (response) {
        var i = _this2.newSliderImage.n === 0 ? 'image' : 'image2';
        _this2.slider[_this2.newSliderImage.imageIndex][i] = response.body.Data.Response.name;
        _this2.toggleLoader();
        _this2.hideCroppieModal();
        _this2.update();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    addNew: function addNew() {
      this.slider.push({
        image: null,
        title: null,
        description: null,
        target_url: null,
        image_type: 'directors',
        order_number: null
      });
    },
    update: function update() {
      var _this3 = this;

      this.slider.forEach(function (s) {
        if (!s.image) s.image = s.image2;
        s.image_type = 'directors';
      });
      this.$http.post('/api/images/edit/', this.slider).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi');
        _this3.getSlider();
      }, function (e) {
        if (!e.body.Error) {

          _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {
          _this3.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    getSlider: function getSlider() {
      var _this4 = this;

      var url = '/api/images/directors';
      this.$http.get(url).then(function (response) {
        _this4.slider = response.body;
        _this4.err = null;
      }, function (er) {
        if (!er.body.Error) {
          _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        } else {
          _this4.err = er.body.Error;
          _this4.notifier('top', 'right', 'danger', er.body.Error);
        }
      });
    },
    initiateCroppie: function initiateCroppie(id, i, n) {
      this.newSliderImage.image_id = id;
      this.newSliderImage.image_name = this.slugify(this.slider[i].title);
      this.newSliderImage.imageIndex = i;
      this.newSliderImage.n = n;
    },
    toggleNavigation: function toggleNavigation() {
      var button = event.target;
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>';
        this.navigation = false;
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>';
        this.navigation = true;
      }
    },
    toggleNewPostPanel: function toggleNewPostPanel(event) {
      event.stopPropagation();
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none');
      } else {
        document.getElementById('new-post').classList.add('d-none');
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },

    changeButtonText: function changeButtonText() {

      this.crop();
    },
    crop: function crop() {
      var _this5 = this;

      var dis = this;
      this.toggleLoader();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: 'jpeg' | 'png' | 'webp',
          backgroundColor: '#fff',
          size: {
            width: 400,
            height: 450
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          _this5.newSliderImage.cropped = output;
          _this5.uploadImage();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit('bv::hide::modal', 'croppieModal');
    },
    result: function result(output) {
      return output;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getSlider();
    });
  }
});

/***/ }),

/***/ "uecc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ufRY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BankInformations_vue__ = __webpack_require__("oTup");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4936c90c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BankInformations_vue__ = __webpack_require__("AiZQ");
function injectStyle (ssrContext) {
  __webpack_require__("P36o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BankInformations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4936c90c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BankInformations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uiR1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FeedbackModules_Index_vue__ = __webpack_require__("6biR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    IndexTable: __WEBPACK_IMPORTED_MODULE_0__FeedbackModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "umZt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/main'}}},[_c('button',{staticClass:"btn btn-danger active btn-sm  px-2 mr-2",attrs:{"type":"submit"}},[_vm._v("Anasayfa Slider")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/intro-video'}}},[_c('button',{staticClass:"btn btn-primary btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("İntro Videosu")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/homeboxes'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Anasayfa Kutular")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/homeinfos'}}},[_c('button',{staticClass:"btn btn-warning btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Anasayfa Bilgiler")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/announcements'}}},[_c('button',{staticClass:"btn btn-success btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Anasayfa Duyurular")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[(!_vm.err)?_c('div',[_c('small',[_vm._v("Resim Boyutu 1110x465")]),_vm._v(" "),_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("Slider \n                "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"mr-2 btn btn-danger btn-sm btn-fill",on:{"click":function($event){return _vm.addNew()}}},[_vm._v("\n                  Ekle\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm btn-fill",on:{"click":function($event){return _vm.update()}}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.mediaURL() + item.image}})]),_vm._v(" "),_c('div',{staticClass:"col-9 d-flex align-items-center"},[_c('div',{staticClass:"row w-100"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Başlık")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.title),expression:"item.title"}],staticClass:"form-control",attrs:{"type":"text","name":""},domProps:{"value":(item.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Link")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.target_url),expression:"item.target_url"}],staticClass:"form-control",attrs:{"type":"text","name":""},domProps:{"value":(item.target_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "target_url", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}},{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn btn-sm ",attrs:{"title":"Slider Resmini Değiştir"},on:{"click":function($event){return _vm.initiateCroppie(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 border border-secondary p-2 d-none",attrs:{"src":_vm.newSliderImage.cropped}})])])])])}),0)],1)],1):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n                          "+_vm._s(_vm.err)+"\n                        ")]):_vm._e()])])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 500, height: 210, type: 'suare'},"boundary":{width: 555, height: 233},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uq87":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.name),expression:"category.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.category.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.category, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uxHi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivityProgramContent_vue__ = __webpack_require__("lNku");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed3eface_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivityProgramContent_vue__ = __webpack_require__("m/23");
function injectStyle (ssrContext) {
  __webpack_require__("yazz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivityProgramContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed3eface_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivityProgramContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v2Ur":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CupPointPage_vue__ = __webpack_require__("PKGG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d13d84c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CupPointPage_vue__ = __webpack_require__("mKUl");
function injectStyle (ssrContext) {
  __webpack_require__("zSON")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CupPointPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d13d84c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CupPointPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vHBR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("VtsW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f0786de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("mt4Z");
function injectStyle (ssrContext) {
  __webpack_require__("ZO0v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f0786de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vIvT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vNb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__ = __webpack_require__("0XqQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54112600_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__ = __webpack_require__("cxu9");
function injectStyle (ssrContext) {
  __webpack_require__("To5b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54112600_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vW6o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vcPX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("aM90");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01573afa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("Xo6s");
function injectStyle (ssrContext) {
  __webpack_require__("WlsZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01573afa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vp1I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vtDO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("+TJz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76a293b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("Hq6I");
function injectStyle (ssrContext) {
  __webpack_require__("csJO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76a293b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vw+w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vzqY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("p0VG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75b72252_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("y6q0");
function injectStyle (ssrContext) {
  __webpack_require__("xz1k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75b72252_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w2DA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w882":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TinymceVue_vue__ = __webpack_require__("2vxi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7a7628c1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TinymceVue_vue__ = __webpack_require__("TyWY");
function injectStyle (ssrContext) {
  __webpack_require__("MAJb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a7628c1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TinymceVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7a7628c1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TinymceVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wB93":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wHFo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"d-flex justify-content-between mt-0"},[_c('span',[_vm._v("\n                Dijital Basın Pdf\n                "),_c('small',{staticClass:"small text-primary"},[_vm._v("(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"mr-2 btn btn-danger btn-sm btn-fill",on:{"click":function($event){return _vm.addNew()}}},[_vm._v("Ekle")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm btn-fill",on:{"click":function($event){return _vm.update()}}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},[_c('transition-group',_vm._l((_vm.slider),function(item,index){return _c('div',{key:index+1},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"row w-100"},[_c('div',{staticClass:"col-12 col-md-2 d-flex align-items-center"},[_c('button',{staticClass:"btn btn-warning activebtn-s mr-2 px-2",attrs:{"disabled":!item.image,"type":"submit"}},[(item.image)?_c('a',{staticClass:"text-warning",attrs:{"href":_vm.generalURL('haberler')+item.image,"target":"_blank"}},[_vm._v("PDF AÇ")]):_vm._e(),_vm._v(" "),(!item.image)?_c('span',{staticClass:"text-danger text-light pdf-alert-text"},[_vm._v("Pdf Yüklenmedi")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-9"},[_c('label',[_vm._v("Açıklama")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.target_url),expression:"item.target_url"}],staticClass:"form-control",attrs:{"type":"text","name":""},domProps:{"value":(item.target_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "target_url", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 d-flex justify-content-end align-items-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('button',{staticClass:"btn btn btn-sm",attrs:{"title":"PDF Değiştir"},on:{"click":function($event){return _vm.myPdf(item.id,index,0)}}},[_c('i',{staticClass:"fas fa-image fa-fw"})]),_vm._v(" "),_c('input',{staticClass:"m-3",staticStyle:{"display":"none"},attrs:{"name":"myFile","id":'myPdf'+index,"type":"file"},on:{"change":function($event){return _vm.upload($event)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm mt-1",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('i',{staticClass:"fas fa-times fa-fw"})])])])])])])}),0)],1)],1)])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wHlF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      publishTime: null,
      futurePost: false,
      socialMedia: true,
      // post data
      currency1: '',
      currency2: '',
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'Sayfa',
        image: null,
        content_id: null,
        video_id: null,
        content: 'jhkjhjkhkajhfkhds'
      },
      errors: [],
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          },
          meta4: {
            meta_key: 'view_count',
            meta_value: 0
          }
        }
      },
      content: {
        content: null
      },
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    setName: function setName() {
      this.post.name = this.currency1 + '/' + this.currency2;
    },
    getName: function getName() {
      var parts = this.post.name.split('/');
      this.currency1 = parts[0];
      this.currency2 = parts[1];
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.currency1) {
        this.errors.push("Para Birimi");
      };
      if (!this.post.url) {
        this.errors.push("URL");
      };
      if (!this.currency2) {
        this.errors.push("Karşı Para Birimi");
      };
      if (!this.metas.items.meta2.meta_value) {
        this.errors.push("Site Başlığı");
      };
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
        _this.notifier('top', 'right', 'danger', 'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin');
        _this.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
        _this.savePost();
      });
    },
    savePost: function savePost() {
      var _this2 = this;

      this.post.comments = null;
      this.post.menus = null;
      this.post.slider = null;
      this.tempMetas = this.post.post_metas;
      this.post.post_metas = null;
      this.post.post_tags = null;
      this.post.category = null;
      this.post.sub_category = null;
      this.post.user = null;
      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.post.content.content, { allowedTags: ['br'] }).substring(0, 500);
      }
      this.post.content.content = this.content.content;
      this.$http.post('/api/posts/edit/' + this.post.id, this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this2.post.id = pid;
        _this2.metas.post_id = pid;
        _this2.saveMetas();
      }, function (e) {
        _this2.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this2.toggleLoader();
      });
    },
    saveMetas: function saveMetas() {
      var _this3 = this;

      this.$http.put('/api/post-metas/edit-bulk/', this.metas).then(function (response) {
        _this3.notifier('top', 'right', 'success', 'Başarılı');
        _this3.toggleLoader();
        _this3.$router.push('/main');
      }, function (e) {
        _this3.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        _this3.toggleLoader();
      });
    },
    getInitialData: function getInitialData() {
      var _this4 = this;

      this.toggleLoader();
      this.$http.get('/api/posts/get/' + this.id).then(function (response) {
        _this4.post = response.body;
        _this4.getName();
        _this4.content.content = _this4.post.content.content;
        _this4.metas = {
          post_id: _this4.post.id,
          items: {
            meta2: {
              meta_id: _this4.post.post_metas[_this4.post.meta_title].id,
              meta_key: 'title',
              meta_value: _this4.post.post_metas[_this4.post.meta_title].meta_value
            },
            meta3: {
              meta_id: _this4.post.post_metas[_this4.post.meta_description].id,
              meta_key: 'description',
              meta_value: _this4.post.post_metas[_this4.post.meta_description].meta_value
            }
          }
        };

        _this4.toggleLoader();
      }, function (er) {
        _this4.toggleLoader();
        _this4.notifier('top', 'right', 'danger', 'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        return;
      });
    },
    slugifyUrl: function slugifyUrl() {
      this.post.url = this.slugify(this.post.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById('url').classList.add('is-invalid');
        document.getElementById('url').classList.remove('is-valid');
        document.getElementById('url-label').classList.add('is-invalid');
        document.getElementById('url-label').classList.remove('is-valid');
      }).catch(function (er) {
        document.getElementById('url').classList.add('is-valid');
        document.getElementById('url').classList.remove('is-invalid');
        document.getElementById('url-label').classList.add('is-valid');
        document.getElementById('url-label').classList.remove('is-invalid');
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this5 = this;

        request.$http.get('/api/filter/posts/exclude/id:' + this.id + 'url/' + request.post.url).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this5.notifier('top', 'right', 'danger', 'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.');
        });
      });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.getInitialData();
    });
  }
});

/***/ }),

/***/ "wHvC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      publishTime: null,
      futurePost: false,
      socialMedia: true,
      // post data
      post: {
        id: null,
        user_id: this.getCurrentUserDetails().id,
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: "Homeinfos",
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: "title",
            meta_value: null
          },
          meta3: {
            meta_key: "description",
            meta_value: null
          },
          meta4: {
            meta_key: "view_count",
            meta_value: 0
          }
        }
      },
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        cropped: null
      },
      sliderImage: {
        cropped: null
      },
      croppieType: "main",
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      }
    };
  },
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  methods: {
    addImageToEditor: function addImageToEditor(i) {
      var _this = this;

      this.$http.post("/api/images/upload/" + this.post.name + "_homeinfos-image", {
        cropped: i
      }).then(function (response) {
        _this.content.content = _this.content.content + '<img src="' + _this.mediaURL() + response.body.Data.Response.name + '" width="100%" alt="' + '" />';
      }, function (e) {
        button.innerHTML = "Kaydet";
        _this.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this.toggleLoader();
      });
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.post.name) {
        this.errors.push("Başlık");
      }
      if (!this.content.content) {
        this.errors.push("İçerik");
      }
      if (!this.image.cropped) {
        this.errors.push("Resim");
      }
      if (!this.errors.length) {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.toggleLoader();
      this.validateUrl().then(function (resolve) {
        document.getElementById("url").classList.add("is-invalid");
        document.getElementById("url").classList.remove("is-valid");
        document.getElementById("url-label").classList.add("is-invalid");
        document.getElementById("url-label").classList.remove("is-valid");
        _this2.notifier("top", "right", "danger", "URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin");
        _this2.toggleLoader();
      }).catch(function (er) {
        var button = event.target;
        // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
        _this2.saveContent();
      });
    },
    saveContent: function saveContent() {
      var _this3 = this;

      var button = event.target;
      this.$http.post("/api/contents/add", this.content).then(function (response) {
        _this3.post.content_id = response.body.Data.Response.id;
        _this3.saveVideo();
      }, function (e) {
        button.innerHTML = "Kaydet";
        _this3.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this3.toggleLoader();
      });
    },

    saveVideo: function saveVideo() {
      var _this4 = this;

      if (this.video.video_url !== null) {
        this.$http.post("/api/videos/add", this.video).then(function (response) {
          _this4.post.video_id = response.body.Data.Response.name;
          _this4.saveImage();
        }, function (e) {
          button.innerHTML = "Kaydet";
          _this4.notifier("top", "right", "danger", "Bir Hata Oluştu");
          _this4.toggleLoader();
        });
      } else {
        this.saveImage();
      }
    },
    saveImage: function saveImage() {
      var _this5 = this;

      this.$http.post("/api/images/upload/" + this.slugify(this.post.name), this.image).then(function (response) {
        _this5.post.image = response.body.Data.Response.name;
        _this5.savePost();
      }, function (e) {
        button.innerHTML = "Kaydet";
        _this5.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this5.toggleLoader();
      });
    },
    savePost: function savePost() {
      var _this6 = this;

      var newdate = new Date();
      if (!this.post.url) {
        this.post.url = this.post.name + newdate.getTime();
      }
      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(this.content.content, { allowedTags: ["br"] }).substring(0, 500);
      }
      this.$http.post("/api/posts/add", this.post).then(function (response) {
        var pid = response.body.Data.Response.id;
        _this6.post.id = pid;
        _this6.metas.post_id = pid;
        _this6.saveMetas();
      }, function (e) {
        _this6.toggleLoader();

        if (!e.body.Error) {
          _this6.notifier('top', 'right', 'danger', 'Bir Hata Oluştu');
        } else {

          _this6.notifier('top', 'right', 'danger', e.body.Error);
        }
      });
    },
    saveMetas: function saveMetas() {
      var _this7 = this;

      this.$http.post("/api/post-metas/add-bulk", this.metas).then(function (response) {
        _this7.notifier("top", "right", "success", "Başarılı");
        _this7.$router.push("/homeinfos");
        _this7.toggleLoader();
      }, function (e) {
        _this7.notifier("top", "right", "danger", "Bir Hata Oluştu");
        _this7.toggleLoader();
      });
    },
    createUrl: function createUrl() {
      this.post.url = this.slugify(this.post.name);
    },
    slugifyUrl: function slugifyUrl() {
      this.post.url = this.slugify(this.post.url);
    },
    validate: function validate() {
      this.validateUrl().then(function (resolve) {
        document.getElementById("url").classList.add("is-invalid");
        document.getElementById("url").classList.remove("is-valid");
        document.getElementById("url-label").classList.add("is-invalid");
        document.getElementById("url-label").classList.remove("is-valid");
      }).catch(function (er) {
        document.getElementById("url").classList.add("is-valid");
        document.getElementById("url").classList.remove("is-invalid");
        document.getElementById("url-label").classList.add("is-valid");
        document.getElementById("url-label").classList.remove("is-invalid");
      });
    },
    validateUrl: function validateUrl() {
      var request = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this8 = this;

        request.$http.get("/api/filter/posts/post-type/Homeinfos/name/" + request.post.name).then(function (response) {
          if (parseInt(response.body.meta.total) > 0) {
            resolve(true);
          } else {
            reject(false);
          }
        }, function (response) {
          _this8.notifier("top", "right", "danger", "Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.");
        });
      });
    },
    initiateCroppie: function initiateCroppie(type) {
      if (this.post.name) {
        this.croppieType = type;
      } else {
        this.notifier("top", "right", "danger", "Resim ekleyebilmek için bir başlık belirlemelisiniz.");
      }
    },
    bind: function bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop: function crop() {
      var _this9 = this;

      var dis = this;
      var wdt = 400;
      var hgt = 200;
      if (this.croppieType === "tinymce") {
        wdt = 400;
        hgt = 200;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var options = {
          format: "jpeg",
          size: {
            width: wdt,
            height: hgt
          },
          quality: 1
        };
        dis.$refs.main.result(options, function (output) {
          if (_this9.croppieType === "main") {
            dis.image.cropped = output;
          } else if (_this9.croppieType === "tinymce") {
            _this9.notifier("top", "right", "warning", "Lütfen resim yükleninceye kadar bekleyin.");
            _this9.addImageToEditor(output);
          }
          _this9.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal: function hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result: function result(output) {
      return output;
    }
  }
});

/***/ }),

/***/ "wUzn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserModules_Index_vue__ = __webpack_require__("d8DU");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    IndexTable: __WEBPACK_IMPORTED_MODULE_0__UserModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "wckU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Tesis Ekle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Kutu Linki")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.link),expression:"post.link"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Link","aria-label":"Başlık","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "link", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Alt Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.subtitle),expression:"post.subtitle"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Alt Başlık","aria-label":"Alt Başlık","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.subtitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "subtitle", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("150 x 150 pixel")]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),(_vm.image.cropped)?_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.cropped}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":true,"viewport":{width: 150, height: 150, type: 'suare'},"boundary":{width: 200, height: 200},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "weCs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "weKa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('main-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "weuY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IntroVideoModules_Index_vue__ = __webpack_require__("W/s6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__IntroVideoModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "wg+L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wgOX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("fAVW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb05c8bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("XXzi");
function injectStyle (ssrContext) {
  __webpack_require__("BU5j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb05c8bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wizZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wnzg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("rWyS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12bad21b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("/7Uy");
function injectStyle (ssrContext) {
  __webpack_require__("GzUv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12bad21b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Views_Login_vue__ = __webpack_require__("4pBi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoggedIn: 'unknown'
    };
  },
  components: {
    LoginArea: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Views_Login_vue__["a" /* default */]
  },
  methods: {
    changeLoggedState: function changeLoggedState(event) {
      this.isLoggedIn = event;
    },
    checkLoggedStatus: function checkLoggedStatus() {
      var _this = this;

      this.$http.get('/api/users/is-logged-in', this.credentials).then(function (response) {
        _this.isLoggedIn = 'yes';
        _this.$cookies.set("panelbuzpatenicompanelsession", response.body.cookie, -1);
        // if user details was not found inside local storage log out and ask to login
        if (!localStorage.getItem("CurrentLoggedUserDetails")) {
          _this.$http.get('/api/users/logout', _this.credentials).then(function (response) {
            localStorage.removeItem('CurrentLoggedUserDetails');
            _this.$router.push('/main');
            location.reload();
          }, function (e) {
            _this.$router.push('/main');
            location.reload();
          });
        }
      }, function (e) {
        _this.isLoggedIn = 'no';
      });
    }
  },
  mounted: function mounted() {
    this.checkLoggedStatus();
  }
});

/***/ }),

/***/ "xOkz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivityProgram_vue__ = __webpack_require__("aJSr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d3e1eb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivityProgram_vue__ = __webpack_require__("UyNu");
function injectStyle (ssrContext) {
  __webpack_require__("bIFN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivityProgram_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d3e1eb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivityProgram_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xROX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xZNU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xmGu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xqWx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logs_vue__ = __webpack_require__("aRo4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23376f30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logs_vue__ = __webpack_require__("gRhf");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23376f30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xx5g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xz1k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y///":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y0U8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/directors'}}},[_c('button',{staticClass:"btn btn-danger  btn-sm  px-2 mr-2",attrs:{"type":"submit"}},[_vm._v("Yönetim Kurulu")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/staffs'}}},[_c('button',{staticClass:"btn btn-info  btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Federasyon Personeli")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/all-leaders'}}},[_c('button',{staticClass:"btn btn-primary btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Başkanlarımız")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/history'}}},[_c('button',{staticClass:"btn btn-success btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Tarihçe")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/sub-board-categories'}}},[_c('button',{staticClass:"btn btn-warning text-white active btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Alt Kurullar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/provincial-offices'}}},[_c('button',{staticClass:"btn btn-secondary  btn-sm  mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("İl Temsilcilikleri")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/bank-informations'}}},[_c('button',{staticClass:"btn btn-success  btn-sm  mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Hesap Numaraları")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/main-status-instructions'}}},[_c('button',{staticClass:"btn btn-info btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Ana Statü Talimatlar")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/sub-board-categories'}}},[_c('button',{staticClass:"btn btn-danger active btn-sm  px-5 mr-4",attrs:{"type":"submit"}},[_vm._v("Alt Kurullar")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/sub-boards'}}},[_c('button',{staticClass:"btn btn-warning  btn-sm mr-4 px-5",attrs:{"type":"submit"}},[_vm._v("Kişiler")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[(!_vm.err)?_c('div',[_c('h4',{staticClass:"card-title d-md-flex justify-content-between",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Alt Kurullar")]),_vm._v(" "),_c('div',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary",attrs:{"title":"Yeni Kurul Ekle","to":{ path: 'sub-board-categories/add-edit/'},"tag":"li"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Yeni Kurul")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h6',{staticClass:"ml-3"},[_vm._v("Kategoriler")]),_vm._v(" "),_c('b-tabs',{attrs:{"pills":"","card":"","vertical":""}},_vm._l((_vm.categories),function(category,index){return _c('div',{key:index,staticClass:"row"},[_c('div',{staticClass:"col-12 card mb-1"},[_c('div',{staticClass:"card-body p-2"},[_c('h5',{staticClass:"d-md-flex justify-content-between align-items-center m-0"},[_c('span',[_vm._v(_vm._s(category.name))]),_vm._v(" "),_c('div',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"title":"Düzenle","to":{ path: 'sub-board-categories/add-edit/'+category.id+'/0'},"tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-danger btn-xs",attrs:{"title":"Sil"},on:{"click":function($event){return _vm.remove(category.id,'categories')}}},[_c('i',{staticClass:"fas fa-eye-slash"})]),_vm._v(" "),(category.is_active)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"remove-item.id"},on:{"click":function($event){return _vm.deactivate(category.id,'categories')}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(!category.is_active)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.activate(category.id,'categories')}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e()],1)])])])])}),0)],1)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n"+_vm._s(_vm.err)+"\n")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y6q0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/coming-from-you'}}},[_c('button',{staticClass:"btn btn-info  btn-sm mr-2 px-2",attrs:{"type":"submit"}},[_vm._v("Sizden Gelenler Onay")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/coming-from-you-content'}}},[_c('button',{staticClass:"btn btn-danger active btn-sm  px-2 mr-2",attrs:{"type":"submit"}},[_vm._v("Gönderi Oluştur İçerik")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('form',{staticClass:"w-100",on:{"submit":_vm.submit}},[(!_vm.err)?_c('div',[_c('h1',{staticClass:"h4 mt-0 d-flex justify-content-between"},[_c('span',[_vm._v("Sizden Gelenler-Gönderi Oluştur İçerik")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-sm btn-fill",attrs:{"type":"submit"}},[_vm._v("Kaydet")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"d-flex flex-column"},[_c('label',{attrs:{"for":_vm.settings.name}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.settings.meta.title))])]),_vm._v(" "),_c('tinymce',{staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.settings.data),callback:function ($$v) {_vm.$set(_vm.settings, "data", $$v)},expression:"settings.data"}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n  "+_vm._s(_vm.err)+"\n")]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yDRE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeaderPdfs_vue__ = __webpack_require__("Zcut");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fd8f964_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeaderPdfs_vue__ = __webpack_require__("kQM8");
function injectStyle (ssrContext) {
  __webpack_require__("LX3s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeaderPdfs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fd8f964_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeaderPdfs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yM92":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('index-table')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yTRN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("iGsp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ea8b5f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("RrDU");
function injectStyle (ssrContext) {
  __webpack_require__("weCs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ea8b5f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yYKm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yazz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yhjo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("İş İlanları\n    "),_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-sm float-md-right",attrs:{"title":"Yeni İş İlanı Oluştur","to":{ path: 'job-posting/add-edit/'},"tag":"li"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Yeni İş İlanı")])],1),_vm._v(" "),_c('table',{staticClass:"table table-hover table-striped table-bordered mb-0"},[_c('caption',[_vm._v("Toplam: "+_vm._s(_vm.total))]),_vm._v(" "),_c('thead',{staticClass:"thead-dark"},[_c('th',[_vm._v("Başlık")]),_vm._v(" "),_c('th',[_vm._v("İçerik")]),_vm._v(" "),_c('th',[_vm._v("İşlemler")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.content))]),_vm._v(" "),_c('td',{staticStyle:{"width":"15%"}},[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-primary btn-fill btn-xs",attrs:{"title":"Düzenle","to":{ path: 'job-posting/add-edit/'+item.id},"tag":"li"}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-info btn-fill",attrs:{"href":"#","title":"Önizleme"}},[_c('i',{staticClass:"fas fa-external-link-alt"})]),_vm._v(" "),(item.is_active)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-danger btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayından Kaldır","id":"deactivate-item.id"},on:{"click":function($event){return _vm.deactivate(item.id)}}},[_c('i',{staticClass:"fas fa-eye-slash"})]):_vm._e(),_vm._v(" "),(!item.is_active)?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-xs btn-success btn-fill",attrs:{"href":"javascript:void(0)","title":"Yayına al","id":"activate-item.id"},on:{"click":function($event){return _vm.activate(item.id)}}},[_c('i',{staticClass:"fas fa-eye"})]):_vm._e()],1)])}),0)]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Page navigation small"}},[_c('ul',{staticClass:"pagination justify-content-end"},[_c('li',{staticClass:"page-item",class:{disabled: _vm.isFirst()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page - 1,_vm.type)}}},[_vm._v("Öncesi")])]),_vm._v(" "),_vm._l((_vm.pageCount),function(current){return _c('li',{key:current,staticClass:"page-item",class:{active: _vm.isActive(current)}},[_c('a',{staticClass:"page-link active",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPosts(current,_vm.type)}}},[_vm._v(_vm._s(current))])])}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{disabled: _vm.isLast()}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.getPosts(_vm.page + 1,_vm.type)}}},[_vm._v("Sonrası")])])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ysku":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dictionary_vue__ = __webpack_require__("e+/Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5b5094e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dictionary_vue__ = __webpack_require__("Otqt");
function injectStyle (ssrContext) {
  __webpack_require__("tCuB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dictionary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5b5094e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dictionary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yx9Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("5Dxb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_388c69d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("cCUz");
function injectStyle (ssrContext) {
  __webpack_require__("UiSI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_388c69d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yyTq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("l4xO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58803247_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("Z5Ph");
function injectStyle (ssrContext) {
  __webpack_require__("TaiZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58803247_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zILr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zLQQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"},[_c('div',[_c('router-link',{attrs:{"to":{ path: '/news'}}},[_c('button',{staticClass:"btn btn-info  btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Bildiriler")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/news-order'}}},[_c('button',{staticClass:"btn btn-warning active text-white btn-sm px-3 mr-3",attrs:{"type":"submit"}},[_vm._v("Bildiri Sıralaması")])])],1),_vm._v(" "),_c('span')]),_vm._v(" "),_c('card',[_c('div',{staticClass:"row"},[(!_vm.err)?_c('div',{staticClass:"col-12 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',[_vm._v("\n              Bildirileri Sırala\n              "),_c('small',{staticClass:"text-info"},[_vm._v("Bildirilerin sıralamasını değiştirmek için sürükleyin.")])]),_vm._v(" "),_c('draggable',{attrs:{"options":{animation:200}},on:{"update":function($event){return _vm.update()}},model:{value:(_vm.sliderItems),callback:function ($$v) {_vm.sliderItems=$$v},expression:"sliderItems"}},[_c('transition-group',_vm._l((_vm.sliderItems),function(item){return _c('div',{key:item.id},[_c('div',{staticClass:"card mb-2 menu-item"},[_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-12 d-flex align-items-center"},[_vm._v(_vm._s(item.post.name)+" ("+_vm._s(item.post.category.name)+" )")])])])])}),0)],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('div',[_vm._v("\n        "+_vm._s(_vm.err)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('p',{staticClass:"text-danger mb-0"},[_vm._v("Genişlik(277) Yükseklik(244). PNG ve arkası şeffaf olacak şekilde")]),_vm._v(" "),_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 277, height: 244, type: 'suare'},"boundary":{width: 400, height: 400},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"id":"submit-image","variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.changeButtonText()}}},[_vm._v("Kaydet")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zRwl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Tesis Ekle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Kutu Linki")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.link),expression:"post.link"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Link","aria-label":"Başlık","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "link", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Alt Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.subtitle),expression:"post.subtitle"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Alt Başlık","aria-label":"Alt Başlık","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.subtitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "subtitle", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("150 x 150 pixel")]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),(_vm.image.cropped)?_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.cropped}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":true,"viewport":{width: 150, height: 150, type: 'suare'},"boundary":{width: 200, height: 200},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zSON":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zTLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    routeName: function routeName() {
      var name = this.$route.name;

      return this.capitalizeFirstLetter(name);
    }
  },
  data: function data() {
    return {
      activeNotifications: false
    };
  },

  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown: function toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown: function closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },

    logout: function logout() {
      var _this = this;

      this.toggleLoader();
      this.$http.get('/api/users/logout', this.credentials).then(function (response) {
        localStorage.removeItem('CurrentLoggedUserDetails');
        _this.$router.push('/main');
        location.reload();
      }, function (e) {
        _this.$router.push('/main');
        location.reload();
      });
    }
  }
});

/***/ }),

/***/ "zX2c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RaceModules_Index_vue__ = __webpack_require__("giiS");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    RaceTable: __WEBPACK_IMPORTED_MODULE_0__RaceModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "zeK9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AdModules_Index_vue__ = __webpack_require__("6/gU");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainView: __WEBPACK_IMPORTED_MODULE_0__AdModules_Index_vue__["a" /* default */]
  },
  data: function data() {
    return {
      navigation: true
    };
  },
  methods: {}
});

/***/ }),

/***/ "ziMA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Bildiri Düzenle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata\n        ")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"change":_vm.validate,"keyup":_vm.createUrl,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"url-label"}},[_vm._v("URL")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.url),expression:"post.url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('URL')},attrs:{"type":"text","placeholder":"URL","aria-label":"URL","id":"url","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.url)},on:{"keyup":_vm.slugifyUrl,"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3 d-flex flex-column align-items-end"},[_c('tinymce',{class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-11"},[_c('vue-tabs',[_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Resim"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 m-3"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],class:{'is-invalid' : _vm.errors.includes('image')},on:{"click":function($event){return _vm.initiateCroppie('main')}}},[_vm._v("Resim Seç")]),_vm._v(" "),_c('small',{staticClass:"d-block w-100 mb-3"},[_vm._v("1200 x 600 pixel")]),_vm._v(" "),_c('img',{staticClass:"img-fluid mt-4 d-block border border-secondary p-2",class:{'border-danger' : _vm.errors.includes('Resim')},attrs:{"src":_vm.image.file,"id":"main-i"}})],1)])]),_vm._v(" "),_c('v-tab',{staticClass:"card border-top-0",attrs:{"title":"Video"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 input-group px-5 m-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Video Adresi")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.newvideo),expression:"post.newvideo"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"https://www.youtube.com/watch?v=KZzON_7EQ70","aria-label":"Başlık","id":"title","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.newvideo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "newvideo", $event.target.value)}}})])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 480, height: 270, type: 'suare'},"boundary":{width: 640, height: 360},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zlvs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"mt-0"},[_vm._v("Yazı Ekle")]),_vm._v(" "),(_vm.errors.length)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading my-0 text-center"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" Hata\n        ")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errors),function(e){return _c('li',{key:e.id},[_c('b',[_vm._v(_vm._s(e))]),_vm._v(" Alanını Doldurmanız gerek\n          ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('small',[_vm._v("Resim Boyutu 1600x1200")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start"},[_c('button',{staticClass:"btn btn-primary btn-fill",on:{"click":_vm.checkForm}},[_vm._v("Kaydet")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon1"}},[_vm._v("Başlık")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.name),expression:"post.name"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('Başlık')},attrs:{"type":"text","placeholder":"Başlık","aria-label":"Başlık","id":"name","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.name)},on:{"change":_vm.validate,"keyup":_vm.createUrl,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"url-label"}},[_vm._v("URL")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.post.url),expression:"post.url"}],staticClass:"form-control",class:{'is-invalid' : _vm.errors.includes('URL')},attrs:{"type":"text","placeholder":"URL","aria-label":"URL","id":"url","aria-describedby":"basic-addon1"},domProps:{"value":(_vm.post.url)},on:{"keyup":_vm.slugifyUrl,"change":_vm.validate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.post, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 input-group mb-3 d-flex flex-column align-items-end"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.croppieModal",modifiers:{"croppieModal":true}}],staticClass:"btn btn-primary btn-sm btn-fill",staticStyle:{"margin-bottom":"-34px","z-index":"2"},on:{"click":function($event){return _vm.initiateCroppie('tinymce')}}},[_vm._v("Resim Ekle")]),_vm._v(" "),_c('tinymce',{class:{'is-invalid' : _vm.errors.includes('İçerik')},staticStyle:{"width":"100%"},attrs:{"id":"d1","other_options":_vm.options},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}}),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row justify-content-around w-100 align-items-center mt-3"},[_c('button',{staticClass:"btn btn-warning activebtn-s mr-2 px-2",attrs:{"disabled":!_vm.post.image,"type":"submit"}},[(_vm.post.image)?_c('a',{staticClass:"text-warning",attrs:{"href":_vm.generalURL('duyurular-pdf')+_vm.post.image,"target":"_blank"}},[_vm._v("PDF AÇ")]):_vm._e()]),_vm._v(" "),_c('label',{staticClass:"btn btn-primary btn-fill mt-3",attrs:{"for":"pdf"}},[_vm._v("PDF Ekle")]),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","id":"pdf"},on:{"change":function($event){return _vm.uploadPdf($event)}}})])],1)]),_vm._v(" "),_c('b-modal',{attrs:{"id":"croppieModal","hide-footer":"","size":"lg","title":"Resim Seç"}},[_c('input',{staticClass:"m-3",attrs:{"name":"myFile","id":"myImage","type":"file"},on:{"change":function($event){return _vm.bind()}}}),_vm._v(" "),_c('vue-croppie',{ref:"main",attrs:{"enable-resize":false,"viewport":{width: 450, height: 300, type: 'suare'},"boundary":{width: 600, height: 450},"enableOrientation":true},on:{"result":_vm.result}}),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"danger btn-fill"},on:{"click":function($event){return _vm.hideCroppieModal()}}},[_vm._v("İptal")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success btn-fill float-right"},on:{"click":function($event){return _vm.crop()}}},[_vm._v("Kaydet")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zqom":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zzQR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("i+ho");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33dedfa9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("IeqH");
function injectStyle (ssrContext) {
  __webpack_require__("czl6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33dedfa9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1de4629c732375d5e5da.js